// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"jc5UF":[function(require,module,exports,__globalThis) {
/**
* vue v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compile", ()=>compile);
var _runtimeDom = require("@vue/runtime-dom");
parcelHelpers.exportAll(_runtimeDom, exports);
function initDev() {
    (0, _runtimeDom.initCustomFormatter)();
}
const compile = ()=>{};

},{"@vue/runtime-dom":"g5CLd","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g5CLd":[function(require,module,exports,__globalThis) {
/**
* @vue/runtime-dom v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transition", ()=>Transition);
parcelHelpers.export(exports, "TransitionGroup", ()=>TransitionGroup);
parcelHelpers.export(exports, "VueElement", ()=>VueElement);
parcelHelpers.export(exports, "createApp", ()=>createApp);
parcelHelpers.export(exports, "createSSRApp", ()=>createSSRApp);
parcelHelpers.export(exports, "defineCustomElement", ()=>defineCustomElement);
parcelHelpers.export(exports, "defineSSRCustomElement", ()=>defineSSRCustomElement);
parcelHelpers.export(exports, "hydrate", ()=>hydrate);
parcelHelpers.export(exports, "initDirectivesForSSR", ()=>initDirectivesForSSR);
parcelHelpers.export(exports, "render", ()=>render);
parcelHelpers.export(exports, "useCssModule", ()=>useCssModule);
parcelHelpers.export(exports, "useCssVars", ()=>useCssVars);
parcelHelpers.export(exports, "useHost", ()=>useHost);
parcelHelpers.export(exports, "useShadowRoot", ()=>useShadowRoot);
parcelHelpers.export(exports, "vModelCheckbox", ()=>vModelCheckbox);
parcelHelpers.export(exports, "vModelDynamic", ()=>vModelDynamic);
parcelHelpers.export(exports, "vModelRadio", ()=>vModelRadio);
parcelHelpers.export(exports, "vModelSelect", ()=>vModelSelect);
parcelHelpers.export(exports, "vModelText", ()=>vModelText);
parcelHelpers.export(exports, "vShow", ()=>vShow);
parcelHelpers.export(exports, "withKeys", ()=>withKeys);
parcelHelpers.export(exports, "withModifiers", ()=>withModifiers);
var _runtimeCore = require("@vue/runtime-core");
parcelHelpers.exportAll(_runtimeCore, exports);
var _shared = require("@vue/shared");
let policy = void 0;
const tt = typeof window !== "undefined" && window.trustedTypes;
if (tt) try {
    policy = /* @__PURE__ */ tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {}
const unsafeToTrustedHTML = policy ? (val)=>policy.createHTML(val) : (val)=>val;
const svgNS = "http://www.w3.org/2000/svg";
const mathmlNS = "http://www.w3.org/1998/Math/MathML";
const doc = typeof document !== "undefined" ? document : null;
const templateContainer = doc && /* @__PURE__ */ doc.createElement("template");
const nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? doc.createElementNS(svgNS, tag) : namespace === "mathml" ? doc.createElementNS(mathmlNS, tag) : is ? doc.createElement(tag, {
            is
        }) : doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>doc.createTextNode(text),
    createComment: (text)=>doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            templateContainer.innerHTML = unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const TRANSITION = "transition";
const ANIMATION = "animation";
const vtcKey = Symbol("_vtc");
const DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const TransitionPropsValidators = /* @__PURE__ */ (0, _shared.extend)({}, (0, _runtimeCore.BaseTransitionPropsValidators), DOMTransitionPropsValidators);
const decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = TransitionPropsValidators;
    return t;
};
const Transition = /* @__PURE__ */ decorate$1((props, { slots })=>(0, _runtimeCore.h)((0, _runtimeCore.BaseTransition), resolveTransitionProps(props), slots));
const callHook = (hook, args = [])=>{
    if ((0, _shared.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const hasExplicitCallback = (hook)=>{
    return hook ? (0, _shared.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name = "v", type, duration, enterFromClass = `${name}-enter-from`, enterActiveClass = `${name}-enter-active`, enterToClass = `${name}-enter-to`, appearFromClass = enterFromClass, appearActiveClass = enterActiveClass, appearToClass = enterToClass, leaveFromClass = `${name}-leave-from`, leaveActiveClass = `${name}-leave-active`, leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter, onEnter, onEnterCancelled, onLeave, onLeaveCancelled, onBeforeAppear = onBeforeEnter, onAppear = onEnter, onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled)=>{
        el._enterCancelled = isCancelled;
        removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        removeTransitionClass(el, leaveFromClass);
        removeTransitionClass(el, leaveToClass);
        removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            callHook(hook, [
                el,
                resolve
            ]);
            nextFrame(()=>{
                removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!hasExplicitCallback(hook)) whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, _shared.extend)(baseProps, {
        onBeforeEnter (el) {
            callHook(onBeforeEnter, [
                el
            ]);
            addTransitionClass(el, enterFromClass);
            addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            callHook(onBeforeAppear, [
                el
            ]);
            addTransitionClass(el, appearFromClass);
            addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                forceReflow();
                addTransitionClass(el, leaveActiveClass);
            } else {
                addTransitionClass(el, leaveActiveClass);
                forceReflow();
            }
            nextFrame(()=>{
                if (!el._isLeaving) return;
                removeTransitionClass(el, leaveFromClass);
                addTransitionClass(el, leaveToClass);
                if (!hasExplicitCallback(onLeave)) whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false, void 0, true);
            callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true, void 0, true);
            callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, _shared.isObject)(duration)) return [
        NumberOf(duration.enter),
        NumberOf(duration.leave)
    ];
    else {
        const n = NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function NumberOf(val) {
    const res = (0, _shared.toNumber)(val);
    return res;
}
function addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[vtcKey] || (el[vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[vtcKey] = void 0;
    }
}
function nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let endId = 0;
function whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type, timeout, propCount } = getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${TRANSITION}Duration`);
    const transitionTimeout = getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${ANIMATION}Duration`);
    const animationTimeout = getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === TRANSITION) {
        if (transitionTimeout > 0) {
            type = TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === ANIMATION) {
        if (animationTimeout > 0) {
            type = ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? TRANSITION : ANIMATION : null;
        propCount = type ? type === TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${TRANSITION}Property`).toString());
    return {
        type,
        timeout,
        propCount,
        hasTransform
    };
}
function getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>toMs(d) + toMs(delays[i])));
}
function toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function forceReflow() {
    return document.body.offsetHeight;
}
function patchClass(el, value, isSVG) {
    const transitionClasses = el[vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const vShowOriginalDisplay = Symbol("_vod");
const vShowHidden = Symbol("_vsh");
const vShow = {
    beforeMount (el, { value }, { transition }) {
        el[vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else setDisplay(el, value);
    },
    mounted (el, { value }, { transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value, oldValue }, { transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                setDisplay(el, false);
            });
        } else setDisplay(el, value);
    },
    beforeUnmount (el, { value }) {
        setDisplay(el, value);
    }
};
function setDisplay(el, value) {
    el.style.display = value ? el[vShowOriginalDisplay] : "none";
    el[vShowHidden] = !value;
}
function initVShowForSSR() {
    vShow.getSSRProps = ({ value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const CSS_VAR_TEXT = Symbol("");
function useCssVars(getter) {
    const instance = (0, _runtimeCore.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        if (instance.ce) setVarsOnNode(instance.ce, vars);
        else setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, _runtimeCore.onBeforeUpdate)(()=>{
        (0, _runtimeCore.queuePostFlushCb)(setVars);
    });
    (0, _runtimeCore.onMounted)(()=>{
        (0, _runtimeCore.watch)(setVars, (0, _shared.NOOP), {
            flush: "post"
        });
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, _runtimeCore.onUnmounted)(()=>ob.disconnect());
    });
}
function setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, _runtimeCore.Fragment)) vnode.children.forEach((c)=>setVarsOnVNode(c, vars));
    else if (vnode.type === (0, _runtimeCore.Static)) {
        let { el, anchor } = vnode;
        while(el){
            setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            style.setProperty(`--${key}`, vars[key]);
            cssText += `--${key}: ${vars[key]};`;
        }
        style[CSS_VAR_TEXT] = cssText;
    }
}
const displayRE = /(^|;)\s*display\s*:/;
function patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, _shared.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, _shared.isString)(prev)) {
                for(const key in prev)if (next[key] == null) setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            setStyle(style, key, next[key]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if (vShowOriginalDisplay in el) {
        el[vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[vShowHidden]) style.display = "none";
    }
}
const semicolonRE = /[^\\];\s*$/;
const importantRE = /\s*!important$/;
function setStyle(style, name, val) {
    if ((0, _shared.isArray)(val)) val.forEach((v)=>setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = autoPrefix(style, name);
            if (importantRE.test(val)) style.setProperty((0, _shared.hyphenate)(prefixed), val.replace(importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const prefixCache = {};
function autoPrefix(style, rawName) {
    const cached = prefixCache[rawName];
    if (cached) return cached;
    let name = (0, _runtimeCore.camelize)(rawName);
    if (name !== "filter" && name in style) return prefixCache[rawName] = name;
    name = (0, _shared.capitalize)(name);
    for(let i = 0; i < prefixes.length; i++){
        const prefixed = prefixes[i] + name;
        if (prefixed in style) return prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const xlinkNS = "http://www.w3.org/1999/xlink";
function patchAttr(el, key, value, isSVG, instance, isBoolean = (0, _shared.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS(xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS(xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, _shared.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, _shared.isSymbol)(value) ? String(value) : value);
}
function patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? unsafeToTrustedHTML(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, _shared.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const veiKey = Symbol("_vei");
function patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[veiKey] || (el[veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = createInvoker(nextValue, instance);
            addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const optionsModifierRE = /(?:Once|Passive|Capture)$/;
function parseName(name) {
    let options;
    if (optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match(optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, _shared.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let cachedNow = 0;
const p = /* @__PURE__ */ Promise.resolve();
const getNow = ()=>cachedNow || (p.then(()=>cachedNow = 0), cachedNow = Date.now());
function createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, _runtimeCore.callWithAsyncErrorHandling)(patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = getNow();
    return invoker;
}
function sanitizeEventValue(value, propName) {
    if ((0, _shared.isFunction)(value) || (0, _shared.isArray)(value)) return value;
    (0, _runtimeCore.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, _shared.NOOP;
}
function patchStopImmediatePropagation(e, value) {
    if ((0, _shared.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const patchProp = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") patchClass(el, nextValue, isSVG);
    else if (key === "style") patchStyle(el, prevValue, nextValue);
    else if ((0, _shared.isOn)(key)) {
        if (!(0, _shared.isModelListener)(key)) patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : shouldSetAsProp(el, key, nextValue, isSVG)) {
        patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && (/[A-Z]/.test(key) || !(0, _shared.isString)(nextValue))) patchDOMProp(el, (0, _shared.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        patchAttr(el, key, nextValue, isSVG);
    }
};
function shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && isNativeOn(key) && (0, _shared.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if (isNativeOn(key) && (0, _shared.isString)(value)) return false;
    return key in el;
}
const REMOVAL = {};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function defineCustomElement(options, extraOptions, _createApp) {
    const Comp = (0, _runtimeCore.defineComponent)(options, extraOptions);
    if ((0, _shared.isPlainObject)(Comp)) (0, _shared.extend)(Comp, extraOptions);
    class VueCustomElement extends VueElement {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ const defineSSRCustomElement = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ defineCustomElement(options, extraOptions, createSSRApp);
};
const BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class VueElement extends BaseClass {
    constructor(_def, _props = {}, _createApp = createApp){
        super();
        this._def = _def;
        this._props = _props;
        this._createApp = _createApp;
        this._isVueCE = true;
        /**
     * @internal
     */ this._instance = null;
        /**
     * @internal
     */ this._app = null;
        /**
     * @internal
     */ this._nonce = this._def.nonce;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._ob = null;
        if (this.shadowRoot && _createApp !== createApp) this._root = this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            this.attachShadow({
                mode: "open"
            });
            this._root = this.shadowRoot;
        } else this._root = this;
        if (!this._def.__asyncLoader) this._resolveProps(this._def);
    }
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof VueElement) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) {
                this._setParent();
                this._update();
            } else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    _setParent(parent = this._parent) {
        if (parent) {
            this._instance.parent = parent._instance;
            this._instance.provides = parent._instance.provides;
        }
    }
    disconnectedCallback() {
        this._connected = false;
        (0, _runtimeCore.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._app && this._app.unmount();
                if (this._instance) this._instance.ce = void 0;
                this._app = this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        if (this._pendingResolve) return;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        });
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props, styles } = def;
            let numberProps;
            if (props && !(0, _shared.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, _shared.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, _shared.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            this._mount(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) this._pendingResolve = asyncDef().then((def)=>resolve(this._def = def, true));
        else resolve(this._def);
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, _shared.hasOwn)(this, key)) Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: ()=>(0, _runtimeCore.unref)(exposed[key])
        });
    }
    _resolveProps(def) {
        const { props } = def;
        const declaredPropKeys = (0, _shared.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, _shared.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, true);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : REMOVAL;
        const camelKey = (0, _shared.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, _shared.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            if (val === REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                const ob = this._ob;
                ob && ob.disconnect();
                if (val === true) this.setAttribute((0, _shared.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, _shared.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, _shared.hyphenate)(key));
                ob && ob.observe(this, {
                    attributes: true
                });
            }
        }
    }
    _update() {
        render(this._createVNode(), this._root);
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, _runtimeCore.createVNode)(this._def, (0, _shared.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.ce = this;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, (0, _shared.isPlainObject)(args[0]) ? (0, _shared.extend)({
                    detail: args
                }, args[0]) : {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, _shared.hyphenate)(event) !== event) dispatch((0, _shared.hyphenate)(event), args);
            };
            this._setParent();
        };
        return vnode;
    }
    _applyStyles(styles, owner) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            this.shadowRoot.prepend(s);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _renderSlots() {
        const outlets = (this._teleportTarget || this).querySelectorAll("slot");
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
   * @internal
   */ _injectChildStyle(comp) {
        this._applyStyles(comp.styles, comp);
    }
    /**
   * @internal
   */ _removeChildStyle(comp) {
        var s;
    }
}
function useHost(caller) {
    const instance = (0, _runtimeCore.getCurrentInstance)();
    const el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, _runtimeCore.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, _runtimeCore.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
function useShadowRoot() {
    const el = useHost();
    return el && el.shadowRoot;
}
function useCssModule(name = "$style") {
    {
        const instance = (0, _runtimeCore.getCurrentInstance)();
        if (!instance) return 0, _shared.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, _shared.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, _shared.EMPTY_OBJ;
        return mod;
    }
}
const positionMap = /* @__PURE__ */ new WeakMap();
const newPositionMap = /* @__PURE__ */ new WeakMap();
const moveCbKey = Symbol("_moveCb");
const enterCbKey = Symbol("_enterCb");
const decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const TransitionGroupImpl = /* @__PURE__ */ decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, _shared.extend)({}, TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots }) {
        const instance = (0, _runtimeCore.getCurrentInstance)();
        const state = (0, _runtimeCore.useTransitionState)();
        let prevChildren;
        let children;
        (0, _runtimeCore.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach(callPendingCbs);
            prevChildren.forEach(recordPosition);
            const movedChildren = prevChildren.filter(applyTranslation);
            forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[moveCbKey] = null;
                        removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, _runtimeCore.toRaw)(props);
            const cssTransitionProps = resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, _runtimeCore.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, _runtimeCore.setTransitionHooks)(child, (0, _runtimeCore.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            children = slots.default ? (0, _runtimeCore.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, _runtimeCore.setTransitionHooks)(child, (0, _runtimeCore.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, _runtimeCore.createVNode)(tag, null, children);
        };
    }
});
const TransitionGroup = TransitionGroupImpl;
function callPendingCbs(c) {
    const el = c.el;
    if (el[moveCbKey]) el[moveCbKey]();
    if (el[enterCbKey]) el[enterCbKey]();
}
function recordPosition(c) {
    newPositionMap.set(c, c.el.getBoundingClientRect());
}
function applyTranslation(c) {
    const oldPos = positionMap.get(c);
    const newPos = newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform } = getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, _shared.isArray)(fn) ? (value)=>(0, _shared.invokeArrayFns)(fn, value) : fn;
};
function onCompositionStart(e) {
    e.target.composing = true;
}
function onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const assignKey = Symbol("_assign");
const vModelText = {
    created (el, { modifiers: { lazy, trim, number } }, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, _shared.looseToNumber)(domValue);
            el[assignKey](domValue);
        });
        if (trim) addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            addEventListener(el, "compositionstart", onCompositionStart);
            addEventListener(el, "compositionend", onCompositionEnd);
            addEventListener(el, "change", onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value, oldValue, modifiers: { lazy, trim, number } }, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, _shared.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const vModelCheckbox = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = getValue(el);
            const checked = el.checked;
            const assign = el[assignKey];
            if ((0, _shared.isArray)(modelValue)) {
                const index = (0, _shared.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, _shared.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign(getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: setChecked,
    beforeUpdate (el, binding, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        setChecked(el, binding, vnode);
    }
};
function setChecked(el, { value, oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if ((0, _shared.isArray)(value)) checked = (0, _shared.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, _shared.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, _shared.looseEqual)(value, getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
const vModelRadio = {
    created (el, { value }, vnode) {
        el.checked = (0, _shared.looseEqual)(value, vnode.props.value);
        el[assignKey] = getModelAssigner(vnode);
        addEventListener(el, "change", ()=>{
            el[assignKey](getValue(el));
        });
    },
    beforeUpdate (el, { value, oldValue }, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, _shared.looseEqual)(value, vnode.props.value);
    }
};
const vModelSelect = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value, modifiers: { number } }, vnode) {
        const isSetModel = (0, _shared.isSet)(value);
        addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, _shared.looseToNumber)(getValue(o)) : getValue(o));
            el[assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, _runtimeCore.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[assignKey] = getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value }) {
        setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[assignKey] = getModelAssigner(vnode);
    },
    updated (el, { value }) {
        if (!el._assigning) setSelected(el, value);
    }
};
function setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, _shared.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, _shared.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, _shared.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, _shared.looseEqual)(getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const vModelDynamic = {
    created (el, binding, vnode) {
        callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return vModelSelect;
        case "TEXTAREA":
            return vModelText;
        default:
            switch(type){
                case "checkbox":
                    return vModelCheckbox;
                case "radio":
                    return vModelRadio;
                default:
                    return vModelText;
            }
    }
}
function callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function initVModelForSSR() {
    vModelText.getSSRProps = ({ value })=>({
            value
        });
    vModelRadio.getSSRProps = ({ value }, vnode)=>{
        if (vnode.props && (0, _shared.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    vModelCheckbox.getSSRProps = ({ value }, vnode)=>{
        if ((0, _shared.isArray)(value)) {
            if (vnode.props && (0, _shared.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, _shared.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    vModelDynamic.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const withModifiers = (fn, modifiers)=>{
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const withKeys = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, _shared.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || keyNames[k] === eventKey)) return fn(event);
    });
};
const rendererOptions = /* @__PURE__ */ (0, _shared.extend)({
    patchProp
}, nodeOps);
let renderer;
let enabledHydration = false;
function ensureRenderer() {
    return renderer || (renderer = (0, _runtimeCore.createRenderer)(rendererOptions));
}
function ensureHydrationRenderer() {
    renderer = enabledHydration ? renderer : (0, _runtimeCore.createHydrationRenderer)(rendererOptions);
    enabledHydration = true;
    return renderer;
}
const render = (...args)=>{
    ensureRenderer().render(...args);
};
const hydrate = (...args)=>{
    ensureHydrationRenderer().hydrate(...args);
};
const createApp = (...args)=>{
    const app = ensureRenderer().createApp(...args);
    const { mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, _shared.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const createSSRApp = (...args)=>{
    const app = ensureHydrationRenderer().createApp(...args);
    const { mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, resolveRootNamespace(container));
    };
    return app;
};
function resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, _shared.isHTMLTag)(tag) || (0, _shared.isSVGTag)(tag) || (0, _shared.isMathMLTag)(tag),
        writable: false
    });
}
function injectCompilerOptionsCheck(app) {
    if ((0, _runtimeCore.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, _runtimeCore.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, _runtimeCore.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, _runtimeCore.warn)(msg);
            }
        });
    }
}
function normalizeContainer(container) {
    if ((0, _shared.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let ssrDirectiveInitialized = false;
const initDirectivesForSSR = ()=>{
    if (!ssrDirectiveInitialized) {
        ssrDirectiveInitialized = true;
        initVModelForSSR();
        initVShowForSSR();
    }
};

},{"@vue/runtime-core":"abcqT","@vue/shared":"gx1ZY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"abcqT":[function(require,module,exports,__globalThis) {
/**
* @vue/runtime-core v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EffectScope", ()=>(0, _reactivity.EffectScope));
parcelHelpers.export(exports, "ReactiveEffect", ()=>(0, _reactivity.ReactiveEffect));
parcelHelpers.export(exports, "TrackOpTypes", ()=>(0, _reactivity.TrackOpTypes));
parcelHelpers.export(exports, "TriggerOpTypes", ()=>(0, _reactivity.TriggerOpTypes));
parcelHelpers.export(exports, "customRef", ()=>(0, _reactivity.customRef));
parcelHelpers.export(exports, "effect", ()=>(0, _reactivity.effect));
parcelHelpers.export(exports, "effectScope", ()=>(0, _reactivity.effectScope));
parcelHelpers.export(exports, "getCurrentScope", ()=>(0, _reactivity.getCurrentScope));
parcelHelpers.export(exports, "getCurrentWatcher", ()=>(0, _reactivity.getCurrentWatcher));
parcelHelpers.export(exports, "isProxy", ()=>(0, _reactivity.isProxy));
parcelHelpers.export(exports, "isReactive", ()=>(0, _reactivity.isReactive));
parcelHelpers.export(exports, "isReadonly", ()=>(0, _reactivity.isReadonly));
parcelHelpers.export(exports, "isRef", ()=>(0, _reactivity.isRef));
parcelHelpers.export(exports, "isShallow", ()=>(0, _reactivity.isShallow));
parcelHelpers.export(exports, "markRaw", ()=>(0, _reactivity.markRaw));
parcelHelpers.export(exports, "onScopeDispose", ()=>(0, _reactivity.onScopeDispose));
parcelHelpers.export(exports, "onWatcherCleanup", ()=>(0, _reactivity.onWatcherCleanup));
parcelHelpers.export(exports, "proxyRefs", ()=>(0, _reactivity.proxyRefs));
parcelHelpers.export(exports, "reactive", ()=>(0, _reactivity.reactive));
parcelHelpers.export(exports, "readonly", ()=>(0, _reactivity.readonly));
parcelHelpers.export(exports, "ref", ()=>(0, _reactivity.ref));
parcelHelpers.export(exports, "shallowReactive", ()=>(0, _reactivity.shallowReactive));
parcelHelpers.export(exports, "shallowReadonly", ()=>(0, _reactivity.shallowReadonly));
parcelHelpers.export(exports, "shallowRef", ()=>(0, _reactivity.shallowRef));
parcelHelpers.export(exports, "stop", ()=>(0, _reactivity.stop));
parcelHelpers.export(exports, "toRaw", ()=>(0, _reactivity.toRaw));
parcelHelpers.export(exports, "toRef", ()=>(0, _reactivity.toRef));
parcelHelpers.export(exports, "toRefs", ()=>(0, _reactivity.toRefs));
parcelHelpers.export(exports, "toValue", ()=>(0, _reactivity.toValue));
parcelHelpers.export(exports, "triggerRef", ()=>(0, _reactivity.triggerRef));
parcelHelpers.export(exports, "unref", ()=>(0, _reactivity.unref));
parcelHelpers.export(exports, "camelize", ()=>(0, _shared.camelize));
parcelHelpers.export(exports, "capitalize", ()=>(0, _shared.capitalize));
parcelHelpers.export(exports, "normalizeClass", ()=>(0, _shared.normalizeClass));
parcelHelpers.export(exports, "normalizeProps", ()=>(0, _shared.normalizeProps));
parcelHelpers.export(exports, "normalizeStyle", ()=>(0, _shared.normalizeStyle));
parcelHelpers.export(exports, "toDisplayString", ()=>(0, _shared.toDisplayString));
parcelHelpers.export(exports, "toHandlerKey", ()=>(0, _shared.toHandlerKey));
parcelHelpers.export(exports, "BaseTransition", ()=>BaseTransition);
parcelHelpers.export(exports, "BaseTransitionPropsValidators", ()=>BaseTransitionPropsValidators);
parcelHelpers.export(exports, "Comment", ()=>Comment);
parcelHelpers.export(exports, "DeprecationTypes", ()=>DeprecationTypes);
parcelHelpers.export(exports, "ErrorCodes", ()=>ErrorCodes);
parcelHelpers.export(exports, "ErrorTypeStrings", ()=>ErrorTypeStrings);
parcelHelpers.export(exports, "Fragment", ()=>Fragment);
parcelHelpers.export(exports, "KeepAlive", ()=>KeepAlive);
parcelHelpers.export(exports, "Static", ()=>Static);
parcelHelpers.export(exports, "Suspense", ()=>Suspense);
parcelHelpers.export(exports, "Teleport", ()=>Teleport);
parcelHelpers.export(exports, "Text", ()=>Text);
parcelHelpers.export(exports, "assertNumber", ()=>assertNumber);
parcelHelpers.export(exports, "callWithAsyncErrorHandling", ()=>callWithAsyncErrorHandling);
parcelHelpers.export(exports, "callWithErrorHandling", ()=>callWithErrorHandling);
parcelHelpers.export(exports, "cloneVNode", ()=>cloneVNode);
parcelHelpers.export(exports, "compatUtils", ()=>compatUtils);
parcelHelpers.export(exports, "computed", ()=>computed);
parcelHelpers.export(exports, "createBlock", ()=>createBlock);
parcelHelpers.export(exports, "createCommentVNode", ()=>createCommentVNode);
parcelHelpers.export(exports, "createElementBlock", ()=>createElementBlock);
parcelHelpers.export(exports, "createElementVNode", ()=>createBaseVNode);
parcelHelpers.export(exports, "createHydrationRenderer", ()=>createHydrationRenderer);
parcelHelpers.export(exports, "createPropsRestProxy", ()=>createPropsRestProxy);
parcelHelpers.export(exports, "createRenderer", ()=>createRenderer);
parcelHelpers.export(exports, "createSlots", ()=>createSlots);
parcelHelpers.export(exports, "createStaticVNode", ()=>createStaticVNode);
parcelHelpers.export(exports, "createTextVNode", ()=>createTextVNode);
parcelHelpers.export(exports, "createVNode", ()=>createVNode);
parcelHelpers.export(exports, "defineAsyncComponent", ()=>defineAsyncComponent);
parcelHelpers.export(exports, "defineComponent", ()=>defineComponent);
parcelHelpers.export(exports, "defineEmits", ()=>defineEmits);
parcelHelpers.export(exports, "defineExpose", ()=>defineExpose);
parcelHelpers.export(exports, "defineModel", ()=>defineModel);
parcelHelpers.export(exports, "defineOptions", ()=>defineOptions);
parcelHelpers.export(exports, "defineProps", ()=>defineProps);
parcelHelpers.export(exports, "defineSlots", ()=>defineSlots);
parcelHelpers.export(exports, "devtools", ()=>devtools);
parcelHelpers.export(exports, "getCurrentInstance", ()=>getCurrentInstance);
parcelHelpers.export(exports, "getTransitionRawChildren", ()=>getTransitionRawChildren);
parcelHelpers.export(exports, "guardReactiveProps", ()=>guardReactiveProps);
parcelHelpers.export(exports, "h", ()=>h);
parcelHelpers.export(exports, "handleError", ()=>handleError);
parcelHelpers.export(exports, "hasInjectionContext", ()=>hasInjectionContext);
parcelHelpers.export(exports, "hydrateOnIdle", ()=>hydrateOnIdle);
parcelHelpers.export(exports, "hydrateOnInteraction", ()=>hydrateOnInteraction);
parcelHelpers.export(exports, "hydrateOnMediaQuery", ()=>hydrateOnMediaQuery);
parcelHelpers.export(exports, "hydrateOnVisible", ()=>hydrateOnVisible);
parcelHelpers.export(exports, "initCustomFormatter", ()=>initCustomFormatter);
parcelHelpers.export(exports, "inject", ()=>inject);
parcelHelpers.export(exports, "isMemoSame", ()=>isMemoSame);
parcelHelpers.export(exports, "isRuntimeOnly", ()=>isRuntimeOnly);
parcelHelpers.export(exports, "isVNode", ()=>isVNode);
parcelHelpers.export(exports, "mergeDefaults", ()=>mergeDefaults);
parcelHelpers.export(exports, "mergeModels", ()=>mergeModels);
parcelHelpers.export(exports, "mergeProps", ()=>mergeProps);
parcelHelpers.export(exports, "nextTick", ()=>nextTick);
parcelHelpers.export(exports, "onActivated", ()=>onActivated);
parcelHelpers.export(exports, "onBeforeMount", ()=>onBeforeMount);
parcelHelpers.export(exports, "onBeforeUnmount", ()=>onBeforeUnmount);
parcelHelpers.export(exports, "onBeforeUpdate", ()=>onBeforeUpdate);
parcelHelpers.export(exports, "onDeactivated", ()=>onDeactivated);
parcelHelpers.export(exports, "onErrorCaptured", ()=>onErrorCaptured);
parcelHelpers.export(exports, "onMounted", ()=>onMounted);
parcelHelpers.export(exports, "onRenderTracked", ()=>onRenderTracked);
parcelHelpers.export(exports, "onRenderTriggered", ()=>onRenderTriggered);
parcelHelpers.export(exports, "onServerPrefetch", ()=>onServerPrefetch);
parcelHelpers.export(exports, "onUnmounted", ()=>onUnmounted);
parcelHelpers.export(exports, "onUpdated", ()=>onUpdated);
parcelHelpers.export(exports, "openBlock", ()=>openBlock);
parcelHelpers.export(exports, "popScopeId", ()=>popScopeId);
parcelHelpers.export(exports, "provide", ()=>provide);
parcelHelpers.export(exports, "pushScopeId", ()=>pushScopeId);
parcelHelpers.export(exports, "queuePostFlushCb", ()=>queuePostFlushCb);
parcelHelpers.export(exports, "registerRuntimeCompiler", ()=>registerRuntimeCompiler);
parcelHelpers.export(exports, "renderList", ()=>renderList);
parcelHelpers.export(exports, "renderSlot", ()=>renderSlot);
parcelHelpers.export(exports, "resolveComponent", ()=>resolveComponent);
parcelHelpers.export(exports, "resolveDirective", ()=>resolveDirective);
parcelHelpers.export(exports, "resolveDynamicComponent", ()=>resolveDynamicComponent);
parcelHelpers.export(exports, "resolveFilter", ()=>resolveFilter);
parcelHelpers.export(exports, "resolveTransitionHooks", ()=>resolveTransitionHooks);
parcelHelpers.export(exports, "setBlockTracking", ()=>setBlockTracking);
parcelHelpers.export(exports, "setDevtoolsHook", ()=>setDevtoolsHook);
parcelHelpers.export(exports, "setTransitionHooks", ()=>setTransitionHooks);
parcelHelpers.export(exports, "ssrContextKey", ()=>ssrContextKey);
parcelHelpers.export(exports, "ssrUtils", ()=>ssrUtils);
parcelHelpers.export(exports, "toHandlers", ()=>toHandlers);
parcelHelpers.export(exports, "transformVNodeArgs", ()=>transformVNodeArgs);
parcelHelpers.export(exports, "useAttrs", ()=>useAttrs);
parcelHelpers.export(exports, "useId", ()=>useId);
parcelHelpers.export(exports, "useModel", ()=>useModel);
parcelHelpers.export(exports, "useSSRContext", ()=>useSSRContext);
parcelHelpers.export(exports, "useSlots", ()=>useSlots);
parcelHelpers.export(exports, "useTemplateRef", ()=>useTemplateRef);
parcelHelpers.export(exports, "useTransitionState", ()=>useTransitionState);
parcelHelpers.export(exports, "version", ()=>version);
parcelHelpers.export(exports, "warn", ()=>warn);
parcelHelpers.export(exports, "watch", ()=>watch);
parcelHelpers.export(exports, "watchEffect", ()=>watchEffect);
parcelHelpers.export(exports, "watchPostEffect", ()=>watchPostEffect);
parcelHelpers.export(exports, "watchSyncEffect", ()=>watchSyncEffect);
parcelHelpers.export(exports, "withAsyncContext", ()=>withAsyncContext);
parcelHelpers.export(exports, "withCtx", ()=>withCtx);
parcelHelpers.export(exports, "withDefaults", ()=>withDefaults);
parcelHelpers.export(exports, "withDirectives", ()=>withDirectives);
parcelHelpers.export(exports, "withMemo", ()=>withMemo);
parcelHelpers.export(exports, "withScopeId", ()=>withScopeId);
var _reactivity = require("@vue/reactivity");
var _shared = require("@vue/shared");
const stack = [];
function pushWarningContext(vnode) {
    stack.push(vnode);
}
function popWarningContext() {
    stack.pop();
}
let isWarning = false;
function warn$1(msg, ...args) {
    if (isWarning) return;
    isWarning = true;
    (0, _reactivity.pauseTracking)();
    const instance = stack.length ? stack[stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = getComponentTrace();
    if (appWarnHandler) callWithErrorHandling(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode })=>`at <${formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, _reactivity.resetTracking)();
    isWarning = false;
}
function getComponentTrace() {
    let currentVNode = stack[stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...formatTraceEntry(entry));
    });
    return logs;
}
function formatTraceEntry({ vnode, recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function formatProp(key, value, raw) {
    if ((0, _shared.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, _reactivity.isRef)(value)) {
        value = formatProp(key, (0, _reactivity.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, _shared.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, _reactivity.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function assertNumber(val, type) {
    return;
}
const ErrorCodes = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function callWithErrorHandling(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        handleError(err, instance, type);
    }
}
function callWithAsyncErrorHandling(fn, instance, type, args) {
    if ((0, _shared.isFunction)(fn)) {
        const res = callWithErrorHandling(fn, instance, type, args);
        if (res && (0, _shared.isPromise)(res)) res.catch((err)=>{
            handleError(err, instance, type);
        });
        return res;
    }
    if ((0, _shared.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push(callWithAsyncErrorHandling(fn[i], instance, type, args));
        return values;
    }
}
function handleError(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler, throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, _shared.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, _reactivity.pauseTracking)();
            callWithErrorHandling(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, _reactivity.resetTracking)();
            return;
        }
    }
    logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (throwInProd) throw err;
    else console.error(err);
}
const queue = [];
let flushIndex = -1;
const pendingPostFlushCbs = [];
let activePostFlushCbs = null;
let postFlushIndex = 0;
const resolvedPromise = /* @__PURE__ */ Promise.resolve();
let currentFlushPromise = null;
const RECURSION_LIMIT = 100;
function nextTick(fn) {
    const p = currentFlushPromise || resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function findInsertionIndex(id) {
    let start = flushIndex + 1;
    let end = queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = queue[middle];
        const middleJobId = getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function queueJob(job) {
    if (!(job.flags & 1)) {
        const jobId = getId(job);
        const lastJob = queue[queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= getId(lastJob)) queue.push(job);
        else queue.splice(findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        queueFlush();
    }
}
function queueFlush() {
    if (!currentFlushPromise) currentFlushPromise = resolvedPromise.then(flushJobs);
}
function queuePostFlushCb(cb) {
    if (!(0, _shared.isArray)(cb)) {
        if (activePostFlushCbs && cb.id === -1) activePostFlushCbs.splice(postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else pendingPostFlushCbs.push(...cb);
    queueFlush();
}
function flushPreFlushCbs(instance, seen, i = flushIndex + 1) {
    for(; i < queue.length; i++){
        const cb = queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid) continue;
            queue.splice(i, 1);
            i--;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function flushPostFlushCbs(seen) {
    if (pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set(pendingPostFlushCbs)
        ].sort((a, b)=>getId(a) - getId(b));
        pendingPostFlushCbs.length = 0;
        if (activePostFlushCbs) {
            activePostFlushCbs.push(...deduped);
            return;
        }
        activePostFlushCbs = deduped;
        for(postFlushIndex = 0; postFlushIndex < activePostFlushCbs.length; postFlushIndex++){
            const cb = activePostFlushCbs[postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        activePostFlushCbs = null;
        postFlushIndex = 0;
    }
}
const getId = (job)=>job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function flushJobs(seen) {
    const check = (0, _shared.NOOP);
    try {
        for(flushIndex = 0; flushIndex < queue.length; flushIndex++){
            const job = queue[flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                callWithErrorHandling(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; flushIndex < queue.length; flushIndex++){
            const job = queue[flushIndex];
            if (job) job.flags &= -2;
        }
        flushIndex = -1;
        queue.length = 0;
        flushPostFlushCbs(seen);
        currentFlushPromise = null;
        if (queue.length || pendingPostFlushCbs.length) flushJobs(seen);
    }
}
function checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && getComponentName(instance.type);
        handleError(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
let isHmrUpdating = false;
const hmrDirtyComponents = /* @__PURE__ */ new Map();
const map = /* @__PURE__ */ new Map();
function registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = map.get(id);
    if (!record) {
        createRecord(id, instance.type);
        record = map.get(id);
    }
    record.instances.add(instance);
}
function unregisterHMR(instance) {
    map.get(instance.type.__hmrId).instances.delete(instance);
}
function createRecord(id, initialDef) {
    if (map.has(id)) return false;
    map.set(id, {
        initialDef: normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function normalizeClassComponent(component) {
    return isClassComponent(component) ? component.__vccOpts : component;
}
function rerender(id, newRender) {
    const record = map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        isHmrUpdating = true;
        instance.update();
        isHmrUpdating = false;
    });
}
function reload(id, newComp) {
    const record = map.get(id);
    if (!record) return;
    newComp = normalizeClassComponent(newComp);
    updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = normalizeClassComponent(instance.type);
        let dirtyInstances = hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) updateComponentDef(oldComp, newComp);
            hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) queueJob(()=>{
            isHmrUpdating = true;
            instance.parent.update();
            isHmrUpdating = false;
            dirtyInstances.delete(instance);
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    }
    queuePostFlushCb(()=>{
        hmrDirtyComponents.clear();
    });
}
function updateComponentDef(oldComp, newComp) {
    (0, _shared.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let devtools$1;
let buffer = [];
let devtoolsNotInstalled = false;
function emit$1(event, ...args) {
    if (devtools$1) devtools$1.emit(event, ...args);
    else if (!devtoolsNotInstalled) buffer.push({
        event,
        args
    });
}
function setDevtoolsHook$1(hook, target) {
    var _a, _b;
    devtools$1 = hook;
    if (devtools$1) {
        devtools$1.enabled = true;
        buffer.forEach(({ event, args })=>devtools$1.emit(event, ...args));
        buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                devtoolsNotInstalled = true;
                buffer = [];
            }
        }, 3e3);
    } else {
        devtoolsNotInstalled = true;
        buffer = [];
    }
}
function devtoolsInitApp(app, version) {
    emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment,
        Text,
        Comment,
        Static
    });
}
function devtoolsUnmountApp(app) {
    emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const devtoolsComponentAdded = /* @__PURE__ */ createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const devtoolsComponentUpdated = /* @__PURE__ */ createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const _devtoolsComponentRemoved = /* @__PURE__ */ createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const devtoolsComponentRemoved = (component)=>{
    if (devtools$1 && typeof devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !devtools$1.cleanupBuffer(component)) _devtoolsComponentRemoved(component);
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function createDevtoolsComponentHook(hook) {
    return (component)=>{
        emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const devtoolsPerfStart = /* @__PURE__ */ createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const devtoolsPerfEnd = /* @__PURE__ */ createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function devtoolsComponentEmit(component, event, params) {
    emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let currentRenderingInstance = null;
let currentScopeId = null;
function setCurrentRenderingInstance(instance) {
    const prev = currentRenderingInstance;
    currentRenderingInstance = instance;
    currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function pushScopeId(id) {
    currentScopeId = id;
}
function popScopeId() {
    currentScopeId = null;
}
const withScopeId = (_id)=>withCtx;
function withCtx(fn, ctx = currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) setBlockTracking(-1);
        const prevInstance = setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) setBlockTracking(1);
        }
        if (__VUE_PROD_DEVTOOLS__) devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function validateDirectiveName(name) {
    if ((0, _shared.isBuiltInDirective)(name)) warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function withDirectives(vnode, directives) {
    if (currentRenderingInstance === null) return vnode;
    const instance = getComponentPublicInstance(currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, _shared.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, _shared.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, _reactivity.traverse)(value);
            bindings.push({
                dir,
                instance,
                value,
                oldValue: void 0,
                arg,
                modifiers
            });
        }
    }
    return vnode;
}
function invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, _reactivity.pauseTracking)();
            callWithAsyncErrorHandling(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, _reactivity.resetTracking)();
        }
    }
}
const TeleportEndKey = Symbol("_vte");
const isTeleport = (type)=>type.__isTeleport;
const isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const isTeleportDeferred = (props)=>props && (props.defer || props.defer === "");
const isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, _shared.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert, querySelector, createText, createComment } } = internals;
        const disabled = isTeleportDisabled(n2.props);
        let { shapeFlag, children, dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) {
                    if (parentComponent && parentComponent.isCE) parentComponent.ce._teleportTarget = container2;
                    mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                }
            };
            const mountToTarget = ()=>{
                const target = n2.target = resolveTarget(n2.props, querySelector);
                const targetAnchor = prepareAnchor(target, n2, createText, insert);
                if (target) {
                    if (namespace !== "svg" && isTargetSVG(target)) namespace = "svg";
                    else if (namespace !== "mathml" && isTargetMathML(target)) namespace = "mathml";
                    if (!disabled) {
                        mount(target, targetAnchor);
                        updateCssVars(n2, false);
                    }
                }
            };
            if (disabled) {
                mount(container, mainAnchor);
                updateCssVars(n2, true);
            }
            if (isTeleportDeferred(n2.props)) queuePostRenderEffect(()=>{
                mountToTarget();
                n2.el.__isMounted = true;
            }, parentSuspense);
            else mountToTarget();
        } else {
            if (isTeleportDeferred(n2.props) && !n1.el.__isMounted) {
                queuePostRenderEffect(()=>{
                    TeleportImpl.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                    delete n1.el.__isMounted;
                }, parentSuspense);
                return;
            }
            n2.el = n1.el;
            n2.targetStart = n1.targetStart;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = resolveTarget(n2.props, querySelector);
                    if (nextTarget) moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            updateCssVars(n2, disabled);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag, children, anchor, targetStart, targetAnchor, target, props } = vnode;
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: moveTeleport,
    hydrate: hydrateTeleport
};
function moveTeleport(vnode, container, parentAnchor, { o: { insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el, anchor, shapeFlag, children, props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling, parentNode, querySelector, insert, createText } }, hydrateChildren) {
    const target = vnode.target = resolveTarget(vnode.props, querySelector);
    if (target) {
        const disabled = isTeleportDisabled(vnode.props);
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetStart = targetNode;
                vnode.targetAnchor = targetNode && nextSibling(targetNode);
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    if (targetAnchor && targetAnchor.nodeType === 8) {
                        if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                        else if (targetAnchor.data === "teleport anchor") {
                            vnode.targetAnchor = targetAnchor;
                            target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                            break;
                        }
                    }
                    targetAnchor = nextSibling(targetAnchor);
                }
                if (!vnode.targetAnchor) prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        updateCssVars(vnode, disabled);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const Teleport = TeleportImpl;
function updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function prepareAnchor(target, vnode, createText, insert) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target);
        insert(targetAnchor, target);
    }
    return targetAnchor;
}
const leaveCbKey = Symbol("_leaveCb");
const enterCbKey = Symbol("_enterCb");
function useTransitionState() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    onMounted(()=>{
        state.isMounted = true;
    });
    onBeforeUnmount(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const TransitionHookValidator = [
    Function,
    Array
];
const BaseTransitionPropsValidators = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: TransitionHookValidator,
    onEnter: TransitionHookValidator,
    onAfterEnter: TransitionHookValidator,
    onEnterCancelled: TransitionHookValidator,
    // leave
    onBeforeLeave: TransitionHookValidator,
    onLeave: TransitionHookValidator,
    onAfterLeave: TransitionHookValidator,
    onLeaveCancelled: TransitionHookValidator,
    // appear
    onBeforeAppear: TransitionHookValidator,
    onAppear: TransitionHookValidator,
    onAfterAppear: TransitionHookValidator,
    onAppearCancelled: TransitionHookValidator
};
const recursiveGetSubtree = (instance)=>{
    const subTree = instance.subTree;
    return subTree.component ? recursiveGetSubtree(subTree.component) : subTree;
};
const BaseTransitionImpl = {
    name: `BaseTransition`,
    props: BaseTransitionPropsValidators,
    setup (props, { slots }) {
        const instance = getCurrentInstance();
        const state = useTransitionState();
        return ()=>{
            const children = slots.default && getTransitionRawChildren(slots.default(), true);
            if (!children || !children.length) return;
            const child = findNonCommentChild(children);
            const rawProps = (0, _reactivity.toRaw)(props);
            const { mode } = rawProps;
            if (state.isLeaving) return emptyPlaceholder(child);
            const innerChild = getInnerChild$1(child);
            if (!innerChild) return emptyPlaceholder(child);
            let enterHooks = resolveTransitionHooks(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            if (innerChild.type !== Comment) setTransitionHooks(innerChild, enterHooks);
            let oldInnerChild = instance.subTree && getInnerChild$1(instance.subTree);
            if (oldInnerChild && oldInnerChild.type !== Comment && !isSameVNodeType(innerChild, oldInnerChild) && recursiveGetSubtree(instance).type !== Comment) {
                let leavingHooks = resolveTransitionHooks(oldInnerChild, rawProps, state, instance);
                setTransitionHooks(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== Comment) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                        oldInnerChild = void 0;
                    };
                    return emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== Comment) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[leaveCbKey] = ()=>{
                        earlyRemove();
                        el[leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                    enterHooks.delayedLeave = ()=>{
                        delayedLeave();
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                };
                else oldInnerChild = void 0;
            } else if (oldInnerChild) oldInnerChild = void 0;
            return child;
        };
    }
};
function findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== Comment) {
            child = c;
            hasFound = true;
            break;
        }
    }
    return child;
}
const BaseTransition = BaseTransitionImpl;
function getLeavingNodesForType(state, vnode) {
    const { leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function resolveTransitionHooks(vnode, props, state, instance, postClone) {
    const { appear, mode, persisted = false, onBeforeEnter, onEnter, onAfterEnter, onEnterCancelled, onBeforeLeave, onLeave, onAfterLeave, onLeaveCancelled, onBeforeAppear, onAppear, onAfterAppear, onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && callWithAsyncErrorHandling(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, _shared.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode,
        persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[leaveCbKey]) el[leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[leaveCbKey]) leavingVNode.el[leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el[enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[enterCbKey]) el[enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el[leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = resolveTransitionHooks(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function emptyPlaceholder(vnode) {
    if (isKeepAlive(vnode)) {
        vnode = cloneVNode(vnode);
        vnode.children = null;
        return vnode;
    }
}
function getInnerChild$1(vnode) {
    if (!isKeepAlive(vnode)) {
        if (isTeleport(vnode.type) && vnode.children) return findNonCommentChild(vnode.children);
        return vnode;
    }
    const { shapeFlag, children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, _shared.isFunction)(children.default)) return children.default();
    }
}
function setTransitionHooks(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        setTransitionHooks(vnode.component.subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function getTransitionRawChildren(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === Fragment) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat(getTransitionRawChildren(child.children, keepComment, key));
        } else if (keepComment || child.type !== Comment) ret.push(key != null ? cloneVNode(child, {
            key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function defineComponent(options, extraOptions) {
    return (0, _shared.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, _shared.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
function useId() {
    const i = getCurrentInstance();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
function markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
const knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function useTemplateRef(key) {
    const i = getCurrentInstance();
    const r = (0, _reactivity.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, _shared.EMPTY_OBJ) ? i.refs = {} : i.refs;
        let desc;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    }
    const ret = r;
    return ret;
}
function setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, _shared.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>setRef(r, oldRawRef && ((0, _shared.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if (isAsyncWrapper(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    const refValue = vnode.shapeFlag & 4 ? getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, _shared.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = (0, _reactivity.toRaw)(setupState);
    const canSetSetupRef = setupState === (0, _shared.EMPTY_OBJ) ? ()=>false : (key)=>{
        return (0, _shared.hasOwn)(rawSetupState, key);
    };
    if (oldRef != null && oldRef !== ref) {
        if ((0, _shared.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, _reactivity.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, _shared.isFunction)(ref)) callWithErrorHandling(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, _shared.isString)(ref);
        const _isRef = (0, _reactivity.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, _shared.isArray)(existing) && (0, _shared.remove)(existing, refValue);
                    else {
                        if (!(0, _shared.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let hasLoggedMismatchError = false;
const logMismatchError = ()=>{
    if (hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    hasLoggedMismatchError = true;
};
const isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const getContainerType = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if (isSVGContainer(container)) return "svg";
    if (isMathMLContainer(container)) return "mathml";
    return void 0;
};
const isComment = (node)=>node.nodeType === 8;
function createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp, createText, nextSibling, parentNode, remove, insert, createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type, ref, shapeFlag, patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, _shared.def)(node, "__vnode", vnode, true);
            (0, _shared.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case Text:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case Comment:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case Static:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case Fragment:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if (isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, getContainerType(container), optimized);
                    if (isAsyncWrapper(vnode) && !vnode.type.__asyncResolved) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = createVNode(Fragment);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? createTextVNode("") : createVNode("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type, props, patchFlag, shapeFlag, dirs, transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) transition.beforeEnter(content);
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    if (!isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                            warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                            hasWarned = true;
                        }
                        logMismatchError();
                    }
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                if (el.textContent !== clientText) {
                    if (!isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${el.textContent}
  - expected on client: ${vnode.children}`);
                        logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some((d)=>d.dir.created)) && propHasMismatch(el, key, props[key], vnode, parentComponent)) logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, _shared.isOn)(key) && !(0, _shared.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement) patchProp(el, key, null, props[key], void 0, parentComponent);
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, _reactivity.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) queueEffectWithSuspense(()=>{
                vnodeHooks && invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = normalizeVNode(children[i]);
            const isText = vnode.type === Text;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && normalizeVNode(children[i + 1]).type === Text) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    logMismatchError();
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ )) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 ? `(text)` : isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
            logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, getContainerType(container), slotScopeIds);
        if (parentComponent) {
            parentComponent.vnode.el = vnode.el;
            updateHOCHostEl(parentComponent, vnode.el);
        }
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        actual = el.getAttribute("class");
        expected = (0, _shared.normalizeClass)(clientValue);
        if (!isSetEqual(toClassSet(actual || ""), toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, _shared.isString)(clientValue) ? clientValue : (0, _shared.stringifyStyle)((0, _shared.normalizeStyle)(clientValue));
        const actualMap = toStyleMap(actual);
        const expectedMap = toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir, value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) resolveCssVars(instance, vnode, expectedMap);
        if (!isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, _shared.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, _shared.isBooleanAttr)(key) || (0, _shared.isKnownHtmlAttr)(key))) {
        if ((0, _shared.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, _shared.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, _shared.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !isMismatchAllowed(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${MismatchTypeString[mismatchType]} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === Fragment && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars)expectedMap.set(`--${(0, _shared.getEscapedCssVarName)(key, false)}`, String(cssVars[key]));
    }
    if (vnode === root && instance.parent) resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const allowMismatchAttr = "data-allow-mismatch";
const MismatchTypeString = {
    [0 /* TEXT */ ]: "text",
    [1 /* CHILDREN */ ]: "children",
    [2 /* CLASS */ ]: "class",
    [3 /* STYLE */ ]: "style",
    [4 /* ATTRIBUTE */ ]: "attribute"
};
function isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute(allowMismatchAttr))el = el.parentElement;
    const allowedAttr = el && el.getAttribute(allowMismatchAttr);
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return allowedAttr.split(",").includes(MismatchTypeString[allowedType]);
    }
}
const requestIdleCallback = (0, _shared.getGlobalThis)().requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const cancelIdleCallback = (0, _shared.getGlobalThis)().cancelIdleCallback || ((id)=>clearTimeout(id));
const hydrateOnIdle = (timeout = 1e4)=>(hydrate)=>{
        const id = requestIdleCallback(hydrate, {
            timeout
        });
        return ()=>cancelIdleCallback(id);
    };
function elementIsVisibleInViewport(el) {
    const { top, left, bottom, right } = el.getBoundingClientRect();
    const { innerHeight, innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
const hydrateOnVisible = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        forEach((el)=>{
            if (!(el instanceof Element)) return;
            if (elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            ob.observe(el);
        });
        return ()=>ob.disconnect();
    };
const hydrateOnMediaQuery = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const hydrateOnInteraction = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, _shared.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function forEachElement(node, cb) {
    if (isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                const result = cb(next);
                if (result === false) break;
            } else if (isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
const isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function defineAsyncComponent(source) {
    if ((0, _shared.isFunction)(source)) source = {
        loader: source
    };
    const { loader, loadingComponent, errorComponent, delay = 200, hydrate: hydrateStrategy, timeout, // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return defineComponent({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            const doHydrate = hydrateStrategy ? ()=>{
                const teardown = hydrateStrategy(hydrate, (cb)=>forEachElement(el, cb));
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : hydrate;
            if (resolvedComp) doHydrate();
            else load().then(()=>!instance.isUnmounted && doHydrate());
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = currentInstance;
            markAsyncBoundary(instance);
            if (resolvedComp) return ()=>createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                handleError(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? createVNode(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, _reactivity.ref)(false);
            const error = (0, _reactivity.ref)();
            const delayed = (0, _reactivity.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && isKeepAlive(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return createVNode(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return createVNode(loadingComponent);
            };
        }
    });
}
function createInnerComp(comp, parent) {
    const { ref: ref2, props, children, ce } = parent.vnode;
    const vnode = createVNode(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots }) {
        const instance = getCurrentInstance();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, _shared.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            invalidateMount(instance2.m);
            invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            queuePostRenderEffect(()=>{
                if (instance2.da) (0, _shared.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = getComponentName(vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !isSameVNodeType(cached, current))) unmount(cached);
            else if (current) resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        watch(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>matches(include, name));
            exclude && pruneCache((name)=>!matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if (isSuspense(instance.subTree.type)) queuePostRenderEffect(()=>{
                    cache.set(pendingCacheKey, getInnerChild(instance.subTree));
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, getInnerChild(instance.subTree));
            }
        };
        onMounted(cacheSubtree);
        onUpdated(cacheSubtree);
        onBeforeUnmount(()=>{
            cache.forEach((cached)=>{
                const { subTree, suspense } = instance;
                const vnode = getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!isVNode(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = getInnerChild(rawVNode);
            if (vnode.type === Comment) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = getComponentName(isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include, exclude, max } = props;
            if (include && (!name || !matches(include, name)) || exclude && name && matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = cloneVNode(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) setTransitionHooks(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const KeepAlive = KeepAliveImpl;
function matches(pattern, name) {
    if ((0, _shared.isArray)(pattern)) return pattern.some((p)=>matches(p, name));
    else if ((0, _shared.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, _shared.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function onActivated(hook, target) {
    registerKeepAliveHook(hook, "a", target);
}
function onDeactivated(hook, target) {
    registerKeepAliveHook(hook, "da", target);
}
function registerKeepAliveHook(hook, type, target = currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if (isKeepAlive(current.parent.vnode)) injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = injectHook(type, hook, keepAliveRoot, true);
    onUnmounted(()=>{
        (0, _shared.remove)(keepAliveRoot[type], injected);
    }, target);
}
function resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function injectHook(type, hook, target = currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, _reactivity.pauseTracking)();
            const reset = setCurrentInstance(target);
            const res = callWithAsyncErrorHandling(hook, target, type, args);
            reset();
            (0, _reactivity.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const createHook = (lifecycle)=>(hook, target = currentInstance)=>{
        if (!isInSSRComponentSetup || lifecycle === "sp") injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const onBeforeMount = createHook("bm");
const onMounted = createHook("m");
const onBeforeUpdate = createHook("bu");
const onUpdated = createHook("u");
const onBeforeUnmount = createHook("bum");
const onUnmounted = createHook("um");
const onServerPrefetch = createHook("sp");
const onRenderTriggered = createHook("rtg");
const onRenderTracked = createHook("rtc");
function onErrorCaptured(hook, target = currentInstance) {
    injectHook("ec", hook, target);
}
const COMPONENTS = "components";
const DIRECTIVES = "directives";
function resolveComponent(name, maybeSelfReference) {
    return resolveAsset(COMPONENTS, name, true, maybeSelfReference) || name;
}
const NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function resolveDynamicComponent(component) {
    if ((0, _shared.isString)(component)) return resolveAsset(COMPONENTS, component, false) || component;
    else return component || NULL_DYNAMIC_COMPONENT;
}
function resolveDirective(name) {
    return resolveAsset(DIRECTIVES, name);
}
function resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = currentRenderingInstance || currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === COMPONENTS) {
            const selfName = getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, _shared.camelize)(name) || selfName === (0, _shared.capitalize)((0, _shared.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        resolve(instance[type] || Component[type], name) || // global registration
        resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function resolve(registry, name) {
    return registry && (registry[name] || registry[(0, _shared.camelize)(name)] || registry[(0, _shared.capitalize)((0, _shared.camelize)(name))]);
}
function renderList(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, _shared.isArray)(source);
    if (sourceIsArray || (0, _shared.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, _reactivity.isReactive)(source);
        let needsWrap = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, _reactivity.isShallow)(source);
            source = (0, _reactivity.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? (0, _reactivity.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, _shared.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function createSlots(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, _shared.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function renderSlot(slots, name, props = {}, fallback, noSlotted) {
    if (currentRenderingInstance.ce || currentRenderingInstance.parent && isAsyncWrapper(currentRenderingInstance.parent) && currentRenderingInstance.parent.ce) {
        if (name !== "default") props.name = name;
        return openBlock(), createBlock(Fragment, null, [
            createVNode("slot", props, fallback && fallback())
        ], 64);
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    openBlock();
    const validSlotContent = slot && ensureValidVNode(slot(props));
    const slotKey = props.key || // slot content array of a dynamic conditional slot may have a branch
    // key attached in the `createSlots` helper, respect that
    validSlotContent && validSlotContent.key;
    const rendered = createBlock(Fragment, {
        key: (slotKey && !(0, _shared.isSymbol)(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
        (!validSlotContent && fallback ? "_fb" : "")
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!isVNode(child)) return true;
        if (child.type === Comment) return false;
        if (child.type === Fragment && !ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function toHandlers(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, _shared.toHandlerKey)(key)] = obj[key];
    return ret;
}
const getPublicInstance = (i)=>{
    if (!i) return null;
    if (isStatefulComponent(i)) return getComponentPublicInstance(i);
    return getPublicInstance(i.parent);
};
const publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, _shared.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>getPublicInstance(i.parent),
    $root: (i)=>getPublicInstance(i.root),
    $host: (i)=>i.ce,
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = nextTick.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? instanceWatch.bind(i) : (0, _shared.NOOP)
});
const isReservedPrefix = (key)=>key === "_" || key === "$";
const hasSetupBinding = (state, key)=>state !== (0, _shared.EMPTY_OBJ) && !state.__isScriptSetup && (0, _shared.hasOwn)(state, key);
const PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx, setupState, data, props, accessCache, type, appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if (hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, _shared.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, _reactivity.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, _shared.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data, setupState, ctx } = instance;
        if (hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (data !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, _shared.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data, setupState, accessCache, ctx, appContext, propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasOwn)(data, key) || hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, _shared.hasOwn)(normalizedProps, key) || (0, _shared.hasOwn)(ctx, key) || (0, _shared.hasOwn)(publicPropertiesMap, key) || (0, _shared.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, _shared.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var target;
const RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, _shared.extend)({}, PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, _shared.isGloballyAllowed)(key);
        return has;
    }
});
function createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys(publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, _shared.NOOP)
        });
    });
    return target;
}
function exposePropsOnRenderContext(instance) {
    const { ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, _shared.NOOP)
        });
    });
}
function exposeSetupStateOnRenderContext(instance) {
    const { ctx, setupState } = instance;
    Object.keys((0, _reactivity.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if (isReservedPrefix(key[0])) {
                warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, _shared.NOOP)
            });
        }
    });
}
const warnRuntimeUsage = (method)=>warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function defineProps() {
    return null;
}
function defineEmits() {
    return null;
}
function defineExpose(exposed) {}
function defineOptions(options) {}
function defineSlots() {
    return null;
}
function defineModel() {}
function withDefaults(props, defaults) {
    return null;
}
function useSlots() {
    return getContext().slots;
}
function useAttrs() {
    return getContext().attrs;
}
function getContext() {
    const i = getCurrentInstance();
    return i.setupContext || (i.setupContext = createSetupContext(i));
}
function normalizePropsOrEmits(props) {
    return (0, _shared.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function mergeDefaults(raw, defaults) {
    const props = normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, _shared.isArray)(opt) || (0, _shared.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function mergeModels(a, b) {
    if (!a || !b) return a || b;
    if ((0, _shared.isArray)(a) && (0, _shared.isArray)(b)) return a.concat(b);
    return (0, _shared.extend)({}, normalizePropsOrEmits(a), normalizePropsOrEmits(b));
}
function createPropsRestProxy(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function withAsyncContext(getAwaitable) {
    const ctx = getCurrentInstance();
    let awaitable = getAwaitable();
    unsetCurrentInstance();
    if ((0, _shared.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>setCurrentInstance(ctx)
    ];
}
function createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let shouldCacheAccess = true;
function applyOptions(instance) {
    const options = resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    shouldCacheAccess = false;
    if (options.beforeCreate) callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, // lifecycle
    created, beforeMount, mounted, beforeUpdate, updated, activated, deactivated, beforeDestroy, beforeUnmount, destroyed, unmounted, render, renderTracked, renderTriggered, errorCaptured, serverPrefetch, // public API
    expose, inheritAttrs, // assets
    components, directives, filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, _shared.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, _shared.isObject)(data)) ;
        else instance.data = (0, _reactivity.reactive)(data);
    }
    shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, _shared.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, _shared.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, _shared.NOOP);
        const set = !(0, _shared.isFunction)(opt) && (0, _shared.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, _shared.NOOP);
        const c = computed({
            get,
            set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, _shared.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            provide(key, provides[key]);
        });
    }
    if (created) callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, _shared.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook(onBeforeMount, beforeMount);
    registerLifecycleHook(onMounted, mounted);
    registerLifecycleHook(onBeforeUpdate, beforeUpdate);
    registerLifecycleHook(onUpdated, updated);
    registerLifecycleHook(onActivated, activated);
    registerLifecycleHook(onDeactivated, deactivated);
    registerLifecycleHook(onErrorCaptured, errorCaptured);
    registerLifecycleHook(onRenderTracked, renderTracked);
    registerLifecycleHook(onRenderTriggered, renderTriggered);
    registerLifecycleHook(onBeforeUnmount, beforeUnmount);
    registerLifecycleHook(onUnmounted, unmounted);
    registerLifecycleHook(onServerPrefetch, serverPrefetch);
    if ((0, _shared.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, _shared.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) markAsyncBoundary(instance);
}
function resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, _shared.NOOP)) {
    if ((0, _shared.isArray)(injectOptions)) injectOptions = normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, _shared.isObject)(opt)) {
            if ("default" in opt) injected = inject(opt.from || key, opt.default, true);
            else injected = inject(opt.from || key);
        } else injected = inject(opt);
        if ((0, _reactivity.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function callHook(hook, instance, type) {
    callWithAsyncErrorHandling((0, _shared.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, _shared.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, _shared.isFunction)(handler)) watch(getter, handler);
    } else if ((0, _shared.isFunction)(raw)) watch(getter, raw.bind(publicThis));
    else if ((0, _shared.isObject)(raw)) {
        if ((0, _shared.isArray)(raw)) raw.forEach((r)=>createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, _shared.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, _shared.isFunction)(handler)) watch(getter, handler, raw);
        }
    } else ;
}
function resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>mergeOptions(resolved, m, optionMergeStrategies, true));
        mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, _shared.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function mergeOptions(to, from, strats, asMixin = false) {
    const { mixins, extends: extendsOptions } = from;
    if (extendsOptions) mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const internalOptionMergeStrats = {
    data: mergeDataFn,
    props: mergeEmitsOrPropsOptions,
    emits: mergeEmitsOrPropsOptions,
    // objects
    methods: mergeObjectOptions,
    computed: mergeObjectOptions,
    // lifecycle
    beforeCreate: mergeAsArray,
    created: mergeAsArray,
    beforeMount: mergeAsArray,
    mounted: mergeAsArray,
    beforeUpdate: mergeAsArray,
    updated: mergeAsArray,
    beforeDestroy: mergeAsArray,
    beforeUnmount: mergeAsArray,
    destroyed: mergeAsArray,
    unmounted: mergeAsArray,
    activated: mergeAsArray,
    deactivated: mergeAsArray,
    errorCaptured: mergeAsArray,
    serverPrefetch: mergeAsArray,
    // assets
    components: mergeObjectOptions,
    directives: mergeObjectOptions,
    // watch
    watch: mergeWatchOptions,
    // provide / inject
    provide: mergeDataFn,
    inject: mergeInject
};
function mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, _shared.extend)((0, _shared.isFunction)(to) ? to.call(this, this) : to, (0, _shared.isFunction)(from) ? from.call(this, this) : from);
    };
}
function mergeInject(to, from) {
    return mergeObjectOptions(normalizeInject(to), normalizeInject(from));
}
function normalizeInject(raw) {
    if ((0, _shared.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function mergeObjectOptions(to, from) {
    return to ? (0, _shared.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, _shared.isArray)(to) && (0, _shared.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, _shared.extend)(/* @__PURE__ */ Object.create(null), normalizePropsOrEmits(to), normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, _shared.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = mergeAsArray(to[key], from[key]);
    return merged;
}
function createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, _shared.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let uid$1 = 0;
function createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, _shared.isFunction)(rootComponent)) rootComponent = (0, _shared.extend)({}, rootComponent);
        if (rootProps != null && !(0, _shared.isObject)(rootProps)) rootProps = null;
        const context = createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, _shared.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, _shared.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = app._ceVNode || createVNode(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        devtoolsInitApp(app, version);
                    }
                    return getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount (cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    callWithAsyncErrorHandling(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = currentApp;
                currentApp = app;
                try {
                    return fn();
                } finally{
                    currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let currentApp = null;
function provide(key, value) {
    if (!currentInstance) ;
    else {
        let provides = currentInstance.provides;
        const parentProvides = currentInstance.parent && currentInstance.parent.provides;
        if (parentProvides === provides) provides = currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function inject(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = currentInstance || currentRenderingInstance;
    if (instance || currentApp) {
        const provides = currentApp ? currentApp._context.provides : instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, _shared.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function hasInjectionContext() {
    return !!(currentInstance || currentRenderingInstance || currentApp);
}
const internalObjectProto = {};
const createInternalObject = ()=>Object.create(internalObjectProto);
const isInternalObject = (obj)=>Object.getPrototypeOf(obj) === internalObjectProto;
function initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, _reactivity.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props, attrs, vnode: { patchFlag } } = instance;
    const rawCurrentProps = (0, _reactivity.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if (isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, _shared.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, _shared.camelize)(key);
                        props[camelizedKey] = resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if (setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, _shared.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, _shared.hyphenate)(key)) === key || !(0, _shared.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, _shared.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, _reactivity.trigger)(instance.attrs, "set", "");
}
function setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, _shared.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, _shared.hasOwn)(options, camelKey = (0, _shared.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, _reactivity.toRaw)(props);
        const castValues = rawCastValues || (0, _shared.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, _shared.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, _shared.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, _shared.isFunction)(defaultValue)) {
                const { propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, _shared.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const mixinPropsCache = /* @__PURE__ */ new WeakMap();
function normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, _shared.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = normalizePropsOptions(raw2, appContext, true);
            (0, _shared.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, _shared.isObject)(comp)) cache.set(comp, (0, _shared.EMPTY_ARR));
        return 0, _shared.EMPTY_ARR;
    }
    if ((0, _shared.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, _shared.camelize)(raw[i]);
        if (validatePropName(normalizedKey)) normalized[normalizedKey] = (0, _shared.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, _shared.camelize)(key);
        if (validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, _shared.isArray)(opt) || (0, _shared.isFunction)(opt) ? {
                type: opt
            } : (0, _shared.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, _shared.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, _shared.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, _shared.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, _shared.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, _shared.isObject)(comp)) cache.set(comp, res);
    return res;
}
function validatePropName(key) {
    if (key[0] !== "$" && !(0, _shared.isReservedProp)(key)) return true;
    return false;
}
function getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function validateProps(rawProps, props, instance) {
    const resolvedValues = (0, _reactivity.toRaw)(props);
    const options = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key)=>(0, _shared.camelize)(key));
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        validateProp(key, resolvedValues[key], opt, resolvedValues, !camelizePropsKey.includes(key));
    }
}
function validateProp(name, value, prop, props, isAbsent) {
    const { type, required, validator, skipCheck } = prop;
    if (required && isAbsent) {
        warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, _shared.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid, expectedType } = assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            warn$1(getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const isSimpleType = /* @__PURE__ */ (0, _shared.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function assertType(value, type) {
    let valid;
    const expectedType = getType(type);
    if (expectedType === "null") valid = value === null;
    else if (isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, _shared.isObject)(value);
    else if (expectedType === "Array") valid = (0, _shared.isArray)(value);
    else valid = value instanceof type;
    return {
        valid,
        expectedType
    };
}
function getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, _shared.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, _shared.toRawType)(value);
    const expectedValue = styleValue(value, expectedType);
    const receivedValue = styleValue(value, receivedType);
    if (expectedTypes.length === 1 && isExplicable(expectedType) && !isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if (isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const normalizeSlotValue = (value)=>(0, _shared.isArray)(value) ? value.map(normalizeVNode) : [
        normalizeVNode(value)
    ];
const normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = withCtx((...args)=>{
        return normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if (isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, _shared.isFunction)(value)) slots[key] = normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const normalizeVNodeSlots = (instance, children)=>{
    const normalized = normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || key !== "_") slots[key] = children[key];
};
const initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            assignSlots(slots, children, optimized);
            if (optimized) (0, _shared.def)(slots, "_", type, true);
        } else normalizeObjectSlots(children, slots);
    } else if (children) normalizeVNodeSlots(instance, children);
};
const updateSlots = (instance, children, optimized)=>{
    const { vnode, slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, _shared.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
let supported;
let perf;
function startMeasure(instance, type) {
    if (instance.appContext.config.performance && isSupported()) perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) devtoolsPerfStart(instance, type, isSupported() ? perf.now() : Date.now());
}
function endMeasure(instance, type) {
    if (instance.appContext.config.performance && isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        perf.mark(endTag);
        perf.measure(`<${formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        perf.clearMarks(startTag);
        perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) devtoolsPerfEnd(instance, type, isSupported() ? perf.now() : Date.now());
}
function isSupported() {
    if (supported !== void 0) return supported;
    if (typeof window !== "undefined" && window.performance) {
        supported = true;
        perf = window.performance;
    } else supported = false;
    return supported;
}
function initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, _shared.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, _shared.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, _shared.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const queuePostRenderEffect = queueEffectWithSuspense;
function createRenderer(options) {
    return baseCreateRenderer(options);
}
function createHydrationRenderer(options) {
    return baseCreateRenderer(options, createHydrationFunctions);
}
function baseCreateRenderer(options, createHydrationFns) {
    initFeatureFlags();
    const target = (0, _shared.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, _shared.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type, ref, shapeFlag } = n2;
        switch(type){
            case Text:
                processText(n1, n2, container, anchor);
                break;
            case Comment:
                processCommentNode(n1, n2, container, anchor);
                break;
            case Static:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case Fragment:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el, anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el, anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props, shapeFlag, transition, dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, _shared.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, _shared.def)(el, "__vnode", vnode, true);
            (0, _shared.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) queuePostRenderEffect(()=>{
            vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree || isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? cloneIfMounted(children[i]) : normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag, dynamicChildren, dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, _shared.EMPTY_OBJ);
        const newProps = n2.props || (0, _shared.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && toggleRecurse(parentComponent, true);
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) queuePostRenderEffect(()=>{
            vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === Fragment || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, _shared.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, _shared.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, _shared.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag, dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if (isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = createVNode(Comment);
                processCommentNode(null, placeholder, container, anchor);
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if (shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el, props } = initialVNode;
                const { bm, m, parent, root, type } = instance;
                const isAsyncWrapperVNode = isAsyncWrapper(initialVNode);
                toggleRecurse(instance, false);
                if (bm) (0, _shared.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) invokeVNodeHook(vnodeHook, parent, initialVNode);
                toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce) root.ce._injectChildStyle(type);
                    const subTree = instance.subTree = renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    queuePostRenderEffect(()=>invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next, bu, u, parent, vnode } = instance;
                {
                    const nonHydratedAsyncRoot = locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, _shared.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) invokeVNodeHook(vnodeHook, parent, next, vnode);
                toggleRecurse(instance, true);
                const nextTree = renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) updateHOCHostEl(instance, nextTree.el);
                if (u) queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) queuePostRenderEffect(()=>invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        const effect = instance.effect = new (0, _reactivity.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        const update = instance.update = effect.run.bind(effect);
        const job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = ()=>queueJob(job);
        toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        updateProps(instance, nextVNode.props, prevProps, optimized);
        updateSlots(instance, nextVNode.children, optimized);
        (0, _reactivity.pauseTracking)();
        flushPreFlushCbs(instance);
        (0, _reactivity.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag, shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, _shared.EMPTY_ARR);
        c2 = c2 || (0, _shared.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
            if (isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? cloneIfMounted(c2[e2]) : normalizeVNode(c2[e2]);
            if (isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? getSequence(newIndexToOldIndexMap) : (0, _shared.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el, type, transition, children, shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === Fragment) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === Static) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave, delayLeave, afterLeave } = transition;
                const remove2 = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type, props, ref, children, dynamicChildren, shapeFlag, patchFlag, dirs, cacheIndex } = vnode;
        if (patchFlag === -2) optimized = false;
        if (ref != null) setRef(ref, null, parentSuspense, vnode, true);
        if (cacheIndex != null) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== Fragment || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === Fragment && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) queuePostRenderEffect(()=>{
            vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type, el, anchor, transition } = vnode;
        if (type === Fragment) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === Static) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave, delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum, scope, job, subTree, um, m, a } = instance;
        invalidateMount(m);
        invalidateMount(a);
        if (bum) (0, _shared.invokeArrayFns)(bum);
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) queuePostRenderEffect(um, parentSuspense);
        queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        if (!isFlushing) {
            isFlushing = true;
            flushPreFlushCbs();
            flushPostFlushCbs();
            isFlushing = false;
        }
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render,
        hydrate,
        createApp: createAppAPI(render, hydrate)
    };
}
function resolveChildrenNamespace({ type, props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function toggleRecurse({ effect, job }, allowed) {
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, _shared.isArray)(ch1) && (0, _shared.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) traverseStaticChildren(c1, c2);
        }
        if (c2.type === Text) c2.el = c1.el;
    }
}
function getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return locateNonHydratedAsyncRoot(subComponent);
    }
}
function invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
const ssrContextKey = Symbol.for("v-scx");
const useSSRContext = ()=>{
    {
        const ctx = inject(ssrContextKey);
        ctx;
        return ctx;
    }
};
function watchEffect(effect, options) {
    return doWatch(effect, null, options);
}
function watchPostEffect(effect, options) {
    return doWatch(effect, null, {
        flush: "post"
    });
}
function watchSyncEffect(effect, options) {
    return doWatch(effect, null, {
        flush: "sync"
    });
}
function watch(source, cb, options) {
    return doWatch(source, cb, options);
}
function doWatch(source, cb, options = (0, _shared.EMPTY_OBJ)) {
    const { immediate, deep, flush, once } = options;
    const baseWatchOptions = (0, _shared.extend)({}, options);
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if (isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = useSSRContext();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            const watchStopHandle = ()=>{};
            watchStopHandle.stop = (0, _shared.NOOP);
            watchStopHandle.resume = (0, _shared.NOOP);
            watchStopHandle.pause = (0, _shared.NOOP);
            return watchStopHandle;
        }
    }
    const instance = currentInstance;
    baseWatchOptions.call = (fn, type, args)=>callWithAsyncErrorHandling(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = (job)=>{
        queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = (job, isFirstRun)=>{
            if (isFirstRun) job();
            else queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = (job)=>{
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    const watchHandle = (0, _reactivity.watch)(source, cb, baseWatchOptions);
    if (isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, _shared.isString)(source) ? source.includes(".") ? createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, _shared.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = setCurrentInstance(this);
    const res = doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function useModel(props, name, options = (0, _shared.EMPTY_OBJ)) {
    const i = getCurrentInstance();
    const camelizedName = (0, _shared.camelize)(name);
    const hyphenatedName = (0, _shared.hyphenate)(name);
    const modifiers = getModelModifiers(props, camelizedName);
    const res = (0, _reactivity.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, _shared.EMPTY_OBJ);
        let prevEmittedValue;
        watchSyncEffect(()=>{
            const propValue = props[camelizedName];
            if ((0, _shared.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, _shared.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps))) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, _shared.hasChanged)(value, emittedValue) && (0, _shared.hasChanged)(value, prevSetValue) && !(0, _shared.hasChanged)(emittedValue, prevEmittedValue)) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, _shared.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, _shared.camelize)(modelName)}Modifiers`] || props[`${(0, _shared.hyphenate)(modelName)}Modifiers`];
};
function emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, _shared.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, _shared.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = rawArgs.map((0, _shared.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, _shared.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, _shared.toHandlerKey)((0, _shared.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, _shared.toHandlerKey)((0, _shared.hyphenate)(event))];
    if (handler) callWithAsyncErrorHandling(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        callWithAsyncErrorHandling(onceHandler, instance, 6, args);
    }
}
function normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, _shared.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, _shared.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, _shared.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, _shared.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, _shared.extend)(normalized, raw);
    if ((0, _shared.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function isEmitListener(options, key) {
    if (!options || !(0, _shared.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, _shared.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, _shared.hasOwn)(options, (0, _shared.hyphenate)(key)) || (0, _shared.hasOwn)(options, key);
}
let accessedAttrs = false;
function markAttrsAccessed() {
    accessedAttrs = true;
}
function renderComponentRoot(instance) {
    const { type: Component, vnode, proxy, withProxy, propsOptions: [propsOptions], slots, attrs, emit, render, renderCache, props, data, setupState, ctx, inheritAttrs } = instance;
    const prev = setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = normalizeVNode(render2.length > 1 ? render2(props, {
                attrs,
                slots,
                emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        blockStack.length = 0;
        handleError(err, instance, 1);
        result = createVNode(Comment);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, _shared.isModelListener))) fallthroughAttrs = filterModelListeners(fallthroughAttrs, propsOptions);
                root = cloneVNode(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = cloneVNode(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) setTransitionHooks(root, vnode.transition);
    result = root;
    setCurrentRenderingInstance(prev);
    return result;
}
const getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        normalizeVNode(childRoot),
        setRoot
    ];
};
function filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if (isVNode(child)) {
            if (child.type !== Comment || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, _shared.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, _shared.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === Comment;
};
function shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function updateHOCHostEl({ vnode, parent }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
const isSuspense = (type)=>type.__isSuspense;
let suspenseId = 0;
const SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: hydrateSuspense,
    normalize: normalizeSuspenseChildren
};
const Suspense = SuspenseImpl;
function triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, _shared.isFunction)(eventListener)) eventListener();
}
function mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        triggerEvent(vnode, "onPending");
        triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch, pendingBranch, isInFallback, isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if (isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        setActiveBranch(suspense, newBranch);
    } else {
        triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout, pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let hasWarned = false;
function createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode, remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, _shared.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode,
        parent: parentSuspense,
        parentComponent,
        namespace,
        container,
        hiddenContainer,
        deps: 0,
        pendingId: suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch, pendingBranch, pendingId, effects, parentComponent: parentComponent2, container: container2 } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        queuePostFlushCb(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) === container2) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) queuePostFlushCb(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect, optimized2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                handleError(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) remove(placeholder);
                updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function normalizeSuspenseChildren(vnode) {
    const { shapeFlag, children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? normalizeSuspenseSlot(children.fallback) : createVNode(Comment);
}
function normalizeSuspenseSlot(s) {
    let block;
    if ((0, _shared.isFunction)(s)) {
        const trackBlock = isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            openBlock();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = currentBlock;
            closeBlock();
        }
    }
    if ((0, _shared.isArray)(s)) {
        const singleChild = filterSingleRoot(s);
        s = singleChild;
    }
    s = normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, _shared.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else queuePostFlushCb(fn);
}
function setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode, parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        updateHOCHostEl(parentComponent, el);
    }
}
function isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const Fragment = Symbol.for("v-fgt");
const Text = Symbol.for("v-txt");
const Comment = Symbol.for("v-cmt");
const Static = Symbol.for("v-stc");
const blockStack = [];
let currentBlock = null;
function openBlock(disableTracking = false) {
    blockStack.push(currentBlock = disableTracking ? null : []);
}
function closeBlock() {
    blockStack.pop();
    currentBlock = blockStack[blockStack.length - 1] || null;
}
let isBlockTreeEnabled = 1;
function setBlockTracking(value, inVOnce = false) {
    isBlockTreeEnabled += value;
    if (value < 0 && currentBlock && inVOnce) currentBlock.hasOnce = true;
}
function setupBlock(vnode) {
    vnode.dynamicChildren = isBlockTreeEnabled > 0 ? currentBlock || (0, _shared.EMPTY_ARR) : null;
    closeBlock();
    if (isBlockTreeEnabled > 0 && currentBlock) currentBlock.push(vnode);
    return vnode;
}
function createElementBlock(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return setupBlock(createBaseVNode(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function createBlock(type, props, children, patchFlag, dynamicProps) {
    return setupBlock(createVNode(type, props, children, patchFlag, dynamicProps, true));
}
function isVNode(value) {
    return value ? value.__v_isVNode === true : false;
}
function isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let vnodeArgsTransformer;
function transformVNodeArgs(transformer) {
    vnodeArgsTransformer = transformer;
}
const createVNodeWithArgsTransform = (...args)=>{
    return _createVNode(...vnodeArgsTransformer ? vnodeArgsTransformer(args, currentRenderingInstance) : args);
};
const normalizeKey = ({ key })=>key != null ? key : null;
const normalizeRef = ({ ref, ref_key, ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, _shared.isString)(ref) || (0, _reactivity.isRef)(ref) || (0, _shared.isFunction)(ref) ? {
        i: currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function createBaseVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === Fragment ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type,
        props,
        key: props && normalizeKey(props),
        ref: props && normalizeRef(props),
        scopeId: currentScopeId,
        slotScopeIds: null,
        children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag,
        patchFlag,
        dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, _shared.isString)(children) ? 8 : 16;
    if (isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) currentBlock.push(vnode);
    return vnode;
}
const createVNode = _createVNode;
function _createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === NULL_DYNAMIC_COMPONENT) type = Comment;
    if (isVNode(type)) {
        const cloned = cloneVNode(type, props, true);
        if (children) normalizeChildren(cloned, children);
        if (isBlockTreeEnabled > 0 && !isBlockNode && currentBlock) {
            if (cloned.shapeFlag & 6) currentBlock[currentBlock.indexOf(type)] = cloned;
            else currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if (isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = guardReactiveProps(props);
        let { class: klass, style } = props;
        if (klass && !(0, _shared.isString)(klass)) props.class = (0, _shared.normalizeClass)(klass);
        if ((0, _shared.isObject)(style)) {
            if ((0, _reactivity.isProxy)(style) && !(0, _shared.isArray)(style)) style = (0, _shared.extend)({}, style);
            props.style = (0, _shared.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, _shared.isString)(type) ? 1 : isSuspense(type) ? 128 : isTeleport(type) ? 64 : (0, _shared.isObject)(type) ? 4 : (0, _shared.isFunction)(type) ? 2 : 0;
    return createBaseVNode(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function guardReactiveProps(props) {
    if (!props) return null;
    return (0, _reactivity.isProxy)(props) || isInternalObject(props) ? (0, _shared.extend)({}, props) : props;
}
function cloneVNode(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props, ref, patchFlag, children, transition } = vnode;
    const mergedProps = extraProps ? mergeProps(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, _shared.isArray)(ref) ? ref.concat(normalizeRef(extraProps)) : [
            ref,
            normalizeRef(extraProps)
        ] : normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== Fragment ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && cloneVNode(vnode.ssContent),
        ssFallback: vnode.ssFallback && cloneVNode(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) setTransitionHooks(cloned, transition.clone(cloned));
    return cloned;
}
function deepCloneVNode(vnode) {
    const cloned = cloneVNode(vnode);
    if ((0, _shared.isArray)(vnode.children)) cloned.children = vnode.children.map(deepCloneVNode);
    return cloned;
}
function createTextVNode(text = " ", flag = 0) {
    return createVNode(Text, null, text, flag);
}
function createStaticVNode(content, numberOfNodes) {
    const vnode = createVNode(Static, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function createCommentVNode(text = "", asBlock = false) {
    return asBlock ? (openBlock(), createBlock(Comment, null, text)) : createVNode(Comment, null, text);
}
function normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return createVNode(Comment);
    else if ((0, _shared.isArray)(child)) return createVNode(Fragment, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (isVNode(child)) return cloneIfMounted(child);
    else return createVNode(Text, null, String(child));
}
function cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : cloneVNode(child);
}
function normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, _shared.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !isInternalObject(children)) children._ctx = currentRenderingInstance;
            else if (slotFlag === 3 && currentRenderingInstance) {
                if (currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, _shared.isFunction)(children)) {
        children = {
            default: children,
            _ctx: currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                createTextVNode(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function mergeProps(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, _shared.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, _shared.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, _shared.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, _shared.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    callWithAsyncErrorHandling(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const emptyAppContext = createAppContext();
let uid = 0;
function createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || emptyAppContext;
    const instance = {
        uid: uid++,
        vnode,
        type,
        parent,
        appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, _reactivity.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: normalizePropsOptions(type, appContext),
        emitsOptions: normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, _shared.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, _shared.EMPTY_OBJ),
        data: (0, _shared.EMPTY_OBJ),
        props: (0, _shared.EMPTY_OBJ),
        attrs: (0, _shared.EMPTY_OBJ),
        slots: (0, _shared.EMPTY_OBJ),
        refs: (0, _shared.EMPTY_OBJ),
        setupState: (0, _shared.EMPTY_OBJ),
        setupContext: null,
        // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let currentInstance = null;
const getCurrentInstance = ()=>currentInstance || currentRenderingInstance;
let internalSetCurrentInstance;
let setInSSRSetupState;
{
    const g = (0, _shared.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>currentInstance = v1);
    setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>isInSSRComponentSetup = v1);
}const setCurrentInstance = (instance)=>{
    const prev = currentInstance;
    internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        internalSetCurrentInstance(prev);
    };
};
const unsetCurrentInstance = ()=>{
    currentInstance && currentInstance.scope.off();
    internalSetCurrentInstance(null);
};
const isBuiltInTag = /* @__PURE__ */ (0, _shared.makeMap)("slot,component");
function validateComponentName(name, { isNativeTag }) {
    if (isBuiltInTag(name) || isNativeTag(name)) warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let isInSSRComponentSetup = false;
function setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && setInSSRSetupState(isSSR);
    const { props, children } = instance.vnode;
    const isStateful = isStatefulComponent(instance);
    initProps(instance, props, isStateful, isSSR);
    initSlots(instance, children, optimized);
    const setupResult = isStateful ? setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && setInSSRSetupState(false);
    return setupResult;
}
function setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, PublicInstanceProxyHandlers);
    const { setup } = Component;
    if (setup) {
        (0, _reactivity.pauseTracking)();
        const setupContext = instance.setupContext = setup.length > 1 ? createSetupContext(instance) : null;
        const reset = setCurrentInstance(instance);
        const setupResult = callWithErrorHandling(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        const isAsyncSetup = (0, _shared.isPromise)(setupResult);
        (0, _reactivity.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !isAsyncWrapper(instance)) markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then(unsetCurrentInstance, unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                handleError(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else handleSetupResult(instance, setupResult, isSSR);
    } else finishComponentSetup(instance, isSSR);
}
function handleSetupResult(instance, setupResult, isSSR) {
    if ((0, _shared.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, _shared.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, _reactivity.proxyRefs)(setupResult);
    }
    finishComponentSetup(instance, isSSR);
}
let compile;
let installWithProxy;
function registerRuntimeCompiler(_compile) {
    compile = _compile;
    installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const isRuntimeOnly = ()=>!compile;
function finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && compile && !Component.render) {
            const template = Component.template || __VUE_OPTIONS_API__ && resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement, compilerOptions } = instance.appContext.config;
                const { delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, _shared.extend)((0, _shared.extend)({
                    isCustomElement,
                    delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, _shared.NOOP);
        if (installWithProxy) installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = setCurrentInstance(instance);
        (0, _reactivity.pauseTracking)();
        try {
            applyOptions(instance);
        } finally{
            (0, _reactivity.resetTracking)();
            reset();
        }
    }
}
const attrsProxyHandlers = {
    get (target, key) {
        (0, _reactivity.track)(target, "get", "");
        return target[key];
    }
};
function getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, _reactivity.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose
    };
}
function getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, _reactivity.proxyRefs)((0, _reactivity.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in publicPropertiesMap) return publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const classifyRE = /(?:^|[-_])(\w)/g;
const classify = (str)=>str.replace(classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function getComponentName(Component, includeInferred = true) {
    return (0, _shared.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function formatComponentName(instance, Component, isRoot = false) {
    let name = getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? classify(name) : isRoot ? `App` : `Anonymous`;
}
function isClassComponent(value) {
    return (0, _shared.isFunction)(value) && "__vccOpts" in value;
}
const computed = (getterOrOptions, debugOptions)=>{
    const c = (0, _reactivity.computed)(getterOrOptions, debugOptions, isInSSRComponentSetup);
    return c;
};
function h(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, _shared.isObject)(propsOrChildren) && !(0, _shared.isArray)(propsOrChildren)) {
            if (isVNode(propsOrChildren)) return createVNode(type, null, [
                propsOrChildren
            ]);
            return createVNode(type, propsOrChildren);
        } else return createVNode(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && isVNode(children)) children = [
            children
        ];
        return createVNode(type, propsOrChildren, children);
    }
}
function initCustomFormatter() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, _reactivity.toRaw)(instance.props)));
        if (instance.setupState !== (0, _shared.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, _shared.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, _reactivity.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, _shared.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, _shared.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, _reactivity.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, _shared.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, _shared.isArray)(opts) && opts.includes(key) || (0, _shared.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, _reactivity.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function withMemo(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && isMemoSame(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function isMemoSame(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, _shared.hasChanged)(prev[i], memo[i])) return false;
    }
    if (isBlockTreeEnabled > 0 && currentBlock) currentBlock.push(cached);
    return true;
}
const version = "3.5.13";
const warn = (0, _shared.NOOP);
const ErrorTypeStrings = ErrorTypeStrings$1;
const devtools = devtools$1;
const setDevtoolsHook = setDevtoolsHook$1;
const _ssrUtils = {
    createComponentInstance,
    setupComponent,
    renderComponentRoot,
    setCurrentRenderingInstance,
    isVNode: isVNode,
    normalizeVNode,
    getComponentPublicInstance,
    ensureValidVNode,
    pushWarningContext,
    popWarningContext
};
const ssrUtils = _ssrUtils;
const resolveFilter = null;
const compatUtils = null;
const DeprecationTypes = null;

},{"@vue/reactivity":"iDupO","@vue/shared":"gx1ZY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iDupO":[function(require,module,exports,__globalThis) {
/**
* @vue/reactivity v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ARRAY_ITERATE_KEY", ()=>ARRAY_ITERATE_KEY);
parcelHelpers.export(exports, "EffectFlags", ()=>EffectFlags);
parcelHelpers.export(exports, "EffectScope", ()=>EffectScope);
parcelHelpers.export(exports, "ITERATE_KEY", ()=>ITERATE_KEY);
parcelHelpers.export(exports, "MAP_KEY_ITERATE_KEY", ()=>MAP_KEY_ITERATE_KEY);
parcelHelpers.export(exports, "ReactiveEffect", ()=>ReactiveEffect);
parcelHelpers.export(exports, "ReactiveFlags", ()=>ReactiveFlags);
parcelHelpers.export(exports, "TrackOpTypes", ()=>TrackOpTypes);
parcelHelpers.export(exports, "TriggerOpTypes", ()=>TriggerOpTypes);
parcelHelpers.export(exports, "WatchErrorCodes", ()=>WatchErrorCodes);
parcelHelpers.export(exports, "computed", ()=>computed);
parcelHelpers.export(exports, "customRef", ()=>customRef);
parcelHelpers.export(exports, "effect", ()=>effect);
parcelHelpers.export(exports, "effectScope", ()=>effectScope);
parcelHelpers.export(exports, "enableTracking", ()=>enableTracking);
parcelHelpers.export(exports, "getCurrentScope", ()=>getCurrentScope);
parcelHelpers.export(exports, "getCurrentWatcher", ()=>getCurrentWatcher);
parcelHelpers.export(exports, "isProxy", ()=>isProxy);
parcelHelpers.export(exports, "isReactive", ()=>isReactive);
parcelHelpers.export(exports, "isReadonly", ()=>isReadonly);
parcelHelpers.export(exports, "isRef", ()=>isRef);
parcelHelpers.export(exports, "isShallow", ()=>isShallow);
parcelHelpers.export(exports, "markRaw", ()=>markRaw);
parcelHelpers.export(exports, "onEffectCleanup", ()=>onEffectCleanup);
parcelHelpers.export(exports, "onScopeDispose", ()=>onScopeDispose);
parcelHelpers.export(exports, "onWatcherCleanup", ()=>onWatcherCleanup);
parcelHelpers.export(exports, "pauseTracking", ()=>pauseTracking);
parcelHelpers.export(exports, "proxyRefs", ()=>proxyRefs);
parcelHelpers.export(exports, "reactive", ()=>reactive);
parcelHelpers.export(exports, "reactiveReadArray", ()=>reactiveReadArray);
parcelHelpers.export(exports, "readonly", ()=>readonly);
parcelHelpers.export(exports, "ref", ()=>ref);
parcelHelpers.export(exports, "resetTracking", ()=>resetTracking);
parcelHelpers.export(exports, "shallowReactive", ()=>shallowReactive);
parcelHelpers.export(exports, "shallowReadArray", ()=>shallowReadArray);
parcelHelpers.export(exports, "shallowReadonly", ()=>shallowReadonly);
parcelHelpers.export(exports, "shallowRef", ()=>shallowRef);
parcelHelpers.export(exports, "stop", ()=>stop);
parcelHelpers.export(exports, "toRaw", ()=>toRaw);
parcelHelpers.export(exports, "toReactive", ()=>toReactive);
parcelHelpers.export(exports, "toReadonly", ()=>toReadonly);
parcelHelpers.export(exports, "toRef", ()=>toRef);
parcelHelpers.export(exports, "toRefs", ()=>toRefs);
parcelHelpers.export(exports, "toValue", ()=>toValue);
parcelHelpers.export(exports, "track", ()=>track);
parcelHelpers.export(exports, "traverse", ()=>traverse);
parcelHelpers.export(exports, "trigger", ()=>trigger);
parcelHelpers.export(exports, "triggerRef", ()=>triggerRef);
parcelHelpers.export(exports, "unref", ()=>unref);
parcelHelpers.export(exports, "watch", ()=>watch);
var _shared = require("@vue/shared");
function warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let activeEffectScope;
class EffectScope {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this.parent = activeEffectScope;
        if (!detached && activeEffectScope) this.index = (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            this._isPaused = true;
            let i, l;
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].pause();
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
        }
    }
    /**
   * Resumes the effect scope, including all child scopes and effects.
   */ resume() {
        if (this._active) {
            if (this._isPaused) {
                this._isPaused = false;
                let i, l;
                if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].resume();
                for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].resume();
            }
        }
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = activeEffectScope;
            try {
                activeEffectScope = this;
                return fn();
            } finally{
                activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        activeEffectScope = this;
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this._active) {
            this._active = false;
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            this.effects.length = 0;
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            this.cleanups.length = 0;
            if (this.scopes) {
                for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
                this.scopes.length = 0;
            }
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
        }
    }
}
function effectScope(detached) {
    return new EffectScope(detached);
}
function getCurrentScope() {
    return activeEffectScope;
}
function onScopeDispose(fn, failSilently = false) {
    if (activeEffectScope) activeEffectScope.cleanups.push(fn);
}
let activeSub;
const EffectFlags = {
    "ACTIVE": 1,
    "1": "ACTIVE",
    "RUNNING": 2,
    "2": "RUNNING",
    "TRACKING": 4,
    "4": "TRACKING",
    "NOTIFIED": 8,
    "8": "NOTIFIED",
    "DIRTY": 16,
    "16": "DIRTY",
    "ALLOW_RECURSE": 32,
    "32": "ALLOW_RECURSE",
    "PAUSED": 64,
    "64": "PAUSED"
};
const pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class ReactiveEffect {
    constructor(fn){
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if (activeEffectScope && activeEffectScope.active) activeEffectScope.effects.push(this);
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if (pausedQueueEffects.has(this)) {
                pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        cleanupEffect(this);
        prepareDeps(this);
        const prevEffect = activeSub;
        const prevShouldTrack = shouldTrack;
        activeSub = this;
        shouldTrack = true;
        try {
            return this.fn();
        } finally{
            cleanupDeps(this);
            activeSub = prevEffect;
            shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)removeSub(link);
            this.deps = this.depsTail = void 0;
            cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if (isDirty(this)) this.run();
    }
    get dirty() {
        return isDirty(this);
    }
}
let batchDepth = 0;
let batchedSub;
let batchedComputed;
function batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = batchedComputed;
        batchedComputed = sub;
        return;
    }
    sub.next = batchedSub;
    batchedSub = sub;
}
function startBatch() {
    batchDepth++;
}
function endBatch() {
    if (--batchDepth > 0) return;
    if (batchedComputed) {
        let e = batchedComputed;
        batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error;
    while(batchedSub){
        let e = batchedSub;
        batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e = next;
        }
    }
    if (error) throw error;
}
function prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            removeSub(link);
            removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && (refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === globalVersion) return;
    computed.globalVersion = globalVersion;
    const dep = computed.dep;
    computed.flags |= 2;
    if (dep.version > 0 && !computed.isSSR && computed.deps && !isDirty(computed)) {
        computed.flags &= -3;
        return;
    }
    const prevSub = activeSub;
    const prevShouldTrack = shouldTrack;
    activeSub = computed;
    shouldTrack = true;
    try {
        prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || (0, _shared.hasChanged)(value, computed._value)) {
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        activeSub = prevSub;
        shouldTrack = prevShouldTrack;
        cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function removeSub(link, soft = false) {
    const { dep, prevSub, nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function removeDep(link) {
    const { prevDep, nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function effect(fn, options) {
    if (fn.effect instanceof ReactiveEffect) fn = fn.effect.fn;
    const e = new ReactiveEffect(fn);
    if (options) (0, _shared.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function stop(runner) {
    runner.effect.stop();
}
let shouldTrack = true;
const trackStack = [];
function pauseTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = false;
}
function enableTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = true;
}
function resetTracking() {
    const last = trackStack.pop();
    shouldTrack = last === void 0 ? true : last;
}
function onEffectCleanup(fn, failSilently = false) {
    if (activeSub instanceof ReactiveEffect) activeSub.cleanup = fn;
}
function cleanupEffect(e) {
    const { cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = activeSub;
        activeSub = void 0;
        try {
            cleanup();
        } finally{
            activeSub = prevSub;
        }
    }
}
let globalVersion = 0;
class Link {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class Dep {
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
    }
    track(debugInfo) {
        if (!activeSub || !shouldTrack || activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== activeSub) {
            link = this.activeLink = new Link(activeSub, this);
            if (!activeSub.deps) activeSub.deps = activeSub.depsTail = link;
            else {
                link.prevDep = activeSub.depsTail;
                activeSub.depsTail.nextDep = link;
                activeSub.depsTail = link;
            }
            addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = activeSub.depsTail;
                link.nextDep = void 0;
                activeSub.depsTail.nextDep = link;
                activeSub.depsTail = link;
                if (activeSub.deps === link) activeSub.deps = next;
            }
        }
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        startBatch();
        try {
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            endBatch();
        }
    }
}
function addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        link.dep.subs = link;
    }
}
const targetMap = /* @__PURE__ */ new WeakMap();
const ITERATE_KEY = Symbol("");
const MAP_KEY_ITERATE_KEY = Symbol("");
const ARRAY_ITERATE_KEY = Symbol("");
function track(target, type, key) {
    if (shouldTrack && activeSub) {
        let depsMap = targetMap.get(target);
        if (!depsMap) targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track();
    }
}
function trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = targetMap.get(target);
    if (!depsMap) {
        globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger();
    };
    startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, _shared.isArray)(target);
        const isArrayIndex = targetIsArray && (0, _shared.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === ARRAY_ITERATE_KEY || !(0, _shared.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get(ARRAY_ITERATE_KEY));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get(ITERATE_KEY));
                        if ((0, _shared.isMap)(target)) run(depsMap.get(MAP_KEY_ITERATE_KEY));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get(ITERATE_KEY));
                        if ((0, _shared.isMap)(target)) run(depsMap.get(MAP_KEY_ITERATE_KEY));
                    }
                    break;
                case "set":
                    if ((0, _shared.isMap)(target)) run(depsMap.get(ITERATE_KEY));
                    break;
            }
        }
    }
    endBatch();
}
function getDepFromReactive(object, key) {
    const depMap = targetMap.get(object);
    return depMap && depMap.get(key);
}
function reactiveReadArray(array) {
    const raw = toRaw(array);
    if (raw === array) return raw;
    track(raw, "iterate", ARRAY_ITERATE_KEY);
    return isShallow(array) ? raw : raw.map(toReactive);
}
function shallowReadArray(arr) {
    track(arr = toRaw(arr), "iterate", ARRAY_ITERATE_KEY);
    return arr;
}
const arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return iterator(this, Symbol.iterator, toReactive);
    },
    concat (...args) {
        return reactiveReadArray(this).concat(...args.map((x)=>(0, _shared.isArray)(x) ? reactiveReadArray(x) : x));
    },
    entries () {
        return iterator(this, "entries", (value)=>{
            value[1] = toReactive(value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return apply(this, "filter", fn, thisArg, (v)=>v.map(toReactive), arguments);
    },
    find (fn, thisArg) {
        return apply(this, "find", fn, thisArg, toReactive, arguments);
    },
    findIndex (fn, thisArg) {
        return apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return apply(this, "findLast", fn, thisArg, toReactive, arguments);
    },
    findLastIndex (fn, thisArg) {
        return apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return reactiveReadArray(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimisation required
    lastIndexOf (...args) {
        return searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return noTracking(this, "pop");
    },
    push (...args) {
        return noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return noTracking(this, "splice", args);
    },
    toReversed () {
        return reactiveReadArray(this).toReversed();
    },
    toSorted (comparer) {
        return reactiveReadArray(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return reactiveReadArray(this).toSpliced(...args);
    },
    unshift (...args) {
        return noTracking(this, "unshift", args);
    },
    values () {
        return iterator(this, "values", toReactive);
    }
};
function iterator(self, method, wrapValue) {
    const arr = shallowReadArray(self);
    const iter = arr[method]();
    if (arr !== self && !isShallow(self)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (result.value) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
const arrayProto = Array.prototype;
function apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = shallowReadArray(self);
    const needsWrap = arr !== self && !isShallow(self);
    const methodFn = arr[method];
    if (methodFn !== arrayProto[method]) {
        const result2 = methodFn.apply(self, args);
        return needsWrap ? toReactive(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, toReactive(item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function reduce(self, method, fn, args) {
    const arr = shallowReadArray(self);
    let wrappedFn = fn;
    if (arr !== self) {
        if (!isShallow(self)) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, toReactive(item), index, self);
        };
        else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    return arr[method](wrappedFn, ...args);
}
function searchProxy(self, method, args) {
    const arr = toRaw(self);
    track(arr, "iterate", ARRAY_ITERATE_KEY);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && isProxy(args[0])) {
        args[0] = toRaw(args[0]);
        return arr[method](...args);
    }
    return res;
}
function noTracking(self, method, args = []) {
    pauseTracking();
    startBatch();
    const res = toRaw(self)[method].apply(self, args);
    endBatch();
    resetTracking();
    return res;
}
const isNonTrackableKeys = /* @__PURE__ */ (0, _shared.makeMap)(`__proto__,__v_isRef,__isVue`);
const builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, _shared.isSymbol)));
function hasOwnProperty(key) {
    if (!(0, _shared.isSymbol)(key)) key = String(key);
    const obj = toRaw(this);
    track(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? shallowReadonlyMap : readonlyMap : isShallow2 ? shallowReactiveMap : reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, _shared.isArray)(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return hasOwnProperty;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        isRef(target) ? target : receiver);
        if ((0, _shared.isSymbol)(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) return res;
        if (!isReadonly2) track(target, "get", key);
        if (isShallow2) return res;
        if (isRef(res)) return targetIsArray && (0, _shared.isIntegerKey)(key) ? res : res.value;
        if ((0, _shared.isObject)(res)) return isReadonly2 ? readonly(res) : reactive(res);
        return res;
    }
}
class MutableReactiveHandler extends BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        if (!this._isShallow) {
            const isOldValueReadonly = isReadonly(oldValue);
            if (!isShallow(value) && !isReadonly(value)) {
                oldValue = toRaw(oldValue);
                value = toRaw(value);
            }
            if (!(0, _shared.isArray)(target) && isRef(oldValue) && !isRef(value)) {
                if (isOldValueReadonly) return false;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = (0, _shared.isArray)(target) && (0, _shared.isIntegerKey)(key) ? Number(key) < target.length : (0, _shared.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, isRef(target) ? target : receiver);
        if (target === toRaw(receiver)) {
            if (!hadKey) trigger(target, "add", key, value);
            else if ((0, _shared.hasChanged)(value, oldValue)) trigger(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, _shared.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) trigger(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, _shared.isSymbol)(key) || !builtInSymbols.has(key)) track(target, "has", key);
        return result;
    }
    ownKeys(target) {
        track(target, "iterate", (0, _shared.isArray)(target) ? "length" : ITERATE_KEY);
        return Reflect.ownKeys(target);
    }
}
class ReadonlyReactiveHandler extends BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const mutableHandlers = /* @__PURE__ */ new MutableReactiveHandler();
const readonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler();
const shallowReactiveHandlers = /* @__PURE__ */ new MutableReactiveHandler(true);
const shallowReadonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler(true);
const toShallow = (value)=>value;
const getProto = (v)=>Reflect.getPrototypeOf(v);
function createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = toRaw(target);
        const targetIsMap = (0, _shared.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? toShallow : isReadonly2 ? toReadonly : toReactive;
        !isReadonly2 && track(rawTarget, "iterate", isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value, done } = innerIterator.next();
                return done ? {
                    value,
                    done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function createInstrumentations(readonly, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = toRaw(target);
            const rawKey = toRaw(key);
            if (!readonly) {
                if ((0, _shared.hasChanged)(key, rawKey)) track(rawTarget, "get", key);
                track(rawTarget, "get", rawKey);
            }
            const { has } = getProto(rawTarget);
            const wrap = shallow ? toShallow : readonly ? toReadonly : toReactive;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly && track(toRaw(target), "iterate", ITERATE_KEY);
            return Reflect.get(target, "size", target);
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = toRaw(target);
            const rawKey = toRaw(key);
            if (!readonly) {
                if ((0, _shared.hasChanged)(key, rawKey)) track(rawTarget, "has", key);
                track(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = toRaw(target);
            const wrap = shallow ? toShallow : readonly ? toReadonly : toReactive;
            !readonly && track(rawTarget, "iterate", ITERATE_KEY);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, _shared.extend)(instrumentations, readonly ? {
        add: createReadonlyMethod("add"),
        set: createReadonlyMethod("set"),
        delete: createReadonlyMethod("delete"),
        clear: createReadonlyMethod("clear")
    } : {
        add (value) {
            if (!shallow && !isShallow(value) && !isReadonly(value)) value = toRaw(value);
            const target = toRaw(this);
            const proto = getProto(target);
            const hadKey = proto.has.call(target, value);
            if (!hadKey) {
                target.add(value);
                trigger(target, "add", value, value);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !isShallow(value) && !isReadonly(value)) value = toRaw(value);
            const target = toRaw(this);
            const { has, get } = getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = toRaw(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) trigger(target, "add", key, value);
            else if ((0, _shared.hasChanged)(value, oldValue)) trigger(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = toRaw(this);
            const { has, get } = getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = toRaw(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get ? get.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) trigger(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = toRaw(this);
            const hadItems = target.size !== 0;
            const oldTarget = void 0;
            const result = target.clear();
            if (hadItems) trigger(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, _shared.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const mutableCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(false, false)
};
const shallowCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(false, true)
};
const readonlyCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(true, false)
};
const shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(true, true)
};
function checkIdentityKeys(target, has, key) {
    const rawKey = toRaw(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, _shared.toRawType)(target);
        warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const reactiveMap = /* @__PURE__ */ new WeakMap();
const shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const readonlyMap = /* @__PURE__ */ new WeakMap();
const shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : targetTypeMap((0, _shared.toRawType)(value));
}
function reactive(target) {
    if (isReadonly(target)) return target;
    return createReactiveObject(target, false, mutableHandlers, mutableCollectionHandlers, reactiveMap);
}
function shallowReactive(target) {
    return createReactiveObject(target, false, shallowReactiveHandlers, shallowCollectionHandlers, shallowReactiveMap);
}
function readonly(target) {
    return createReactiveObject(target, true, readonlyHandlers, readonlyCollectionHandlers, readonlyMap);
}
function shallowReadonly(target) {
    return createReactiveObject(target, true, shallowReadonlyHandlers, shallowReadonlyCollectionHandlers, shallowReadonlyMap);
}
function createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, _shared.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function isReactive(value) {
    if (isReadonly(value)) return isReactive(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function isReadonly(value) {
    return !!(value && value["__v_isReadonly"]);
}
function isShallow(value) {
    return !!(value && value["__v_isShallow"]);
}
function isProxy(value) {
    return value ? !!value["__v_raw"] : false;
}
function toRaw(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? toRaw(raw) : observed;
}
function markRaw(value) {
    if (!(0, _shared.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, _shared.def)(value, "__v_skip", true);
    return value;
}
const toReactive = (value)=>(0, _shared.isObject)(value) ? reactive(value) : value;
const toReadonly = (value)=>(0, _shared.isObject)(value) ? readonly(value) : value;
function isRef(r) {
    return r ? r["__v_isRef"] === true : false;
}
function ref(value) {
    return createRef(value, false);
}
function shallowRef(value) {
    return createRef(value, true);
}
function createRef(rawValue, shallow) {
    if (isRef(rawValue)) return rawValue;
    return new RefImpl(rawValue, shallow);
}
class RefImpl {
    constructor(value, isShallow2){
        this.dep = new Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : toRaw(value);
        this._value = isShallow2 ? value : toReactive(value);
        this["__v_isShallow"] = isShallow2;
    }
    get value() {
        this.dep.track();
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || isShallow(newValue) || isReadonly(newValue);
        newValue = useDirectValue ? newValue : toRaw(newValue);
        if ((0, _shared.hasChanged)(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : toReactive(newValue);
            this.dep.trigger();
        }
    }
}
function triggerRef(ref2) {
    if (ref2.dep) ref2.dep.trigger();
}
function unref(ref2) {
    return isRef(ref2) ? ref2.value : ref2;
}
function toValue(source) {
    return (0, _shared.isFunction)(source) ? source() : unref(source);
}
const shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : unref(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if (isRef(oldValue) && !isRef(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function proxyRefs(objectWithRefs) {
    return isReactive(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, shallowUnwrapHandlers);
}
class CustomRefImpl {
    constructor(factory){
        this["__v_isRef"] = true;
        this._value = void 0;
        const dep = this.dep = new Dep();
        const { get, set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function customRef(factory) {
    return new CustomRefImpl(factory);
}
function toRefs(object) {
    const ret = (0, _shared.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = propertyToRef(object, key);
    return ret;
}
class ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
    }
    get value() {
        const val = this._object[this._key];
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return getDepFromReactive(toRaw(this._object), this._key);
    }
}
class GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
}
function toRef(source, key, defaultValue) {
    if (isRef(source)) return source;
    else if ((0, _shared.isFunction)(source)) return new GetterRefImpl(source);
    else if ((0, _shared.isObject)(source) && arguments.length > 1) return propertyToRef(source, key, defaultValue);
    else return ref(source);
}
function propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return isRef(val) ? val : new ObjectRefImpl(source, key, defaultValue);
}
class ComputedRefImpl {
    constructor(fn, setter, isSSR){
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    /**
   * @internal
   */ notify() {
        this.flags |= 16;
        if (!(this.flags & 8) && // avoid infinite self recursion
        activeSub !== this) {
            batch(this, true);
            return true;
        }
    }
    get value() {
        const link = this.dep.track();
        refreshComputed(this);
        if (link) link.version = this.dep.version;
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
    }
}
function computed(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, _shared.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
const TrackOpTypes = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const TriggerOpTypes = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const ReactiveFlags = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
const WatchErrorCodes = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const INITIAL_WATCHER_VALUE = {};
const cleanupMap = /* @__PURE__ */ new WeakMap();
let activeWatcher = void 0;
function getCurrentWatcher() {
    return activeWatcher;
}
function onWatcherCleanup(cleanupFn, failSilently = false, owner = activeWatcher) {
    if (owner) {
        let cleanups = cleanupMap.get(owner);
        if (!cleanups) cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function watch(source, cb, options = (0, _shared.EMPTY_OBJ)) {
    const { immediate, deep, once, scheduler, augmentJob, call } = options;
    const warnInvalidSource = (s)=>{
        (options.onWarn || warn)(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const reactiveGetter = (source2)=>{
        if (deep) return source2;
        if (isShallow(source2) || deep === false || deep === 0) return traverse(source2, 1);
        return traverse(source2);
    };
    let effect;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if (isRef(source)) {
        getter = ()=>source.value;
        forceTrigger = isShallow(source);
    } else if (isReactive(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, _shared.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>isReactive(s) || isShallow(s));
        getter = ()=>source.map((s)=>{
                if (isRef(s)) return s.value;
                else if (isReactive(s)) return reactiveGetter(s);
                else if ((0, _shared.isFunction)(s)) return call ? call(s, 2) : s();
            });
    } else if ((0, _shared.isFunction)(source)) {
        if (cb) getter = call ? ()=>call(source, 2) : source;
        else getter = ()=>{
            if (cleanup) {
                pauseTracking();
                try {
                    cleanup();
                } finally{
                    resetTracking();
                }
            }
            const currentEffect = activeWatcher;
            activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                activeWatcher = currentEffect;
            }
        };
    } else getter = (0, _shared.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        const depth = deep === true ? Infinity : deep;
        getter = ()=>traverse(baseGetter(), depth);
    }
    const scope = getCurrentScope();
    const watchHandle = ()=>{
        effect.stop();
        if (scope && scope.active) (0, _shared.remove)(scope.effects, effect);
    };
    if (once && cb) {
        const _cb = cb;
        cb = (...args)=>{
            _cb(...args);
            watchHandle();
        };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill(INITIAL_WATCHER_VALUE) : INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun)=>{
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>(0, _shared.hasChanged)(v, oldValue[i])) : (0, _shared.hasChanged)(newValue, oldValue))) {
                if (cleanup) cleanup();
                const currentWatcher = activeWatcher;
                activeWatcher = effect;
                try {
                    const args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb(...args);
                    oldValue = newValue;
                } finally{
                    activeWatcher = currentWatcher;
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new ReactiveEffect(getter);
    effect.scheduler = scheduler ? ()=>scheduler(job, false) : job;
    boundCleanup = (fn)=>onWatcherCleanup(fn, false, effect);
    cleanup = effect.onStop = ()=>{
        const cleanups = cleanupMap.get(effect);
        if (cleanups) {
            if (call) call(cleanups, 4);
            else for (const cleanup2 of cleanups)cleanup2();
            cleanupMap.delete(effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function traverse(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, _shared.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    depth--;
    if (isRef(value)) traverse(value.value, depth, seen);
    else if ((0, _shared.isArray)(value)) for(let i = 0; i < value.length; i++)traverse(value[i], depth, seen);
    else if ((0, _shared.isSet)(value) || (0, _shared.isMap)(value)) value.forEach((v)=>{
        traverse(v, depth, seen);
    });
    else if ((0, _shared.isPlainObject)(value)) {
        for(const key in value)traverse(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) traverse(value[key], depth, seen);
    }
    return value;
}

},{"@vue/shared":"gx1ZY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gx1ZY":[function(require,module,exports,__globalThis) {
/**
* @vue/shared v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY_ARR", ()=>EMPTY_ARR);
parcelHelpers.export(exports, "EMPTY_OBJ", ()=>EMPTY_OBJ);
parcelHelpers.export(exports, "NO", ()=>NO);
parcelHelpers.export(exports, "NOOP", ()=>NOOP);
parcelHelpers.export(exports, "PatchFlagNames", ()=>PatchFlagNames);
parcelHelpers.export(exports, "PatchFlags", ()=>PatchFlags);
parcelHelpers.export(exports, "ShapeFlags", ()=>ShapeFlags);
parcelHelpers.export(exports, "SlotFlags", ()=>SlotFlags);
parcelHelpers.export(exports, "camelize", ()=>camelize);
parcelHelpers.export(exports, "capitalize", ()=>capitalize);
parcelHelpers.export(exports, "cssVarNameEscapeSymbolsRE", ()=>cssVarNameEscapeSymbolsRE);
parcelHelpers.export(exports, "def", ()=>def);
parcelHelpers.export(exports, "escapeHtml", ()=>escapeHtml);
parcelHelpers.export(exports, "escapeHtmlComment", ()=>escapeHtmlComment);
parcelHelpers.export(exports, "extend", ()=>extend);
parcelHelpers.export(exports, "genCacheKey", ()=>genCacheKey);
parcelHelpers.export(exports, "genPropsAccessExp", ()=>genPropsAccessExp);
parcelHelpers.export(exports, "generateCodeFrame", ()=>generateCodeFrame);
parcelHelpers.export(exports, "getEscapedCssVarName", ()=>getEscapedCssVarName);
parcelHelpers.export(exports, "getGlobalThis", ()=>getGlobalThis);
parcelHelpers.export(exports, "hasChanged", ()=>hasChanged);
parcelHelpers.export(exports, "hasOwn", ()=>hasOwn);
parcelHelpers.export(exports, "hyphenate", ()=>hyphenate);
parcelHelpers.export(exports, "includeBooleanAttr", ()=>includeBooleanAttr);
parcelHelpers.export(exports, "invokeArrayFns", ()=>invokeArrayFns);
parcelHelpers.export(exports, "isArray", ()=>isArray);
parcelHelpers.export(exports, "isBooleanAttr", ()=>isBooleanAttr);
parcelHelpers.export(exports, "isBuiltInDirective", ()=>isBuiltInDirective);
parcelHelpers.export(exports, "isDate", ()=>isDate);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
parcelHelpers.export(exports, "isGloballyAllowed", ()=>isGloballyAllowed);
parcelHelpers.export(exports, "isGloballyWhitelisted", ()=>isGloballyWhitelisted);
parcelHelpers.export(exports, "isHTMLTag", ()=>isHTMLTag);
parcelHelpers.export(exports, "isIntegerKey", ()=>isIntegerKey);
parcelHelpers.export(exports, "isKnownHtmlAttr", ()=>isKnownHtmlAttr);
parcelHelpers.export(exports, "isKnownMathMLAttr", ()=>isKnownMathMLAttr);
parcelHelpers.export(exports, "isKnownSvgAttr", ()=>isKnownSvgAttr);
parcelHelpers.export(exports, "isMap", ()=>isMap);
parcelHelpers.export(exports, "isMathMLTag", ()=>isMathMLTag);
parcelHelpers.export(exports, "isModelListener", ()=>isModelListener);
parcelHelpers.export(exports, "isObject", ()=>isObject);
parcelHelpers.export(exports, "isOn", ()=>isOn);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "isPromise", ()=>isPromise);
parcelHelpers.export(exports, "isRegExp", ()=>isRegExp);
parcelHelpers.export(exports, "isRenderableAttrValue", ()=>isRenderableAttrValue);
parcelHelpers.export(exports, "isReservedProp", ()=>isReservedProp);
parcelHelpers.export(exports, "isSSRSafeAttrName", ()=>isSSRSafeAttrName);
parcelHelpers.export(exports, "isSVGTag", ()=>isSVGTag);
parcelHelpers.export(exports, "isSet", ()=>isSet);
parcelHelpers.export(exports, "isSpecialBooleanAttr", ()=>isSpecialBooleanAttr);
parcelHelpers.export(exports, "isString", ()=>isString);
parcelHelpers.export(exports, "isSymbol", ()=>isSymbol);
parcelHelpers.export(exports, "isVoidTag", ()=>isVoidTag);
parcelHelpers.export(exports, "looseEqual", ()=>looseEqual);
parcelHelpers.export(exports, "looseIndexOf", ()=>looseIndexOf);
parcelHelpers.export(exports, "looseToNumber", ()=>looseToNumber);
parcelHelpers.export(exports, "makeMap", ()=>makeMap);
parcelHelpers.export(exports, "normalizeClass", ()=>normalizeClass);
parcelHelpers.export(exports, "normalizeProps", ()=>normalizeProps);
parcelHelpers.export(exports, "normalizeStyle", ()=>normalizeStyle);
parcelHelpers.export(exports, "objectToString", ()=>objectToString);
parcelHelpers.export(exports, "parseStringStyle", ()=>parseStringStyle);
parcelHelpers.export(exports, "propsToAttrMap", ()=>propsToAttrMap);
parcelHelpers.export(exports, "remove", ()=>remove);
parcelHelpers.export(exports, "slotFlagsText", ()=>slotFlagsText);
parcelHelpers.export(exports, "stringifyStyle", ()=>stringifyStyle);
parcelHelpers.export(exports, "toDisplayString", ()=>toDisplayString);
parcelHelpers.export(exports, "toHandlerKey", ()=>toHandlerKey);
parcelHelpers.export(exports, "toNumber", ()=>toNumber);
parcelHelpers.export(exports, "toRawType", ()=>toRawType);
parcelHelpers.export(exports, "toTypeString", ()=>toTypeString);
var global = arguments[3];
function makeMap(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const EMPTY_OBJ = {};
const EMPTY_ARR = [];
const NOOP = ()=>{};
const NO = ()=>false;
const isOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const isModelListener = (key)=>key.startsWith("onUpdate:");
const extend = Object.assign;
const remove = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const hasOwnProperty = Object.prototype.hasOwnProperty;
const hasOwn = (val, key)=>hasOwnProperty.call(val, key);
const isArray = Array.isArray;
const isMap = (val)=>toTypeString(val) === "[object Map]";
const isSet = (val)=>toTypeString(val) === "[object Set]";
const isDate = (val)=>toTypeString(val) === "[object Date]";
const isRegExp = (val)=>toTypeString(val) === "[object RegExp]";
const isFunction = (val)=>typeof val === "function";
const isString = (val)=>typeof val === "string";
const isSymbol = (val)=>typeof val === "symbol";
const isObject = (val)=>val !== null && typeof val === "object";
const isPromise = (val)=>{
    return (isObject(val) || isFunction(val)) && isFunction(val.then) && isFunction(val.catch);
};
const objectToString = Object.prototype.toString;
const toTypeString = (value)=>objectToString.call(value);
const toRawType = (value)=>{
    return toTypeString(value).slice(8, -1);
};
const isPlainObject = (val)=>toTypeString(val) === "[object Object]";
const isIntegerKey = (key)=>isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const isReservedProp = /* @__PURE__ */ makeMap(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const isBuiltInDirective = /* @__PURE__ */ makeMap("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const camelizeRE = /-(\w)/g;
const camelize = cacheStringFunction((str)=>{
    return str.replace(camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const hyphenateRE = /\B([A-Z])/g;
const hyphenate = cacheStringFunction((str)=>str.replace(hyphenateRE, "-$1").toLowerCase());
const capitalize = cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const toHandlerKey = cacheStringFunction((str)=>{
    const s = str ? `on${capitalize(str)}` : ``;
    return s;
});
const hasChanged = (value, oldValue)=>!Object.is(value, oldValue);
const invokeArrayFns = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const def = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable,
        value
    });
};
const looseToNumber = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const toNumber = (val)=>{
    const n = isString(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let _globalThis;
const getGlobalThis = ()=>{
    return _globalThis || (_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {});
};
const identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function genPropsAccessExp(name) {
    return identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function genCacheKey(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const PatchFlags = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const PatchFlagNames = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const ShapeFlags = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const SlotFlags = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const slotFlagsText = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const isGloballyAllowed = /* @__PURE__ */ makeMap(GLOBALS_ALLOWED);
const isGloballyWhitelisted = isGloballyAllowed;
const range = 2;
function generateCodeFrame(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - range; j <= i + range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function normalizeStyle(value) {
    if (isArray(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = isString(item) ? parseStringStyle(item) : normalizeStyle(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if (isString(value) || isObject(value)) return value;
}
const listDelimiterRE = /;(?![^(]*\))/g;
const propertyDelimiterRE = /:([^]+)/;
const styleCommentRE = /\/\*[^]*?\*\//g;
function parseStringStyle(cssText) {
    const ret = {};
    cssText.replace(styleCommentRE, "").split(listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split(propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function stringifyStyle(styles) {
    if (!styles) return "";
    if (isString(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if (isString(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : hyphenate(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function normalizeClass(value) {
    let res = "";
    if (isString(value)) res = value;
    else if (isArray(value)) for(let i = 0; i < value.length; i++){
        const normalized = normalizeClass(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if (isObject(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function normalizeProps(props) {
    if (!props) return null;
    let { class: klass, style } = props;
    if (klass && !isString(klass)) props.class = normalizeClass(klass);
    if (style) props.style = normalizeStyle(style);
    return props;
}
const HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const isHTMLTag = /* @__PURE__ */ makeMap(HTML_TAGS);
const isSVGTag = /* @__PURE__ */ makeMap(SVG_TAGS);
const isMathMLTag = /* @__PURE__ */ makeMap(MATH_TAGS);
const isVoidTag = /* @__PURE__ */ makeMap(VOID_TAGS);
const specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const isSpecialBooleanAttr = /* @__PURE__ */ makeMap(specialBooleanAttrs);
const isBooleanAttr = /* @__PURE__ */ makeMap(specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function includeBooleanAttr(value) {
    return !!value || value === "";
}
const unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const attrValidationCache = {};
function isSSRSafeAttrName(name) {
    if (attrValidationCache.hasOwnProperty(name)) return attrValidationCache[name];
    const isUnsafe = unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return attrValidationCache[name] = !isUnsafe;
}
const propsToAttrMap = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const isKnownHtmlAttr = /* @__PURE__ */ makeMap(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const isKnownSvgAttr = /* @__PURE__ */ makeMap(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const isKnownMathMLAttr = /* @__PURE__ */ makeMap(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function isRenderableAttrValue(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const escapeRE = /["'&<>]/;
function escapeHtml(string) {
    const str = "" + string;
    const match = escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function escapeHtmlComment(src) {
    return src.replace(commentStripRE, "");
}
const cssVarNameEscapeSymbolsRE = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function getEscapedCssVarName(key, doubleEscape) {
    return key.replace(cssVarNameEscapeSymbolsRE, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = looseEqual(a[i], b[i]);
    return equal;
}
function looseEqual(a, b) {
    if (a === b) return true;
    let aValidType = isDate(a);
    let bValidType = isDate(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = isSymbol(a);
    bValidType = isSymbol(b);
    if (aValidType || bValidType) return a === b;
    aValidType = isArray(a);
    bValidType = isArray(b);
    if (aValidType || bValidType) return aValidType && bValidType ? looseCompareArrays(a, b) : false;
    aValidType = isObject(a);
    bValidType = isObject(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !looseEqual(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function looseIndexOf(arr, val) {
    return arr.findIndex((item)=>looseEqual(item, val));
}
const isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const toDisplayString = (val)=>{
    return isString(val) ? val : val == null ? "" : isArray(val) || isObject(val) && (val.toString === objectToString || !isFunction(val.toString)) ? isRef(val) ? toDisplayString(val.value) : JSON.stringify(val, replacer, 2) : String(val);
};
const replacer = (_key, val)=>{
    if (isRef(val)) return replacer(_key, val.value);
    else if (isMap(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if (isSet(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>stringifySymbol(v))
    };
    else if (isSymbol(val)) return stringifySymbol(val);
    else if (isObject(val) && !isArray(val) && !isPlainObject(val)) return String(val);
    return val;
};
const stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    isSymbol(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"91HVb":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"jLHUS":[function(require,module,exports,__globalThis) {
/*! Buefy v1.0.2 | MIT License | github.com/buefy/buefy */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Autocomplete", ()=>Plugin$F);
parcelHelpers.export(exports, "BAutocomplete", ()=>BAutocomplete);
parcelHelpers.export(exports, "BBreadcrumb", ()=>Breadcrumb);
parcelHelpers.export(exports, "BBreadcrumbItem", ()=>BreadcrumbItem);
parcelHelpers.export(exports, "BButton", ()=>BButton);
parcelHelpers.export(exports, "BCarousel", ()=>Carousel);
parcelHelpers.export(exports, "BCarouselItem", ()=>CarouselItem);
parcelHelpers.export(exports, "BCarouselList", ()=>CarouselList);
parcelHelpers.export(exports, "BCheckbox", ()=>BCheckbox);
parcelHelpers.export(exports, "BCheckboxButton", ()=>CheckboxButton);
parcelHelpers.export(exports, "BClockpicker", ()=>Clockpicker);
parcelHelpers.export(exports, "BCollapse", ()=>_sfc_main$F);
parcelHelpers.export(exports, "BColorpicker", ()=>Colorpicker);
parcelHelpers.export(exports, "BDatepicker", ()=>BDatepicker);
parcelHelpers.export(exports, "BDatetimepicker", ()=>Datetimepicker);
parcelHelpers.export(exports, "BDialog", ()=>Dialog);
parcelHelpers.export(exports, "BDropdown", ()=>BDropdown);
parcelHelpers.export(exports, "BDropdownItem", ()=>BDropdownItem);
parcelHelpers.export(exports, "BField", ()=>Field);
parcelHelpers.export(exports, "BIcon", ()=>BIcon);
parcelHelpers.export(exports, "BImage", ()=>Image$1);
parcelHelpers.export(exports, "BInput", ()=>BInput);
parcelHelpers.export(exports, "BLoading", ()=>BLoading);
parcelHelpers.export(exports, "BMenu", ()=>Menu);
parcelHelpers.export(exports, "BMenuItem", ()=>MenuItem);
parcelHelpers.export(exports, "BMenuList", ()=>MenuList);
parcelHelpers.export(exports, "BMessage", ()=>Message);
parcelHelpers.export(exports, "BModal", ()=>Modal);
parcelHelpers.export(exports, "BNavbar", ()=>_sfc_main$k);
parcelHelpers.export(exports, "BNavbarDropdown", ()=>NavbarDropdown);
parcelHelpers.export(exports, "BNavbarItem", ()=>NavbarItem);
parcelHelpers.export(exports, "BNotification", ()=>Notification);
parcelHelpers.export(exports, "BNumberinput", ()=>Numberinput);
parcelHelpers.export(exports, "BPagination", ()=>BPagination);
parcelHelpers.export(exports, "BPaginationButton", ()=>PaginationButton);
parcelHelpers.export(exports, "BProgress", ()=>Progress);
parcelHelpers.export(exports, "BProgressBar", ()=>ProgressBar);
parcelHelpers.export(exports, "BRadio", ()=>Radio);
parcelHelpers.export(exports, "BRadioButton", ()=>RadioButton);
parcelHelpers.export(exports, "BRate", ()=>Rate);
parcelHelpers.export(exports, "BSelect", ()=>BSelect);
parcelHelpers.export(exports, "BSidebar", ()=>Sidebar);
parcelHelpers.export(exports, "BSkeleton", ()=>BSkeleton);
parcelHelpers.export(exports, "BSlider", ()=>Slider);
parcelHelpers.export(exports, "BSliderTick", ()=>SliderTick);
parcelHelpers.export(exports, "BSnackbar", ()=>Snackbar);
parcelHelpers.export(exports, "BStepItem", ()=>_sfc_main$9);
parcelHelpers.export(exports, "BSteps", ()=>Steps);
parcelHelpers.export(exports, "BSwitch", ()=>Switch);
parcelHelpers.export(exports, "BTabItem", ()=>_sfc_main$3);
parcelHelpers.export(exports, "BTable", ()=>Table);
parcelHelpers.export(exports, "BTableColumn", ()=>_sfc_main$5);
parcelHelpers.export(exports, "BTabs", ()=>Tabs);
parcelHelpers.export(exports, "BTag", ()=>BTag);
parcelHelpers.export(exports, "BTaginput", ()=>Taginput);
parcelHelpers.export(exports, "BTaglist", ()=>Taglist);
parcelHelpers.export(exports, "BTimepicker", ()=>Timepicker);
parcelHelpers.export(exports, "BToast", ()=>Toast);
parcelHelpers.export(exports, "BTooltip", ()=>Tooltip);
parcelHelpers.export(exports, "BUpload", ()=>Upload);
parcelHelpers.export(exports, "Breadcrumb", ()=>Plugin$E);
parcelHelpers.export(exports, "Button", ()=>Plugin$D);
parcelHelpers.export(exports, "Carousel", ()=>Plugin$C);
parcelHelpers.export(exports, "Checkbox", ()=>Plugin$B);
parcelHelpers.export(exports, "Clockpicker", ()=>Plugin$x);
parcelHelpers.export(exports, "Collapse", ()=>Plugin$A);
parcelHelpers.export(exports, "Color", ()=>Color);
parcelHelpers.export(exports, "Colorpicker", ()=>Plugin$w);
parcelHelpers.export(exports, "ConfigProgrammatic", ()=>ConfigComponent);
parcelHelpers.export(exports, "Datepicker", ()=>Plugin$v);
parcelHelpers.export(exports, "Datetimepicker", ()=>Plugin$u);
parcelHelpers.export(exports, "Dialog", ()=>Plugin$t);
parcelHelpers.export(exports, "DialogProgrammatic", ()=>DialogProgrammatic);
parcelHelpers.export(exports, "Dropdown", ()=>Plugin$z);
parcelHelpers.export(exports, "Field", ()=>Plugin$s);
parcelHelpers.export(exports, "Icon", ()=>Plugin$r);
parcelHelpers.export(exports, "Image", ()=>Plugin$q);
parcelHelpers.export(exports, "Input", ()=>Plugin$y);
parcelHelpers.export(exports, "Loading", ()=>Plugin$p);
parcelHelpers.export(exports, "LoadingProgrammatic", ()=>LoadingProgrammatic);
parcelHelpers.export(exports, "Menu", ()=>Plugin$o);
parcelHelpers.export(exports, "Message", ()=>Plugin$n);
parcelHelpers.export(exports, "Modal", ()=>Plugin$m);
parcelHelpers.export(exports, "ModalProgrammatic", ()=>ModalProgrammatic);
parcelHelpers.export(exports, "Navbar", ()=>Plugin$k);
parcelHelpers.export(exports, "Notification", ()=>Plugin$l);
parcelHelpers.export(exports, "NotificationProgrammatic", ()=>NotificationProgrammatic);
parcelHelpers.export(exports, "Numberinput", ()=>Plugin$j);
parcelHelpers.export(exports, "Pagination", ()=>Plugin$i);
parcelHelpers.export(exports, "Progress", ()=>Plugin$h);
parcelHelpers.export(exports, "Radio", ()=>Plugin$g);
parcelHelpers.export(exports, "Rate", ()=>Plugin$f);
parcelHelpers.export(exports, "Select", ()=>Plugin$e);
parcelHelpers.export(exports, "Sidebar", ()=>Plugin$c);
parcelHelpers.export(exports, "Skeleton", ()=>Plugin$d);
parcelHelpers.export(exports, "Slider", ()=>Plugin$b);
parcelHelpers.export(exports, "Snackbar", ()=>Plugin$a);
parcelHelpers.export(exports, "SnackbarProgrammatic", ()=>SnackbarProgrammatic);
parcelHelpers.export(exports, "Steps", ()=>Plugin$9);
parcelHelpers.export(exports, "Switch", ()=>Plugin$8);
parcelHelpers.export(exports, "Table", ()=>Plugin$7);
parcelHelpers.export(exports, "Tabs", ()=>Plugin$6);
parcelHelpers.export(exports, "Tag", ()=>Plugin$5);
parcelHelpers.export(exports, "Taginput", ()=>Plugin$4);
parcelHelpers.export(exports, "Timepicker", ()=>Plugin$3);
parcelHelpers.export(exports, "Toast", ()=>Plugin$2);
parcelHelpers.export(exports, "ToastProgrammatic", ()=>ToastProgrammatic);
parcelHelpers.export(exports, "Tooltip", ()=>Plugin$1);
parcelHelpers.export(exports, "Upload", ()=>Plugin);
parcelHelpers.export(exports, "bound", ()=>bound);
parcelHelpers.export(exports, "copyAppContext", ()=>copyAppContext);
parcelHelpers.export(exports, "createAbsoluteElement", ()=>createAbsoluteElement);
parcelHelpers.export(exports, "createNewEvent", ()=>createNewEvent);
parcelHelpers.export(exports, "default", ()=>Buefy);
parcelHelpers.export(exports, "escapeRegExpChars", ()=>escapeRegExpChars);
parcelHelpers.export(exports, "getComponentFromVNode", ()=>getComponentFromVNode);
parcelHelpers.export(exports, "getMonthNames", ()=>getMonthNames);
parcelHelpers.export(exports, "getValueByPath", ()=>getValueByPath);
parcelHelpers.export(exports, "getWeekdayNames", ()=>getWeekdayNames);
parcelHelpers.export(exports, "hasFlag", ()=>hasFlag);
parcelHelpers.export(exports, "indexOf", ()=>indexOf);
parcelHelpers.export(exports, "isCustomElement", ()=>isCustomElement);
parcelHelpers.export(exports, "isDefined", ()=>isDefined);
parcelHelpers.export(exports, "isFragment", ()=>isFragment);
parcelHelpers.export(exports, "isMobile", ()=>isMobile);
parcelHelpers.export(exports, "isNil", ()=>isNil);
parcelHelpers.export(exports, "isTag", ()=>isTag);
parcelHelpers.export(exports, "isVueComponent", ()=>isVueComponent);
parcelHelpers.export(exports, "isWebpSupported", ()=>isWebpSupported);
parcelHelpers.export(exports, "matchWithGroups", ()=>matchWithGroups);
parcelHelpers.export(exports, "merge", ()=>merge);
parcelHelpers.export(exports, "mod", ()=>mod);
parcelHelpers.export(exports, "multiColumnSort", ()=>multiColumnSort);
parcelHelpers.export(exports, "removeDiacriticsFromString", ()=>removeDiacriticsFromString);
parcelHelpers.export(exports, "removeElement", ()=>removeElement);
parcelHelpers.export(exports, "sign", ()=>sign);
parcelHelpers.export(exports, "toCssWidth", ()=>toCssWidth);
parcelHelpers.export(exports, "translateTouchAsDragEvent", ()=>translateTouchAsDragEvent);
var _vue = require("vue");
var __defProp$d = Object.defineProperty;
var __pow = Math.pow;
var __defNormalProp$d = (obj, key, value)=>key in obj ? __defProp$d(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __publicField$6 = (obj, key, value)=>__defNormalProp$d(obj, key + "", value);
const colorChannels = [
    "red",
    "green",
    "blue",
    "alpha"
];
const colorsNammed = {
    transparent: "#00000000",
    black: "#000000",
    silver: "#c0c0c0",
    gray: "#808080",
    white: "#ffffff",
    maroon: "#800000",
    red: "#ff0000",
    purple: "#800080",
    fuchsia: "#ff00ff",
    green: "#008000",
    lime: "#00ff00",
    olive: "#808000",
    yellow: "#ffff00",
    navy: "#000080",
    blue: "#0000ff",
    teal: "#008080",
    aqua: "#00ffff",
    orange: "#ffa500",
    aliceblue: "#f0f8ff",
    antiquewhite: "#faebd7",
    aquamarine: "#7fffd4",
    azure: "#f0ffff",
    beige: "#f5f5dc",
    bisque: "#ffe4c4",
    blanchedalmond: "#ffebcd",
    blueviolet: "#8a2be2",
    brown: "#a52a2a",
    burlywood: "#deb887",
    cadetblue: "#5f9ea0",
    chartreuse: "#7fff00",
    chocolate: "#d2691e",
    coral: "#ff7f50",
    cornflowerblue: "#6495ed",
    cornsilk: "#fff8dc",
    crimson: "#dc143c",
    cyan: "#00ffff",
    darkblue: "#00008b",
    darkcyan: "#008b8b",
    darkgoldenrod: "#b8860b",
    darkgray: "#a9a9a9",
    darkgreen: "#006400",
    darkgrey: "#a9a9a9",
    darkkhaki: "#bdb76b",
    darkmagenta: "#8b008b",
    darkolivegreen: "#556b2f",
    darkorange: "#ff8c00",
    darkorchid: "#9932cc",
    darkred: "#8b0000",
    darksalmon: "#e9967a",
    darkseagreen: "#8fbc8f",
    darkslateblue: "#483d8b",
    darkslategray: "#2f4f4f",
    darkslategrey: "#2f4f4f",
    darkturquoise: "#00ced1",
    darkviolet: "#9400d3",
    deeppink: "#ff1493",
    deepskyblue: "#00bfff",
    dimgray: "#696969",
    dimgrey: "#696969",
    dodgerblue: "#1e90ff",
    firebrick: "#b22222",
    floralwhite: "#fffaf0",
    forestgreen: "#228b22",
    gainsboro: "#dcdcdc",
    ghostwhite: "#f8f8ff",
    gold: "#ffd700",
    goldenrod: "#daa520",
    greenyellow: "#adff2f",
    grey: "#808080",
    honeydew: "#f0fff0",
    hotpink: "#ff69b4",
    indianred: "#cd5c5c",
    indigo: "#4b0082",
    ivory: "#fffff0",
    khaki: "#f0e68c",
    lavender: "#e6e6fa",
    lavenderblush: "#fff0f5",
    lawngreen: "#7cfc00",
    lemonchiffon: "#fffacd",
    lightblue: "#add8e6",
    lightcoral: "#f08080",
    lightcyan: "#e0ffff",
    lightgoldenrodyellow: "#fafad2",
    lightgray: "#d3d3d3",
    lightgreen: "#90ee90",
    lightgrey: "#d3d3d3",
    lightpink: "#ffb6c1",
    lightsalmon: "#ffa07a",
    lightseagreen: "#20b2aa",
    lightskyblue: "#87cefa",
    lightslategray: "#778899",
    lightslategrey: "#778899",
    lightsteelblue: "#b0c4de",
    lightyellow: "#ffffe0",
    limegreen: "#32cd32",
    linen: "#faf0e6",
    magenta: "#ff00ff",
    mediumaquamarine: "#66cdaa",
    mediumblue: "#0000cd",
    mediumorchid: "#ba55d3",
    mediumpurple: "#9370db",
    mediumseagreen: "#3cb371",
    mediumslateblue: "#7b68ee",
    mediumspringgreen: "#00fa9a",
    mediumturquoise: "#48d1cc",
    mediumvioletred: "#c71585",
    midnightblue: "#191970",
    mintcream: "#f5fffa",
    mistyrose: "#ffe4e1",
    moccasin: "#ffe4b5",
    navajowhite: "#ffdead",
    oldlace: "#fdf5e6",
    olivedrab: "#6b8e23",
    orangered: "#ff4500",
    orchid: "#da70d6",
    palegoldenrod: "#eee8aa",
    palegreen: "#98fb98",
    paleturquoise: "#afeeee",
    palevioletred: "#db7093",
    papayawhip: "#ffefd5",
    peachpuff: "#ffdab9",
    peru: "#cd853f",
    pink: "#ffc0cb",
    plum: "#dda0dd",
    powderblue: "#b0e0e6",
    rosybrown: "#bc8f8f",
    royalblue: "#4169e1",
    saddlebrown: "#8b4513",
    salmon: "#fa8072",
    sandybrown: "#f4a460",
    seagreen: "#2e8b57",
    seashell: "#fff5ee",
    sienna: "#a0522d",
    skyblue: "#87ceeb",
    slateblue: "#6a5acd",
    slategray: "#708090",
    slategrey: "#708090",
    snow: "#fffafa",
    springgreen: "#00ff7f",
    steelblue: "#4682b4",
    tan: "#d2b48c",
    thistle: "#d8bfd8",
    tomato: "#ff6347",
    turquoise: "#40e0d0",
    violet: "#ee82ee",
    wheat: "#f5deb3",
    whitesmoke: "#f5f5f5",
    yellowgreen: "#9acd32",
    rebeccapurple: "#663399"
};
class ColorTypeError extends Error {
    constructor(){
        super("ColorTypeError: type must be hex(a), rgb(a) or hsl(a)");
    }
}
class Color {
    // Since getters and setters for the color channels, e.g., "alpha", are
    // dynamically defined with `Object.defineProperty` in the constructor, we
    // cannot write property declarations inside the class body. Instead, we
    // augment the `Color` class with an ambient module declared in `color.ts`.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args){
        // @ts-expect-error - TypeScript failed to inter the initialization of this property
        __publicField$6(this, "$channels");
        if (args.length > 0) return Color.parse(...args);
        this.$channels = new Uint8Array(colorChannels.length);
    }
    get red() {
        return this.$channels[0];
    }
    set red(byte) {
        if (!Number.isNaN(byte / 1)) this.$channels[0] = Math.min(255, Math.max(0, byte));
    }
    get green() {
        return this.$channels[1];
    }
    set green(byte) {
        if (!Number.isNaN(byte / 1)) this.$channels[1] = Math.min(255, Math.max(0, byte));
    }
    get blue() {
        return this.$channels[2];
    }
    set blue(byte) {
        if (!Number.isNaN(byte / 1)) this.$channels[2] = Math.min(255, Math.max(0, byte));
    }
    get alpha() {
        return this.$channels[3];
    }
    set alpha(byte) {
        if (!Number.isNaN(byte / 1)) this.$channels[3] = Math.min(255, Math.max(0, byte));
    }
    get hue() {
        return this.getHue();
    }
    set hue(value) {
        if (!Number.isNaN(value / 1)) this.setHue(value);
    }
    get saturation() {
        return this.getSaturation();
    }
    set saturation(value) {
        if (!Number.isNaN(value / 1)) this.setSaturation(value);
    }
    get lightness() {
        return this.getLightness();
    }
    set lightness(value) {
        if (!Number.isNaN(value / 1)) this.setLightness(value);
    }
    getHue() {
        const [red, green, blue] = Array.from(this.$channels).map((c)=>c / 255);
        const [min, max] = [
            Math.min(red, green, blue),
            Math.max(red, green, blue)
        ];
        const delta = max - min;
        let hue = 0;
        if (delta === 0) return hue;
        if (red === max) hue = (green - blue) / delta % 6;
        else if (green === max) hue = (blue - red) / delta + 2;
        else hue = (red - green) / delta + 4;
        hue *= 60;
        while(hue !== -Infinity && hue < 0)hue += 360;
        return Math.round(hue % 360);
    }
    setHue(value) {
        const color = Color.fromHSL(value, this.saturation, this.lightness, this.alpha / 255);
        for(let i = 0; i < this.$channels.length; i++)this.$channels[i] = Number(color.$channels[i]);
    }
    getSaturation() {
        const [red, green, blue] = Array.from(this.$channels).map((c)=>c / 255);
        const [min, max] = [
            Math.min(red, green, blue),
            Math.max(red, green, blue)
        ];
        const delta = max - min;
        return delta !== 0 ? Math.round(delta / (1 - Math.abs(2 * this.lightness - 1)) * 100) / 100 : 0;
    }
    setSaturation(value) {
        const color = Color.fromHSL(this.hue, value, this.lightness, this.alpha / 255);
        colorChannels.forEach((_, i)=>this.$channels[i] = color.$channels[i]);
    }
    getLightness() {
        const [red, green, blue] = Array.from(this.$channels).map((c)=>c / 255);
        const [min, max] = [
            Math.min(red, green, blue),
            Math.max(red, green, blue)
        ];
        return Math.round((max + min) / 2 * 100) / 100;
    }
    setLightness(value) {
        const color = Color.fromHSL(this.hue, this.lightness, value, this.alpha / 255);
        colorChannels.forEach((_, i)=>this.$channels[i] = color.$channels[i]);
    }
    clone() {
        const color = new Color();
        colorChannels.forEach((_, i)=>color.$channels[i] = this.$channels[i]);
        return color;
    }
    toString(type = "hex") {
        switch(String(type).toLowerCase()){
            case "hex":
                return "#" + colorChannels.slice(0, 3).map((channel)=>this[channel].toString(16).padStart(2, "0")).join("");
            case "hexa":
                return "#" + colorChannels.map((channel)=>this[channel].toString(16).padStart(2, "0")).join("");
            case "rgb":
                return `rgb(${this.red}, ${this.green}, ${this.blue})`;
            case "rgba":
                return `rgba(${this.red}, ${this.green}, ${this.blue}, ${Math.round(this.alpha / 2.55) / 100})`;
            case "hsl":
                return `hsl(${Math.round(this.hue)}deg, ${Math.round(this.saturation * 100)}%, ${Math.round(this.lightness * 100)}%)`;
            case "hsla":
                return `hsla(${Math.round(this.hue)}deg, ${Math.round(this.saturation * 100)}%, ${Math.round(this.lightness * 100)}%, ${Math.round(this.alpha / 2.55) / 100})`;
            default:
                throw new ColorTypeError();
        }
    }
    get [Symbol.toStringTag]() {
        return this.toString("hex");
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static parse(...args) {
        if (typeof args[0] === "object") return Color.parseObject(args[0]);
        else if (args.every((arg)=>!Number.isNaN(arg / 1))) {
            const color = new Color();
            if (args.length > 3) {
                color.red = args[0];
                color.green = args[1];
                color.blue = args[2];
                if (args[3]) color.alpha = args[3];
            } else if (args.length === 1) {
                const index = Number(args[0]);
                return Color.parseIndex(index, index > __pow(2, 24) ? 3 : 4);
            }
        } else if (typeof args[0] === "string") {
            let match = null;
            if (typeof colorsNammed[args[0].toLowerCase()] === "string") return Color.parseHex(colorsNammed[args[0].toLowerCase()]);
            else if ((match = args[0].match(/^(#|&h|0x)?(([a-f0-9]{3,4}){1,2})$/i)) !== null) return Color.parseHex(match[2]);
            else if ((match = args[0].match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(\s*,\s*(\d*\.?\d+))?\s*\)$/i)) !== null) {
                const channels = [
                    match[1],
                    match[2],
                    match[3],
                    typeof match[5] !== "undefined" ? match[5] : 1
                ];
                return Color.fromRGB(...channels.map((value)=>Number(value)));
            } else if (args[0].match(/^(h(sl|wb)a?|lab|color|cmyk)\(/i)) throw new Error("Color expression not implemented yet");
        }
        throw new Error("Invalid color expression");
    }
    static parseObject(object) {
        const color = new Color();
        if (object === null || typeof object !== "object") return color;
        if (Color.isColor(object)) return object.clone();
        colorChannels.forEach((channel)=>{
            if (!Number.isNaN(object[channel])) color[channel] = object[channel];
        });
        return color;
    }
    static parseHex(hex) {
        if (typeof hex !== "string") throw new Error("Hex expression must be a string");
        hex = hex.trim().replace(/^(0x|&h|#)/i, "");
        if (hex.length === 3 || hex.length === 4) hex = hex.split("").map((c)=>c.repeat(2)).join("");
        if (!(hex.length === 6 || hex.length === 8)) throw new Error("Incorrect Hex expression length");
        const chans = hex.split(/(..)/).filter((value)=>value).map((value)=>Number.parseInt(value, 16));
        if (typeof chans[3] === "number") chans[3] /= 255;
        return Color.fromRGB(...chans);
    }
    static parseIndex(value, channels = 3) {
        const color = new Color();
        for(let i = 0; i < 4; i++)color[colorChannels[i]] = value >> (channels - i) * 8 && 255;
        return color;
    }
    static fromRGB(red, green, blue, alpha = 1) {
        if ([
            red,
            green,
            blue,
            alpha
        ].some((arg)=>Number.isNaN(arg / 1))) throw new Error("Invalid arguments");
        alpha *= 255;
        const color = new Color();
        [
            red,
            green,
            blue,
            alpha
        ].forEach((value, index)=>{
            color[colorChannels[index]] = value;
        });
        return color;
    }
    static fromHSL(hue, saturation, lightness, alpha = 1) {
        if ([
            hue,
            saturation,
            lightness,
            alpha
        ].some((arg)=>Number.isNaN(arg))) throw new Error("Invalid arguments");
        while(hue < 0 && hue !== -Infinity)hue += 360;
        hue = hue % 360;
        saturation = Math.max(0, Math.min(1, saturation));
        lightness = Math.max(0, Math.min(1, lightness));
        alpha = Math.max(0, Math.min(1, alpha));
        const c = (1 - Math.abs(2 * lightness - 1)) * saturation;
        const x = c * (1 - Math.abs(hue / 60 % 2 - 1));
        const m = lightness - c / 2;
        const [r, g, b] = hue < 60 ? [
            c,
            x,
            0
        ] : hue < 120 ? [
            x,
            c,
            0
        ] : hue < 180 ? [
            0,
            c,
            x
        ] : hue < 240 ? [
            0,
            x,
            c
        ] : hue < 300 ? [
            x,
            0,
            c
        ] : [
            c,
            0,
            x
        ];
        return Color.fromRGB((r + m) * 255, (g + m) * 255, (b + m) * 255, alpha);
    }
    static isColor(arg) {
        return arg instanceof Color;
    }
}
const NOTICE_POSITIONS = [
    "is-top-right",
    "is-top",
    "is-top-left",
    "is-bottom-right",
    "is-bottom",
    "is-bottom-left"
];
let config = {
    defaultContainerElement: null,
    defaultIconPack: "mdi",
    defaultIconComponent: null,
    defaultIconPrev: "chevron-left",
    defaultIconNext: "chevron-right",
    defaultLocale: void 0,
    defaultDialogConfirmText: null,
    defaultDialogCancelText: null,
    defaultSnackbarDuration: 3500,
    defaultSnackbarPosition: null,
    defaultToastDuration: 2e3,
    defaultToastPosition: null,
    defaultNotificationDuration: 2e3,
    defaultNotificationPosition: null,
    defaultTooltipType: "is-primary",
    defaultTooltipDelay: null,
    defaultTooltipCloseDelay: null,
    defaultSidebarDelay: null,
    defaultInputAutocomplete: "on",
    defaultDateFormatter: null,
    defaultDateParser: null,
    defaultDateCreator: null,
    defaultTimeCreator: null,
    defaultDayNames: null,
    defaultMonthNames: null,
    defaultFirstDayOfWeek: null,
    defaultUnselectableDaysOfWeek: null,
    defaultTimeFormatter: null,
    defaultTimeParser: null,
    defaultDatetimeFormatter: null,
    defaultDatetimeParser: null,
    defaultDatetimeCreator: null,
    defaultClockpickerHoursLabel: null,
    defaultClockpickerMinutesLabel: null,
    defaultColorFormatter: null,
    defaultColorParser: null,
    defaultModalCanCancel: [
        "escape",
        "x",
        "outside",
        "button"
    ],
    defaultModalScroll: null,
    defaultDatepickerMobileNative: true,
    defaultTimepickerMobileNative: true,
    defaultTimepickerMobileModal: true,
    defaultNoticeQueue: true,
    defaultInputHasCounter: true,
    defaultCompatFallthrough: true,
    defaultTaginputHasCounter: true,
    defaultUseHtml5Validation: true,
    defaultDropdownMobileModal: true,
    defaultFieldLabelPosition: null,
    defaultDatepickerYearsRange: [
        -100,
        10
    ],
    defaultDatepickerNearbyMonthDays: true,
    defaultDatepickerNearbySelectableMonthDays: false,
    defaultDatepickerShowWeekNumber: false,
    defaultDatepickerWeekNumberClickable: false,
    defaultDatepickerMobileModal: true,
    defaultTrapFocus: true,
    defaultAutoFocus: true,
    defaultButtonRounded: false,
    defaultSwitchRounded: true,
    defaultCarouselInterval: 3500,
    defaultTabsExpanded: false,
    defaultTabsAnimated: true,
    defaultTabsType: null,
    defaultStatusIcon: true,
    defaultProgrammaticPromise: false,
    defaultLinkTags: [
        "a",
        "button",
        "input",
        "router-link",
        "nuxt-link",
        "n-link",
        "RouterLink",
        "NuxtLink",
        "NLink"
    ],
    defaultImageWebpFallback: null,
    defaultImageLazy: true,
    defaultImageResponsive: true,
    defaultImageRatio: null,
    defaultImageSrcsetFormatter: null,
    defaultBreadcrumbTag: "a",
    defaultBreadcrumbAlign: "is-left",
    defaultBreadcrumbSeparator: "",
    defaultBreadcrumbSize: "is-medium",
    customIconPacks: null
};
const setOptions = (options)=>{
    config = options;
};
var __defProp$c = Object.defineProperty;
var __getOwnPropSymbols$d = Object.getOwnPropertySymbols;
var __hasOwnProp$d = Object.prototype.hasOwnProperty;
var __propIsEnum$d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$c = (obj, key, value)=>key in obj ? __defProp$c(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues$c = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp$d.call(b, prop)) __defNormalProp$c(a, prop, b[prop]);
    if (__getOwnPropSymbols$d) {
        for (var prop of __getOwnPropSymbols$d(b))if (__propIsEnum$d.call(b, prop)) __defNormalProp$c(a, prop, b[prop]);
    }
    return a;
};
function signPoly(value) {
    if (value < 0) return -1;
    return value > 0 ? 1 : 0;
}
const sign = Math.sign || signPoly;
function hasFlag(val, flag) {
    return (val & flag) === flag;
}
function mod(n, mod2) {
    return (n % mod2 + mod2) % mod2;
}
function bound(val, min, max) {
    return Math.max(min, Math.min(max, val));
}
function getValueByPath(obj, path) {
    return path.split(".").reduce((o, i)=>o ? o[i] : null, obj);
}
function indexOf(array, obj, fn) {
    if (!array) return -1;
    if (!fn || typeof fn !== "function") return array.indexOf(obj);
    for(let i = 0; i < array.length; i++){
        if (fn(array[i], obj)) return i;
    }
    return -1;
}
const isObject = (item)=>typeof item === "object" && !Array.isArray(item);
const mergeFn = (target, source, deep = false)=>{
    if (deep || !Object.assign) {
        const isDeep = (prop)=>isObject(source[prop]) && target !== null && Object.prototype.hasOwnProperty.call(target, prop) && isObject(target[prop]);
        const replaced = Object.getOwnPropertyNames(source).map((prop)=>({
                [prop]: isDeep(prop) ? mergeFn(target[prop], source[prop] || {}, deep) : source[prop]
            })).reduce((a, b)=>__spreadValues$c(__spreadValues$c({}, a), b), // eslint-disable-next-line no-use-before-define
        {});
        return __spreadValues$c(__spreadValues$c({}, target), replaced);
    } else return Object.assign(target, source);
};
const merge = mergeFn;
const isMobile = {
    Android: function() {
        return typeof window !== "undefined" && window.navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
        return typeof window !== "undefined" && window.navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
        return typeof window !== "undefined" && (window.navigator.userAgent.match(/iPhone|iPad|iPod/i) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
    },
    Opera: function() {
        return typeof window !== "undefined" && window.navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
        return typeof window !== "undefined" && window.navigator.userAgent.match(/IEMobile/i);
    },
    any: function() {
        return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
    }
};
function removeElement(el) {
    if (typeof el.remove !== "undefined") el.remove();
    else if (typeof el.parentNode !== "undefined" && el.parentNode !== null) el.parentNode.removeChild(el);
}
function createAbsoluteElement(el) {
    const root = document.createElement("div");
    root.style.position = "absolute";
    root.style.left = "0px";
    root.style.top = "0px";
    root.style.width = "100%";
    const wrapper = document.createElement("div");
    root.appendChild(wrapper);
    wrapper.appendChild(el);
    document.body.appendChild(root);
    return root;
}
function isVueComponent(c) {
    return c != null && c.$ != null && c.$.vnode != null;
}
function escapeRegExpChars(value) {
    if (!value) return value;
    return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
function removeDiacriticsFromString(value) {
    if (!value) return value;
    return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function multiColumnSort(inputArray, sortingPriority) {
    const array = JSON.parse(JSON.stringify(inputArray));
    const fieldSorter = (fields)=>(a, b)=>fields.map((o)=>{
                const { field, order, customSort } = o;
                if (typeof customSort === "function") return customSort(a, b, order !== "desc");
                else {
                    const aValue = getValueByPath(a, field);
                    const bValue = getValueByPath(b, field);
                    const ord = aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
                    return order === "desc" ? -ord : ord;
                }
            }).reduce((p, n)=>p || n, 0);
    return array.sort(fieldSorter(sortingPriority));
}
function createNewEvent(eventName) {
    let event;
    if (typeof Event === "function") event = new Event(eventName);
    else {
        event = document.createEvent("Event");
        event.initEvent(eventName, true, true);
    }
    return event;
}
function toCssWidth(width) {
    return width === void 0 ? null : isNaN(+width) ? `${width}` : width + "px";
}
function getMonthNames(locale, format = "long") {
    const dates = [];
    for(let i = 0; i < 12; i++)dates.push(new Date(2e3, i, 15));
    const dtf = new Intl.DateTimeFormat(locale, {
        month: format
    });
    return dates.map((d)=>dtf.format(d));
}
function getWeekdayNames(locale, format = "narrow") {
    const dates = [];
    for(let i = 0; i < 7; i++){
        const dt = new Date(2e3, 0, i + 1);
        dates[dt.getDay()] = dt;
    }
    const dtf = new Intl.DateTimeFormat(locale, {
        weekday: format
    });
    return dates.map((d)=>dtf.format(d));
}
function matchWithGroups(pattern, str) {
    const matches = str.match(pattern);
    const groupNames = pattern.toString().match(/<(.+?)>/g);
    if (groupNames == null) throw new RangeError("pattern must contain at least one group");
    return groupNames.map((group)=>{
        const groupMatches = group.match(/<(.+)>/);
        return groupMatches[1];
    }).reduce((acc, curr, index)=>{
        if (matches && matches.length > index) acc[curr] = matches[index + 1];
        else acc[curr] = null;
        return acc;
    }, {});
}
function isWebpSupported() {
    return new Promise((resolve)=>{
        const image = new Image();
        image.onerror = ()=>resolve(false);
        image.onload = ()=>resolve(image.width === 1);
        image.src = "data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=";
    }).catch(()=>false);
}
function isCustomElement(vm) {
    return vm.$root != null && "shadowRoot" in vm.$root.$options;
}
const isDefined = (d)=>d !== void 0;
const isNil = (value)=>value === null || value === void 0;
function isFragment(vnode) {
    return vnode.type === (0, _vue.Fragment);
}
function isTag(vnode) {
    return vnode.type !== (0, _vue.Comment) && vnode.type !== (0, _vue.Text) && vnode.type !== (0, _vue.Static);
}
function getComponentFromVNode(vnode) {
    if (!vnode) return void 0;
    const { component } = vnode;
    if (!component) return void 0;
    return component.exposed && component.exposeProxy || component.proxy;
}
function copyAppContext(src, dest) {
    const { _context: srcContext } = src;
    const { _context: destContext } = dest;
    destContext.config = srcContext.config;
    destContext.mixins = srcContext.mixins;
    destContext.components = srcContext.components;
    destContext.directives = srcContext.directives;
    destContext.provides = srcContext.provides;
    destContext.optionsCache = srcContext.optionsCache;
    destContext.propsCache = srcContext.propsCache;
    destContext.emitsCache = srcContext.emitsCache;
    if ("__VUE_I18N_SYMBOL__" in src) dest.__VUE_I18N_SYMBOL__ = src.__VUE_I18N_SYMBOL__;
}
const translateTouchAsDragEvent = (event, options)=>{
    const { type, target } = options;
    let translateX = 0;
    let translateY = 0;
    if (target != null && target !== event.target) {
        const baseRect = event.target.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();
        translateX = targetRect.left - baseRect.left;
        translateY = targetRect.top - baseRect.top;
    }
    const touch = event.touches[0] || event.changedTouches[0];
    return new DragEvent(type, {
        dataTransfer: new DataTransfer(),
        bubbles: true,
        screenX: touch.screenX,
        screenY: touch.screenY,
        clientX: touch.clientX + translateX,
        clientY: touch.clientY + translateY,
        ctrlKey: event.ctrlKey,
        shiftKey: event.shiftKey,
        altKey: event.altKey,
        metaKey: event.metaKey
    });
};
var ConfigComponent = {
    getOptions () {
        return config;
    },
    setOptions (options) {
        setOptions(merge(config, options, true));
    }
};
var __getOwnPropSymbols$c = Object.getOwnPropertySymbols;
var __hasOwnProp$c = Object.prototype.hasOwnProperty;
var __propIsEnum$c = Object.prototype.propertyIsEnumerable;
var __objRest$3 = (source, exclude)=>{
    var target = {};
    for(var prop in source)if (__hasOwnProp$c.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$c) {
        for (var prop of __getOwnPropSymbols$c(source))if (exclude.indexOf(prop) < 0 && __propIsEnum$c.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var CompatFallthroughMixin = (0, _vue.defineComponent)({
    inheritAttrs: false,
    props: {
        compatFallthrough: {
            type: Boolean,
            default: ()=>config.defaultCompatFallthrough
        }
    },
    computed: {
        rootAttrs () {
            return this.compatFallthrough ? {
                class: this.$attrs.class,
                style: this.$attrs.style,
                id: this.$attrs.id
            } : {};
        },
        fallthroughAttrs () {
            if (this.compatFallthrough) {
                const _a = this.$attrs, { style: _1, class: _2, id: _3 } = _a, rest = __objRest$3(_a, [
                    "style",
                    "class",
                    "id"
                ]);
                return rest;
            } else return this.$attrs;
        }
    }
});
var _sfc_main$S = (0, _vue.defineComponent)({
    name: "BFieldBody",
    inject: {
        parent: {
            from: "BField",
            default: null
        }
    },
    props: {
        message: {
            type: [
                String,
                Array
            ]
        },
        type: {
            type: [
                String,
                Object
            ]
        }
    },
    render () {
        let first = true;
        let children = typeof this.$slots.default === "function" ? this.$slots.default() : this.$slots.default;
        if (children != null && children.length === 1 && children[0].type === (0, _vue.Fragment)) children = children[0].children;
        return (0, _vue.h)("div", {
            class: "field-body"
        }, {
            default: ()=>{
                return children != null && children.map((element)=>{
                    if (element.type === (0, _vue.Comment) || element.type === (0, _vue.Text)) return element;
                    let message;
                    if (first) {
                        message = this.message;
                        first = false;
                    }
                    const parentField = this.parent;
                    return (0, _vue.h)(// parentField.$.type is supposed to be BField
                    // it falls back to `resolveComponent('b-field')`
                    // but won't work unless `BField` is globally registered
                    // should not be a problem as long as `BFieldBody` is properly used
                    parentField ? parentField.$.type : (0, _vue.resolveComponent)("b-field"), {
                        type: this.type,
                        message
                    }, ()=>element);
                });
            }
        });
    }
});
const Field$1 = (0, _vue.defineComponent)({
    name: "BField",
    components: {
        BFieldBody: _sfc_main$S
    },
    provide () {
        return {
            BField: this
        };
    },
    inject: {
        parent: {
            from: "BField",
            default: false
        }
    },
    // Used internally only when using Field in Field
    props: {
        type: {
            type: [
                String,
                Object
            ],
            default: void 0
        },
        label: String,
        labelFor: String,
        message: {
            type: [
                String,
                Array,
                Object
            ],
            default: void 0
        },
        grouped: Boolean,
        groupMultiline: Boolean,
        position: String,
        expanded: Boolean,
        horizontal: Boolean,
        addons: {
            type: Boolean,
            default: true
        },
        customClass: String,
        labelPosition: {
            type: String,
            default: ()=>{
                return config.defaultFieldLabelPosition;
            }
        }
    },
    data () {
        return {
            newType: this.type,
            newMessage: this.message,
            fieldLabelSize: null,
            numberInputClasses: [],
            _isField: true
        };
    },
    computed: {
        rootClasses () {
            return [
                {
                    "is-expanded": this.expanded,
                    "is-horizontal": this.horizontal,
                    "is-floating-in-label": this.hasLabel && !this.horizontal && this.labelPosition === "inside",
                    "is-floating-label": this.hasLabel && !this.horizontal && this.labelPosition === "on-border"
                },
                this.numberInputClasses
            ];
        },
        innerFieldClasses () {
            return [
                this.fieldType(),
                this.newPosition,
                {
                    "is-grouped-multiline": this.groupMultiline
                }
            ];
        },
        hasInnerField () {
            return this.grouped || this.groupMultiline || this.hasAddons();
        },
        /*
    * Correct Bulma class for the side of the addon or group.
    *
    * This is not kept like the others (is-small, etc.),
    * because since 'has-addons' is set automatically it
    * doesn't make sense to teach users what addons are exactly.
    */ newPosition () {
            if (this.position === void 0) return;
            const position = this.position.split("-");
            if (position.length < 1) return;
            const prefix = this.grouped ? "is-grouped-" : "has-addons-";
            if (this.position) return prefix + position[1];
            return void 0;
        },
        /*
    * Formatted message in case it's an array
    * (each element is separated by <br> tag)
    */ formattedMessage () {
            const parentField = this.parent;
            if (parentField && parentField.hasInnerField) return "";
            if (typeof this.newMessage === "string") return [
                this.newMessage
            ];
            const messages = [];
            if (Array.isArray(this.newMessage)) this.newMessage.forEach((message)=>{
                if (typeof message === "string") messages.push(message);
                else {
                    for(const key in message)if (message[key]) messages.push(key);
                }
            });
            else {
                for(const key in this.newMessage)if (this.newMessage[key]) messages.push(key);
            }
            return messages.filter((m)=>!!m);
        },
        hasLabel () {
            return this.label || this.$slots.label;
        },
        hasMessage () {
            const parentField = this.parent;
            return (!parentField || !parentField.hasInnerField) && this.newMessage || this.$slots.message;
        }
    },
    watch: {
        /*
    * Set internal type when prop change.
    */ type (value) {
            this.newType = value;
        },
        /*
    * Set internal message when prop change.
    */ message (value) {
            if (JSON.stringify(value) !== JSON.stringify(this.newMessage)) this.newMessage = value;
        },
        /*
    * Set parent message if we use Field in Field.
    */ newMessage (value) {
            const parentField = this.parent;
            if (parentField && parentField.hasInnerField) {
                if (!parentField.type) parentField.newType = this.newType;
                if (!parentField.message) parentField.newMessage = value;
            }
        }
    },
    methods: {
        /*
    * Field has addons if there are more than one slot
    * (element / component) in the Field.
    * Or is grouped when prop is set.
    * Is a method to be called when component re-render.
    */ fieldType () {
            if (this.grouped) return "is-grouped";
            if (this.hasAddons()) return "has-addons";
        },
        hasAddons () {
            let renderedNode = 0;
            if (this.$slots.default) renderedNode = this.$slots.default().reduce((i, node)=>isTag(node) ? i + 1 : i, 0);
            return renderedNode > 1 && this.addons && !this.horizontal;
        },
        // called by a number input if it is a direct child.
        wrapNumberinput ({ controlsPosition, size }) {
            const classes = [
                "has-numberinput"
            ];
            if (controlsPosition) classes.push(`has-numberinput-${controlsPosition}`);
            if (size) classes.push(`has-numberinput-${size}`);
            this.numberInputClasses = classes;
        }
    },
    mounted () {
        if (this.horizontal) {
            const elements = this.$el.querySelectorAll(".input, .select, .button, .textarea, .b-slider");
            if (elements.length > 0) this.fieldLabelSize = "is-normal";
        }
    }
});
var _export_sfc = (sfc, props)=>{
    const target = sfc.__vccOpts || sfc;
    for (const [key, val] of props)target[key] = val;
    return target;
};
const _hoisted_1$T = [
    "for"
];
const _hoisted_2$J = [
    "for"
];
const _hoisted_3$u = {
    key: 3,
    class: "field-body"
};
function _sfc_render$10(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_field_body = (0, _vue.resolveComponent)("b-field-body");
    const _component_b_field = (0, _vue.resolveComponent)("b-field");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "field",
            _ctx.rootClasses
        ])
    }, [
        _ctx.horizontal ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
            key: 0,
            class: (0, _vue.normalizeClass)([
                "field-label",
                [
                    _ctx.customClass,
                    _ctx.fieldLabelSize
                ]
            ])
        }, [
            _ctx.hasLabel ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("label", {
                key: 0,
                for: _ctx.labelFor,
                class: (0, _vue.normalizeClass)([
                    _ctx.customClass,
                    "label"
                ])
            }, [
                _ctx.$slots.label ? (0, _vue.renderSlot)(_ctx.$slots, "label", {
                    key: 0
                }) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                    key: 1
                }, [
                    (0, _vue.createTextVNode)((0, _vue.toDisplayString)(_ctx.label), 1)
                ], 64))
            ], 10, _hoisted_1$T)) : (0, _vue.createCommentVNode)("v-if", true)
        ], 2)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
            key: 1
        }, [
            _ctx.hasLabel ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("label", {
                key: 0,
                for: _ctx.labelFor,
                class: (0, _vue.normalizeClass)([
                    _ctx.customClass,
                    "label"
                ])
            }, [
                _ctx.$slots.label ? (0, _vue.renderSlot)(_ctx.$slots, "label", {
                    key: 0
                }) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                    key: 1
                }, [
                    (0, _vue.createTextVNode)((0, _vue.toDisplayString)(_ctx.label), 1)
                ], 64))
            ], 10, _hoisted_2$J)) : (0, _vue.createCommentVNode)("v-if", true)
        ], 64)),
        _ctx.horizontal ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_field_body, {
            key: 2,
            message: _ctx.newMessage ? _ctx.formattedMessage : "",
            type: _ctx.newType
        }, {
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.renderSlot)(_ctx.$slots, "default")
                ]),
            _: 3
        }, 8, [
            "message",
            "type"
        ])) : _ctx.hasInnerField ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_3$u, [
            (0, _vue.createVNode)(_component_b_field, {
                addons: false,
                type: _ctx.type,
                class: (0, _vue.normalizeClass)(_ctx.innerFieldClasses)
            }, {
                default: (0, _vue.withCtx)(()=>[
                        (0, _vue.renderSlot)(_ctx.$slots, "default")
                    ]),
                _: 3
            }, 8, [
                "type",
                "class"
            ])
        ])) : (0, _vue.renderSlot)(_ctx.$slots, "default", {
            key: 4
        }),
        _ctx.hasMessage && !_ctx.horizontal ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", {
            key: 5,
            class: (0, _vue.normalizeClass)([
                "help",
                _ctx.newType
            ])
        }, [
            _ctx.$slots.message ? (0, _vue.renderSlot)(_ctx.$slots, "message", {
                key: 0,
                messages: _ctx.formattedMessage
            }) : ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                key: 1
            }, (0, _vue.renderList)(_ctx.formattedMessage, (mess, i)=>{
                return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, [
                    (0, _vue.createTextVNode)((0, _vue.toDisplayString)(mess) + " ", 1),
                    i + 1 < _ctx.formattedMessage.length ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("br", {
                        key: i
                    })) : (0, _vue.createCommentVNode)("v-if", true)
                ], 64);
            }), 256))
        ], 2)) : (0, _vue.createCommentVNode)("v-if", true)
    ], 2);
}
var Field = /* @__PURE__ */ _export_sfc(Field$1, [
    [
        "render",
        _sfc_render$10
    ]
]);
const FormElementMixin = (0, _vue.defineComponent)({
    props: {
        size: String,
        expanded: Boolean,
        loading: Boolean,
        rounded: Boolean,
        icon: String,
        iconPack: String,
        maxlength: [
            Number,
            String
        ],
        useHtml5Validation: {
            type: Boolean,
            default: ()=>config.defaultUseHtml5Validation
        },
        validationMessage: String,
        locale: {
            type: [
                String,
                Array
            ],
            default: ()=>{
                return config.defaultLocale;
            }
        },
        statusIcon: {
            type: Boolean,
            default: ()=>{
                return config.defaultStatusIcon;
            }
        }
    },
    emits: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        blur: (event)=>true,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        focus: (event)=>true
    },
    data () {
        return {
            isValid: true,
            isFocused: false,
            newIconPack: this.iconPack || config.defaultIconPack,
            // host component must override this
            _elementRef: ""
        };
    },
    computed: {
        /*
     * Find parent Field, max 3 levels deep.
     */ parentField () {
            let parent = this.$parent;
            for(let i = 0; i < 3; i++)if (parent && !parent.$data._isField) parent = parent.$parent;
            return parent;
        },
        /*
     * Get the type prop from parent if it's a Field.
     */ statusType () {
            const { newType } = this.parentField || {};
            if (!newType) return;
            if (typeof newType === "string") return newType;
            else for(const key in newType){
                if (newType[key]) return key;
            }
            return void 0;
        },
        /*
     * Get the message prop from parent if it's a Field.
     */ statusMessage () {
            if (!this.parentField) return;
            return this.parentField.newMessage || this.parentField.$slots.message;
        },
        /*
     * Fix icon size for inputs, large was too big
     */ iconSize () {
            switch(this.size){
                case "is-small":
                    return this.size;
                case "is-medium":
                    return;
                case "is-large":
                    return this.newIconPack === "mdi" ? "is-medium" : "";
            }
            return void 0;
        }
    },
    methods: {
        /*
     * Focus method that work dynamically depending on the component.
     */ focus () {
            const el = this.getElement();
            if (el === void 0) return;
            this.$nextTick(()=>{
                if (el) el.focus();
            });
        },
        onBlur ($event) {
            this.isFocused = false;
            this.$emit("blur", $event);
            this.checkHtml5Validity();
        },
        onFocus ($event) {
            this.isFocused = true;
            this.$emit("focus", $event);
        },
        getElement () {
            let el = this.$refs[this.$data._elementRef];
            while(el != null && typeof el === "object" && "$refs" in el){
                const form = el;
                el = form.$refs[form.$data._elementRef];
            }
            return el;
        },
        setInvalid () {
            const type = "is-danger";
            const message = this.validationMessage || this.getElement().validationMessage;
            this.setValidity(type, message);
        },
        setValidity (type, message) {
            this.$nextTick(()=>{
                if (this.parentField) {
                    if (!this.parentField.type) this.parentField.newType = type;
                    if (!this.parentField.message) this.parentField.newMessage = message;
                }
            });
        },
        /*
     * Check HTML5 validation, set isValid property.
     * If validation fail, send 'is-danger' type,
     * and error message to parent if it's a Field.
     */ checkHtml5Validity () {
            if (!this.useHtml5Validation) return false;
            const el = this.getElement();
            if (el == null) return false;
            if (!el.checkValidity()) {
                this.setInvalid();
                this.isValid = false;
            } else {
                this.setValidity(null, null);
                this.isValid = true;
            }
            return this.isValid;
        }
    }
});
const mdiIcons = {
    sizes: {
        default: "mdi-24px",
        "is-small": null,
        "is-medium": "mdi-36px",
        "is-large": "mdi-48px"
    },
    iconPrefix: "mdi-"
};
const faIcons = ()=>{
    const faIconPrefix = config && config.defaultIconComponent ? "" : "fa-";
    return {
        sizes: {
            default: null,
            "is-small": null,
            "is-medium": faIconPrefix + "lg",
            "is-large": faIconPrefix + "2x"
        },
        iconPrefix: faIconPrefix,
        internalIcons: {
            information: "info-circle",
            alert: "exclamation-triangle",
            "alert-circle": "exclamation-circle",
            "chevron-right": "angle-right",
            "chevron-left": "angle-left",
            "chevron-down": "angle-down",
            "eye-off": "eye-slash",
            "menu-down": "caret-down",
            "menu-up": "caret-up",
            "close-circle": "times-circle"
        }
    };
};
const getIcons = ()=>{
    let icons = {
        mdi: mdiIcons,
        fa: faIcons(),
        fas: faIcons(),
        far: faIcons(),
        fad: faIcons(),
        fab: faIcons(),
        fal: faIcons(),
        "fa-solid": faIcons(),
        "fa-regular": faIcons(),
        "fa-light": faIcons(),
        "fa-thin": faIcons(),
        "fa-duotone": faIcons(),
        "fa-brands": faIcons()
    };
    if (config && config.customIconPacks) icons = merge(icons, config.customIconPacks, true);
    return icons;
};
var _sfc_main$R = (0, _vue.defineComponent)({
    name: "BIcon",
    props: {
        type: [
            String,
            Object
        ],
        component: String,
        pack: String,
        icon: {
            type: String,
            required: true
        },
        size: String,
        customSize: String,
        customClass: String,
        both: Boolean
    },
    computed: {
        iconConfig () {
            const allIcons = getIcons();
            return allIcons[this.newPack];
        },
        iconPrefix () {
            if (this.iconConfig && this.iconConfig.iconPrefix) return this.iconConfig.iconPrefix;
            return "";
        },
        /*
    * Internal icon name based on the pack.
    * If pack is 'fa', gets the equivalent FA icon name of the MDI,
    * internal icons are always MDI.
    */ newIcon () {
            return `${this.iconPrefix}${this.getEquivalentIconOf(this.icon)}`;
        },
        newPack () {
            return this.pack || config.defaultIconPack;
        },
        newType () {
            if (!this.type) return;
            let splitType = [];
            if (typeof this.type === "string") splitType = this.type.split("-");
            else {
                for(const key in this.type)if (this.type[key]) {
                    splitType = key.split("-");
                    break;
                }
            }
            if (splitType.length <= 1) return;
            const [, ...type] = splitType;
            return `has-text-${type.join("-")}`;
        },
        newCustomSize () {
            return this.customSize || this.customSizeByPack;
        },
        customSizeByPack () {
            if (this.iconConfig && this.iconConfig.sizes) {
                if (this.size && this.iconConfig.sizes[this.size] !== void 0) return this.iconConfig.sizes[this.size];
                else if (this.iconConfig.sizes.default) return this.iconConfig.sizes.default;
            }
            return null;
        },
        useIconComponent () {
            return this.component || config.defaultIconComponent;
        }
    },
    methods: {
        /*
    * Equivalent icon name of the MDI.
    */ getEquivalentIconOf (value) {
            if (!this.both) return value;
            if (this.iconConfig == null) return value;
            const maybeInternal = this.iconConfig;
            if (maybeInternal && maybeInternal.internalIcons && maybeInternal.internalIcons[value]) return maybeInternal.internalIcons[value];
            return value;
        }
    }
});
function _sfc_render$$(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", {
        class: (0, _vue.normalizeClass)([
            "icon",
            [
                _ctx.newType,
                _ctx.size
            ]
        ])
    }, [
        !_ctx.useIconComponent ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", {
            key: 0,
            class: (0, _vue.normalizeClass)([
                _ctx.newPack,
                _ctx.newIcon,
                _ctx.newCustomSize,
                _ctx.customClass
            ])
        }, null, 2)) : ((0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.resolveDynamicComponent)(_ctx.useIconComponent), {
            key: 1,
            icon: [
                _ctx.newPack,
                _ctx.newIcon
            ],
            size: _ctx.newCustomSize,
            class: (0, _vue.normalizeClass)([
                _ctx.customClass
            ])
        }, null, 8, [
            "icon",
            "size",
            "class"
        ]))
    ], 2);
}
var BIcon = /* @__PURE__ */ _export_sfc(_sfc_main$R, [
    [
        "render",
        _sfc_render$$
    ]
]);
var _sfc_main$Q = (0, _vue.defineComponent)({
    name: "BInput",
    components: {
        BIcon
    },
    mixins: [
        CompatFallthroughMixin,
        FormElementMixin
    ],
    props: {
        modelValue: {
            type: [
                Number,
                String
            ]
        },
        type: {
            type: String,
            default: "text"
        },
        lazy: {
            type: Boolean,
            default: false
        },
        passwordReveal: Boolean,
        iconClickable: Boolean,
        hasCounter: {
            type: Boolean,
            default: ()=>config.defaultInputHasCounter
        },
        customClass: {
            type: String,
            default: ""
        },
        iconRight: String,
        iconRightClickable: Boolean,
        iconRightType: String,
        // Native options to use in HTML5 validation
        autocomplete: String
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars */ "icon-click": (event)=>true,
        "icon-right-click": (event)=>true,
        "update:modelValue": (value)=>true
    },
    data () {
        return {
            newValue: this.modelValue,
            newType: this.type,
            newAutocomplete: this.autocomplete || config.defaultInputAutocomplete,
            isPasswordVisible: false,
            _elementRef: this.type === "textarea" ? "textarea" : "input"
        };
    },
    computed: {
        computedValue: {
            get () {
                return this.newValue;
            },
            set (value) {
                this.newValue = value;
                this.$emit("update:modelValue", value);
            }
        },
        rootClasses () {
            return [
                this.iconPosition,
                this.size,
                {
                    "is-expanded": this.expanded,
                    "is-loading": this.loading,
                    "is-clearfix": !this.hasMessage
                }
            ];
        },
        inputClasses () {
            return [
                this.statusType,
                this.size,
                {
                    "is-rounded": this.rounded
                }
            ];
        },
        hasIconRight () {
            return this.passwordReveal || this.loading || this.statusIcon && this.statusTypeIcon || this.iconRight;
        },
        rightIcon () {
            if (this.passwordReveal) return this.passwordVisibleIcon;
            else if (this.iconRight) return this.iconRight;
            return this.statusTypeIcon;
        },
        rightIconType () {
            if (this.passwordReveal) return "is-primary";
            else if (this.iconRight) return this.iconRightType || void 0;
            return this.statusType;
        },
        /*
    * Position of the icon or if it's both sides.
    */ iconPosition () {
            let iconClasses = "";
            if (this.icon) iconClasses += "has-icons-left ";
            if (this.hasIconRight) iconClasses += "has-icons-right";
            return iconClasses;
        },
        /*
    * Icon name (MDI) based on the type.
    */ statusTypeIcon () {
            switch(this.statusType){
                case "is-success":
                    return "check";
                case "is-danger":
                    return "alert-circle";
                case "is-info":
                    return "information";
                case "is-warning":
                    return "alert";
                default:
                    return void 0;
            }
        },
        /*
    * Check if have any message prop from parent if it's a Field.
    */ hasMessage () {
            return !!this.statusMessage;
        },
        /*
    * Current password-reveal icon name.
    */ passwordVisibleIcon () {
            return !this.isPasswordVisible ? "eye" : "eye-off";
        },
        /*
    * Get value length
    */ valueLength () {
            if (typeof this.computedValue === "string") return Array.from(this.computedValue).length;
            else if (typeof this.computedValue === "number") return this.computedValue.toString().length;
            return 0;
        }
    },
    watch: {
        /*
    * When v-model is changed:
    *   1. Set internal value.
    *   2. Validate it if the value came from outside;
    *      i.e., not equal to computedValue
    */ modelValue (value) {
            const fromOutside = this.computedValue != value;
            this.newValue = value;
            if (fromOutside) this.$nextTick(()=>{
                !this.isValid && this.checkHtml5Validity();
            });
        },
        type (type) {
            this.newType = type;
        }
    },
    methods: {
        /*
    * Toggle the visibility of a password-reveal input
    * by changing the type and focus the input right away.
    */ togglePasswordVisibility () {
            this.isPasswordVisible = !this.isPasswordVisible;
            this.newType = this.isPasswordVisible ? "text" : "password";
            this.$nextTick(()=>{
                this.focus();
            });
        },
        iconClick (emit, event) {
            this.$emit(emit, event);
            this.$nextTick(()=>{
                this.focus();
            });
        },
        rightIconClick (event) {
            if (this.passwordReveal) this.togglePasswordVisibility();
            else if (this.iconRightClickable) this.iconClick("icon-right-click", event);
        },
        onInput () {
            if (!this.lazy) this.revalidate();
        },
        onChange () {
            if (this.lazy) this.revalidate();
        },
        revalidate () {
            !this.isValid && this.checkHtml5Validity();
        }
    }
});
const _hoisted_1$S = [
    "type",
    "autocomplete",
    "maxlength"
];
const _hoisted_2$I = [
    "maxlength"
];
const _hoisted_3$t = [
    "type",
    "autocomplete",
    "maxlength"
];
const _hoisted_4$l = [
    "maxlength"
];
function _sfc_render$_(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", (0, _vue.mergeProps)({
        class: [
            "control",
            _ctx.rootClasses
        ]
    }, _ctx.rootAttrs), [
        _ctx.lazy ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
            key: 0
        }, [
            _ctx.type !== "textarea" ? (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("input", (0, _vue.mergeProps)({
                key: 0,
                ref: "input",
                class: [
                    "input",
                    [
                        _ctx.inputClasses,
                        _ctx.customClass
                    ]
                ],
                type: _ctx.newType,
                autocomplete: _ctx.newAutocomplete,
                maxlength: _ctx.maxlength,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.computedValue = $event)
            }, _ctx.fallthroughAttrs, {
                onInput: _cache[1] || (_cache[1] = (...args)=>_ctx.onInput && _ctx.onInput(...args)),
                onChange: _cache[2] || (_cache[2] = (...args)=>_ctx.onChange && _ctx.onChange(...args)),
                onBlur: _cache[3] || (_cache[3] = (...args)=>_ctx.onBlur && _ctx.onBlur(...args)),
                onFocus: _cache[4] || (_cache[4] = (...args)=>_ctx.onFocus && _ctx.onFocus(...args))
            }), null, 16, _hoisted_1$S)), [
                [
                    (0, _vue.vModelDynamic),
                    _ctx.computedValue,
                    void 0,
                    {
                        lazy: true
                    }
                ]
            ]) : (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("textarea", (0, _vue.mergeProps)({
                key: 1,
                ref: "textarea",
                class: [
                    "textarea",
                    [
                        _ctx.inputClasses,
                        _ctx.customClass
                    ]
                ],
                maxlength: _ctx.maxlength,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>_ctx.computedValue = $event)
            }, _ctx.fallthroughAttrs, {
                onInput: _cache[6] || (_cache[6] = (...args)=>_ctx.onInput && _ctx.onInput(...args)),
                onChange: _cache[7] || (_cache[7] = (...args)=>_ctx.onChange && _ctx.onChange(...args)),
                onBlur: _cache[8] || (_cache[8] = (...args)=>_ctx.onBlur && _ctx.onBlur(...args)),
                onFocus: _cache[9] || (_cache[9] = (...args)=>_ctx.onFocus && _ctx.onFocus(...args))
            }), null, 16, _hoisted_2$I)), [
                [
                    (0, _vue.vModelText),
                    _ctx.computedValue,
                    void 0,
                    {
                        lazy: true
                    }
                ]
            ])
        ], 64)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
            key: 1
        }, [
            _ctx.type !== "textarea" ? (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("input", (0, _vue.mergeProps)({
                key: 0,
                ref: "input",
                class: [
                    "input",
                    [
                        _ctx.inputClasses,
                        _ctx.customClass
                    ]
                ],
                type: _ctx.newType,
                autocomplete: _ctx.newAutocomplete,
                maxlength: _ctx.maxlength,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event)=>_ctx.computedValue = $event)
            }, _ctx.fallthroughAttrs, {
                onInput: _cache[11] || (_cache[11] = (...args)=>_ctx.onInput && _ctx.onInput(...args)),
                onChange: _cache[12] || (_cache[12] = (...args)=>_ctx.onChange && _ctx.onChange(...args)),
                onBlur: _cache[13] || (_cache[13] = (...args)=>_ctx.onBlur && _ctx.onBlur(...args)),
                onFocus: _cache[14] || (_cache[14] = (...args)=>_ctx.onFocus && _ctx.onFocus(...args))
            }), null, 16, _hoisted_3$t)), [
                [
                    (0, _vue.vModelDynamic),
                    _ctx.computedValue
                ]
            ]) : (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("textarea", (0, _vue.mergeProps)({
                key: 1,
                ref: "textarea",
                class: [
                    "textarea",
                    [
                        _ctx.inputClasses,
                        _ctx.customClass
                    ]
                ],
                maxlength: _ctx.maxlength,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event)=>_ctx.computedValue = $event)
            }, _ctx.fallthroughAttrs, {
                onInput: _cache[16] || (_cache[16] = (...args)=>_ctx.onInput && _ctx.onInput(...args)),
                onChange: _cache[17] || (_cache[17] = (...args)=>_ctx.onChange && _ctx.onChange(...args)),
                onBlur: _cache[18] || (_cache[18] = (...args)=>_ctx.onBlur && _ctx.onBlur(...args)),
                onFocus: _cache[19] || (_cache[19] = (...args)=>_ctx.onFocus && _ctx.onFocus(...args))
            }), null, 16, _hoisted_4$l)), [
                [
                    (0, _vue.vModelText),
                    _ctx.computedValue
                ]
            ])
        ], 64)),
        _ctx.icon ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
            key: 2,
            class: (0, _vue.normalizeClass)([
                "is-left",
                {
                    "is-clickable": _ctx.iconClickable
                }
            ]),
            icon: _ctx.icon,
            pack: _ctx.iconPack,
            size: _ctx.iconSize,
            onClick: _cache[20] || (_cache[20] = ($event)=>_ctx.iconClick("icon-click", $event))
        }, null, 8, [
            "class",
            "icon",
            "pack",
            "size"
        ])) : (0, _vue.createCommentVNode)("v-if", true),
        !_ctx.loading && _ctx.hasIconRight && _ctx.rightIcon ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
            key: 3,
            class: (0, _vue.normalizeClass)([
                "is-right",
                {
                    "is-clickable": _ctx.passwordReveal || _ctx.iconRightClickable
                }
            ]),
            icon: _ctx.rightIcon,
            pack: _ctx.iconPack,
            size: _ctx.iconSize,
            type: _ctx.rightIconType,
            both: "",
            onClick: _ctx.rightIconClick
        }, null, 8, [
            "class",
            "icon",
            "pack",
            "size",
            "type",
            "onClick"
        ])) : (0, _vue.createCommentVNode)("v-if", true),
        _ctx.maxlength && _ctx.hasCounter && _ctx.type !== "number" ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("small", {
            key: 4,
            class: (0, _vue.normalizeClass)([
                "help counter",
                {
                    "is-invisible": !_ctx.isFocused
                }
            ])
        }, (0, _vue.toDisplayString)(_ctx.valueLength) + " / " + (0, _vue.toDisplayString)(_ctx.maxlength), 3)) : (0, _vue.createCommentVNode)("v-if", true)
    ], 16);
}
var BInput = /* @__PURE__ */ _export_sfc(_sfc_main$Q, [
    [
        "render",
        _sfc_render$_
    ]
]);
var _sfc_main$P = (0, _vue.defineComponent)({
    name: "BAutocomplete",
    components: {
        BInput
    },
    mixins: [
        CompatFallthroughMixin,
        FormElementMixin
    ],
    props: {
        modelValue: [
            Number,
            String,
            null
        ],
        data: {
            type: Array,
            default: ()=>[]
        },
        field: {
            type: String,
            default: "value"
        },
        keepFirst: Boolean,
        clearOnSelect: Boolean,
        openOnFocus: Boolean,
        customFormatter: {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            type: Function
        },
        checkInfiniteScroll: Boolean,
        keepOpen: Boolean,
        selectOnClickOutside: Boolean,
        clearable: Boolean,
        maxHeight: [
            String,
            Number
        ],
        dropdownPosition: {
            type: String,
            default: "auto"
        },
        groupField: String,
        groupOptions: String,
        iconRight: String,
        iconRightClickable: Boolean,
        appendToBody: Boolean,
        type: {
            type: String,
            default: "text"
        },
        confirmKeys: {
            type: Array,
            default: ()=>[
                    "Tab",
                    "Enter"
                ]
        },
        selectableHeader: Boolean,
        selectableFooter: Boolean,
        // Native options to use in HTML5 validation
        autocomplete: String
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any */ active: (active)=>true,
        blur: (event)=>true,
        focus: (event)=>true,
        "icon-click": (event)=>true,
        "icon-right-click": (event)=>true,
        "infinite-scroll": ()=>true,
        select: (selected, event)=>true,
        "select-footer": (event)=>true,
        "select-header": (event)=>true,
        typing: (value)=>true,
        "update:modelValue": (value)=>true
    },
    data () {
        return {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            selected: null,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            hovered: null,
            headerHovered: null,
            footerHovered: null,
            isActive: false,
            newValue: this.modelValue,
            newAutocomplete: this.autocomplete || "off",
            ariaAutocomplete: this.keepFirst ? "both" : "list",
            isListInViewportVertically: true,
            hasFocus: false,
            style: {},
            _isAutocomplete: true,
            _elementRef: "input",
            _bodyEl: void 0,
            // Used to append to body
            timeOutID: void 0
        };
    },
    computed: {
        computedData () {
            const { groupField, groupOptions } = this;
            if (groupField) {
                if (groupOptions) {
                    const newData = [];
                    this.data.forEach((option)=>{
                        const group = getValueByPath(option, groupField);
                        const items = getValueByPath(option, groupOptions);
                        newData.push({
                            group,
                            items
                        });
                    });
                    return newData;
                } else {
                    const tmp = {};
                    this.data.forEach((option)=>{
                        const group = getValueByPath(option, groupField);
                        if (!tmp[group]) tmp[group] = [];
                        tmp[group].push(option);
                    });
                    const newData = [];
                    Object.keys(tmp).forEach((group)=>{
                        newData.push({
                            group,
                            items: tmp[group]
                        });
                    });
                    return newData;
                }
            }
            return [
                {
                    items: this.data
                }
            ];
        },
        isEmpty () {
            if (!this.computedData) return true;
            return !this.computedData.some((element)=>element.items && element.items.length);
        },
        /*
     * White-listed items to not close when clicked.
     * Add input, dropdown and all children.
     */ whiteList () {
            var _a;
            this.computedData;
            const whiteList = [];
            whiteList.push(this.$refs.input.$el.querySelector("input"));
            whiteList.push(this.$refs.dropdown);
            if (this.$refs.dropdown != null) {
                const children = this.$refs.dropdown.querySelectorAll("*");
                for (const child of children)whiteList.push(child);
            }
            if (((_a = this.$parent) == null ? void 0 : _a.$data)._isTaginput) {
                whiteList.push(this.$parent.$el);
                const tagInputChildren = this.$parent.$el.querySelectorAll("*");
                for (const tagInputChild of tagInputChildren)whiteList.push(tagInputChild);
            }
            return whiteList;
        },
        /*
     * Check if exists default slot
     */ hasDefaultSlot () {
            return !!this.$slots.default;
        },
        /*
     * Check if exists group slot
     */ hasGroupSlot () {
            return !!this.$slots.group;
        },
        /*
     * Check if exists "empty" slot
     */ hasEmptySlot () {
            return !!this.$slots.empty;
        },
        /*
     * Check if exists "header" slot
     */ hasHeaderSlot () {
            return !!this.$slots.header;
        },
        /*
     * Check if exists "footer" slot
     */ hasFooterSlot () {
            return !!this.$slots.footer;
        },
        /*
     * Apply dropdownPosition property
     */ isOpenedTop () {
            return this.dropdownPosition === "top" || this.dropdownPosition === "auto" && !this.isListInViewportVertically;
        },
        newIconRight () {
            if (this.clearable && this.newValue) return "close-circle";
            return this.iconRight;
        },
        newIconRightClickable () {
            if (this.clearable) return true;
            return this.iconRightClickable;
        },
        contentStyle () {
            return {
                maxHeight: toCssWidth(this.maxHeight) || void 0
            };
        }
    },
    watch: {
        /*
     * When dropdown is toggled, check the visibility to know when
     * to open upwards.
     */ isActive (active) {
            if (this.dropdownPosition === "auto") {
                if (active) this.calcDropdownInViewportVertical();
                else this.timeOutID = setTimeout(()=>{
                    this.calcDropdownInViewportVertical();
                }, 100);
            }
            this.$nextTick(()=>{
                this.$emit("active", active);
            });
        },
        /*
     * When checkInfiniteScroll property changes scroll event should be removed or added
     */ checkInfiniteScroll (checkInfiniteScroll) {
            if (!this.$refs.dropdown) return;
            const list = this.$refs.dropdown.querySelector(".dropdown-content");
            if (!list) return;
            if (checkInfiniteScroll === true) {
                list.addEventListener("scroll", this.checkIfReachedTheEndOfScroll);
                return;
            }
            list.removeEventListener("scroll", this.checkIfReachedTheEndOfScroll);
        },
        /*
     * When updating input's value
     *   1. Emit changes
     *   2. If value isn't the same as selected, set null
     *   3. Close dropdown if value is clear or else open it
     */ newValue (value) {
            this.$emit("update:modelValue", value);
            const currentValue = this.getValue(this.selected);
            if (currentValue !== void 0 && currentValue !== null && currentValue !== value) this.setSelected(null, false);
            if (this.hasFocus && (!this.openOnFocus || value !== "")) this.isActive = value !== "" && value !== void 0 && value !== null;
        },
        /*
     * When v-model is changed:
     *   1. Update internal value.
     *   2. If it's invalid, validate again.
     */ modelValue (value) {
            this.newValue = value;
        },
        keepFirst (value) {
            this.ariaAutocomplete = value ? "both" : "list";
        },
        /*
     * Select first option if "keep-first
     */ data () {
            if (this.keepFirst) this.$nextTick(()=>{
                if (this.isActive) this.selectFirstOption(this.computedData);
                else this.setHovered(null);
            });
            else if (this.hovered) {
                const hoveredValue = this.getValue(this.hovered);
                const data = this.computedData.map((d)=>d.items).reduce((a, b)=>[
                        ...a,
                        ...b
                    ], []);
                if (!data.some((d)=>this.getValue(d) === hoveredValue)) this.setHovered(null);
            }
        },
        /*
     * When appendToBody property changes, handle the transition properly
     */ appendToBody (newValue, oldValue) {
            if (newValue && !oldValue) {
                if (this.isActive && this.$refs.dropdown && !this.$data._bodyEl) {
                    this.$data._bodyEl = createAbsoluteElement(this.$refs.dropdown);
                    this.updateAppendToBody();
                }
            } else if (!newValue && oldValue) {
                if (this.$data._bodyEl) {
                    removeElement(this.$data._bodyEl);
                    this.$data._bodyEl = void 0;
                }
            }
        }
    },
    methods: {
        /*
     * Set which option is currently hovered.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setHovered (option) {
            if (option === void 0) return;
            this.hovered = option;
        },
        /*
     * Set which option is currently selected, update v-model,
     * update input value and close dropdown.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setSelected (option, closeDropdown = true, event) {
            if (option === void 0) return;
            this.selected = option;
            this.$emit("select", this.selected, event);
            if (this.selected !== null) {
                if (this.clearOnSelect) this.newValue = "";
                else this.newValue = this.getValue(this.selected);
                this.setHovered(null);
            }
            closeDropdown && this.$nextTick(()=>{
                this.isActive = false;
            });
            this.checkValidity();
        },
        /*
     * Select first option
     */ selectFirstOption (computedData) {
            this.$nextTick(()=>{
                const nonEmptyElements = computedData.filter((element)=>element.items && element.items.length);
                if (nonEmptyElements.length) {
                    const option = nonEmptyElements[0].items[0];
                    this.setHovered(option);
                } else this.setHovered(null);
            });
        },
        /*
     * Find index of hovered item in data array by comparing display values
     * instead of object references. This fixes the bug with computed data
     * where proxy objects cause indexOf to fail.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
        findHoveredIndex (data) {
            if (this.hovered === null || this.hovered === void 0) return -1;
            const exactIndex = data.indexOf(this.hovered);
            if (exactIndex !== -1) return exactIndex;
            const hoveredValue = this.getValue(this.hovered);
            if (hoveredValue === null || hoveredValue === void 0) return -1;
            return data.findIndex((item)=>{
                if (item === null || item === void 0) return hoveredValue === null || hoveredValue === void 0;
                return this.getValue(item) === hoveredValue;
            });
        },
        keydown (event) {
            const { key } = event;
            if (key === "Enter") event.preventDefault();
            if (key === "Escape" || key === "Tab") this.isActive = false;
            if (this.confirmKeys.indexOf(key) >= 0) {
                if (key === ",") event.preventDefault();
                const closeDropdown = !this.keepOpen || key === "Tab";
                if (this.hovered === null) {
                    this.checkIfHeaderOrFooterSelected(event, null, closeDropdown);
                    return;
                }
                this.setSelected(this.hovered, closeDropdown, event);
            }
        },
        selectHeaderOrFoterByClick (event, origin) {
            this.checkIfHeaderOrFooterSelected(event, {
                origin
            });
        },
        /*
     * Check if header or footer was selected.
     */ checkIfHeaderOrFooterSelected (event, triggerClick, closeDropdown = true) {
            if (this.selectableHeader && (this.headerHovered || triggerClick && triggerClick.origin === "header")) {
                this.$emit("select-header", event);
                this.headerHovered = false;
                if (triggerClick) this.setHovered(null);
                if (closeDropdown) this.isActive = false;
            }
            if (this.selectableFooter && (this.footerHovered || triggerClick && triggerClick.origin === "footer")) {
                this.$emit("select-footer", event);
                this.footerHovered = false;
                if (triggerClick) this.setHovered(null);
                if (closeDropdown) this.isActive = false;
            }
        },
        /*
     * Close dropdown if clicked outside.
     */ clickedOutside (event) {
            const target = isCustomElement(this) ? event.composedPath()[0] : event.target;
            if (!this.hasFocus && this.whiteList.indexOf(target) < 0) {
                if (this.keepFirst && this.hovered && this.selectOnClickOutside) this.setSelected(this.hovered, true);
                else this.isActive = false;
            }
        },
        /*
     * Return display text for the input.
     * If object, get value from path, or else just the value.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
        getValue (option) {
            if (option === null) return;
            if (typeof this.customFormatter !== "undefined") return this.customFormatter(option);
            return typeof option === "object" ? getValueByPath(option, this.field) : option;
        },
        /*
     * Check if the scroll list inside the dropdown
     * reached it's end.
     */ checkIfReachedTheEndOfScroll () {
            const list = this.$refs.dropdown.querySelector(".dropdown-content");
            const footerHeight = this.hasFooterSlot ? list.querySelectorAll("div.dropdown-footer")[0].clientHeight : 0;
            if (list.clientHeight !== list.scrollHeight && list.scrollTop + list.parentElement.clientHeight + footerHeight >= list.scrollHeight) this.$emit("infinite-scroll");
        },
        /*
     * Calculate if the dropdown is vertically visible when activated,
     * otherwise it is openened upwards.
     */ calcDropdownInViewportVertical () {
            this.$nextTick(()=>{
                var _a;
                if (this.$refs.dropdown == null) return;
                const rect = this.$refs.dropdown.getBoundingClientRect();
                this.isListInViewportVertically = rect.top >= 0 && rect.bottom <= ((window == null ? void 0 : window.innerHeight) || ((_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.clientHeight));
                if (this.appendToBody) this.updateAppendToBody();
            });
        },
        /*
     * Arrows keys listener.
     * If dropdown is active, set hovered option, or else just open.
     */ keyArrows (direction) {
            const sum = direction === "down" ? 1 : -1;
            if (this.isActive) {
                const data = this.computedData.map((d)=>d.items).reduce((a, b)=>[
                        ...a,
                        ...b
                    ], []);
                if (this.hasHeaderSlot && this.selectableHeader) data.unshift(void 0);
                if (this.hasFooterSlot && this.selectableFooter) data.push(void 0);
                let index;
                if (this.headerHovered) index = 0 + sum;
                else if (this.footerHovered) index = data.length - 1 + sum;
                else index = this.findHoveredIndex(data) + sum;
                index = index > data.length - 1 ? data.length - 1 : index;
                index = index < 0 ? 0 : index;
                this.footerHovered = false;
                this.headerHovered = false;
                this.setHovered(data[index] !== void 0 ? data[index] : null);
                if (this.hasFooterSlot && this.selectableFooter && index === data.length - 1) this.footerHovered = true;
                if (this.hasHeaderSlot && this.selectableHeader && index === 0) this.headerHovered = true;
                const list = this.$refs.dropdown.querySelector(".dropdown-content");
                let querySelectorText = "a.dropdown-item:not(.is-disabled)";
                if (this.hasHeaderSlot && this.selectableHeader) querySelectorText += ",div.dropdown-header";
                if (this.hasFooterSlot && this.selectableFooter) querySelectorText += ",div.dropdown-footer";
                const element = list.querySelectorAll(querySelectorText)[index];
                if (!element) return;
                const visMin = list.scrollTop;
                const visMax = list.scrollTop + list.clientHeight - element.clientHeight;
                if (element.offsetTop < visMin) list.scrollTop = element.offsetTop;
                else if (element.offsetTop >= visMax) list.scrollTop = element.offsetTop - list.clientHeight + element.clientHeight;
            } else this.isActive = true;
        },
        /*
     * Focus listener.
     * If value is the same as selected, select all text.
     */ focused (event) {
            if (this.getValue(this.selected) === this.newValue) this.$el.querySelector("input").select();
            if (this.openOnFocus) {
                this.isActive = true;
                if (this.keepFirst) this.selectFirstOption(this.computedData);
            }
            this.hasFocus = true;
            this.$emit("focus", event);
        },
        /*
     * Blur listener.
     */ onBlur (event) {
            this.hasFocus = false;
            this.$emit("blur", event);
        },
        onInput () {
            const currentValue = this.getValue(this.selected);
            if (currentValue !== void 0 && currentValue !== null && currentValue === this.newValue) return;
            this.$emit("typing", this.newValue);
            this.checkValidity();
        },
        rightIconClick (event) {
            if (this.clearable) {
                this.newValue = "";
                this.setSelected(null, false);
                if (this.openOnFocus) this.$refs.input.$el.focus();
            } else this.$emit("icon-right-click", event);
        },
        checkValidity () {
            if (this.useHtml5Validation) this.$nextTick(()=>{
                this.checkHtml5Validity();
            });
        },
        updateAppendToBody () {
            const dropdownMenu = this.$refs.dropdown;
            const trigger = this.$parent.$data._isTaginput ? this.$parent.$el : this.$refs.input.$el;
            if (dropdownMenu && trigger) {
                if (!this.$data._bodyEl) this.$data._bodyEl = createAbsoluteElement(dropdownMenu);
                const root = this.$data._bodyEl;
                root.classList.forEach((item)=>root.classList.remove(item));
                root.classList.add("autocomplete");
                root.classList.add("control");
                if (this.expanded) root.classList.add("is-expanded");
                const rect = trigger.getBoundingClientRect();
                let top = rect.top + window.scrollY;
                const left = rect.left + window.scrollX;
                if (!this.isOpenedTop) top += trigger.clientHeight;
                else top -= dropdownMenu.clientHeight;
                this.style = {
                    position: "absolute",
                    top: `${top}px`,
                    left: `${left}px`,
                    width: `${trigger.clientWidth}px`,
                    maxWidth: `${trigger.clientWidth}px`,
                    zIndex: "99"
                };
            }
        }
    },
    created () {
        if (typeof window !== "undefined") {
            document.addEventListener("click", this.clickedOutside);
            if (this.dropdownPosition === "auto") window.addEventListener("resize", this.calcDropdownInViewportVertical);
            if (this.appendToBody) window.addEventListener("scroll", this.calcDropdownInViewportVertical);
        }
    },
    mounted () {
        if (this.checkInfiniteScroll && this.$refs.dropdown && this.$refs.dropdown.querySelector(".dropdown-content")) {
            const list = this.$refs.dropdown.querySelector(".dropdown-content");
            list.addEventListener("scroll", this.checkIfReachedTheEndOfScroll);
        }
        if (this.appendToBody) {
            this.$data._bodyEl = createAbsoluteElement(this.$refs.dropdown);
            this.updateAppendToBody();
        }
    },
    beforeUnmount () {
        if (typeof window !== "undefined") {
            document.removeEventListener("click", this.clickedOutside);
            if (this.dropdownPosition === "auto") window.removeEventListener("resize", this.calcDropdownInViewportVertical);
            if (this.appendToBody) window.removeEventListener("scroll", this.calcDropdownInViewportVertical);
        }
        if (this.checkInfiniteScroll && this.$refs.dropdown && this.$refs.dropdown.querySelector(".dropdown-content")) {
            const list = this.$refs.dropdown.querySelector(".dropdown-content");
            list.removeEventListener("scroll", this.checkIfReachedTheEndOfScroll);
        }
        if (this.appendToBody && this.$data._bodyEl) removeElement(this.$data._bodyEl);
        clearTimeout(this.timeOutID);
    }
});
const _hoisted_1$R = {
    key: 1,
    class: "has-text-weight-bold"
};
const _hoisted_2$H = [
    "onClick"
];
const _hoisted_3$s = {
    key: 1
};
const _hoisted_4$k = {
    key: 1,
    class: "dropdown-item is-disabled"
};
function _sfc_render$Z(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_input = (0, _vue.resolveComponent)("b-input");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", (0, _vue.mergeProps)({
        class: [
            "autocomplete control",
            {
                "is-expanded": _ctx.expanded
            }
        ]
    }, _ctx.rootAttrs), [
        (0, _vue.createVNode)(_component_b_input, (0, _vue.mergeProps)({
            modelValue: _ctx.newValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.newValue = $event),
            ref: "input",
            type: _ctx.type,
            size: _ctx.size,
            loading: _ctx.loading,
            rounded: _ctx.rounded,
            icon: _ctx.icon,
            "icon-right": _ctx.newIconRight,
            "icon-right-clickable": _ctx.newIconRightClickable,
            "icon-pack": _ctx.iconPack,
            maxlength: _ctx.maxlength,
            autocomplete: _ctx.newAutocomplete,
            "use-html5-validation": false,
            "aria-autocomplete": _ctx.ariaAutocomplete
        }, _ctx.fallthroughAttrs, {
            "onUpdate:modelValue": _ctx.onInput,
            onFocus: _ctx.focused,
            onBlur: _ctx.onBlur,
            onKeydown: [
                _ctx.keydown,
                _cache[1] || (_cache[1] = (0, _vue.withKeys)((0, _vue.withModifiers)(($event)=>_ctx.keyArrows("up"), [
                    "prevent"
                ]), [
                    "up"
                ])),
                _cache[2] || (_cache[2] = (0, _vue.withKeys)((0, _vue.withModifiers)(($event)=>_ctx.keyArrows("down"), [
                    "prevent"
                ]), [
                    "down"
                ]))
            ],
            onIconRightClick: _ctx.rightIconClick,
            onIconClick: _cache[3] || (_cache[3] = (event)=>_ctx.$emit("icon-click", event))
        }), null, 16, [
            "modelValue",
            "type",
            "size",
            "loading",
            "rounded",
            "icon",
            "icon-right",
            "icon-right-clickable",
            "icon-pack",
            "maxlength",
            "autocomplete",
            "aria-autocomplete",
            "onUpdate:modelValue",
            "onFocus",
            "onBlur",
            "onKeydown",
            "onIconRightClick"
        ]),
        (0, _vue.createVNode)((0, _vue.Transition), {
            name: "fade",
            persisted: ""
        }, {
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("div", {
                        class: (0, _vue.normalizeClass)([
                            "dropdown-menu",
                            {
                                "is-opened-top": _ctx.isOpenedTop && !_ctx.appendToBody
                            }
                        ]),
                        style: (0, _vue.normalizeStyle)(_ctx.style),
                        ref: "dropdown"
                    }, [
                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("div", {
                            class: "dropdown-content",
                            style: (0, _vue.normalizeStyle)(_ctx.contentStyle)
                        }, [
                            _ctx.hasHeaderSlot ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                                key: 0,
                                class: (0, _vue.normalizeClass)([
                                    "dropdown-item dropdown-header",
                                    {
                                        "is-hovered": _ctx.headerHovered
                                    }
                                ]),
                                role: "button",
                                tabindex: "0",
                                onClick: _cache[4] || (_cache[4] = ($event)=>_ctx.selectHeaderOrFoterByClick($event, "header"))
                            }, [
                                (0, _vue.renderSlot)(_ctx.$slots, "header")
                            ], 2)) : (0, _vue.createCommentVNode)("v-if", true),
                            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.computedData, (element, groupindex)=>{
                                return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, [
                                    element.group ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                                        key: groupindex + "group",
                                        class: "dropdown-item"
                                    }, [
                                        _ctx.hasGroupSlot ? (0, _vue.renderSlot)(_ctx.$slots, "group", {
                                            key: 0,
                                            group: element.group,
                                            index: groupindex
                                        }) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_1$R, (0, _vue.toDisplayString)(element.group), 1))
                                    ])) : (0, _vue.createCommentVNode)("v-if", true),
                                    ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(element.items, (option, index)=>{
                                        return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("a", {
                                            key: groupindex + ":" + index,
                                            class: (0, _vue.normalizeClass)([
                                                "dropdown-item",
                                                {
                                                    "is-hovered": option === _ctx.hovered
                                                }
                                            ]),
                                            role: "button",
                                            tabindex: "0",
                                            onClick: (0, _vue.withModifiers)(($event)=>_ctx.setSelected(option, !_ctx.keepOpen, $event), [
                                                "stop"
                                            ])
                                        }, [
                                            _ctx.hasDefaultSlot ? (0, _vue.renderSlot)(_ctx.$slots, "default", {
                                                key: 0,
                                                option,
                                                index
                                            }) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_3$s, (0, _vue.toDisplayString)(_ctx.getValue(option)), 1))
                                        ], 10, _hoisted_2$H);
                                    }), 128))
                                ], 64);
                            }), 256)),
                            _ctx.isEmpty && _ctx.hasEmptySlot ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_4$k, [
                                (0, _vue.renderSlot)(_ctx.$slots, "empty")
                            ])) : (0, _vue.createCommentVNode)("v-if", true),
                            _ctx.hasFooterSlot ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                                key: 2,
                                class: (0, _vue.normalizeClass)([
                                    "dropdown-item dropdown-footer",
                                    {
                                        "is-hovered": _ctx.footerHovered
                                    }
                                ]),
                                role: "button",
                                tabindex: "0",
                                onClick: _cache[5] || (_cache[5] = ($event)=>_ctx.selectHeaderOrFoterByClick($event, "footer"))
                            }, [
                                (0, _vue.renderSlot)(_ctx.$slots, "footer")
                            ], 2)) : (0, _vue.createCommentVNode)("v-if", true)
                        ], 4), [
                            [
                                (0, _vue.vShow),
                                _ctx.isActive
                            ]
                        ])
                    ], 6), [
                        [
                            (0, _vue.vShow),
                            _ctx.isActive && (!_ctx.isEmpty || _ctx.hasEmptySlot || _ctx.hasHeaderSlot || _ctx.hasFooterSlot)
                        ]
                    ])
                ]),
            _: 3
        })
    ], 16);
}
var BAutocomplete = /* @__PURE__ */ _export_sfc(_sfc_main$P, [
    [
        "render",
        _sfc_render$Z
    ]
]);
const registerComponent = (Vue, component, name)=>{
    const componentName = name || component.name;
    if (componentName == null) throw new Error("Buefy.registerComponent: missing component name");
    Vue.component(componentName, component);
};
const registerComponentProgrammatic = (Vue, property, component)=>{
    if (!Vue.config.globalProperties.$buefy) Vue.config.globalProperties.$buefy = {};
    Vue.config.globalProperties.$buefy[property] = component;
};
const Plugin$F = {
    install (Vue) {
        registerComponent(Vue, BAutocomplete);
    }
};
var _sfc_main$O = (0, _vue.defineComponent)({
    name: "BBreadcrumb",
    props: {
        align: {
            type: String,
            default: ()=>{
                return config.defaultBreadcrumbAlign;
            }
        },
        separator: {
            type: String,
            default: ()=>{
                return config.defaultBreadcrumbSeparator;
            }
        },
        size: {
            type: String,
            default: ()=>{
                return config.defaultBreadcrumbSize;
            }
        }
    },
    computed: {
        breadcrumbClasses () {
            return [
                "breadcrumb",
                this.align,
                this.separator,
                this.size
            ];
        }
    }
});
function _sfc_render$Y(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("nav", {
        class: (0, _vue.normalizeClass)(_ctx.breadcrumbClasses)
    }, [
        (0, _vue.createElementVNode)("ul", null, [
            (0, _vue.renderSlot)(_ctx.$slots, "default")
        ])
    ], 2);
}
var Breadcrumb = /* @__PURE__ */ _export_sfc(_sfc_main$O, [
    [
        "render",
        _sfc_render$Y
    ]
]);
var _sfc_main$N = (0, _vue.defineComponent)({
    name: "BBreadcrumbItem",
    mixins: [
        CompatFallthroughMixin
    ],
    props: {
        tag: {
            type: [
                String,
                Object
            ],
            default: ()=>{
                return config.defaultBreadcrumbTag;
            }
        },
        active: Boolean
    }
});
function _sfc_render$X(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", (0, _vue.mergeProps)({
        class: {
            "is-active": _ctx.active
        }
    }, _ctx.rootAttrs), [
        ((0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.resolveDynamicComponent)(_ctx.tag), (0, _vue.normalizeProps)((0, _vue.guardReactiveProps)(_ctx.fallthroughAttrs)), {
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.renderSlot)(_ctx.$slots, "default")
                ]),
            _: 3
        }, 16))
    ], 16);
}
var BreadcrumbItem = /* @__PURE__ */ _export_sfc(_sfc_main$N, [
    [
        "render",
        _sfc_render$X
    ]
]);
const Plugin$E = {
    install (Vue) {
        registerComponent(Vue, Breadcrumb);
        registerComponent(Vue, BreadcrumbItem);
    }
};
const NATIVE_TYPES = [
    "button",
    "submit",
    "reset"
];
var _sfc_main$M = (0, _vue.defineComponent)({
    name: "BButton",
    components: {
        BIcon
    },
    inheritAttrs: false,
    props: {
        type: [
            String,
            Object
        ],
        size: String,
        label: String,
        iconPack: String,
        iconLeft: String,
        iconRight: String,
        rounded: {
            type: Boolean,
            default: ()=>{
                return config.defaultButtonRounded;
            }
        },
        loading: Boolean,
        outlined: Boolean,
        expanded: Boolean,
        inverted: Boolean,
        focused: Boolean,
        active: Boolean,
        hovered: Boolean,
        selected: Boolean,
        nativeType: {
            type: String,
            default: "button",
            validator: (value)=>{
                return NATIVE_TYPES.indexOf(value) >= 0;
            }
        },
        tag: {
            type: [
                String,
                Object
            ],
            default: "button",
            validator: (value)=>{
                return typeof value === "object" || config.defaultLinkTags.indexOf(value) >= 0;
            }
        }
    },
    computed: {
        computedTag () {
            if (this.$attrs.disabled !== void 0 && this.$attrs.disabled !== false) return "button";
            return this.tag;
        },
        iconSize () {
            if (!this.size || this.size === "is-medium") return "is-small";
            else if (this.size === "is-large") return "is-medium";
            return this.size;
        }
    }
});
const _hoisted_1$Q = {
    key: 1
};
const _hoisted_2$G = {
    key: 2
};
function _sfc_render$W(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    return (0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.resolveDynamicComponent)(_ctx.computedTag), (0, _vue.mergeProps)({
        class: "button"
    }, _ctx.$attrs, {
        type: typeof _ctx.computedTag === "string" && [
            "button",
            "input"
        ].includes(_ctx.computedTag) ? _ctx.nativeType : void 0,
        class: [
            _ctx.size,
            _ctx.type,
            {
                "is-rounded": _ctx.rounded,
                "is-loading": _ctx.loading,
                "is-outlined": _ctx.outlined,
                "is-fullwidth": _ctx.expanded,
                "is-inverted": _ctx.inverted,
                "is-focused": _ctx.focused,
                "is-active": _ctx.active,
                "is-hovered": _ctx.hovered,
                "is-selected": _ctx.selected
            }
        ]
    }), {
        default: (0, _vue.withCtx)(()=>[
                _ctx.iconLeft ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
                    key: 0,
                    pack: _ctx.iconPack,
                    icon: _ctx.iconLeft,
                    size: _ctx.iconSize
                }, null, 8, [
                    "pack",
                    "icon",
                    "size"
                ])) : (0, _vue.createCommentVNode)("v-if", true),
                _ctx.label ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_1$Q, (0, _vue.toDisplayString)(_ctx.label), 1)) : _ctx.$slots.default ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_2$G, [
                    (0, _vue.renderSlot)(_ctx.$slots, "default")
                ])) : (0, _vue.createCommentVNode)("v-if", true),
                _ctx.iconRight ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
                    key: 3,
                    pack: _ctx.iconPack,
                    icon: _ctx.iconRight,
                    size: _ctx.iconSize
                }, null, 8, [
                    "pack",
                    "icon",
                    "size"
                ])) : (0, _vue.createCommentVNode)("v-if", true)
            ]),
        _: 3
    }, 16, [
        "type",
        "class"
    ]);
}
var BButton = /* @__PURE__ */ _export_sfc(_sfc_main$M, [
    [
        "render",
        _sfc_render$W
    ]
]);
const Plugin$D = {
    install (Vue) {
        registerComponent(Vue, BButton);
    }
};
var __defProp$b = Object.defineProperty;
var __getOwnPropSymbols$b = Object.getOwnPropertySymbols;
var __hasOwnProp$b = Object.prototype.hasOwnProperty;
var __propIsEnum$b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$b = (obj, key, value)=>key in obj ? __defProp$b(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues$b = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp$b.call(b, prop)) __defNormalProp$b(a, prop, b[prop]);
    if (__getOwnPropSymbols$b) {
        for (var prop of __getOwnPropSymbols$b(b))if (__propIsEnum$b.call(b, prop)) __defNormalProp$b(a, prop, b[prop]);
    }
    return a;
};
const items = 1;
const sorted$1 = 3;
const Sorted$1 = sorted$1;
var ProviderParentMixin = (itemName, flags)=>{
    const mixin = {
        provide () {
            return {
                ["b" + itemName]: this
            };
        }
    };
    if (hasFlag(flags, items)) {
        mixin.data = function() {
            return __spreadValues$b({
                childItems: []
            }, hasFlag(flags, sorted$1) ? {
                nextIndex: 0
            } : {});
        };
        mixin.methods = {
            _registerItem (item) {
                if (hasFlag(flags, sorted$1)) {
                    item.dynamicIndex = this.nextIndex;
                    ++this.nextIndex;
                }
                this.childItems.push(item);
            },
            _unregisterItem (item) {
                this.childItems = this.childItems.filter((i)=>i.uniqueValue !== item.uniqueValue);
            }
        };
        if (hasFlag(flags, sorted$1)) mixin.computed = {
            /*
         * When items are added/removed sort them according to their position
         */ sortedItems () {
                return this.childItems.slice().sort((i1, i2)=>{
                    return i1.index - i2.index;
                });
            }
        };
    }
    return mixin;
};
var _sfc_main$L = (0, _vue.defineComponent)({
    name: "BCarousel",
    components: {
        BIcon
    },
    mixins: [
        ProviderParentMixin("carousel", Sorted$1)
    ],
    props: {
        modelValue: {
            type: Number,
            default: 0
        },
        animated: {
            type: String,
            default: "slide"
        },
        interval: Number,
        hasDrag: {
            type: Boolean,
            default: true
        },
        autoplay: {
            type: Boolean,
            default: true
        },
        pauseHover: {
            type: Boolean,
            default: true
        },
        pauseInfo: {
            type: Boolean,
            default: true
        },
        pauseInfoType: {
            type: String,
            default: "is-white"
        },
        pauseText: {
            type: String,
            default: "Pause"
        },
        arrow: {
            type: Boolean,
            default: true
        },
        arrowHover: {
            type: Boolean,
            default: true
        },
        repeat: {
            type: Boolean,
            default: true
        },
        iconPack: String,
        iconSize: String,
        iconPrev: {
            type: String,
            default: ()=>{
                return config.defaultIconPrev;
            }
        },
        iconNext: {
            type: String,
            default: ()=>{
                return config.defaultIconNext;
            }
        },
        indicator: {
            type: Boolean,
            default: true
        },
        indicatorBackground: Boolean,
        indicatorCustom: Boolean,
        indicatorCustomSize: {
            type: String,
            default: "is-small"
        },
        indicatorInside: {
            type: Boolean,
            default: true
        },
        indicatorMode: {
            type: String,
            default: "click"
        },
        indicatorPosition: {
            type: String,
            default: "is-bottom"
        },
        indicatorStyle: {
            type: String,
            default: "is-dots"
        },
        overlay: Boolean,
        progress: Boolean,
        progressType: {
            type: String,
            default: "is-primary"
        },
        withCarouselList: Boolean
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars */ change: (_index)=>true,
        click: ()=>true,
        "update:modelValue": (_value)=>true
    },
    data () {
        return {
            transition: "next",
            activeChild: this.modelValue || 0,
            isPause: false,
            dragX: false,
            timer: void 0
        };
    },
    computed: {
        indicatorClasses () {
            return [
                {
                    "has-background": this.indicatorBackground,
                    "has-custom": this.indicatorCustom,
                    "is-inside": this.indicatorInside
                },
                this.indicatorCustom && this.indicatorCustomSize,
                this.indicatorInside && this.indicatorPosition
            ];
        },
        // checking arrows
        hasPrev () {
            return this.repeat || this.activeChild !== 0;
        },
        hasNext () {
            return this.repeat || this.activeChild < this.childItems.length - 1;
        },
        activeChildIndex () {
            const item = this.sortedItems[this.activeChild];
            return item != null ? item.index : void 0;
        }
    },
    watch: {
        /*
     * When v-model is changed set the new active item.
     */ modelValue (value) {
            this.changeActive(value);
        },
        /*
     * When carousel-items are updated, set active one.
     */ sortedItems (items) {
            if (this.activeChild >= items.length && this.activeChild > 0) this.changeActive(this.activeChild - 1);
        },
        /*
     *  When autoplay is changed, start or pause timer accordingly
     */ autoplay (status) {
            status ? this.startTimer() : this.pauseTimer();
        },
        /*
     *  Since the timer can get paused at the end, if repeat is changed we need to restart it
     */ repeat (status) {
            if (status) this.startTimer();
        }
    },
    methods: {
        startTimer () {
            if (!this.autoplay || this.timer) return;
            this.isPause = false;
            this.timer = setInterval(()=>{
                if (!this.repeat && this.activeChild >= this.childItems.length - 1) this.pauseTimer();
                else this.next();
            }, this.interval || config.defaultCarouselInterval);
        },
        pauseTimer () {
            this.isPause = true;
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = void 0;
            }
        },
        restartTimer () {
            this.pauseTimer();
            this.startTimer();
        },
        checkPause () {
            if (this.pauseHover && this.autoplay) this.pauseTimer();
        },
        /*
     * Change the active item and emit change event.
     * action only for animated slide, there true = next, false = prev
     */ changeActive (newIndex, direction = 0) {
            if (this.activeChild === newIndex || isNaN(newIndex)) return;
            direction = direction || newIndex - this.activeChild;
            newIndex = this.repeat ? mod(newIndex, this.childItems.length) : bound(newIndex, 0, this.childItems.length - 1);
            this.transition = direction > 0 ? "prev" : "next";
            this.activeChild = newIndex;
            if (newIndex !== this.modelValue) this.$emit("update:modelValue", newIndex);
            this.restartTimer();
            this.$emit("change", newIndex);
        },
        // Indicator trigger when change active item.
        modeChange (trigger, value) {
            if (this.indicatorMode === trigger) return this.changeActive(value);
        },
        prev () {
            this.changeActive(this.activeChild - 1, -1);
        },
        next () {
            this.changeActive(this.activeChild + 1, 1);
        },
        // handle drag event
        dragStart (event) {
            if (!this.hasDrag || !event.target.draggable) return;
            const touches = event.touches;
            this.dragX = touches ? event.changedTouches[0].pageX : event.pageX;
            if (touches) this.pauseTimer();
            else event.preventDefault();
        },
        dragEnd (event) {
            if (this.dragX === false) return;
            const touches = event.touches;
            const detected = touches ? event.changedTouches[0].pageX : event.pageX;
            const diffX = detected - this.dragX;
            if (Math.abs(diffX) > 30) {
                if (diffX < 0) this.next();
                else this.prev();
            } else {
                event.target.click();
                this.sortedItems[this.activeChild].$emit("click");
                this.$emit("click");
            }
            if (touches) this.startTimer();
            this.dragX = false;
        }
    },
    mounted () {
        this.startTimer();
    },
    beforeUnmount () {
        this.pauseTimer();
    }
});
const _hoisted_1$P = [
    "value",
    "max"
];
const _hoisted_2$F = {
    key: 1,
    class: "carousel-pause"
};
const _hoisted_3$r = [
    "onMouseover",
    "onClick"
];
function _sfc_render$V(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "carousel",
            {
                "is-overlay": _ctx.overlay
            }
        ]),
        onMouseenter: _cache[4] || (_cache[4] = (...args)=>_ctx.checkPause && _ctx.checkPause(...args)),
        onMouseleave: _cache[5] || (_cache[5] = (...args)=>_ctx.startTimer && _ctx.startTimer(...args))
    }, [
        _ctx.progress ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("progress", {
            key: 0,
            class: (0, _vue.normalizeClass)([
                "progress",
                _ctx.progressType
            ]),
            value: _ctx.activeChild,
            max: _ctx.childItems.length - 1
        }, (0, _vue.toDisplayString)(_ctx.childItems.length - 1), 11, _hoisted_1$P)) : (0, _vue.createCommentVNode)("v-if", true),
        (0, _vue.createElementVNode)("div", {
            class: "carousel-items",
            onMousedown: _cache[0] || (_cache[0] = (...args)=>_ctx.dragStart && _ctx.dragStart(...args)),
            onMouseup: _cache[1] || (_cache[1] = (...args)=>_ctx.dragEnd && _ctx.dragEnd(...args)),
            onTouchstart: _cache[2] || (_cache[2] = (0, _vue.withModifiers)((...args)=>_ctx.dragStart && _ctx.dragStart(...args), [
                "stop"
            ])),
            onTouchend: _cache[3] || (_cache[3] = (0, _vue.withModifiers)((...args)=>_ctx.dragEnd && _ctx.dragEnd(...args), [
                "stop"
            ]))
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "default"),
            _ctx.arrow ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                key: 0,
                class: (0, _vue.normalizeClass)([
                    "carousel-arrow",
                    {
                        "is-hovered": _ctx.arrowHover
                    }
                ])
            }, [
                (0, _vue.withDirectives)((0, _vue.createVNode)(_component_b_icon, {
                    class: "has-icons-left",
                    onClick: _ctx.prev,
                    pack: _ctx.iconPack,
                    icon: _ctx.iconPrev,
                    size: _ctx.iconSize,
                    both: ""
                }, null, 8, [
                    "onClick",
                    "pack",
                    "icon",
                    "size"
                ]), [
                    [
                        (0, _vue.vShow),
                        _ctx.hasPrev
                    ]
                ]),
                (0, _vue.withDirectives)((0, _vue.createVNode)(_component_b_icon, {
                    class: "has-icons-right",
                    onClick: _ctx.next,
                    pack: _ctx.iconPack,
                    icon: _ctx.iconNext,
                    size: _ctx.iconSize,
                    both: ""
                }, null, 8, [
                    "onClick",
                    "pack",
                    "icon",
                    "size"
                ]), [
                    [
                        (0, _vue.vShow),
                        _ctx.hasNext
                    ]
                ])
            ], 2)) : (0, _vue.createCommentVNode)("v-if", true)
        ], 32),
        _ctx.autoplay && _ctx.pauseHover && _ctx.pauseInfo && _ctx.isPause ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_2$F, [
            (0, _vue.createElementVNode)("span", {
                class: (0, _vue.normalizeClass)([
                    "tag",
                    _ctx.pauseInfoType
                ])
            }, (0, _vue.toDisplayString)(_ctx.pauseText), 3)
        ])) : (0, _vue.createCommentVNode)("v-if", true),
        _ctx.withCarouselList && !_ctx.indicator ? (0, _vue.renderSlot)(_ctx.$slots, "list", {
            key: 2,
            active: _ctx.activeChild,
            switch: _ctx.changeActive
        }) : (0, _vue.createCommentVNode)("v-if", true),
        _ctx.indicator ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
            key: 3,
            class: (0, _vue.normalizeClass)([
                "carousel-indicator",
                _ctx.indicatorClasses
            ])
        }, [
            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.sortedItems, (item, index)=>{
                return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("a", {
                    class: (0, _vue.normalizeClass)([
                        "indicator-item",
                        {
                            "is-active": item.isActive
                        }
                    ]),
                    onMouseover: ($event)=>_ctx.modeChange("hover", index),
                    onClick: ($event)=>_ctx.modeChange("click", index),
                    key: item.uniqueValue
                }, [
                    (0, _vue.renderSlot)(_ctx.$slots, "indicators", {
                        i: index
                    }, ()=>[
                            (0, _vue.createElementVNode)("span", {
                                class: (0, _vue.normalizeClass)([
                                    "indicator-style",
                                    _ctx.indicatorStyle
                                ])
                            }, null, 2)
                        ])
                ], 42, _hoisted_3$r);
            }), 128))
        ], 2)) : (0, _vue.createCommentVNode)("v-if", true),
        _ctx.overlay ? (0, _vue.renderSlot)(_ctx.$slots, "overlay", {
            key: 4
        }) : (0, _vue.createCommentVNode)("v-if", true)
    ], 34);
}
var Carousel = /* @__PURE__ */ _export_sfc(_sfc_main$L, [
    [
        "render",
        _sfc_render$V
    ]
]);
var __defProp$a = Object.defineProperty;
var __defProps$7 = Object.defineProperties;
var __getOwnPropDescs$7 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$a = Object.getOwnPropertySymbols;
var __hasOwnProp$a = Object.prototype.hasOwnProperty;
var __propIsEnum$a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$a = (obj, key, value)=>key in obj ? __defProp$a(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues$a = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp$a.call(b, prop)) __defNormalProp$a(a, prop, b[prop]);
    if (__getOwnPropSymbols$a) {
        for (var prop of __getOwnPropSymbols$a(b))if (__propIsEnum$a.call(b, prop)) __defNormalProp$a(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps$7 = (a, b)=>__defProps$7(a, __getOwnPropDescs$7(b));
const sorted = 1;
const optional = 2;
const Sorted = sorted;
var InjectedChildMixin = (parentItemName, flags)=>{
    const mixin = {
        // FIXME: initializing `parent` with an empty string does not make
        // sense at all, but some code supposes that `parent` is non-null.
        // so I leave it as is for now.
        inject: {
            parent: {
                from: "b" + parentItemName,
                default: ""
            }
        },
        props: {
            // if `value` is non-null, it must be unique among all the siblings.
            // see `uniqueValue`
            value: {
                type: String,
                default: null
            }
        },
        computed: {
            // `ProviderParentMixin` uses `uniqueValue` computed value to
            // identify the child in its `childItems` collection.
            // so the value must be unique among all the siblings.
            // falls back to the `uid` internal field to ensure uniqueness.
            uniqueValue () {
                return this.value != null ? this.value : this.$.uid;
            }
        },
        created () {
            if (!this.parent) {
                if (!hasFlag(flags, optional)) throw new Error("You should wrap " + this.$options.name + " in a " + parentItemName);
            } else if (this.parent._registerItem) this.parent._registerItem(this);
        },
        beforeUnmount () {
            if (this.parent && this.parent._unregisterItem) this.parent._unregisterItem(this);
        }
    };
    if (hasFlag(flags, sorted)) {
        mixin.props = __spreadProps$7(__spreadValues$a({}, mixin.props), {
            order: {
                type: Number,
                required: false
            }
        });
        mixin.data = ()=>{
            return {
                dynamicIndex: void 0
            };
        };
        mixin.computed = __spreadProps$7(__spreadValues$a({}, mixin.computed), {
            index () {
                return this.order != null ? this.order : this.dynamicIndex;
            }
        });
    }
    return mixin;
};
var _sfc_main$K = (0, _vue.defineComponent)({
    name: "BCarouselItem",
    mixins: [
        InjectedChildMixin("carousel", Sorted)
    ],
    data () {
        return {
            transitionName: null
        };
    },
    computed: {
        transition () {
            if (this.parent.animated === "fade") return "fade";
            else if (this.parent.transition) return "slide-" + this.parent.transition;
            else return void 0;
        },
        isActive () {
            return this.parent.activeChildIndex === this.index;
        }
    }
});
const _hoisted_1$O = {
    class: "carousel-item"
};
function _sfc_render$U(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.Transition), {
        name: _ctx.transition,
        persisted: ""
    }, {
        default: (0, _vue.withCtx)(()=>[
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("div", _hoisted_1$O, [
                    (0, _vue.renderSlot)(_ctx.$slots, "default")
                ], 512), [
                    [
                        (0, _vue.vShow),
                        _ctx.isActive
                    ]
                ])
            ]),
        _: 3
    }, 8, [
        "name"
    ]);
}
var CarouselItem = /* @__PURE__ */ _export_sfc(_sfc_main$K, [
    [
        "render",
        _sfc_render$U
    ]
]);
var __defProp$9 = Object.defineProperty;
var __getOwnPropSymbols$9 = Object.getOwnPropertySymbols;
var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$9 = (obj, key, value)=>key in obj ? __defProp$9(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues$9 = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp$9.call(b, prop)) __defNormalProp$9(a, prop, b[prop]);
    if (__getOwnPropSymbols$9) {
        for (var prop of __getOwnPropSymbols$9(b))if (__propIsEnum$9.call(b, prop)) __defNormalProp$9(a, prop, b[prop]);
    }
    return a;
};
const BULMA_KNOWN_RATIO = [
    "square",
    "1by1",
    "5by4",
    "4by3",
    "3by2",
    "5by3",
    "16by9",
    "b2y1",
    "3by1",
    "4by5",
    "3by4",
    "2by3",
    "3by5",
    "9by16",
    "1by2",
    "1by3"
];
function isBulmaKnownRatio(value) {
    return BULMA_KNOWN_RATIO.indexOf(value) !== -1;
}
var _sfc_main$J = (0, _vue.defineComponent)({
    name: "BImage",
    props: {
        src: String,
        alt: String,
        srcFallback: String,
        webpFallback: {
            type: String,
            default: ()=>{
                return config.defaultImageWebpFallback;
            }
        },
        lazy: {
            type: Boolean,
            default: ()=>{
                return config.defaultImageLazy;
            }
        },
        responsive: {
            type: Boolean,
            default: ()=>{
                return config.defaultImageResponsive;
            }
        },
        ratio: {
            type: String,
            default: ()=>{
                return config.defaultImageRatio;
            }
        },
        placeholder: String,
        srcset: String,
        srcsetSizes: Array,
        srcsetFormatter: {
            type: Function,
            default: (src, size, vm)=>{
                if (typeof config.defaultImageSrcsetFormatter === "function") return config.defaultImageSrcsetFormatter(src, size);
                else return vm.formatSrcset(src, size);
            }
        },
        rounded: {
            type: Boolean,
            default: false
        },
        captionFirst: {
            type: Boolean,
            default: false
        },
        customClass: String
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars */ load: (event, src)=>true,
        error: (event, src)=>true
    },
    data () {
        return {
            clientWidth: 0,
            webpSupportVerified: false,
            webpSupported: false,
            useNativeLazy: false,
            observer: null,
            inViewPort: false,
            loaded: false,
            failed: false
        };
    },
    computed: {
        ratioPattern () {
            return /([0-9]+)by([0-9]+)/;
        },
        hasRatio () {
            return this.ratio != null && this.ratioPattern.test(this.ratio);
        },
        figureClasses () {
            const classes = {
                image: this.responsive
            };
            if (this.hasRatio && isBulmaKnownRatio(this.ratio)) classes[`is-${this.ratio}`] = true;
            return classes;
        },
        figureStyles () {
            if (this.hasRatio && !isBulmaKnownRatio(this.ratio)) {
                const ratioValues = this.ratioPattern.exec(this.ratio);
                return {
                    paddingTop: `${+ratioValues[2] / +ratioValues[1] * 100}%`
                };
            }
            return void 0;
        },
        imgClasses () {
            return __spreadValues$9({
                "is-rounded": this.rounded,
                "has-ratio": this.hasRatio
            }, this.customClass ? {
                [this.customClass]: !!this.customClass
            } : {});
        },
        srcExt () {
            return this.getExt(this.src);
        },
        isWepb () {
            return this.srcExt === "webp";
        },
        computedSrc () {
            let src = this.src;
            if (this.failed && this.srcFallback) src = this.srcFallback;
            if (!this.webpSupported && this.isWepb && this.webpFallback) {
                if (this.webpFallback.startsWith(".")) return src.replace(/\.webp/gi, `${this.webpFallback}`);
                return this.webpFallback;
            }
            return src;
        },
        computedWidth () {
            if (this.responsive && this.clientWidth > 0) return this.clientWidth;
            return void 0;
        },
        computedNativeLazy () {
            if (this.lazy && this.useNativeLazy) return "lazy";
            return void 0;
        },
        isDisplayed () {
            return (this.webpSupportVerified || !this.isWepb) && (!this.lazy || this.useNativeLazy || this.inViewPort);
        },
        placeholderExt () {
            if (this.placeholder) return this.getExt(this.placeholder);
            return void 0;
        },
        isPlaceholderWepb () {
            if (this.placeholder) return this.placeholderExt === "webp";
            return false;
        },
        computedPlaceholder () {
            if (!this.webpSupported && this.isPlaceholderWepb && this.webpFallback && this.webpFallback.startsWith(".")) return this.placeholder.replace(/\.webp/gi, `${this.webpFallback}`);
            return this.placeholder;
        },
        isPlaceholderDisplayed () {
            return !this.loaded && (this.$slots.placeholder || this.placeholder && (this.webpSupportVerified || !this.isPlaceholderWepb));
        },
        computedSrcset () {
            if (this.srcset) {
                if (!this.webpSupported && this.isWepb && this.webpFallback && this.webpFallback.startsWith(".")) return this.srcset.replace(/\.webp/gi, `${this.webpFallback}`);
                return this.srcset;
            }
            if (this.srcsetSizes && Array.isArray(this.srcsetSizes) && this.srcsetSizes.length > 0) return this.srcsetSizes.map((size)=>{
                return `${this.srcsetFormatter(this.computedSrc, size, this)} ${size}w`;
            }).join(",");
            return void 0;
        },
        computedSizes () {
            if (this.computedSrcset && this.computedWidth) return `${this.computedWidth}px`;
            return void 0;
        },
        isCaptionFirst () {
            return this.$slots.caption && this.captionFirst;
        },
        isCaptionLast () {
            return this.$slots.caption && !this.captionFirst;
        }
    },
    methods: {
        getExt (filename, clean = true) {
            if (filename) {
                const noParam = clean ? filename.split("?")[0] : filename;
                return noParam.split(".").pop();
            }
            return "";
        },
        setWidth () {
            this.clientWidth = this.$el.clientWidth;
        },
        formatSrcset (src, size) {
            const ext = this.getExt(src, false);
            const name = src.split(".").slice(0, -1).join(".");
            return `${name}-${size}.${ext}`;
        },
        onLoad (event) {
            this.loaded = true;
            this.emitSrc(event, (src)=>this.$emit("load", event, src));
        },
        onError (event) {
            this.emitSrc(event, (src)=>this.$emit("error", event, src));
            if (!this.failed) this.failed = true;
        },
        emitSrc (event, emit) {
            const target = event.target;
            emit(target.currentSrc || target.src || this.computedSrc);
        }
    },
    created () {
        if (this.isWepb) isWebpSupported().then((supported)=>{
            this.webpSupportVerified = true;
            this.webpSupported = supported;
        });
        if (this.lazy) {
            const nativeLazySupported = typeof window !== "undefined" && "HTMLImageElement" in window && "loading" in HTMLImageElement.prototype;
            const intersectionObserverSupported = typeof window !== "undefined" && "IntersectionObserver" in window;
            if (!nativeLazySupported && intersectionObserverSupported) this.observer = new IntersectionObserver((events)=>{
                const { target, isIntersecting } = events[0];
                if (isIntersecting && !this.inViewPort) {
                    this.inViewPort = true;
                    this.observer.unobserve(target);
                }
            });
            else this.useNativeLazy = true;
        }
    },
    mounted () {
        if (this.lazy && this.observer) this.observer.observe(this.$el);
        this.setWidth();
        if (typeof window !== "undefined") window.addEventListener("resize", this.setWidth);
    },
    beforeUnmount () {
        if (this.observer) this.observer.disconnect();
        if (typeof window !== "undefined") window.removeEventListener("resize", this.setWidth);
    }
});
const _hoisted_1$N = {
    key: 0
};
const _hoisted_2$E = [
    "srcset",
    "src",
    "alt",
    "width",
    "sizes",
    "loading"
];
const _hoisted_3$q = [
    "src",
    "alt"
];
const _hoisted_4$j = {
    key: 1
};
function _sfc_render$T(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("figure", {
        class: (0, _vue.normalizeClass)([
            "b-image-wrapper",
            _ctx.figureClasses
        ]),
        style: (0, _vue.normalizeStyle)(_ctx.figureStyles)
    }, [
        _ctx.isCaptionFirst ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("figcaption", _hoisted_1$N, [
            (0, _vue.renderSlot)(_ctx.$slots, "caption")
        ])) : (0, _vue.createCommentVNode)("v-if", true),
        (0, _vue.createVNode)((0, _vue.Transition), {
            name: "fade"
        }, {
            default: (0, _vue.withCtx)(()=>[
                    _ctx.isDisplayed ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("img", {
                        key: 0,
                        srcset: _ctx.computedSrcset,
                        src: _ctx.computedSrc,
                        alt: _ctx.alt,
                        class: (0, _vue.normalizeClass)(_ctx.imgClasses),
                        width: _ctx.computedWidth,
                        sizes: _ctx.computedSizes,
                        loading: _ctx.computedNativeLazy,
                        onLoad: _cache[0] || (_cache[0] = (...args)=>_ctx.onLoad && _ctx.onLoad(...args)),
                        onError: _cache[1] || (_cache[1] = (...args)=>_ctx.onError && _ctx.onError(...args))
                    }, null, 42, _hoisted_2$E)) : (0, _vue.createCommentVNode)("v-if", true)
                ]),
            _: 1
        }),
        (0, _vue.createVNode)((0, _vue.Transition), {
            name: "fade"
        }, {
            default: (0, _vue.withCtx)(()=>[
                    _ctx.isPlaceholderDisplayed ? (0, _vue.renderSlot)(_ctx.$slots, "placeholder", {
                        key: 0
                    }, ()=>[
                            (0, _vue.createElementVNode)("img", {
                                src: _ctx.computedPlaceholder,
                                alt: _ctx.alt,
                                class: (0, _vue.normalizeClass)([
                                    _ctx.imgClasses,
                                    "placeholder"
                                ])
                            }, null, 10, _hoisted_3$q)
                        ]) : (0, _vue.createCommentVNode)("v-if", true)
                ]),
            _: 3
        }),
        _ctx.isCaptionLast ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("figcaption", _hoisted_4$j, [
            (0, _vue.renderSlot)(_ctx.$slots, "caption")
        ])) : (0, _vue.createCommentVNode)("v-if", true)
    ], 6);
}
var Image$1 = /* @__PURE__ */ _export_sfc(_sfc_main$J, [
    [
        "render",
        _sfc_render$T
    ]
]);
var __defProp$8 = Object.defineProperty;
var __getOwnPropSymbols$8 = Object.getOwnPropertySymbols;
var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$8 = (obj, key, value)=>key in obj ? __defProp$8(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues$8 = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp$8.call(b, prop)) __defNormalProp$8(a, prop, b[prop]);
    if (__getOwnPropSymbols$8) {
        for (var prop of __getOwnPropSymbols$8(b))if (__propIsEnum$8.call(b, prop)) __defNormalProp$8(a, prop, b[prop]);
    }
    return a;
};
var _sfc_main$I = (0, _vue.defineComponent)({
    name: "BCarouselList",
    components: {
        BIcon,
        BImage: Image$1
    },
    props: {
        data: {
            type: Array,
            default: ()=>[]
        },
        modelValue: {
            type: Number,
            default: 0
        },
        scrollValue: {
            type: Number,
            default: 0
        },
        hasDrag: {
            type: Boolean,
            default: true
        },
        hasGrayscale: Boolean,
        hasOpacity: Boolean,
        repeat: Boolean,
        itemsToShow: {
            type: Number,
            default: 4
        },
        itemsToList: {
            type: Number,
            default: 1
        },
        asIndicator: Boolean,
        arrow: {
            type: Boolean,
            default: true
        },
        arrowHover: {
            type: Boolean,
            default: true
        },
        iconPack: String,
        iconSize: String,
        iconPrev: {
            type: String,
            default: ()=>{
                return config.defaultIconPrev;
            }
        },
        iconNext: {
            type: String,
            default: ()=>{
                return config.defaultIconNext;
            }
        },
        breakpoints: {
            type: Object,
            default: ()=>({})
        }
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars */ switch: (_value)=>true,
        "update:modelValue": (_value)=>true,
        "updated:scroll": (_index)=>true
    },
    data () {
        return {
            activeItem: this.modelValue,
            scrollIndex: this.asIndicator ? this.scrollValue : this.modelValue,
            delta: 0,
            dragX: false,
            hold: 0,
            windowWidth: 0,
            touch: false,
            observer: null,
            refresh_: 0
        };
    },
    computed: {
        dragging () {
            return this.dragX !== false;
        },
        listClass () {
            return [
                {
                    "has-grayscale": this.settings.hasGrayscale,
                    "has-opacity": this.settings.hasOpacity,
                    "is-dragging": this.dragging
                }
            ];
        },
        itemStyle () {
            return `width: ${this.itemWidth}px;`;
        },
        translation () {
            return -bound(this.delta + this.scrollIndex * this.itemWidth, 0, (this.data.length - this.settings.itemsToShow) * this.itemWidth);
        },
        total () {
            return this.data.length - this.settings.itemsToShow;
        },
        hasPrev () {
            return this.settings.repeat || this.scrollIndex > 0;
        },
        hasNext () {
            return this.settings.repeat || this.scrollIndex < this.total;
        },
        breakpointKeys () {
            return Object.keys(this.breakpoints).sort((a, b)=>+b - +a);
        },
        settings () {
            const breakpoint = this.breakpointKeys.filter((breakpoint2)=>{
                if (this.windowWidth >= +breakpoint2) return true;
                else return false;
            })[0];
            if (breakpoint) return __spreadValues$8(__spreadValues$8({}, this.$props), this.breakpoints[+breakpoint]);
            return this.$props;
        },
        itemWidth () {
            if (this.windowWidth) {
                this.refresh_;
                const rect = this.$el.getBoundingClientRect();
                return rect.width / this.settings.itemsToShow;
            }
            return 0;
        }
    },
    watch: {
        /*
     * When v-model is changed set the new active item.
     */ modelValue (value) {
            this.switchTo(this.asIndicator ? value - (this.itemsToShow - 3) / 2 : value);
            if (this.activeItem !== value) this.activeItem = bound(value, 0, this.data.length - 1);
        },
        scrollValue (value) {
            this.switchTo(value);
        }
    },
    methods: {
        resized () {
            this.windowWidth = window.innerWidth;
        },
        switchTo (newIndex) {
            if (newIndex === this.scrollIndex || isNaN(newIndex)) return;
            if (this.settings.repeat) newIndex = mod(newIndex, this.total + 1);
            newIndex = bound(newIndex, 0, this.total);
            this.scrollIndex = newIndex;
            if (!this.asIndicator && this.modelValue !== newIndex) this.$emit("update:modelValue", newIndex);
            else if (this.scrollIndex !== newIndex) this.$emit("updated:scroll", newIndex);
        },
        next () {
            this.switchTo(this.scrollIndex + this.settings.itemsToList);
        },
        prev () {
            this.switchTo(this.scrollIndex - this.settings.itemsToList);
        },
        checkAsIndicator (value, event) {
            if (!this.asIndicator) return;
            const dragEndX = event.changedTouches ? event.changedTouches[0].clientX : event.clientX;
            if (this.hold - Date.now() > 2e3 || Math.abs(+this.dragX - dragEndX) > 10) return;
            this.dragX = false;
            this.hold = 0;
            event.preventDefault();
            this.activeItem = value;
            this.$emit("switch", value);
        },
        // handle drag event
        dragStart (event) {
            if (this.dragging || !this.settings.hasDrag || event.button !== 0 && event.type !== "touchstart") return;
            this.hold = Date.now();
            this.touch = !!event.touches;
            this.dragX = this.touch ? event.touches[0].clientX : event.clientX;
            window.addEventListener(this.touch ? "touchmove" : "mousemove", this.dragMove);
            window.addEventListener(this.touch ? "touchend" : "mouseup", this.dragEnd);
        },
        dragMove (event) {
            if (!this.dragging) return;
            const dragEndX = event.touches ? (event.changedTouches[0] || event.touches[0]).clientX : event.clientX;
            this.delta = +this.dragX - dragEndX;
            if (!event.touches) event.preventDefault();
        },
        dragEnd () {
            if (!this.dragging && !this.hold) return;
            if (this.hold) {
                const signCheck = sign(this.delta);
                const results = Math.round(Math.abs(this.delta / this.itemWidth) + 0.15);
                this.switchTo(this.scrollIndex + signCheck * results);
            }
            this.delta = 0;
            this.dragX = false;
            window.removeEventListener(this.touch ? "touchmove" : "mousemove", this.dragMove);
            window.removeEventListener(this.touch ? "touchend" : "mouseup", this.dragEnd);
        },
        refresh () {
            this.$nextTick(()=>{
                this.refresh_++;
            });
        }
    },
    mounted () {
        if (typeof window !== "undefined") {
            if (window.ResizeObserver) {
                this.observer = new ResizeObserver(this.refresh);
                this.observer.observe(this.$el);
            }
            window.addEventListener("resize", this.resized);
            document.addEventListener("animationend", this.refresh);
            document.addEventListener("transitionend", this.refresh);
            document.addEventListener("transitionstart", this.refresh);
            this.resized();
        }
        if (this.$attrs.config) throw new Error("The config prop was removed, you need to use v-bind instead");
    },
    beforeUnmount () {
        if (typeof window !== "undefined") {
            if (window.ResizeObserver) this.observer.disconnect();
            window.removeEventListener("resize", this.resized);
            document.removeEventListener("animationend", this.refresh);
            document.removeEventListener("transitionend", this.refresh);
            document.removeEventListener("transitionstart", this.refresh);
            this.dragEnd();
        }
    }
});
const _hoisted_1$M = [
    "onMouseup",
    "onTouchend"
];
function _sfc_render$S(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_image = (0, _vue.resolveComponent)("b-image");
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "carousel-list",
            {
                "has-shadow": _ctx.scrollIndex > 0
            }
        ]),
        onMousedown: _cache[0] || (_cache[0] = (0, _vue.withModifiers)((...args)=>_ctx.dragStart && _ctx.dragStart(...args), [
            "prevent"
        ])),
        onTouchstart: _cache[1] || (_cache[1] = (...args)=>_ctx.dragStart && _ctx.dragStart(...args))
    }, [
        (0, _vue.createElementVNode)("div", {
            class: (0, _vue.normalizeClass)([
                "carousel-slides",
                _ctx.listClass
            ]),
            style: (0, _vue.normalizeStyle)("transform:translateX(" + _ctx.translation + "px)")
        }, [
            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.data, (list, index)=>{
                return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                    class: (0, _vue.normalizeClass)([
                        "carousel-slide",
                        {
                            "is-active": _ctx.asIndicator ? _ctx.activeItem === index : _ctx.scrollIndex === index
                        }
                    ]),
                    onMouseup: ($event)=>_ctx.checkAsIndicator(index, $event),
                    onTouchend: ($event)=>_ctx.checkAsIndicator(index, $event),
                    key: index,
                    style: (0, _vue.normalizeStyle)(_ctx.itemStyle)
                }, [
                    (0, _vue.renderSlot)(_ctx.$slots, "item", (0, _vue.mergeProps)({
                        index,
                        active: _ctx.activeItem,
                        scroll: _ctx.scrollIndex
                    }, list, {
                        list
                    }), ()=>[
                            (0, _vue.createVNode)(_component_b_image, (0, _vue.mergeProps)({
                                src: list.image
                            }, list), null, 16, [
                                "src"
                            ])
                        ])
                ], 46, _hoisted_1$M);
            }), 128))
        ], 6),
        _ctx.arrow ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
            key: 0,
            class: (0, _vue.normalizeClass)([
                "carousel-arrow",
                {
                    "is-hovered": _ctx.settings.arrowHover
                }
            ])
        }, [
            (0, _vue.withDirectives)((0, _vue.createVNode)(_component_b_icon, {
                class: "has-icons-left",
                onClick: (0, _vue.withModifiers)(_ctx.prev, [
                    "prevent"
                ]),
                pack: _ctx.settings.iconPack,
                icon: _ctx.settings.iconPrev,
                size: _ctx.settings.iconSize,
                both: ""
            }, null, 8, [
                "onClick",
                "pack",
                "icon",
                "size"
            ]), [
                [
                    (0, _vue.vShow),
                    _ctx.hasPrev
                ]
            ]),
            (0, _vue.withDirectives)((0, _vue.createVNode)(_component_b_icon, {
                class: "has-icons-right",
                onClick: (0, _vue.withModifiers)(_ctx.next, [
                    "prevent"
                ]),
                pack: _ctx.settings.iconPack,
                icon: _ctx.settings.iconNext,
                size: _ctx.settings.iconSize,
                both: ""
            }, null, 8, [
                "onClick",
                "pack",
                "icon",
                "size"
            ]), [
                [
                    (0, _vue.vShow),
                    _ctx.hasNext
                ]
            ])
        ], 2)) : (0, _vue.createCommentVNode)("v-if", true)
    ], 34);
}
var CarouselList = /* @__PURE__ */ _export_sfc(_sfc_main$I, [
    [
        "render",
        _sfc_render$S
    ]
]);
const Plugin$C = {
    install (Vue) {
        registerComponent(Vue, Carousel);
        registerComponent(Vue, CarouselItem);
        registerComponent(Vue, CarouselList);
    }
};
var CheckRadioMixin = (0, _vue.defineComponent)({
    props: {
        modelValue: [
            String,
            Number,
            Boolean,
            Function,
            Object,
            Array
        ],
        nativeValue: [
            String,
            Number,
            Boolean,
            Function,
            Object,
            Array
        ],
        type: String,
        disabled: Boolean,
        required: Boolean,
        name: String,
        size: String
    },
    emits: {
        // eslint-disable-next-line max-len
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
        "update:modelValue": (value)=>true
    },
    data () {
        return {
            newValue: this.modelValue
        };
    },
    computed: {
        computedValue: {
            get () {
                return this.newValue;
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            set (value) {
                this.newValue = value;
                this.$emit("update:modelValue", value);
            }
        },
        disabledOrUndefined () {
            return this.disabled || void 0;
        },
        requiredOrUndefined () {
            return this.required || void 0;
        }
    },
    watch: {
        /*
    * When v-model change, set internal value.
    */ modelValue (value) {
            this.newValue = value;
        }
    },
    methods: {
        focus () {
            this.$refs.input.focus();
        }
    }
});
var _sfc_main$H = (0, _vue.defineComponent)({
    name: "BCheckbox",
    mixins: [
        CheckRadioMixin
    ],
    props: {
        indeterminate: Boolean,
        ariaLabelledby: String,
        trueValue: {
            type: [
                String,
                Number,
                Boolean,
                Function,
                Object,
                Array
            ],
            default: true
        },
        falseValue: {
            type: [
                String,
                Number,
                Boolean,
                Function,
                Object,
                Array
            ],
            default: false
        },
        autocomplete: {
            type: String,
            default: "on"
        },
        inputId: {
            type: String,
            default: ""
        }
    }
});
const _hoisted_1$L = [
    "disabled"
];
const _hoisted_2$D = [
    "id",
    ".indeterminate",
    "autocomplete",
    "disabled",
    "required",
    "name",
    "value",
    "true-value",
    "false-value",
    "aria-labelledby"
];
const _hoisted_3$p = [
    "id"
];
function _sfc_render$R(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("label", {
        class: (0, _vue.normalizeClass)([
            "b-checkbox checkbox",
            [
                _ctx.size,
                {
                    "is-disabled": _ctx.disabled
                }
            ]
        ]),
        ref: "label",
        disabled: _ctx.disabledOrUndefined,
        onClick: _cache[2] || (_cache[2] = (...args)=>_ctx.focus && _ctx.focus(...args)),
        onKeydown: [
            _cache[3] || (_cache[3] = (0, _vue.withKeys)((0, _vue.withModifiers)(($event)=>_ctx.$refs.label.click(), [
                "prevent"
            ]), [
                "enter"
            ])),
            _cache[4] || (_cache[4] = (0, _vue.withKeys)((0, _vue.withModifiers)(($event)=>_ctx.$refs.label.click(), [
                "prevent"
            ]), [
                "space"
            ]))
        ]
    }, [
        (0, _vue.createCommentVNode)(" Checkbox needs to listen for a space event instead of a just a\n             click and enter event so that that using the keyboard spacebar will also\n             trigger the checkbox change in the b-table "),
        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.computedValue = $event),
            id: _ctx.inputId,
            ".indeterminate": _ctx.indeterminate,
            type: "checkbox",
            ref: "input",
            onClick: _cache[1] || (_cache[1] = (0, _vue.withModifiers)(()=>{}, [
                "stop"
            ])),
            autocomplete: _ctx.autocomplete,
            disabled: _ctx.disabledOrUndefined,
            required: _ctx.requiredOrUndefined,
            name: _ctx.name,
            value: _ctx.nativeValue,
            "true-value": _ctx.trueValue,
            "false-value": _ctx.falseValue,
            "aria-labelledby": _ctx.ariaLabelledby
        }, null, 40, _hoisted_2$D), [
            [
                (0, _vue.vModelCheckbox),
                _ctx.computedValue
            ]
        ]),
        (0, _vue.createElementVNode)("span", {
            class: (0, _vue.normalizeClass)([
                "check",
                _ctx.type
            ])
        }, null, 2),
        (0, _vue.createElementVNode)("span", {
            id: _ctx.ariaLabelledby,
            class: "control-label"
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "default")
        ], 8, _hoisted_3$p)
    ], 42, _hoisted_1$L);
}
var BCheckbox = /* @__PURE__ */ _export_sfc(_sfc_main$H, [
    [
        "render",
        _sfc_render$R
    ]
]);
var _sfc_main$G = (0, _vue.defineComponent)({
    name: "BCheckboxButton",
    mixins: [
        CheckRadioMixin
    ],
    props: {
        type: {
            type: String,
            default: "is-primary"
        },
        expanded: Boolean
    },
    data () {
        return {
            isFocused: false
        };
    },
    computed: {
        checked () {
            if (Array.isArray(this.newValue)) return this.newValue.indexOf(this.nativeValue) >= 0;
            return this.newValue === this.nativeValue;
        }
    }
});
const _hoisted_1$K = [
    "disabled"
];
const _hoisted_2$C = [
    "disabled",
    "required",
    "name",
    "value"
];
function _sfc_render$Q(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "control",
            {
                "is-expanded": _ctx.expanded
            }
        ])
    }, [
        (0, _vue.createElementVNode)("label", {
            class: (0, _vue.normalizeClass)([
                "b-checkbox checkbox button",
                [
                    _ctx.checked ? _ctx.type : null,
                    _ctx.size,
                    {
                        "is-disabled": _ctx.disabled,
                        "is-focused": _ctx.isFocused
                    }
                ]
            ]),
            ref: "label",
            disabled: _ctx.disabledOrUndefined,
            onClick: _cache[4] || (_cache[4] = (...args)=>_ctx.focus && _ctx.focus(...args)),
            onKeydown: _cache[5] || (_cache[5] = (0, _vue.withKeys)((0, _vue.withModifiers)(($event)=>_ctx.$refs.label.click(), [
                "prevent"
            ]), [
                "enter"
            ]))
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "default"),
            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.computedValue = $event),
                type: "checkbox",
                ref: "input",
                onClick: _cache[1] || (_cache[1] = (0, _vue.withModifiers)(()=>{}, [
                    "stop"
                ])),
                disabled: _ctx.disabledOrUndefined,
                required: _ctx.requiredOrUndefined,
                name: _ctx.name,
                value: _ctx.nativeValue,
                onFocus: _cache[2] || (_cache[2] = ($event)=>_ctx.isFocused = true),
                onBlur: _cache[3] || (_cache[3] = ($event)=>_ctx.isFocused = false)
            }, null, 40, _hoisted_2$C), [
                [
                    (0, _vue.vModelCheckbox),
                    _ctx.computedValue
                ]
            ])
        ], 42, _hoisted_1$K)
    ], 2);
}
var CheckboxButton = /* @__PURE__ */ _export_sfc(_sfc_main$G, [
    [
        "render",
        _sfc_render$Q
    ]
]);
const Plugin$B = {
    install (Vue) {
        registerComponent(Vue, BCheckbox);
        registerComponent(Vue, CheckboxButton);
    }
};
const COLLAPSE_POSITIONS = [
    "is-top",
    "is-bottom"
];
var _sfc_main$F = (0, _vue.defineComponent)({
    name: "BCollapse",
    props: {
        modelValue: {
            type: Boolean,
            default: true
        },
        animation: {
            type: String,
            default: "fade"
        },
        ariaId: {
            type: String,
            default: ""
        },
        position: {
            type: String,
            default: "is-top",
            validator (value) {
                return COLLAPSE_POSITIONS.indexOf(value) > -1;
            }
        }
    },
    emits: {
        close: ()=>true,
        open: ()=>true,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        "update:modelValue": (_value)=>true
    },
    data () {
        return {
            isOpen: this.modelValue
        };
    },
    watch: {
        modelValue (value) {
            this.isOpen = value;
        }
    },
    methods: {
        /*
    * Toggle and emit events
    */ toggle () {
            this.isOpen = !this.isOpen;
            this.$emit("update:modelValue", this.isOpen);
            this.isOpen ? this.$emit("open") : this.$emit("close");
        }
    },
    render () {
        const trigger = (0, _vue.h)("div", {
            class: "collapse-trigger",
            onClick: this.toggle
        }, this.$slots.trigger ? this.$slots.trigger({
            open: this.isOpen
        }) : void 0);
        const content = (0, _vue.withDirectives)((0, _vue.h)((0, _vue.Transition), {
            name: this.animation
        }, ()=>[
                (0, _vue.h)("div", {
                    class: "collapse-content",
                    id: this.ariaId
                }, this.$slots)
            ]), [
            [
                (0, _vue.vShow),
                this.isOpen
            ]
        ]);
        return (0, _vue.h)("div", {
            class: "collapse"
        }, this.position === "is-top" ? [
            trigger,
            content
        ] : [
            content,
            trigger
        ]);
    }
});
const Plugin$A = {
    install (Vue) {
        registerComponent(Vue, _sfc_main$F);
    }
};
const findFocusable = (element, programmatic = false)=>{
    if (!element) return null;
    if (programmatic) return element.querySelectorAll('*[tabindex="-1"]');
    return element.querySelectorAll(`a[href]:not([tabindex="-1"]),
                                     area[href],
                                     input:not([disabled]),
                                     select:not([disabled]),
                                     textarea:not([disabled]),
                                     button:not([disabled]),
                                     iframe,
                                     object,
                                     embed,
                                     *[tabindex]:not([tabindex="-1"]),
                                     *[contenteditable]`);
};
let onKeyDown;
const beforeMount$1 = (el, { value = true })=>{
    if (value) {
        let focusable = findFocusable(el);
        let focusableProg = findFocusable(el, true);
        if (focusable && focusable.length > 0) {
            onKeyDown = (event)=>{
                focusable = findFocusable(el);
                focusableProg = findFocusable(el, true);
                const firstFocusable = focusable[0];
                const lastFocusable = focusable[focusable.length - 1];
                if (event.target === firstFocusable && event.shiftKey && event.key === "Tab") {
                    event.preventDefault();
                    lastFocusable.focus();
                } else if ((event.target === lastFocusable || Array.from(focusableProg).indexOf(event.target) >= 0) && !event.shiftKey && event.key === "Tab") {
                    event.preventDefault();
                    firstFocusable.focus();
                }
            };
            el.addEventListener("keydown", onKeyDown);
        }
    }
};
const unmounted$1 = (el)=>{
    el.removeEventListener("keydown", onKeyDown);
};
const directive$1 = {
    beforeMount: beforeMount$1,
    unmounted: unmounted$1
};
const DEFAULT_CLOSE_OPTIONS = [
    "escape",
    "outside"
];
const DROPDOWN_INJECTION_KEY = Symbol("bdropdown");
var _sfc_main$E = (0, _vue.defineComponent)({
    name: "BDropdown",
    directives: {
        trapFocus: directive$1
    },
    provide () {
        return {
            [DROPDOWN_INJECTION_KEY]: this
        };
    },
    props: {
        modelValue: {
            type: [
                String,
                Number,
                Boolean,
                Object,
                Array,
                Function
            ],
            default: null
        },
        disabled: Boolean,
        inline: Boolean,
        scrollable: Boolean,
        maxHeight: {
            type: [
                String,
                Number
            ],
            default: 200
        },
        position: {
            type: String,
            validator (value) {
                return [
                    "is-top-right",
                    "is-top-left",
                    "is-bottom-left",
                    "is-bottom-right"
                ].indexOf(value) > -1;
            }
        },
        triggers: {
            type: Array,
            default: ()=>[
                    "click"
                ]
        },
        mobileModal: {
            type: Boolean,
            default: ()=>{
                return config.defaultDropdownMobileModal;
            }
        },
        ariaRole: {
            type: String,
            validator (value) {
                return [
                    "menu",
                    "list",
                    "dialog"
                ].indexOf(value) > -1;
            },
            default: null
        },
        animation: {
            type: String,
            default: "fade"
        },
        multiple: Boolean,
        trapFocus: {
            type: Boolean,
            default: ()=>{
                return config.defaultTrapFocus;
            }
        },
        closeOnClick: {
            type: Boolean,
            default: true
        },
        canClose: {
            type: [
                Array,
                Boolean
            ],
            default: true
        },
        expanded: Boolean,
        appendToBody: Boolean,
        appendToBodyCopyParent: Boolean,
        triggerTabindex: {
            type: Number,
            default: 0
        }
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars */ "active-change": (_isActive)=>true,
        change: (_selected)=>true,
        "update:modelValue": (_value)=>true
    },
    data () {
        return {
            selected: this.modelValue,
            style: {},
            isActive: false,
            isHoverable: false,
            maybeTap: false,
            isTouchEnabled: false,
            _bodyEl: void 0,
            // Used to append to body
            timeOutID: void 0,
            timeOutID2: void 0
        };
    },
    computed: {
        rootClasses () {
            return [
                this.position,
                {
                    "is-disabled": this.disabled,
                    "is-hoverable": this.hoverable,
                    "is-inline": this.inline,
                    "is-active": this.isActive || this.inline,
                    "is-mobile-modal": this.isMobileModal,
                    "is-expanded": this.expanded,
                    "is-touch-enabled": this.isTouchEnabled
                }
            ];
        },
        isMobileModal () {
            return this.mobileModal && !this.inline;
        },
        cancelOptions () {
            return typeof this.canClose === "boolean" ? this.canClose ? DEFAULT_CLOSE_OPTIONS : [] : this.canClose;
        },
        contentStyle () {
            var _a;
            return {
                maxHeight: this.scrollable ? (_a = toCssWidth(this.maxHeight)) != null ? _a : void 0 : void 0,
                overflow: this.scrollable ? "auto" : void 0
            };
        },
        hoverable () {
            return this.triggers.indexOf("hover") >= 0;
        }
    },
    watch: {
        /*
    * When v-model is changed set the new selected item.
    */ modelValue (value) {
            this.selected = value;
        },
        /*
    * Emit event when isActive value is changed.
    *
    * Also resets `isTouchEnabled` when it turns inactive.
    */ isActive (value) {
            this.$emit("active-change", value);
            if (!value) this.timeOutID = setTimeout(()=>{
                if (!this.isActive) this.isTouchEnabled = false;
            }, 250);
            this.handleScroll();
            if (this.appendToBody) this.$nextTick(()=>{
                this.updateAppendToBody();
            });
        },
        isHoverable (value) {
            if (this.hoverable) this.$emit("active-change", value);
        }
    },
    methods: {
        handleScroll () {
            if (typeof window === "undefined") return;
            if (this.isMobileModal) {
                if (this.isActive) document.documentElement.classList.add("is-clipped-touch");
                else document.documentElement.classList.remove("is-clipped-touch");
            }
        },
        /*
     * Click listener from DropdownItem.
     *   1. Set new selected item.
     *   2. Emit input event to update the user v-model.
     *   3. Close the dropdown.
     */ selectItem (value) {
            if (this.multiple) {
                if (this.selected) {
                    const selected = this.selected;
                    if (selected.indexOf(value) === -1) this.selected = [
                        ...selected,
                        value
                    ];
                    else this.selected = selected.filter((val)=>val !== value);
                } else this.selected = [
                    value
                ];
                this.$emit("change", this.selected);
            } else if (this.selected !== value) {
                this.selected = value;
                this.$emit("change", this.selected);
            }
            this.$emit("update:modelValue", this.selected);
            if (!this.multiple) {
                this.isActive = !this.closeOnClick;
                if (this.hoverable && this.closeOnClick) this.isHoverable = false;
            }
        },
        /*
    * White-listed items to not close when clicked.
    */ isInWhiteList (el) {
            if (el === this.$refs.dropdownMenu) return true;
            if (el === this.$refs.trigger) return true;
            if (this.$refs.dropdownMenu != null) {
                const children = this.$refs.dropdownMenu.querySelectorAll("*");
                for (const child of children){
                    if (el === child) return true;
                }
            }
            if (this.$refs.trigger != null) {
                const children = this.$refs.trigger.querySelectorAll("*");
                for (const child of children){
                    if (el === child) return true;
                }
            }
            return false;
        },
        /*
    * Close dropdown if clicked outside.
    */ clickedOutside (event) {
            if (this.cancelOptions.indexOf("outside") < 0) return;
            if (this.inline) return;
            const target = isCustomElement(this) ? event.composedPath()[0] : event.target;
            if (!this.isInWhiteList(target)) this.isActive = false;
        },
        /*
     * Keypress event that is bound to the document
     */ keyPress ({ key }) {
            if (this.isActive && (key === "Escape" || key === "Esc")) {
                if (this.cancelOptions.indexOf("escape") < 0) return;
                this.isActive = false;
            }
        },
        onClick () {
            if (this.triggers.indexOf("hover") !== -1) return;
            if (this.triggers.indexOf("click") < 0) return;
            this.toggle();
        },
        onContextMenu () {
            if (this.triggers.indexOf("contextmenu") < 0) return;
            this.toggle();
        },
        onHover () {
            if (this.triggers.indexOf("hover") < 0) return;
            if (this.isTouchEnabled) return;
            this.isHoverable = true;
        },
        // takes care of touch-enabled devices
        // - does nothing if hover trigger is disabled
        // - suppresses hover trigger by setting isTouchEnabled
        // - handles only a tap; i.e., touchstart on the trigger immediately
        //   folowed by touchend
        onTouchStart () {
            this.maybeTap = true;
        },
        onTouchMove () {
            this.maybeTap = false;
        },
        onTouchEnd (e) {
            if (this.triggers.indexOf("hover") === -1) return;
            if (!this.maybeTap) return;
            e.preventDefault();
            this.maybeTap = false;
            this.isTouchEnabled = true;
            this.toggle();
        },
        onFocus () {
            if (this.triggers.indexOf("focus") < 0) return;
            this.toggle();
        },
        /*
    * Toggle dropdown if it's not disabled.
    */ toggle () {
            if (this.disabled) return;
            if (!this.isActive) this.timeOutID2 = setTimeout(()=>{
                const value = !this.isActive;
                this.isActive = value;
            });
            else this.isActive = !this.isActive;
        },
        updateAppendToBody () {
            const dropdown = this.$refs.dropdown;
            const dropdownMenu = this.$refs.dropdownMenu;
            const trigger = this.$refs.trigger;
            if (dropdownMenu && trigger) {
                const dropdownWrapper = this.$data._bodyEl.children[0];
                dropdownWrapper.classList.forEach((item)=>dropdownWrapper.classList.remove(item));
                dropdownWrapper.classList.add("dropdown");
                dropdownWrapper.classList.add("dropdown-menu-animation");
                this.rootClasses.forEach((item)=>{
                    if (item && typeof item === "object") {
                        for(const key in item)if (item[key]) dropdownWrapper.classList.add(key);
                    }
                });
                if (this.appendToBodyCopyParent) {
                    const parentNode = this.$refs.dropdown.parentNode;
                    const parent = this.$data._bodyEl;
                    parent.classList.forEach((item)=>parent.classList.remove(item));
                    parentNode.classList.forEach((item)=>{
                        parent.classList.add(item);
                    });
                }
                const rect = trigger.getBoundingClientRect();
                let top = rect.top + window.scrollY;
                let left = rect.left + window.scrollX;
                if (!this.position || this.position.indexOf("bottom") >= 0) top += trigger.clientHeight;
                else top -= dropdownMenu.clientHeight;
                if (this.position && this.position.indexOf("left") >= 0) left -= dropdownMenu.clientWidth - trigger.clientWidth;
                this.style = {
                    position: "absolute",
                    top: `${top}px`,
                    left: `${left}px`,
                    zIndex: "99",
                    width: this.expanded ? `${dropdown.offsetWidth}px` : void 0
                };
            }
        }
    },
    mounted () {
        if (this.appendToBody) {
            this.$data._bodyEl = createAbsoluteElement(this.$refs.dropdownMenu);
            this.updateAppendToBody();
        }
    },
    created () {
        if (typeof window !== "undefined") {
            document.addEventListener("click", this.clickedOutside);
            document.addEventListener("keyup", this.keyPress);
        }
    },
    beforeUnmount () {
        if (typeof window !== "undefined") {
            document.removeEventListener("click", this.clickedOutside);
            document.removeEventListener("keyup", this.keyPress);
        }
        if (this.appendToBody) removeElement(this.$data._bodyEl);
        clearTimeout(this.timeOutID);
        clearTimeout(this.timeOutID2);
    }
});
const _hoisted_1$J = [
    "tabindex"
];
const _hoisted_2$B = [
    "aria-hidden"
];
const _hoisted_3$o = [
    "aria-hidden"
];
const _hoisted_4$i = [
    "role",
    "aria-modal"
];
function _sfc_render$P(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_trap_focus = (0, _vue.resolveDirective)("trap-focus");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "dropdown dropdown-menu-animation",
            _ctx.rootClasses
        ]),
        ref: "dropdown",
        onMouseleave: _cache[7] || (_cache[7] = ($event)=>_ctx.isHoverable = false)
    }, [
        !_ctx.inline ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
            key: 0,
            tabindex: _ctx.disabled ? void 0 : _ctx.triggerTabindex,
            ref: "trigger",
            class: "dropdown-trigger",
            onClick: _cache[0] || (_cache[0] = (...args)=>_ctx.onClick && _ctx.onClick(...args)),
            onContextmenu: _cache[1] || (_cache[1] = (0, _vue.withModifiers)((...args)=>_ctx.onContextMenu && _ctx.onContextMenu(...args), [
                "prevent"
            ])),
            onMouseenter: _cache[2] || (_cache[2] = (...args)=>_ctx.onHover && _ctx.onHover(...args)),
            onFocusCapture: _cache[3] || (_cache[3] = (...args)=>_ctx.onFocus && _ctx.onFocus(...args)),
            onTouchstart: _cache[4] || (_cache[4] = (...args)=>_ctx.onTouchStart && _ctx.onTouchStart(...args)),
            onTouchmove: _cache[5] || (_cache[5] = (...args)=>_ctx.onTouchMove && _ctx.onTouchMove(...args)),
            onTouchend: _cache[6] || (_cache[6] = (...args)=>_ctx.onTouchEnd && _ctx.onTouchEnd(...args)),
            "aria-haspopup": "true"
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "trigger", {
                active: _ctx.isActive
            })
        ], 40, _hoisted_1$J)) : (0, _vue.createCommentVNode)("v-if", true),
        (0, _vue.createVNode)((0, _vue.Transition), {
            name: _ctx.animation
        }, {
            default: (0, _vue.withCtx)(()=>[
                    _ctx.isMobileModal ? (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                        key: 0,
                        class: "background",
                        "aria-hidden": !_ctx.isActive
                    }, null, 8, _hoisted_2$B)), [
                        [
                            (0, _vue.vShow),
                            _ctx.isActive
                        ]
                    ]) : (0, _vue.createCommentVNode)("v-if", true)
                ]),
            _: 1
        }, 8, [
            "name"
        ]),
        (0, _vue.createVNode)((0, _vue.Transition), {
            name: _ctx.animation,
            persisted: ""
        }, {
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                        ref: "dropdownMenu",
                        class: "dropdown-menu",
                        style: (0, _vue.normalizeStyle)(_ctx.style),
                        "aria-hidden": !_ctx.isActive
                    }, [
                        (0, _vue.createElementVNode)("div", {
                            class: "dropdown-content",
                            role: _ctx.ariaRole,
                            "aria-modal": !_ctx.inline,
                            style: (0, _vue.normalizeStyle)(_ctx.contentStyle)
                        }, [
                            (0, _vue.renderSlot)(_ctx.$slots, "default")
                        ], 12, _hoisted_4$i)
                    ], 12, _hoisted_3$o)), [
                        [
                            (0, _vue.vShow),
                            !_ctx.disabled && (_ctx.isActive || _ctx.isHoverable) || _ctx.inline
                        ],
                        [
                            _directive_trap_focus,
                            _ctx.trapFocus
                        ]
                    ])
                ]),
            _: 3
        }, 8, [
            "name"
        ])
    ], 34);
}
var BDropdown = /* @__PURE__ */ _export_sfc(_sfc_main$E, [
    [
        "render",
        _sfc_render$P
    ]
]);
var _sfc_main$D = (0, _vue.defineComponent)({
    name: "BDropdownItem",
    inject: {
        parent: {
            from: DROPDOWN_INJECTION_KEY,
            default: void 0
        }
    },
    props: {
        value: {
            type: [
                String,
                Number,
                Boolean,
                Object,
                Array,
                Function
            ],
            default: null
        },
        separator: Boolean,
        disabled: Boolean,
        custom: Boolean,
        focusable: {
            type: Boolean,
            default: true
        },
        paddingless: Boolean,
        hasLink: Boolean,
        ariaRole: {
            type: String,
            default: ""
        }
    },
    emits: {
        click: ()=>true
    },
    computed: {
        anchorClasses () {
            return {
                "is-disabled": this.parent.disabled || this.disabled,
                "is-paddingless": this.paddingless,
                "is-active": this.isActive
            };
        },
        itemClasses () {
            return {
                "dropdown-item": !this.hasLink,
                "is-disabled": this.disabled,
                "is-paddingless": this.paddingless,
                "is-active": this.isActive,
                "has-link": this.hasLink
            };
        },
        ariaRoleItem () {
            return this.ariaRole === "menuitem" || this.ariaRole === "listitem" ? this.ariaRole : void 0;
        },
        isClickable () {
            return !this.parent.disabled && !this.separator && !this.disabled && !this.custom;
        },
        isActive () {
            if (this.parent.selected === null) return false;
            if (this.parent.multiple) return this.parent.selected.indexOf(this.value) >= 0;
            return this.value === this.parent.selected;
        },
        isFocusable () {
            return this.hasLink ? false : this.focusable;
        }
    },
    methods: {
        /*
    * Click listener, select the item.
    */ selectItem () {
            if (!this.isClickable) return;
            this.parent.selectItem(this.value);
            this.$emit("click");
        }
    }
});
const _hoisted_1$I = {
    key: 0,
    class: "dropdown-divider"
};
const _hoisted_2$A = [
    "role",
    "tabindex"
];
const _hoisted_3$n = [
    "role",
    "tabindex"
];
function _sfc_render$O(_ctx, _cache, $props, $setup, $data, $options) {
    return _ctx.separator ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("hr", _hoisted_1$I)) : !_ctx.custom && !_ctx.hasLink ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("a", {
        key: 1,
        class: (0, _vue.normalizeClass)([
            "dropdown-item",
            _ctx.anchorClasses
        ]),
        onClick: _cache[0] || (_cache[0] = (...args)=>_ctx.selectItem && _ctx.selectItem(...args)),
        role: _ctx.ariaRoleItem,
        tabindex: _ctx.isFocusable ? 0 : void 0
    }, [
        (0, _vue.renderSlot)(_ctx.$slots, "default")
    ], 10, _hoisted_2$A)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        key: 2,
        class: (0, _vue.normalizeClass)(_ctx.itemClasses),
        onClick: _cache[1] || (_cache[1] = (...args)=>_ctx.selectItem && _ctx.selectItem(...args)),
        role: _ctx.ariaRoleItem,
        tabindex: _ctx.isFocusable ? 0 : void 0
    }, [
        (0, _vue.renderSlot)(_ctx.$slots, "default")
    ], 10, _hoisted_3$n));
}
var BDropdownItem = /* @__PURE__ */ _export_sfc(_sfc_main$D, [
    [
        "render",
        _sfc_render$O
    ]
]);
const Plugin$z = {
    install (Vue) {
        registerComponent(Vue, BDropdown);
        registerComponent(Vue, BDropdownItem);
    }
};
const Plugin$y = {
    install (Vue) {
        registerComponent(Vue, BInput);
    }
};
const AM$1 = "AM";
const PM$1 = "PM";
const HOUR_FORMAT_24 = "24";
const HOUR_FORMAT_12 = "12";
const defaultTimeFormatter = (date, vm)=>{
    return vm.dtf.format(date);
};
const defaultTimeParser = (timeString, vm)=>{
    if (timeString) {
        let d = null;
        if (vm.computedValue && !isNaN(vm.computedValue.valueOf())) d = new Date(vm.computedValue);
        else {
            d = vm.timeCreator();
            d.setMilliseconds(0);
        }
        if (vm.dtf.formatToParts && typeof vm.dtf.formatToParts === "function") {
            const formatRegex = vm.dtf.formatToParts(d).map((part)=>{
                if (part.type === "literal") return part.value.replace(/ /g, "\\s?");
                else if (part.type === "dayPeriod") return `((?!=<${part.type}>)(${vm.amString}|${vm.pmString}|${AM$1}|${PM$1}|${AM$1.toLowerCase()}|${PM$1.toLowerCase()})?)`;
                return `((?!=<${part.type}>)\\d+)`;
            }).join("");
            const timeGroups = matchWithGroups(formatRegex, timeString);
            timeGroups.hour = timeGroups.hour ? parseInt(timeGroups.hour + "", 10) : null;
            timeGroups.minute = timeGroups.minute ? parseInt(timeGroups.minute + "", 10) : null;
            timeGroups.second = timeGroups.second ? parseInt(timeGroups.second + "", 10) : null;
            if (timeGroups.hour && timeGroups.hour >= 0 && timeGroups.hour < 24 && timeGroups.minute && timeGroups.minute >= 0 && timeGroups.minute < 59) {
                const dayPeriod = timeGroups.dayPeriod;
                if (dayPeriod && (dayPeriod.toLowerCase() === vm.pmString.toLowerCase() || dayPeriod.toLowerCase() === PM$1.toLowerCase()) && timeGroups.hour < 12) timeGroups.hour += 12;
                d.setHours(timeGroups.hour);
                d.setMinutes(timeGroups.minute);
                d.setSeconds(timeGroups.second || 0);
                return d;
            }
        }
        let am = false;
        if (vm.hourFormat === HOUR_FORMAT_12) {
            const dateString12 = timeString.split(" ");
            timeString = dateString12[0];
            am = dateString12[1] === vm.amString || dateString12[1] === AM$1;
        }
        const time = timeString.split(":");
        let hours = parseInt(time[0], 10);
        const minutes = parseInt(time[1], 10);
        const seconds = vm.enableSeconds ? parseInt(time[2], 10) : 0;
        if (isNaN(hours) || hours < 0 || hours > 23 || vm.hourFormat === HOUR_FORMAT_12 && (hours < 1 || hours > 12) || isNaN(minutes) || minutes < 0 || minutes > 59) return null;
        d.setSeconds(seconds);
        d.setMinutes(minutes);
        if (vm.hourFormat === HOUR_FORMAT_12) {
            if (am && hours === 12) hours = 0;
            else if (!am && hours !== 12) hours += 12;
        }
        d.setHours(hours);
        return new Date(d.getTime());
    }
    return null;
};
var TimepickerMixin = (0, _vue.defineComponent)({
    mixins: [
        CompatFallthroughMixin,
        FormElementMixin
    ],
    props: {
        modelValue: [
            Date,
            null
        ],
        inline: Boolean,
        minTime: [
            Date,
            null
        ],
        maxTime: [
            Date,
            null
        ],
        placeholder: String,
        editable: Boolean,
        disabled: Boolean,
        hourFormat: {
            type: String,
            validator: (value)=>{
                return value === HOUR_FORMAT_24 || value === HOUR_FORMAT_12;
            }
        },
        incrementHours: {
            type: Number,
            default: 1
        },
        incrementMinutes: {
            type: Number,
            default: 1
        },
        incrementSeconds: {
            type: Number,
            default: 1
        },
        timeFormatter: {
            type: Function,
            default: (date, vm)=>{
                if (typeof config.defaultTimeFormatter === "function") return config.defaultTimeFormatter(date);
                else return defaultTimeFormatter(date, vm);
            }
        },
        timeParser: {
            type: Function,
            default: (date, vm)=>{
                if (typeof config.defaultTimeParser === "function") return config.defaultTimeParser(date);
                else return defaultTimeParser(date, vm);
            }
        },
        mobileNative: {
            type: Boolean,
            default: ()=>config.defaultTimepickerMobileNative
        },
        mobileModal: {
            type: Boolean,
            default: ()=>config.defaultTimepickerMobileModal
        },
        timeCreator: {
            type: Function,
            default: ()=>{
                if (typeof config.defaultTimeCreator === "function") return config.defaultTimeCreator();
                else return /* @__PURE__ */ new Date();
            }
        },
        position: String,
        unselectableTimes: Array,
        openOnFocus: Boolean,
        enableSeconds: Boolean,
        defaultMinutes: Number,
        defaultSeconds: Number,
        focusable: {
            type: Boolean,
            default: true
        },
        tzOffset: {
            type: Number,
            default: 0
        },
        appendToBody: Boolean,
        resetOnMeridianChange: {
            type: Boolean,
            default: false
        }
    },
    emits: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        "update:modelValue": (_value)=>true
    },
    data () {
        return {
            dateSelected: this.modelValue,
            hoursSelected: null,
            minutesSelected: null,
            secondsSelected: null,
            meridienSelected: null,
            _elementRef: "input",
            AM: AM$1,
            PM: PM$1,
            HOUR_FORMAT_24,
            HOUR_FORMAT_12
        };
    },
    computed: {
        computedValue: {
            get () {
                return this.dateSelected;
            },
            set (value) {
                this.dateSelected = value;
                this.$emit("update:modelValue", this.dateSelected);
            }
        },
        localeOptions () {
            return new Intl.DateTimeFormat(this.locale, {
                hour: "numeric",
                minute: "numeric",
                second: this.enableSeconds ? "numeric" : void 0
            }).resolvedOptions();
        },
        dtf () {
            return new Intl.DateTimeFormat(this.locale, {
                hour: this.localeOptions.hour || "numeric",
                minute: this.localeOptions.minute || "numeric",
                second: this.enableSeconds ? this.localeOptions.second || "numeric" : void 0,
                // Fixes 12 hour display github.com/buefy/buefy/issues/3418
                hourCycle: !this.isHourFormat24 ? "h12" : "h23"
            });
        },
        newHourFormat () {
            return this.hourFormat || (this.localeOptions.hour12 ? HOUR_FORMAT_12 : HOUR_FORMAT_24);
        },
        sampleTime () {
            const d = this.timeCreator();
            d.setHours(10);
            d.setSeconds(0);
            d.setMinutes(0);
            d.setMilliseconds(0);
            return d;
        },
        hourLiteral () {
            if (this.dtf.formatToParts && typeof this.dtf.formatToParts === "function") {
                const d = this.sampleTime;
                const parts = this.dtf.formatToParts(d);
                const literal = parts.find((part, idx)=>idx > 0 && parts[idx - 1].type === "hour");
                if (literal) return literal.value;
            }
            return ":";
        },
        minuteLiteral () {
            if (this.dtf.formatToParts && typeof this.dtf.formatToParts === "function") {
                const d = this.sampleTime;
                const parts = this.dtf.formatToParts(d);
                const literal = parts.find((part, idx)=>idx > 0 && parts[idx - 1].type === "minute");
                if (literal) return literal.value;
            }
            return ":";
        },
        secondLiteral () {
            if (this.dtf.formatToParts && typeof this.dtf.formatToParts === "function") {
                const d = this.sampleTime;
                const parts = this.dtf.formatToParts(d);
                const literal = parts.find((part, idx)=>idx > 0 && parts[idx - 1].type === "second");
                if (literal) return literal.value;
            }
            return void 0;
        },
        amString () {
            if (this.dtf.formatToParts && typeof this.dtf.formatToParts === "function") {
                const d = this.sampleTime;
                d.setHours(10);
                const dayPeriod = this.dtf.formatToParts(d).find((part)=>part.type === "dayPeriod");
                if (dayPeriod) return dayPeriod.value;
            }
            return AM$1;
        },
        pmString () {
            if (this.dtf.formatToParts && typeof this.dtf.formatToParts === "function") {
                const d = this.sampleTime;
                d.setHours(20);
                const dayPeriod = this.dtf.formatToParts(d).find((part)=>part.type === "dayPeriod");
                if (dayPeriod) return dayPeriod.value;
            }
            return PM$1;
        },
        hours () {
            if (!this.incrementHours || this.incrementHours < 1) throw new Error("Hour increment cannot be null or less than 1.");
            const hours = [];
            const numberOfHours = this.isHourFormat24 ? 24 : 12;
            for(let i = 0; i < numberOfHours; i += this.incrementHours){
                let value = i;
                let label = value;
                if (!this.isHourFormat24) {
                    value = i + 1;
                    label = value;
                    if (this.meridienSelected === this.amString) {
                        if (value === 12) value = 0;
                    } else if (this.meridienSelected === this.pmString) {
                        if (value !== 12) value += 12;
                    }
                }
                hours.push({
                    label: this.formatNumber(label),
                    value
                });
            }
            return hours;
        },
        minutes () {
            if (!this.incrementMinutes || this.incrementMinutes < 1) throw new Error("Minute increment cannot be null or less than 1.");
            const minutes = [];
            for(let i = 0; i < 60; i += this.incrementMinutes)minutes.push({
                label: this.formatNumber(i, true),
                value: i
            });
            return minutes;
        },
        seconds () {
            if (!this.incrementSeconds || this.incrementSeconds < 1) throw new Error("Second increment cannot be null or less than 1.");
            const seconds = [];
            for(let i = 0; i < 60; i += this.incrementSeconds)seconds.push({
                label: this.formatNumber(i, true),
                value: i
            });
            return seconds;
        },
        meridiens () {
            return [
                this.amString,
                this.pmString
            ];
        },
        isMobile () {
            return this.mobileNative && isMobile.any();
        },
        isHourFormat24 () {
            return this.newHourFormat === HOUR_FORMAT_24;
        },
        disabledOrUndefined () {
            return this.disabled || void 0;
        }
    },
    watch: {
        hourFormat () {
            if (this.hoursSelected !== null) this.meridienSelected = this.hoursSelected >= 12 ? this.pmString : this.amString;
        },
        locale () {
            if (!this.modelValue) this.meridienSelected = this.amString;
        },
        /*
     * When v-model is changed:
     *   1. Update internal value.
     *   2. If it's invalid, validate again.
     */ modelValue: {
            handler (value) {
                this.updateInternalState(value);
                !this.isValid && this.$refs.input.checkHtml5Validity();
            },
            immediate: true
        }
    },
    methods: {
        onMeridienChange (value) {
            if (this.hoursSelected !== null && this.resetOnMeridianChange) {
                this.hoursSelected = null;
                this.minutesSelected = null;
                this.secondsSelected = null;
                this.computedValue = null;
            } else if (this.hoursSelected !== null) {
                if (value === this.pmString) this.hoursSelected += 12;
                else if (value === this.amString) this.hoursSelected -= 12;
            }
            this.updateDateSelected(this.hoursSelected, this.minutesSelected, this.enableSeconds ? this.secondsSelected : 0, value);
        },
        onHoursChange (value) {
            if (!this.minutesSelected && typeof this.defaultMinutes !== "undefined") this.minutesSelected = this.defaultMinutes;
            if (!this.secondsSelected && typeof this.defaultSeconds !== "undefined") this.secondsSelected = this.defaultSeconds;
            this.updateDateSelected(parseInt(`${value}`, 10), this.minutesSelected, this.enableSeconds ? this.secondsSelected : 0, this.meridienSelected);
        },
        onMinutesChange (value) {
            if (!this.secondsSelected && this.defaultSeconds) this.secondsSelected = this.defaultSeconds;
            this.updateDateSelected(this.hoursSelected, parseInt(`${value}`, 10), this.enableSeconds ? this.secondsSelected : 0, this.meridienSelected);
        },
        onSecondsChange (value) {
            this.updateDateSelected(this.hoursSelected, this.minutesSelected, parseInt(`${value}`, 10), this.meridienSelected);
        },
        updateDateSelected (hours, minutes, seconds, meridiens) {
            if (hours != null && minutes != null && (!this.isHourFormat24 && meridiens !== null || this.isHourFormat24)) {
                let time = null;
                if (this.computedValue && !isNaN(this.computedValue.valueOf())) time = new Date(this.computedValue);
                else {
                    time = this.timeCreator();
                    time.setMilliseconds(0);
                }
                time.setHours(hours);
                time.setMinutes(minutes);
                time.setSeconds(seconds);
                if (!isNaN(time.getTime())) this.computedValue = new Date(time.getTime());
            }
        },
        updateInternalState (value) {
            if (value) {
                this.hoursSelected = value.getHours();
                this.minutesSelected = value.getMinutes();
                this.secondsSelected = value.getSeconds();
                this.meridienSelected = value.getHours() >= 12 ? this.pmString : this.amString;
            } else {
                this.hoursSelected = null;
                this.minutesSelected = null;
                this.secondsSelected = null;
                this.meridienSelected = this.amString;
            }
            this.dateSelected = value;
        },
        isHourDisabled (hour) {
            let disabled = false;
            if (this.minTime) {
                const minHours = this.minTime.getHours();
                const noMinutesAvailable = this.minutes.every((minute)=>{
                    return this.isMinuteDisabledForHour(hour, minute.value);
                });
                disabled = hour < minHours || noMinutesAvailable;
            }
            if (this.maxTime) {
                if (!disabled) {
                    const maxHours = this.maxTime.getHours();
                    disabled = hour > maxHours;
                }
            }
            if (this.unselectableTimes) {
                if (!disabled) {
                    const unselectable = this.unselectableTimes.filter((time)=>{
                        if (this.enableSeconds && this.secondsSelected !== null) return time.getHours() === hour && time.getMinutes() === this.minutesSelected && time.getSeconds() === this.secondsSelected;
                        else if (this.minutesSelected !== null) return time.getHours() === hour && time.getMinutes() === this.minutesSelected;
                        return false;
                    });
                    if (unselectable.length > 0) disabled = true;
                    else disabled = this.minutes.every((minute)=>{
                        return this.unselectableTimes.filter((time)=>{
                            return time.getHours() === hour && time.getMinutes() === minute.value;
                        }).length > 0;
                    });
                }
            }
            return disabled;
        },
        isMinuteDisabledForHour (hour, minute) {
            let disabled = false;
            if (this.minTime) {
                const minHours = this.minTime.getHours();
                const minMinutes = this.minTime.getMinutes();
                disabled = hour === minHours && minute < minMinutes;
            }
            if (this.maxTime) {
                if (!disabled) {
                    const maxHours = this.maxTime.getHours();
                    const maxMinutes = this.maxTime.getMinutes();
                    disabled = hour === maxHours && minute > maxMinutes;
                }
            }
            return disabled;
        },
        isMinuteDisabled (minute) {
            let disabled = false;
            if (this.hoursSelected !== null) {
                if (this.isHourDisabled(this.hoursSelected)) disabled = true;
                else disabled = this.isMinuteDisabledForHour(this.hoursSelected, minute);
                if (this.unselectableTimes) {
                    if (!disabled) {
                        const unselectable = this.unselectableTimes.filter((time)=>{
                            if (this.enableSeconds && this.secondsSelected !== null) return time.getHours() === this.hoursSelected && time.getMinutes() === minute && time.getSeconds() === this.secondsSelected;
                            else return time.getHours() === this.hoursSelected && time.getMinutes() === minute;
                        });
                        disabled = unselectable.length > 0;
                    }
                }
            }
            return disabled;
        },
        isSecondDisabled (second) {
            let disabled = false;
            if (this.minutesSelected !== null) {
                if (this.isMinuteDisabled(this.minutesSelected)) disabled = true;
                else {
                    if (this.minTime) {
                        const minHours = this.minTime.getHours();
                        const minMinutes = this.minTime.getMinutes();
                        const minSeconds = this.minTime.getSeconds();
                        disabled = this.hoursSelected === minHours && this.minutesSelected === minMinutes && second < minSeconds;
                    }
                    if (this.maxTime) {
                        if (!disabled) {
                            const maxHours = this.maxTime.getHours();
                            const maxMinutes = this.maxTime.getMinutes();
                            const maxSeconds = this.maxTime.getSeconds();
                            disabled = this.hoursSelected === maxHours && this.minutesSelected === maxMinutes && second > maxSeconds;
                        }
                    }
                }
                if (this.unselectableTimes) {
                    if (!disabled) {
                        const unselectable = this.unselectableTimes.filter((time)=>{
                            return time.getHours() === this.hoursSelected && time.getMinutes() === this.minutesSelected && time.getSeconds() === second;
                        });
                        disabled = unselectable.length > 0;
                    }
                }
            }
            return disabled;
        },
        /*
     * Parse string into date
     */ onChange (value) {
            const date = this.timeParser(value, this);
            this.updateInternalState(date);
            if (date && !isNaN(date.valueOf())) this.computedValue = date;
            else {
                this.computedValue = null;
                this.$refs.input.newValue = this.computedValue;
            }
        },
        /*
     * Toggle timepicker
     */ toggle (active) {
            if (this.$refs.dropdown) this.$refs.dropdown.isActive = typeof active === "boolean" ? active : !this.$refs.dropdown.isActive;
        },
        /*
     * Close timepicker
     */ close () {
            this.toggle(false);
        },
        /*
     * Call default onFocus method and show timepicker
     */ handleOnFocus () {
            this.onFocus();
            if (this.openOnFocus) this.toggle(true);
        },
        /*
     * Format date into string 'HH-MM-SS'
     */ formatHHMMSS (value) {
            const date = new Date(value);
            if (value && !isNaN(date.valueOf())) {
                const hours = date.getHours();
                const minutes = date.getMinutes();
                const seconds = date.getSeconds();
                return this.formatNumber(hours, true) + ":" + this.formatNumber(minutes, true) + ":" + this.formatNumber(seconds, true);
            }
            return "";
        },
        /*
     * Parse time from string
     */ onChangeNativePicker (event) {
            const date = event.target.value;
            if (date) {
                let time = null;
                if (this.computedValue && !isNaN(this.computedValue.valueOf())) time = new Date(this.computedValue);
                else {
                    time = /* @__PURE__ */ new Date();
                    time.setMilliseconds(0);
                }
                const t = date.split(":");
                time.setHours(parseInt(t[0], 10));
                time.setMinutes(parseInt(t[1], 10));
                time.setSeconds(t[2] ? parseInt(t[2], 10) : 0);
                this.computedValue = new Date(time.getTime());
            } else this.computedValue = null;
        },
        formatNumber (value, prependZero) {
            return this.isHourFormat24 || prependZero ? this.pad(value) : `${value}`;
        },
        pad (value) {
            return (value < 10 ? "0" : "") + value;
        },
        /*
     * Format date into string
     */ formatValue (date) {
            if (date && !isNaN(date.valueOf())) return this.timeFormatter(date, this);
            else return null;
        },
        /*
     * Keypress event that is bound to the document.
     */ keyPress ({ key }) {
            if (this.$refs.dropdown && this.$refs.dropdown.isActive && (key === "Escape" || key === "Esc")) this.toggle(false);
        },
        /*
     * Emit 'blur' event on dropdown is not active (closed)
     */ onActiveChange (value) {
            if (!value) this.onBlur();
        }
    },
    created () {
        if (typeof window !== "undefined") document.addEventListener("keyup", this.keyPress);
    },
    beforeUnmounted () {
        if (typeof window !== "undefined") document.removeEventListener("keyup", this.keyPress);
    }
});
const indicatorSize = 40;
const paddingInner = 5;
var _sfc_main$C = (0, _vue.defineComponent)({
    name: "BClockpickerFace",
    props: {
        pickerSize: Number,
        min: Number,
        max: Number,
        double: Boolean,
        value: Number,
        faceNumbers: Array,
        disabledValues: Function
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars */ change: (_value)=>true,
        input: (_value)=>true
    },
    data () {
        return {
            isDragging: false,
            inputValue: this.value,
            prevAngle: 720
        };
    },
    computed: {
        /*
    * How many number indicators are shown on the face
    */ count () {
            return this.max - this.min + 1;
        },
        /*
    * How many number indicators are shown per ring on the face
    */ countPerRing () {
            return this.double ? this.count / 2 : this.count;
        },
        /*
    * Radius of the clock face
    */ radius () {
            return this.pickerSize / 2;
        },
        /*
    * Radius of the outer ring of number indicators
    */ outerRadius () {
            return this.radius - paddingInner - indicatorSize / 2;
        },
        /*
    * Radius of the inner ring of number indicators
    */ innerRadius () {
            return Math.max(this.outerRadius * 0.6, this.outerRadius - paddingInner - indicatorSize);
        },
        /*
    * The angle for each selectable value
    * For hours this ends up being 30 degrees, for minutes 6 degrees
    */ degreesPerUnit () {
            return 360 / this.countPerRing;
        },
        /*
    * Used for calculating x/y grid location based on degrees
    */ degrees () {
            return this.degreesPerUnit * Math.PI / 180;
        },
        /*
    * Calculates the angle the clock hand should be rotated for the
    * selected value
    */ handRotateAngle () {
            let currentAngle = this.prevAngle;
            while(currentAngle < 0)currentAngle += 360;
            const targetAngle = this.calcHandAngle(this.displayedValue);
            const degreesDiff = this.shortestDistanceDegrees(currentAngle, targetAngle);
            const angle = this.prevAngle + degreesDiff;
            return angle;
        },
        /*
    * Determines how long the selector hand is based on if the
    * selected value is located along the outer or inner ring
    */ handScale () {
            return this.calcHandScale(this.displayedValue);
        },
        handStyle () {
            return {
                transform: `rotate(${this.handRotateAngle}deg) scaleY(${this.handScale})`,
                transition: ".3s cubic-bezier(.25,.8,.50,1)"
            };
        },
        /*
    * The value the hand should be pointing at
    */ displayedValue () {
            return this.inputValue == null ? this.min : this.inputValue;
        }
    },
    watch: {
        value (value) {
            if (value !== this.inputValue) this.prevAngle = this.handRotateAngle;
            this.inputValue = value;
        }
    },
    methods: {
        isDisabled (value) {
            return this.disabledValues && this.disabledValues(value);
        },
        /*
    * Calculates the distance between two points
    */ euclidean (p0, p1) {
            const dx = p1.x - p0.x;
            const dy = p1.y - p0.y;
            return Math.sqrt(dx * dx + dy * dy);
        },
        shortestDistanceDegrees (start, stop) {
            const modDiff = (stop - start) % 360;
            const shortestDistance = 180 - Math.abs(Math.abs(modDiff) - 180);
            return (modDiff + 360) % 360 < 180 ? shortestDistance * 1 : shortestDistance * -1;
        },
        /*
    * Calculates the angle of the line from the center point
    * to the given point.
    */ coordToAngle (center, p1) {
            const value = 2 * Math.atan2(p1.y - center.y - this.euclidean(center, p1), p1.x - center.x);
            return Math.abs(value * 180 / Math.PI);
        },
        /*
    * Generates the inline style translate() property for a
    * number indicator, which determines it's location on the
    * clock face
    */ getNumberTranslate (value) {
            const { x, y } = this.getNumberCoords(value);
            return `translate(${x}px, ${y}px)`;
        },
        /*
    * Calculates the coordinates on the clock face for a number
    * indicator value
    */ getNumberCoords (value) {
            const radius = this.isInnerRing(value) ? this.innerRadius : this.outerRadius;
            return {
                x: Math.round(radius * Math.sin((value - this.min) * this.degrees)),
                y: Math.round(-radius * Math.cos((value - this.min) * this.degrees))
            };
        },
        getFaceNumberClasses (num) {
            return {
                active: num.value === this.displayedValue,
                disabled: this.isDisabled(num.value)
            };
        },
        /*
    * Determines if a value resides on the inner ring
    */ isInnerRing (value) {
            return this.double && value - this.min >= this.countPerRing;
        },
        calcHandAngle (value) {
            let angle = this.degreesPerUnit * (value - this.min);
            if (this.isInnerRing(value)) angle -= 360;
            return angle;
        },
        calcHandScale (value) {
            return this.isInnerRing(value) ? this.innerRadius / this.outerRadius : 1;
        },
        onMouseDown (e) {
            e.preventDefault();
            this.isDragging = true;
            this.onDragMove(e);
        },
        onMouseUp () {
            this.isDragging = false;
            if (!this.isDisabled(this.inputValue)) this.$emit("change", this.inputValue);
        },
        onDragMove (e) {
            e.preventDefault();
            if (!this.isDragging && e.type !== "click") return;
            const { width, top, left } = this.$refs.clock.getBoundingClientRect();
            const { clientX, clientY } = "touches" in e ? e.touches[0] : e;
            const center = {
                x: width / 2,
                y: -width / 2
            };
            const coords = {
                x: clientX - left,
                y: top - clientY
            };
            const handAngle = Math.round(this.coordToAngle(center, coords) + 360) % 360;
            const insideClick = this.double && this.euclidean(center, coords) < (this.outerRadius + this.innerRadius) / 2 - 16;
            let value = Math.round(handAngle / this.degreesPerUnit) + this.min + (insideClick ? this.countPerRing : 0);
            if (handAngle >= 360 - this.degreesPerUnit / 2) value = insideClick ? this.max : this.min;
            this.update(value);
        },
        update (value) {
            if (this.inputValue !== value && !this.isDisabled(value)) {
                this.prevAngle = this.handRotateAngle;
                this.inputValue = value;
                this.$emit("input", value);
            }
        }
    }
});
const _hoisted_1$H = {
    class: "b-clockpicker-face-outer-ring",
    ref: "clock"
};
function _sfc_render$N(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: "b-clockpicker-face",
        onMousedown: _cache[0] || (_cache[0] = (...args)=>_ctx.onMouseDown && _ctx.onMouseDown(...args)),
        onMouseup: _cache[1] || (_cache[1] = (...args)=>_ctx.onMouseUp && _ctx.onMouseUp(...args)),
        onMousemove: _cache[2] || (_cache[2] = (...args)=>_ctx.onDragMove && _ctx.onDragMove(...args)),
        onTouchstart: _cache[3] || (_cache[3] = (...args)=>_ctx.onMouseDown && _ctx.onMouseDown(...args)),
        onTouchend: _cache[4] || (_cache[4] = (...args)=>_ctx.onMouseUp && _ctx.onMouseUp(...args)),
        onTouchmove: _cache[5] || (_cache[5] = (...args)=>_ctx.onDragMove && _ctx.onDragMove(...args))
    }, [
        (0, _vue.createElementVNode)("div", _hoisted_1$H, [
            (0, _vue.createElementVNode)("div", {
                class: "b-clockpicker-face-hand",
                style: (0, _vue.normalizeStyle)(_ctx.handStyle)
            }, null, 4),
            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.faceNumbers, (num, index)=>{
                return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", {
                    key: index,
                    class: (0, _vue.normalizeClass)([
                        "b-clockpicker-face-number",
                        _ctx.getFaceNumberClasses(num)
                    ]),
                    style: (0, _vue.normalizeStyle)({
                        transform: _ctx.getNumberTranslate(num.value)
                    })
                }, [
                    (0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)(num.label), 1)
                ], 6);
            }), 128))
        ], 512)
    ], 32);
}
var BClockpickerFace = /* @__PURE__ */ _export_sfc(_sfc_main$C, [
    [
        "render",
        _sfc_render$N
    ]
]);
const outerPadding = 12;
var _sfc_main$B = (0, _vue.defineComponent)({
    name: "BClockpicker",
    components: {
        BClockpickerFace,
        BInput,
        BDropdown
    },
    mixins: [
        TimepickerMixin
    ],
    props: {
        pickerSize: {
            type: Number,
            default: 290
        },
        incrementMinutes: {
            type: Number,
            default: 5
        },
        type: {
            type: String,
            default: "is-primary"
        },
        hoursLabel: {
            type: String,
            default: ()=>config.defaultClockpickerHoursLabel || "Hours"
        },
        minutesLabel: {
            type: String,
            default: ()=>config.defaultClockpickerMinutesLabel || "Min"
        }
    },
    data () {
        return {
            isSelectingHour: true,
            isDragging: false,
            _isClockpicker: true
        };
    },
    computed: {
        hoursDisplay () {
            if (this.hoursSelected == null) return "--";
            if (this.isHourFormat24) return this.pad(this.hoursSelected);
            let display = this.hoursSelected;
            if (this.meridienSelected === this.pmString) display -= 12;
            if (display === 0) display = 12;
            return display;
        },
        minutesDisplay () {
            return this.minutesSelected == null ? "--" : this.pad(this.minutesSelected);
        },
        minFaceValue () {
            return this.isSelectingHour && !this.isHourFormat24 && this.meridienSelected === this.pmString ? 12 : 0;
        },
        maxFaceValue () {
            return this.isSelectingHour ? !this.isHourFormat24 && this.meridienSelected === this.amString ? 11 : 23 : 59;
        },
        faceSize () {
            return this.pickerSize - outerPadding * 2;
        },
        faceDisabledValues () {
            return this.isSelectingHour ? this.isHourDisabled : this.isMinuteDisabled;
        }
    },
    methods: {
        onClockInput (value) {
            if (this.isSelectingHour) {
                this.hoursSelected = value;
                this.onHoursChange(value);
            } else {
                this.minutesSelected = value;
                this.onMinutesChange(value);
            }
        },
        onClockChange () {
            if (this.isSelectingHour) this.isSelectingHour = !this.isSelectingHour;
            else this.toggle(false);
        },
        /*
     * Toggle clockpicker
     */ toggle (active) {
            if (this.$refs.dropdown) {
                const dropdown = this.$refs.dropdown;
                dropdown.isActive = active != null ? active : !dropdown.isActive;
                if (dropdown.isActive) this.isSelectingHour = true;
            }
        },
        onMeridienClick (value) {
            if (this.meridienSelected !== value) {
                this.meridienSelected = value;
                this.onMeridienChange(value);
            }
        },
        /*
     * Avoid dropdown toggle when is already visible
     */ onInputClick (event) {
            if (this.$refs.dropdown.isActive) event.stopPropagation();
        }
    }
});
const _hoisted_1$G = [
    "disabled"
];
const _hoisted_2$z = {
    key: 0,
    class: "card-header"
};
const _hoisted_3$m = {
    class: "b-clockpicker-header card-header-title"
};
const _hoisted_4$h = {
    class: "b-clockpicker-time"
};
const _hoisted_5$b = {
    key: 0,
    class: "b-clockpicker-period"
};
const _hoisted_6$8 = {
    class: "card-content"
};
const _hoisted_7$8 = {
    key: 0,
    class: "b-clockpicker-time"
};
const _hoisted_8$7 = {
    key: 1,
    class: "b-clockpicker-period"
};
const _hoisted_9$5 = {
    key: 1,
    class: "b-clockpicker-footer card-footer"
};
function _sfc_render$M(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_input = (0, _vue.resolveComponent)("b-input");
    const _component_b_clockpicker_face = (0, _vue.resolveComponent)("b-clockpicker-face");
    const _component_b_dropdown = (0, _vue.resolveComponent)("b-dropdown");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", (0, _vue.mergeProps)({
        class: [
            "b-clockpicker control",
            [
                _ctx.size,
                _ctx.type,
                {
                    "is-expanded": _ctx.expanded
                }
            ]
        ]
    }, _ctx.rootAttrs), [
        !_ctx.isMobile || _ctx.inline ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_dropdown, {
            key: 0,
            ref: "dropdown",
            position: _ctx.position,
            disabled: _ctx.disabledOrUndefined,
            inline: _ctx.inline,
            "mobile-modal": _ctx.mobileModal,
            "append-to-body": _ctx.appendToBody,
            "append-to-body-copy-parent": "",
            onActiveChange: _ctx.onActiveChange
        }, (0, _vue.createSlots)({
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.createElementVNode)("div", {
                        class: "card",
                        disabled: _ctx.disabledOrUndefined,
                        custom: ""
                    }, [
                        _ctx.inline ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("header", _hoisted_2$z, [
                            (0, _vue.createElementVNode)("div", _hoisted_3$m, [
                                (0, _vue.createElementVNode)("div", _hoisted_4$h, [
                                    (0, _vue.createElementVNode)("span", {
                                        class: (0, _vue.normalizeClass)([
                                            "b-clockpicker-btn",
                                            {
                                                active: _ctx.isSelectingHour
                                            }
                                        ]),
                                        onClick: _cache[3] || (_cache[3] = ($event)=>_ctx.isSelectingHour = true)
                                    }, (0, _vue.toDisplayString)(_ctx.hoursDisplay), 3),
                                    (0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)(_ctx.hourLiteral), 1),
                                    (0, _vue.createElementVNode)("span", {
                                        class: (0, _vue.normalizeClass)([
                                            "b-clockpicker-btn",
                                            {
                                                active: !_ctx.isSelectingHour
                                            }
                                        ]),
                                        onClick: _cache[4] || (_cache[4] = ($event)=>_ctx.isSelectingHour = false)
                                    }, (0, _vue.toDisplayString)(_ctx.minutesDisplay), 3)
                                ]),
                                !_ctx.isHourFormat24 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_5$b, [
                                    (0, _vue.createElementVNode)("div", {
                                        class: (0, _vue.normalizeClass)([
                                            "b-clockpicker-btn",
                                            {
                                                active: _ctx.meridienSelected === _ctx.amString || _ctx.meridienSelected === _ctx.AM
                                            }
                                        ]),
                                        onClick: _cache[5] || (_cache[5] = ($event)=>_ctx.onMeridienClick(_ctx.amString))
                                    }, (0, _vue.toDisplayString)(_ctx.amString), 3),
                                    (0, _vue.createElementVNode)("div", {
                                        class: (0, _vue.normalizeClass)([
                                            "b-clockpicker-btn",
                                            {
                                                active: _ctx.meridienSelected === _ctx.pmString || _ctx.meridienSelected === _ctx.PM
                                            }
                                        ]),
                                        onClick: _cache[6] || (_cache[6] = ($event)=>_ctx.onMeridienClick(_ctx.pmString))
                                    }, (0, _vue.toDisplayString)(_ctx.pmString), 3)
                                ])) : (0, _vue.createCommentVNode)("v-if", true)
                            ])
                        ])) : (0, _vue.createCommentVNode)("v-if", true),
                        (0, _vue.createElementVNode)("div", _hoisted_6$8, [
                            (0, _vue.createElementVNode)("div", {
                                class: "b-clockpicker-body",
                                style: (0, _vue.normalizeStyle)({
                                    width: _ctx.faceSize + "px",
                                    height: _ctx.faceSize + "px"
                                })
                            }, [
                                !_ctx.inline ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_7$8, [
                                    (0, _vue.createElementVNode)("div", {
                                        class: (0, _vue.normalizeClass)([
                                            "b-clockpicker-btn",
                                            {
                                                active: _ctx.isSelectingHour
                                            }
                                        ]),
                                        onClick: _cache[7] || (_cache[7] = ($event)=>_ctx.isSelectingHour = true)
                                    }, (0, _vue.toDisplayString)(_ctx.hoursLabel), 3),
                                    (0, _vue.createElementVNode)("span", {
                                        class: (0, _vue.normalizeClass)([
                                            "b-clockpicker-btn",
                                            {
                                                active: !_ctx.isSelectingHour
                                            }
                                        ]),
                                        onClick: _cache[8] || (_cache[8] = ($event)=>_ctx.isSelectingHour = false)
                                    }, (0, _vue.toDisplayString)(_ctx.minutesLabel), 3)
                                ])) : (0, _vue.createCommentVNode)("v-if", true),
                                !_ctx.isHourFormat24 && !_ctx.inline ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_8$7, [
                                    (0, _vue.createElementVNode)("div", {
                                        class: (0, _vue.normalizeClass)([
                                            "b-clockpicker-btn",
                                            {
                                                active: _ctx.meridienSelected === _ctx.amString || _ctx.meridienSelected === _ctx.AM
                                            }
                                        ]),
                                        onClick: _cache[9] || (_cache[9] = ($event)=>_ctx.onMeridienClick(_ctx.amString))
                                    }, (0, _vue.toDisplayString)(_ctx.amString), 3),
                                    (0, _vue.createElementVNode)("div", {
                                        class: (0, _vue.normalizeClass)([
                                            "b-clockpicker-btn",
                                            {
                                                active: _ctx.meridienSelected === _ctx.pmString || _ctx.meridienSelected === _ctx.PM
                                            }
                                        ]),
                                        onClick: _cache[10] || (_cache[10] = ($event)=>_ctx.onMeridienClick(_ctx.pmString))
                                    }, (0, _vue.toDisplayString)(_ctx.pmString), 3)
                                ])) : (0, _vue.createCommentVNode)("v-if", true),
                                (0, _vue.createVNode)(_component_b_clockpicker_face, {
                                    ref: "clockpickerFace",
                                    "picker-size": _ctx.faceSize,
                                    min: _ctx.minFaceValue,
                                    max: _ctx.maxFaceValue,
                                    "face-numbers": _ctx.isSelectingHour ? _ctx.hours : _ctx.minutes,
                                    "disabled-values": _ctx.faceDisabledValues,
                                    double: _ctx.isSelectingHour && _ctx.isHourFormat24,
                                    value: _ctx.isSelectingHour ? _ctx.hoursSelected ?? void 0 : _ctx.minutesSelected ?? void 0,
                                    onInput: _ctx.onClockInput,
                                    onChange: _ctx.onClockChange
                                }, null, 8, [
                                    "picker-size",
                                    "min",
                                    "max",
                                    "face-numbers",
                                    "disabled-values",
                                    "double",
                                    "value",
                                    "onInput",
                                    "onChange"
                                ])
                            ], 4)
                        ]),
                        _ctx.$slots.default !== void 0 && _ctx.$slots.default([]).length ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("footer", _hoisted_9$5, [
                            (0, _vue.renderSlot)(_ctx.$slots, "default")
                        ])) : (0, _vue.createCommentVNode)("v-if", true)
                    ], 8, _hoisted_1$G)
                ]),
            _: 2
        }, [
            !_ctx.inline ? {
                name: "trigger",
                fn: (0, _vue.withCtx)(()=>[
                        (0, _vue.renderSlot)(_ctx.$slots, "trigger", {}, ()=>[
                                (0, _vue.createVNode)(_component_b_input, (0, _vue.mergeProps)({
                                    ref: "input",
                                    autocomplete: "off",
                                    "model-value": _ctx.formatValue(_ctx.computedValue),
                                    placeholder: _ctx.placeholder,
                                    size: _ctx.size,
                                    icon: _ctx.icon,
                                    "icon-pack": _ctx.iconPack,
                                    loading: _ctx.loading,
                                    disabled: _ctx.disabledOrUndefined,
                                    readonly: !_ctx.editable,
                                    rounded: _ctx.rounded
                                }, _ctx.fallthroughAttrs, {
                                    "use-html5-validation": _ctx.useHtml5Validation,
                                    onClick: _ctx.onInputClick,
                                    onKeyup: _cache[0] || (_cache[0] = (0, _vue.withKeys)(($event)=>_ctx.toggle(true), [
                                        "enter"
                                    ])),
                                    onChange: _cache[1] || (_cache[1] = ($event)=>_ctx.onChange($event.target.value)),
                                    onFocus: _ctx.handleOnFocus,
                                    onBlur: _cache[2] || (_cache[2] = ($event)=>_ctx.checkHtml5Validity())
                                }), null, 16, [
                                    "model-value",
                                    "placeholder",
                                    "size",
                                    "icon",
                                    "icon-pack",
                                    "loading",
                                    "disabled",
                                    "readonly",
                                    "rounded",
                                    "use-html5-validation",
                                    "onClick",
                                    "onFocus"
                                ])
                            ])
                    ]),
                key: "0"
            } : void 0
        ]), 1032, [
            "position",
            "disabled",
            "inline",
            "mobile-modal",
            "append-to-body",
            "onActiveChange"
        ])) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_input, (0, _vue.mergeProps)({
            key: 1,
            ref: "input",
            type: "time",
            autocomplete: "off",
            "model-value": _ctx.formatHHMMSS(_ctx.computedValue),
            placeholder: _ctx.placeholder,
            size: _ctx.size,
            icon: _ctx.icon,
            "icon-pack": _ctx.iconPack,
            loading: _ctx.loading,
            max: _ctx.formatHHMMSS(_ctx.maxTime),
            min: _ctx.formatHHMMSS(_ctx.minTime),
            disabled: _ctx.disabledOrUndefined,
            readonly: false
        }, _ctx.fallthroughAttrs, {
            "use-html5-validation": _ctx.useHtml5Validation,
            onClick: _cache[11] || (_cache[11] = (0, _vue.withModifiers)(($event)=>_ctx.toggle(true), [
                "stop"
            ])),
            onKeyup: _cache[12] || (_cache[12] = (0, _vue.withKeys)(($event)=>_ctx.toggle(true), [
                "enter"
            ])),
            onChange: _ctx.onChangeNativePicker,
            onFocus: _ctx.handleOnFocus,
            onBlur: _cache[13] || (_cache[13] = ($event)=>_ctx.onBlur() && _ctx.checkHtml5Validity())
        }), null, 16, [
            "model-value",
            "placeholder",
            "size",
            "icon",
            "icon-pack",
            "loading",
            "max",
            "min",
            "disabled",
            "use-html5-validation",
            "onChange",
            "onFocus"
        ]))
    ], 16);
}
var Clockpicker = /* @__PURE__ */ _export_sfc(_sfc_main$B, [
    [
        "render",
        _sfc_render$M
    ]
]);
const Plugin$x = {
    install (Vue) {
        registerComponent(Vue, Clockpicker);
    }
};
const cos30 = 0.86602540378;
const sin30 = 0.5;
let id = 0;
var _sfc_main$A = (0, _vue.defineComponent)({
    name: "BColorpickerHSLRepresentationTriangle",
    props: {
        value: {
            type: Object,
            required: true,
            validator (value) {
                return typeof value.hue === "number" && typeof value.saturation === "number" && typeof value.lightness === "number";
            }
        },
        size: {
            type: Number,
            default: 200
        },
        thickness: {
            type: Number,
            default: 20
        }
    },
    emits: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        input: (_value)=>true
    },
    data () {
        return {
            id: id++,
            hue: this.value.hue,
            saturation: this.value.saturation,
            lightness: this.value.lightness,
            captureMouse: false,
            captureType: "hue",
            clientOffset: {
                cx: -1,
                cy: -1,
                width: 0,
                height: 0
            },
            cos30,
            sin30,
            debounce: 0
        };
    },
    computed: {
        viewBox () {
            const { size } = this;
            return `0 0 ${size} ${size}`;
        },
        internalRadius () {
            return this.size / 2 - this.thickness;
        },
        haloPath () {
            const { size, thickness } = this;
            const radius = size / 2 - 2;
            const thicknessRadius = radius - thickness;
            const center = size / 2;
            return `M${center - radius} ${center}a${radius}  ${radius}  0 1 1 ${2 * radius} 0h${-thickness}a${-thicknessRadius}  ${thicknessRadius}  0 1 0 ${-2 * thicknessRadius} 0a${thicknessRadius}  ${thicknessRadius}  0 1 0 ${2 * thicknessRadius} 0h${thickness}a${radius}  ${radius}  0 1 1 ${-2 * radius} 0z`;
        },
        trianglePath () {
            const { size, thickness } = this;
            const radius = size - 4;
            const thicknessRadius = (radius - 2 * thickness) / 2;
            return `M0 ${-thicknessRadius}L${cos30 * thicknessRadius} ${sin30 * thicknessRadius}H${-0.86602540378 * thicknessRadius}z`;
        }
    },
    watch: {
        captureMouse (newValue, oldValue) {
            if (oldValue === false && newValue !== false) {
                const rect = this.$el.getBoundingClientRect();
                this.clientOffset.cx = rect.x + rect.width / 2;
                this.clientOffset.cy = rect.y + rect.height / 2;
                this.clientOffset.width = rect.width;
                this.clientOffset.height = rect.height;
            }
        },
        value: {
            deep: true,
            handler (newColor) {
                const { hue, saturation, lightness } = newColor;
                window.clearTimeout(this.debounce);
                this.debounce = window.setTimeout(()=>{
                    if (lightness >= 0.03 && lightness <= 0.97 && saturation > 0) this.hue = hue;
                    this.saturation = saturation;
                    this.lightness = lightness;
                }, 200);
            }
        }
    },
    methods: {
        increaseHue (value = 1) {
            this.hue = (this.hue + value) % 360;
        },
        decreaseHue (value = 1) {
            this.hue = (360 + this.hue - value) % 360;
        },
        increaseSaturation (value = 0.01) {
            this.saturation = Math.min(1, Math.max(0, this.saturation + value));
            this.lightness = Math.min(0.5 + (1 - this.saturation) * 0.5, Math.max(0.5 - (1 - this.saturation) * 0.5, this.lightness));
        },
        decreaseSaturation (value = 0.01) {
            this.saturation = Math.min(1, Math.max(0, this.saturation - value));
            this.lightness = Math.min(0.5 + (1 - this.saturation) * 0.5, Math.max(0.5 - (1 - this.saturation) * 0.5, this.lightness));
        },
        increaseLightness (value = 0.01) {
            this.lightness = Math.min(0.5 + (1 - this.saturation) * 0.5, Math.max(0.5 - (1 - this.saturation) * 0.5, this.lightness + value));
        },
        decreaseLightness (value = 0.01) {
            this.lightness = Math.min(0.5 + (1 - this.saturation) * 0.5, Math.max(0.5 - (1 - this.saturation) * 0.5, this.lightness - value));
        },
        hueKeyPress (event) {
            let handled = false;
            switch(event.key){
                case "ArrowRight":
                case "ArrowUp":
                    this.increaseHue();
                    handled = true;
                    break;
                case "ArrowLeft":
                case "ArrowDown":
                    this.decreaseHue();
                    handled = true;
                    break;
                case "Home":
                    this.increaseHue(360 - this.hue);
                    handled = true;
                    break;
                case "End":
                    this.decreaseHue(this.hue);
                    handled = true;
                    break;
                case "PageUp":
                    this.increaseHue(60 - this.hue % 60);
                    handled = true;
                    break;
                case "PageDown":
                    this.decreaseHue(60 + this.hue % 60);
                    handled = true;
                    break;
            }
            if (handled) {
                event.preventDefault();
                event.stopPropagation();
                this.emitColor();
            }
        },
        slKeyPress (event) {
            let handled = false;
            switch(event.key){
                case "ArrowRight":
                    this.decreaseLightness();
                    handled = true;
                    break;
                case "ArrowUp":
                    this.increaseSaturation();
                    handled = true;
                    break;
                case "ArrowLeft":
                    this.increaseLightness();
                    handled = true;
                    break;
                case "ArrowDown":
                    this.decreaseSaturation();
                    handled = true;
                    break;
                case "Home":
                    this.increaseLightness(1 - this.lightness);
                    handled = true;
                    break;
                case "End":
                    this.decreaseLightness(this.lightness);
                    handled = true;
                    break;
                case "PageUp":
                    this.increaseSaturation(1 - this.saturation);
                    handled = true;
                    break;
                case "PageDown":
                    this.decreaseSaturation(this.saturation);
                    handled = true;
                    break;
            }
            if (handled) {
                event.preventDefault();
                event.stopPropagation();
                this.emitColor();
            }
        },
        clickHue (event) {
            this.startMouseCapture(event);
            this.trackMouse(event);
            this.stopMouseCapture(event);
            this.$refs.hueCursor.focus();
        },
        clickSL (event) {
            this.startMouseCapture(event);
            this.trackMouse(event);
            this.stopMouseCapture(event);
            this.$refs.slCursor.focus();
        },
        trackMouse (event) {
            if (this.captureMouse === false) return;
            event.preventDefault();
            event.stopPropagation();
            const touches = event.touches;
            let [mouseX, mouseY] = [
                0,
                0
            ];
            if (typeof touches !== "undefined" && touches.length) [mouseX, mouseY] = [
                touches[0].clientX,
                touches[0].clientY
            ];
            else [mouseX, mouseY] = [
                event.clientX,
                event.clientY
            ];
            const angle = Math.atan2(mouseY - this.clientOffset.cy, mouseX - this.clientOffset.cx);
            if (this.captureType === "sl") {
                const d = Math.sqrt(Math.pow(mouseX - this.clientOffset.cx, 2) + Math.pow(mouseY - this.clientOffset.cy, 2));
                const ratio = this.size / this.clientOffset.width;
                const dx = d * Math.cos(angle - this.hue / 180 * Math.PI) * ratio;
                const dy = d * Math.sin(angle - this.hue / 180 * Math.PI) * ratio;
                const radius = this.internalRadius;
                const saturation = 1 - (Math.min(radius * sin30, Math.max(-radius, dy)) + radius) / (radius + radius * sin30);
                const lightness = (Math.min(radius * cos30 * (1 - saturation), Math.max(-radius * cos30 * (1 - saturation), dx)) + radius * cos30) / (radius * 2 * cos30);
                this.saturation = Math.round(saturation * 1e3) / 1e3;
                this.lightness = 1 - Math.round(lightness * 1e3) / 1e3;
            } else this.hue = Math.round(angle / Math.PI * 180 + 90) % 360;
            this.emitColor();
        },
        startMouseCapture (event) {
            event.stopPropagation();
            this.captureMouse = true;
            if (event.target.closest(".colorpicker-triangle-slider-sl") !== null) this.captureType = "sl";
            else this.captureType = "hue";
        },
        stopMouseCapture (event) {
            if (this.captureMouse !== false) {
                event.preventDefault();
                event.stopPropagation();
                this.$refs[this.captureType === "sl" ? "slCursor" : "hueCursor"].focus();
            }
            this.captureMouse = false;
        },
        emitColor () {
            const { hue, saturation, lightness } = this;
            this.$emit("input", Color.fromHSL(hue, saturation, lightness));
            window.clearTimeout(this.debounce);
        }
    },
    mounted () {
        window.addEventListener("mousemove", this.trackMouse);
        window.addEventListener("touchmove", this.trackMouse, {
            passive: false
        });
        window.addEventListener("mouseup", this.stopMouseCapture);
        window.addEventListener("touchend", this.stopMouseCapture);
    },
    beforeUnmount () {
        window.removeEventListener("mousemove", this.trackMouse);
        window.removeEventListener("touchmove", this.trackMouse);
        window.removeEventListener("mouseup", this.stopMouseCapture);
        window.removeEventListener("touchend", this.stopMouseCapture);
        clearTimeout(this.debounce);
    }
});
const _hoisted_1$F = [
    "viewBox"
];
const _hoisted_2$y = [
    "id"
];
const _hoisted_3$l = /* @__PURE__ */ (0, _vue.createElementVNode)("stop", {
    offset: "0%",
    "stop-color": "#fff"
}, null, -1);
const _hoisted_4$g = /* @__PURE__ */ (0, _vue.createElementVNode)("stop", {
    offset: "100%",
    "stop-color": "#000"
}, null, -1);
const _hoisted_5$a = [
    _hoisted_3$l,
    _hoisted_4$g
];
const _hoisted_6$7 = [
    "id"
];
const _hoisted_7$7 = [
    "stop-color"
];
const _hoisted_8$6 = [
    "stop-color"
];
const _hoisted_9$4 = [
    "id"
];
const _hoisted_10$3 = [
    "d"
];
const _hoisted_11$3 = {
    class: "colorpicker-triangle-slider-hue"
};
const _hoisted_12$3 = [
    "width",
    "height",
    "clip-path"
];
const _hoisted_13$1 = [
    "x",
    "height"
];
const _hoisted_14$1 = [
    "aria-valuenow"
];
const _hoisted_15$1 = [
    "d",
    "fill"
];
const _hoisted_16$1 = [
    "d",
    "fill"
];
const _hoisted_17$1 = [
    "x",
    "y"
];
const _hoisted_18$1 = [
    "aria-datavalues"
];
function _sfc_render$L(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("svg", {
        viewBox: _ctx.viewBox,
        class: "b-colorpicker-triangle"
    }, [
        (0, _vue.createElementVNode)("defs", null, [
            (0, _vue.createElementVNode)("linearGradient", {
                id: `cp-triangle-gradient-ligthness-${_ctx.id}`,
                x1: "0",
                y1: "0",
                x2: "1",
                y2: "0"
            }, [
                ..._hoisted_5$a
            ], 8, _hoisted_2$y),
            (0, _vue.createElementVNode)("linearGradient", {
                id: `cp-triangle-gradient-saturation-${_ctx.id}`,
                x1: "0",
                y1: "0",
                x2: "0",
                y2: "1"
            }, [
                (0, _vue.createElementVNode)("stop", {
                    offset: "0%",
                    "stop-color": `hsl(${_ctx.hue}deg, 100%, 50%)`,
                    "stop-opacity": "1"
                }, null, 8, _hoisted_7$7),
                (0, _vue.createElementVNode)("stop", {
                    offset: "100%",
                    "stop-color": `hsl(${_ctx.hue}deg, 100%, 50%)`,
                    "stop-opacity": "0"
                }, null, 8, _hoisted_8$6)
            ], 8, _hoisted_6$7),
            (0, _vue.createElementVNode)("clipPath", {
                id: `cp-triangle-clip-${_ctx.id}`
            }, [
                (0, _vue.createElementVNode)("path", {
                    d: _ctx.haloPath
                }, null, 8, _hoisted_10$3)
            ], 8, _hoisted_9$4)
        ]),
        (0, _vue.createElementVNode)("g", _hoisted_11$3, [
            ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("foreignObject", {
                x: 0,
                y: 0,
                width: _ctx.size,
                height: _ctx.size,
                "clip-path": `url(#cp-triangle-clip-${_ctx.id})`
            }, [
                (0, _vue.createElementVNode)("div", {
                    class: "colorpicker-triangle-hue",
                    onClick: _cache[0] || (_cache[0] = (...args)=>_ctx.clickHue && _ctx.clickHue(...args)),
                    onMousedown: _cache[1] || (_cache[1] = (0, _vue.withModifiers)((...args)=>_ctx.startMouseCapture && _ctx.startMouseCapture(...args), [
                        "prevent"
                    ])),
                    onTouchstart: _cache[2] || (_cache[2] = (0, _vue.withModifiers)((...args)=>_ctx.startMouseCapture && _ctx.startMouseCapture(...args), [
                        "prevent"
                    ]))
                }, null, 32)
            ], 8, _hoisted_12$3)),
            (0, _vue.createElementVNode)("g", {
                style: (0, _vue.normalizeStyle)(`transform: rotate(${_ctx.hue}deg)`)
            }, [
                ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("foreignObject", {
                    x: _ctx.size / 2 - 4,
                    y: 0,
                    width: "8",
                    height: _ctx.thickness + 4
                }, [
                    (0, _vue.createElementVNode)("div", {
                        ref: "hueCursor",
                        class: "hue-range-thumb",
                        style: (0, _vue.normalizeStyle)(`background-color: hsl(${_ctx.hue}deg, 100%, 50%)`),
                        role: "slider",
                        tabindex: "0",
                        "aria-label": "Hue",
                        "aria-valuemin": "0",
                        "aria-valuenow": _ctx.hue,
                        "aria-valuemax": "360",
                        onClick: _cache[3] || (_cache[3] = (...args)=>_ctx.clickHue && _ctx.clickHue(...args)),
                        onKeydown: _cache[4] || (_cache[4] = (...args)=>_ctx.hueKeyPress && _ctx.hueKeyPress(...args)),
                        onMousedown: _cache[5] || (_cache[5] = (0, _vue.withModifiers)((...args)=>_ctx.startMouseCapture && _ctx.startMouseCapture(...args), [
                            "prevent"
                        ])),
                        onTouchstart: _cache[6] || (_cache[6] = (0, _vue.withModifiers)((...args)=>_ctx.startMouseCapture && _ctx.startMouseCapture(...args), [
                            "prevent"
                        ]))
                    }, null, 44, _hoisted_14$1)
                ], 8, _hoisted_13$1))
            ], 4)
        ]),
        (0, _vue.createElementVNode)("g", {
            class: "colorpicker-triangle-slider-sl",
            style: (0, _vue.normalizeStyle)(`transform: rotate(${_ctx.hue}deg) translate(50%, 50%)`),
            role: "graphics-datagroup",
            "aria-datascales": "lightness, saturation"
        }, [
            (0, _vue.createElementVNode)("path", {
                d: _ctx.trianglePath,
                fill: `url(#cp-triangle-gradient-ligthness-${_ctx.id})`
            }, null, 8, _hoisted_15$1),
            (0, _vue.createElementVNode)("path", {
                d: _ctx.trianglePath,
                fill: `url(#cp-triangle-gradient-saturation-${_ctx.id})`,
                style: {
                    "mix-blend-mode": "overlay"
                },
                onClick: _cache[7] || (_cache[7] = (...args)=>_ctx.clickSL && _ctx.clickSL(...args)),
                onMousedown: _cache[8] || (_cache[8] = (0, _vue.withModifiers)((...args)=>_ctx.startMouseCapture && _ctx.startMouseCapture(...args), [
                    "prevent"
                ])),
                onTouchstart: _cache[9] || (_cache[9] = (0, _vue.withModifiers)((...args)=>_ctx.startMouseCapture && _ctx.startMouseCapture(...args), [
                    "prevent"
                ]))
            }, null, 40, _hoisted_16$1),
            ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("foreignObject", {
                x: (_ctx.internalRadius - 3) * _ctx.cos30 * (-_ctx.lightness + 0.5) * 2 - 6,
                y: -_ctx.internalRadius + (1 - _ctx.saturation) * (_ctx.internalRadius - 3) * 1.5 - 3,
                width: "12",
                height: "12"
            }, [
                (0, _vue.createElementVNode)("div", {
                    ref: "slCursor",
                    class: "sl-range-thumb",
                    style: (0, _vue.normalizeStyle)({
                        backgroundColor: `hsl(${_ctx.hue}deg, ${_ctx.saturation * 100}%, ${_ctx.lightness * 100}%)`
                    }),
                    tabindex: "0",
                    "aria-datavalues": `${_ctx.saturation * 100}%, ${_ctx.lightness * 100}%`,
                    onClick: _cache[10] || (_cache[10] = (...args)=>_ctx.clickSL && _ctx.clickSL(...args)),
                    onKeydown: _cache[11] || (_cache[11] = (...args)=>_ctx.slKeyPress && _ctx.slKeyPress(...args)),
                    onMousedown: _cache[12] || (_cache[12] = (0, _vue.withModifiers)((...args)=>_ctx.startMouseCapture && _ctx.startMouseCapture(...args), [
                        "prevent"
                    ])),
                    onTouchstart: _cache[13] || (_cache[13] = (0, _vue.withModifiers)((...args)=>_ctx.startMouseCapture && _ctx.startMouseCapture(...args), [
                        "prevent"
                    ]))
                }, null, 44, _hoisted_18$1)
            ], 8, _hoisted_17$1))
        ], 4)
    ], 8, _hoisted_1$F);
}
var BColorpickerHSLRepresentationTriangle = /* @__PURE__ */ _export_sfc(_sfc_main$A, [
    [
        "render",
        _sfc_render$L
    ]
]);
const precision = (strs, ...values)=>{
    const tmp = [];
    strs.forEach((str, i)=>{
        tmp.push(str);
        const value = values[i];
        if (value) tmp.push(Number.isNaN(+value / 1) ? value : Math.round(+value * 10) / 10);
    });
    return tmp.join("");
};
var _sfc_main$z = (0, _vue.defineComponent)({
    name: "BColorpickerHSLRepresentationSquare",
    props: {
        value: {
            type: Object,
            required: true,
            validator (value) {
                return typeof value.hue === "number" && typeof value.saturation === "number" && typeof value.lightness === "number";
            }
        },
        size: {
            type: Number,
            default: 200
        },
        thickness: {
            type: Number,
            default: 20
        }
    },
    emits: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        input: (_value)=>true
    },
    data () {
        return {
            hue: this.value.hue,
            saturation: this.value.saturation,
            lightness: this.value.lightness,
            captureMouse: false,
            captureType: "hue",
            clientOffset: {
                cx: -1,
                cy: -1,
                width: 0,
                height: 0
            },
            debounce: 0
        };
    },
    computed: {
        hueThumbStyle () {
            const { hue, size, thickness } = this;
            const side = size - thickness;
            const offset = size / 2;
            const angle = (hue + 720 + 90) % 360 / 180 * Math.PI;
            const ciq = 1 / Math.cos(Math.PI / 4);
            const { x, y } = {
                x: -Math.min(1, Math.max(-1, ciq * Math.cos(angle))) / 2 * side + offset,
                y: -Math.min(1, Math.max(-1, ciq * Math.sin(angle))) / 2 * side + offset
            };
            return {
                background: `hsl(${hue}deg, 100%, 50%)`,
                left: precision`${x}px`,
                top: precision`${y}px`,
                width: precision`${thickness - 2}px`
            };
        },
        slThumbStyle () {
            let { hue, saturation, lightness } = this;
            saturation = Math.max(0, Math.min(1, saturation));
            lightness = Math.max(0, Math.min(1, lightness));
            return {
                background: `hsl(${hue}deg, ${saturation * 100}%, ${lightness * 100}%)`,
                left: `${saturation * 100}%`,
                top: `${(1 - lightness) * 100}%`
            };
        },
        SLBackground () {
            const { hue } = this;
            return `linear-gradient(90deg, hsl(${hue}deg, 0%, 50%), hsl(${hue}deg, 100%, 50%))`;
        }
    },
    watch: {
        captureMouse (newValue, oldValue) {
            if (oldValue === false && newValue !== false) {
                const rect = this.$el.getBoundingClientRect();
                this.clientOffset.cx = rect.x + rect.width / 2;
                this.clientOffset.cy = rect.y + rect.height / 2;
                this.clientOffset.width = rect.width;
                this.clientOffset.height = rect.height;
            }
        },
        value: {
            deep: true,
            handler (newColor) {
                const { hue, saturation, lightness } = newColor;
                window.clearTimeout(this.debounce);
                this.debounce = window.setTimeout(()=>{
                    this.hue = hue;
                    this.saturation = saturation;
                    this.lightness = lightness;
                }, 200);
            }
        }
    },
    methods: {
        increaseHue (value = 1) {
            this.hue = (this.hue + value) % 360;
        },
        decreaseHue (value = 1) {
            this.hue = (360 + this.hue - value) % 360;
        },
        increaseSaturation (value = 0.01) {
            this.saturation = Math.min(1, Math.max(0, this.saturation + value));
            this.lightness = Math.min(0.5 + (1 - this.saturation) * 0.5, Math.max(0.5 - (1 - this.saturation) * 0.5, this.lightness));
        },
        decreaseSaturation (value = 0.01) {
            this.saturation = Math.min(1, Math.max(0, this.saturation - value));
            this.lightness = Math.min(0.5 + (1 - this.saturation) * 0.5, Math.max(0.5 - (1 - this.saturation) * 0.5, this.lightness));
        },
        increaseLightness (value = 0.01) {
            this.lightness = Math.min(0.5 + (1 - this.saturation) * 0.5, Math.max(0.5 - (1 - this.saturation) * 0.5, this.lightness + value));
        },
        decreaseLightness (value = 0.01) {
            this.lightness = Math.min(0.5 + (1 - this.saturation) * 0.5, Math.max(0.5 - (1 - this.saturation) * 0.5, this.lightness - value));
        },
        hueKeyPress (event) {
            let handled = false;
            switch(event.key){
                case "ArrowRight":
                case "ArrowUp":
                    this.increaseHue();
                    handled = true;
                    break;
                case "ArrowLeft":
                case "ArrowDown":
                    this.decreaseHue();
                    handled = true;
                    break;
                case "Home":
                    this.increaseHue(360 - this.hue);
                    handled = true;
                    break;
                case "End":
                    this.decreaseHue(this.hue);
                    handled = true;
                    break;
                case "PageUp":
                    this.increaseHue(60 - this.hue % 60);
                    handled = true;
                    break;
                case "PageDown":
                    this.decreaseHue(60 + this.hue % 60);
                    handled = true;
                    break;
            }
            if (handled) {
                event.preventDefault();
                event.stopPropagation();
                this.emitColor();
            }
        },
        slKeyPress (event) {
            let handled = false;
            switch(event.key){
                case "ArrowRight":
                    this.increaseSaturation();
                    handled = true;
                    break;
                case "ArrowUp":
                    this.increaseLightness();
                    handled = true;
                    break;
                case "ArrowLeft":
                    this.decreaseSaturation();
                    handled = true;
                    break;
                case "ArrowDown":
                    this.decreaseLightness();
                    handled = true;
                    break;
                case "Home":
                    this.increaseLightness(1 - this.lightness);
                    handled = true;
                    break;
                case "End":
                    this.decreaseLightness(this.lightness);
                    handled = true;
                    break;
                case "PageUp":
                    this.increaseSaturation(1 - this.saturation);
                    handled = true;
                    break;
                case "PageDown":
                    this.decreaseSaturation(this.saturation);
                    handled = true;
                    break;
            }
            if (handled) {
                event.preventDefault();
                event.stopPropagation();
                this.emitColor();
            }
        },
        startMouseCapture (event) {
            event.stopPropagation();
            this.captureMouse = true;
            if (event.target.closest(".colorpicker-square-slider-sl") !== null) this.captureType = "sl";
            else this.captureType = "hue";
        },
        stopMouseCapture (event) {
            if (this.captureMouse !== false) {
                event.preventDefault();
                event.stopPropagation();
                this.$refs[this.captureType === "sl" ? "slCursor" : "hueCursor"].focus();
            }
            this.captureMouse = false;
        },
        clickHue (event) {
            this.startMouseCapture(event);
            this.trackMouse(event);
            this.stopMouseCapture(event);
            this.$refs.hueCursor.focus();
        },
        clickSL (event) {
            this.startMouseCapture(event);
            this.trackMouse(event);
            this.stopMouseCapture(event);
            this.$refs.slCursor.focus();
        },
        trackMouse (event) {
            if (this.captureMouse === false) return;
            event.preventDefault();
            event.stopPropagation();
            const touches = event.touches;
            let [mouseX, mouseY] = [
                0,
                0
            ];
            if (typeof touches !== "undefined" && touches.length) [mouseX, mouseY] = [
                touches[0].clientX,
                touches[0].clientY
            ];
            else [mouseX, mouseY] = [
                event.clientX,
                event.clientY
            ];
            const angle = Math.atan2(mouseY - this.clientOffset.cy, mouseX - this.clientOffset.cx);
            if (this.captureType === "sl") {
                const saturation = (mouseX - this.clientOffset.cx) / (this.clientOffset.width - this.thickness * 2) + 0.5;
                const lightness = (mouseY - this.clientOffset.cy) / (this.clientOffset.height - this.thickness * 2) + 0.5;
                this.saturation = Math.round(Math.min(1, Math.max(0, saturation)) * 1e3) / 1e3;
                this.lightness = 1 - Math.round(Math.min(1, Math.max(0, lightness)) * 1e3) / 1e3;
            } else this.hue = Math.round(angle / Math.PI * 180 + 90) % 360;
            this.emitColor();
        },
        emitColor () {
            const { hue, saturation, lightness } = this;
            this.$emit("input", Color.fromHSL(hue, saturation, lightness));
            window.clearTimeout(this.debounce);
        }
    },
    mounted () {
        window.addEventListener("mousemove", this.trackMouse);
        window.addEventListener("touchmove", this.trackMouse, {
            passive: false
        });
        window.addEventListener("mouseup", this.stopMouseCapture);
        window.addEventListener("touchend", this.stopMouseCapture);
    },
    beforeUnmount () {
        window.removeEventListener("mousemove", this.trackMouse);
        window.removeEventListener("touchmove", this.trackMouse);
        window.removeEventListener("mouseup", this.stopMouseCapture);
        window.removeEventListener("touchend", this.stopMouseCapture);
        clearTimeout(this.debounce);
    }
});
const _hoisted_1$E = [
    "aria-datavalues"
];
function _sfc_render$K(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: "b-colorpicker-square",
        style: (0, _vue.normalizeStyle)({
            width: `${_ctx.size}px`
        })
    }, [
        (0, _vue.createElementVNode)("div", {
            class: "colorpicker-square-slider-hue",
            onClick: _cache[0] || (_cache[0] = (...args)=>_ctx.clickHue && _ctx.clickHue(...args)),
            onMousedown: _cache[1] || (_cache[1] = (0, _vue.withModifiers)((...args)=>_ctx.startMouseCapture && _ctx.startMouseCapture(...args), [
                "prevent"
            ])),
            onTouchstart: _cache[2] || (_cache[2] = (0, _vue.withModifiers)((...args)=>_ctx.startMouseCapture && _ctx.startMouseCapture(...args), [
                "prevent"
            ]))
        }, [
            (0, _vue.createElementVNode)("div", {
                ref: "hueCursor",
                role: "slider",
                class: "hue-range-thumb",
                tabindex: "0",
                "aria-label": "Hue",
                "aria-valuemin": "0",
                "aria-valuemax": "359",
                style: (0, _vue.normalizeStyle)(_ctx.hueThumbStyle)
            }, null, 4)
        ], 32),
        (0, _vue.createElementVNode)("div", {
            class: "colorpicker-square-slider-sl",
            style: (0, _vue.normalizeStyle)({
                background: _ctx.SLBackground,
                margin: `${_ctx.thickness}px`
            }),
            "aria-datascales": "lightness, saturation",
            onClick: _cache[7] || (_cache[7] = (...args)=>_ctx.clickSL && _ctx.clickSL(...args)),
            onMousedown: _cache[8] || (_cache[8] = (0, _vue.withModifiers)((...args)=>_ctx.startMouseCapture && _ctx.startMouseCapture(...args), [
                "prevent"
            ])),
            onTouchstart: _cache[9] || (_cache[9] = (0, _vue.withModifiers)((...args)=>_ctx.startMouseCapture && _ctx.startMouseCapture(...args), [
                "prevent"
            ]))
        }, [
            (0, _vue.createElementVNode)("div", {
                ref: "slCursor",
                role: "slider",
                class: "sl-range-thumb",
                tabindex: "0",
                "aria-datavalues": `${_ctx.saturation * 100}%, ${_ctx.lightness * 100}%`,
                style: (0, _vue.normalizeStyle)(_ctx.slThumbStyle),
                onClick: _cache[3] || (_cache[3] = (...args)=>_ctx.clickSL && _ctx.clickSL(...args)),
                onKeydown: _cache[4] || (_cache[4] = (...args)=>_ctx.slKeyPress && _ctx.slKeyPress(...args)),
                onMousedown: _cache[5] || (_cache[5] = (0, _vue.withModifiers)((...args)=>_ctx.startMouseCapture && _ctx.startMouseCapture(...args), [
                    "prevent"
                ])),
                onTouchstart: _cache[6] || (_cache[6] = (0, _vue.withModifiers)((...args)=>_ctx.startMouseCapture && _ctx.startMouseCapture(...args), [
                    "prevent"
                ]))
            }, null, 44, _hoisted_1$E)
        ], 36)
    ], 4);
}
var BColorpickerHSLRepresentationSquare = /* @__PURE__ */ _export_sfc(_sfc_main$z, [
    [
        "render",
        _sfc_render$K
    ]
]);
const TOOLTIP_POSITIONS = [
    "is-auto",
    "is-top",
    "is-bottom",
    "is-left",
    "is-right"
];
var _sfc_main$y = (0, _vue.defineComponent)({
    name: "BTooltip",
    props: {
        active: {
            type: Boolean,
            default: true
        },
        type: {
            type: String,
            default: ()=>config.defaultTooltipType
        },
        label: String,
        delay: {
            type: Number,
            default: ()=>config.defaultTooltipDelay
        },
        closeDelay: {
            type: Number,
            default: ()=>config.defaultTooltipCloseDelay
        },
        position: {
            type: String,
            default: "is-auto",
            validator (value) {
                return TOOLTIP_POSITIONS.indexOf(value) > -1;
            }
        },
        triggers: {
            type: Array,
            default: ()=>[
                    "hover"
                ]
        },
        always: Boolean,
        square: Boolean,
        dashed: Boolean,
        multilined: Boolean,
        size: {
            type: String,
            default: "is-medium"
        },
        appendToBody: Boolean,
        animated: {
            type: Boolean,
            default: true
        },
        animation: {
            type: String,
            default: "fade"
        },
        contentClass: String,
        autoClose: {
            type: [
                Array,
                Boolean
            ],
            default: true
        }
    },
    emits: {
        close: ()=>true,
        open: ()=>true
    },
    data () {
        return {
            isActive: false,
            triggerStyle: {},
            timer: void 0,
            _bodyEl: void 0,
            // Used to append to body
            resizeObserver: void 0,
            resizeListener: void 0,
            timeOutID: void 0,
            controller: void 0,
            dynamicPosition: void 0
        };
    },
    computed: {
        rootClasses () {
            return [
                "b-tooltip",
                this.type,
                this.dynamicPosition,
                this.size,
                {
                    "is-square": this.square,
                    "is-always": this.always,
                    "is-multiline": this.multilined,
                    "is-dashed": this.dashed
                }
            ];
        },
        newAnimation () {
            return this.animated ? this.animation : void 0;
        }
    },
    watch: {
        isActive () {
            this.isActive ? this.$emit("open") : this.$emit("close");
            if (this.appendToBody) this.updateAppendToBody();
        }
    },
    methods: {
        computePosition () {
            if (this.position !== "is-auto") return this.position;
            const trigger = this.$refs.trigger;
            const bounds = trigger.getBoundingClientRect();
            const dt = bounds.top;
            const db = window.innerHeight - bounds.bottom;
            const dl = bounds.left;
            const dr = window.innerWidth - bounds.right;
            const min = Math.min(dt, db, dl, dr);
            if (min === dt) return "is-bottom";
            else if (min === db) return "is-top";
            else if (min === dl) return "is-right";
            else return "is-left";
        },
        updateAppendToBody () {
            const tooltip = this.$refs.tooltip;
            const trigger = this.$refs.trigger;
            if (tooltip && trigger) {
                const tooltipEl = this.$data._bodyEl.children[0];
                tooltipEl.classList.forEach((item)=>tooltipEl.classList.remove(item));
                this.rootClasses.forEach((item)=>{
                    if (typeof item === "object") {
                        const record = item;
                        for(const key in record)if (record[key]) tooltipEl.classList.add(key);
                    } else tooltipEl.classList.add(item);
                });
                const rect = trigger.getBoundingClientRect();
                const top = rect.top + window.scrollY;
                const left = rect.left + window.scrollX;
                tooltipEl.style.position = "absolute";
                this.dynamicPosition = this.computePosition();
                switch(this.dynamicPosition){
                    case "is-top":
                        tooltipEl.style.width = `${trigger.clientWidth}px`;
                        tooltipEl.style.height = "0px";
                        tooltipEl.style.top = "0px";
                        tooltipEl.style.left = "0px";
                        break;
                    case "is-bottom":
                        tooltipEl.style.width = `${trigger.clientWidth}px`;
                        tooltipEl.style.height = "0px";
                        tooltipEl.style.top = `${trigger.clientHeight}px`;
                        tooltipEl.style.left = "0px";
                        break;
                    case "is-left":
                        tooltipEl.style.width = "0px";
                        tooltipEl.style.height = `${trigger.clientHeight}px`;
                        tooltipEl.style.top = "0px";
                        tooltipEl.style.left = "0px";
                        break;
                    case "is-right":
                        tooltipEl.style.width = "0px";
                        tooltipEl.style.height = `${trigger.clientHeight}px`;
                        tooltipEl.style.top = "0px";
                        tooltipEl.style.left = `${trigger.clientWidth}px`;
                        break;
                }
                const wrapper = this.$data._bodyEl;
                wrapper.style.position = "absolute";
                wrapper.style.top = `${top}px`;
                wrapper.style.left = `${left}px`;
                wrapper.style.width = "0px";
                wrapper.style.zIndex = this.isActive || this.always ? "99" : "-1";
                this.triggerStyle = {
                    zIndex: this.isActive || this.always ? "100" : void 0
                };
            }
        },
        onClick () {
            if (this.triggers.indexOf("click") < 0) return;
            this.$nextTick(()=>{
                this.timeOutID = setTimeout(()=>this.open());
            });
        },
        onHover () {
            if (this.triggers.indexOf("hover") < 0) return;
            this.open();
        },
        onContextMenu (e) {
            if (this.triggers.indexOf("contextmenu") < 0) return;
            e.preventDefault();
            this.open();
        },
        onFocus () {
            if (this.triggers.indexOf("focus") < 0) return;
            this.open();
        },
        open () {
            this.dynamicPosition = this.computePosition();
            if (this.delay) this.timer = setTimeout(()=>{
                this.isActive = true;
                this.timer = void 0;
            }, this.delay);
            else this.isActive = true;
        },
        close () {
            if (typeof this.autoClose === "boolean") {
                if (this.autoClose && this.timer) clearTimeout(this.timer);
                if (this.closeDelay) this.timer = setTimeout(()=>{
                    this.isActive = !this.autoClose;
                    this.timer = void 0;
                }, this.closeDelay);
                else this.isActive = !this.autoClose;
            }
        },
        /*
    * Close tooltip if clicked outside.
    */ clickedOutside (event) {
            if (this.isActive) {
                if (Array.isArray(this.autoClose)) {
                    if (this.autoClose.includes("outside")) {
                        if (!this.isInWhiteList(event.target)) {
                            this.isActive = false;
                            return;
                        }
                    }
                    if (this.autoClose.includes("inside")) {
                        if (this.isInWhiteList(event.target)) this.isActive = false;
                    }
                }
            }
        },
        /*
     * Keypress event that is bound to the document
     */ keyPress ({ key }) {
            if (this.isActive && (key === "Escape" || key === "Esc")) {
                if (Array.isArray(this.autoClose)) {
                    if (this.autoClose.indexOf("escape") >= 0) this.isActive = false;
                }
            }
        },
        /*
    * White-listed items to not close when clicked.
    */ isInWhiteList (el) {
            if (el === this.$refs.content) return true;
            if (this.$refs.content != null) {
                const children = this.$refs.content.querySelectorAll("*");
                for (const child of children){
                    if (el === child) return true;
                }
            }
            return false;
        }
    },
    mounted () {
        if (this.appendToBody && typeof window !== "undefined") {
            this.controller = new window.AbortController();
            this.$data._bodyEl = createAbsoluteElement(this.$refs.content);
            this.updateAppendToBody();
            const animation = this.$el.closest(".animation-content");
            if (animation != null) {
                const listener = ()=>{
                    this.updateAppendToBody();
                    animation.removeEventListener("transitionend", listener);
                };
                animation.addEventListener("transitionend", listener, {
                    signal: this.controller.signal
                });
            }
            this.resizeListener = ()=>this.updateAppendToBody();
            window.addEventListener("resize", this.resizeListener);
            this.resizeObserver = new ResizeObserver(this.resizeListener);
            if (this.$el.parentNode != null && this.$el.parentNode.nodeType === Node.ELEMENT_NODE) this.resizeObserver.observe(this.$el.parentNode);
        }
        if (this.always) this.dynamicPosition = this.computePosition();
    },
    created () {
        if (typeof window !== "undefined") {
            document.addEventListener("click", this.clickedOutside);
            document.addEventListener("keyup", this.keyPress);
        }
    },
    beforeUnmount () {
        if (typeof window !== "undefined") {
            document.removeEventListener("click", this.clickedOutside);
            document.removeEventListener("keyup", this.keyPress);
        }
        if (this.resizeListener != null) window.removeEventListener("resize", this.resizeListener);
        if (this.resizeObserver != null) this.resizeObserver.disconnect();
        if (this.appendToBody) removeElement(this.$data._bodyEl);
        if (this.controller != null) this.controller.abort();
        clearTimeout(this.timer);
        clearTimeout(this.timeOutID);
    }
});
function _sfc_render$J(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        ref: "tooltip",
        class: (0, _vue.normalizeClass)(_ctx.rootClasses)
    }, [
        (0, _vue.createVNode)((0, _vue.Transition), {
            name: _ctx.newAnimation,
            persisted: ""
        }, {
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("div", {
                        ref: "content",
                        class: (0, _vue.normalizeClass)([
                            "tooltip-content",
                            _ctx.contentClass
                        ])
                    }, [
                        _ctx.label ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                            key: 0
                        }, [
                            (0, _vue.createTextVNode)((0, _vue.toDisplayString)(_ctx.label), 1)
                        ], 64)) : _ctx.$slots.content ? (0, _vue.renderSlot)(_ctx.$slots, "content", {
                            key: 1
                        }) : (0, _vue.createCommentVNode)("v-if", true)
                    ], 2), [
                        [
                            (0, _vue.vShow),
                            _ctx.active && (_ctx.isActive || _ctx.always)
                        ]
                    ])
                ]),
            _: 3
        }, 8, [
            "name"
        ]),
        (0, _vue.createElementVNode)("div", {
            ref: "trigger",
            class: "tooltip-trigger",
            style: (0, _vue.normalizeStyle)(_ctx.triggerStyle),
            onClick: _cache[0] || (_cache[0] = (...args)=>_ctx.onClick && _ctx.onClick(...args)),
            onContextmenu: _cache[1] || (_cache[1] = (...args)=>_ctx.onContextMenu && _ctx.onContextMenu(...args)),
            onMouseenter: _cache[2] || (_cache[2] = (...args)=>_ctx.onHover && _ctx.onHover(...args)),
            onFocusCapture: _cache[3] || (_cache[3] = (...args)=>_ctx.onFocus && _ctx.onFocus(...args)),
            onBlurCapture: _cache[4] || (_cache[4] = (...args)=>_ctx.close && _ctx.close(...args)),
            onMouseleave: _cache[5] || (_cache[5] = (...args)=>_ctx.close && _ctx.close(...args))
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "default", {
                ref: "slot"
            })
        ], 36)
    ], 2);
}
var Tooltip = /* @__PURE__ */ _export_sfc(_sfc_main$y, [
    [
        "render",
        _sfc_render$J
    ]
]);
var _sfc_main$x = (0, _vue.defineComponent)({
    name: "BColorpickerAlphaSlider",
    components: {
        BTooltip: Tooltip
    },
    props: {
        value: {
            type: Number,
            validator: (value)=>value >= 0 && value < 256
        },
        color: [
            String,
            Object
        ]
    },
    emits: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        input: (_value)=>true
    },
    data () {
        const color = Color.parse(this.color);
        color.alpha = 0;
        return {
            startColor: color.toString("hex"),
            endColor: color.toString("hexa"),
            percent: Math.round((1 - this.value / 255) * 100),
            captureMouse: false,
            clientOffset: {
                cx: -1,
                cy: -1,
                width: 0,
                height: 0
            }
        };
    },
    computed: {
        style () {
            return {
                backgroundImage: `linear-gradient(90deg, ${this.startColor} 0%, ${this.endColor} 100%),
                    linear-gradient(45deg, #c7c7c7 25%, transparent 25%, transparent 75%, #c7c7c7 75%, #c7c7c7),
                    linear-gradient(45deg, #c7c7c7 25%, transparent 25%, transparent 75%, #c7c7c7 75%, #c7c7c7)`,
                backgroundSize: "100% 100%, 1em 1em, 1em 1em",
                backgroundPosition: "0 0, .5em .5em, 0 0"
            };
        }
    },
    watch: {
        value (newValue, oldValue) {
            if (newValue !== oldValue) this.percent = Math.round((1 - newValue / 255) * 100);
        },
        color (newColor) {
            const color = Color.parse(newColor);
            color.alpha = 0;
            this.startColor = color.toString("hex");
            this.endColor = color.toString("hexa");
        },
        captureMouse (newValue, oldValue) {
            if (oldValue === false && newValue !== false) {
                const rect = this.$el.getBoundingClientRect();
                this.clientOffset.cx = rect.x + rect.width / 2;
                this.clientOffset.cy = rect.y + rect.height / 2;
                this.clientOffset.width = rect.width;
                this.clientOffset.height = rect.height;
            }
        }
    },
    methods: {
        increaseAlpha (value = 1) {
            this.percent = Math.max(0, Math.min(100, this.percent + value));
        },
        decreaseAlpha (value = 0.01) {
            this.increaseAlpha(-value);
        },
        alphaKeyPress (event) {
            let handled = false;
            switch(event.key){
                case "ArrowRight":
                case "ArrowUp":
                    this.increaseAlpha();
                    handled = true;
                    break;
                case "ArrowLeft":
                case "ArrowDown":
                    this.decreaseAlpha();
                    handled = true;
                    break;
                case "Home":
                    this.decreaseAlpha(this.percent);
                    handled = true;
                    break;
                case "End":
                    this.increaseAlpha(100 - this.percent);
                    handled = true;
                    break;
                case "PageUp":
                    this.increaseAlpha(10 - this.percent % 10);
                    handled = true;
                    break;
                case "PageDown":
                    this.decreaseAlpha(this.percent % 10);
                    handled = true;
                    break;
            }
            if (handled) {
                event.preventDefault();
                event.stopPropagation();
                this.emitAlpha();
            }
        },
        clickAlpha (event) {
            this.startMouseCapture(event);
            this.trackMouse(event);
            this.stopMouseCapture(event);
            this.$refs.alphaCursor.focus();
        },
        startMouseCapture (event) {
            event.stopPropagation();
            this.captureMouse = true;
        },
        trackMouse (event) {
            if (this.captureMouse === false) return;
            event.preventDefault();
            event.stopPropagation();
            let [mouseX] = [
                0,
                0
            ];
            const touches = event.touches;
            if (typeof touches !== "undefined" && touches.length) [mouseX] = [
                touches[0].clientX
            ];
            else [mouseX] = [
                event.clientX
            ];
            const ratio = 0.5 + (this.clientOffset.cx - mouseX) / this.clientOffset.width;
            this.percent = Math.round(100 - Math.max(0, Math.min(1, ratio)) * 100);
            this.emitAlpha();
        },
        stopMouseCapture (event) {
            if (this.captureMouse !== false) {
                event.preventDefault();
                event.stopPropagation();
                this.$refs.alphaCursor.focus();
            }
            this.captureMouse = false;
        },
        emitAlpha () {
            this.$emit("input", (1 - this.percent / 100) * 255);
        }
    },
    mounted () {
        window.addEventListener("mousemove", this.trackMouse);
        window.addEventListener("touchmove", this.trackMouse, {
            passive: false
        });
        window.addEventListener("mouseup", this.stopMouseCapture);
        window.addEventListener("touchend", this.stopMouseCapture);
    },
    beforeUnmount () {
        window.removeEventListener("mousemove", this.trackMouse);
        window.removeEventListener("touchmove", this.trackMouse);
        window.removeEventListener("mouseup", this.stopMouseCapture);
        window.removeEventListener("touchend", this.stopMouseCapture);
    }
});
const _hoisted_1$D = [
    "aria-valuenow"
];
function _sfc_render$I(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_tooltip = (0, _vue.resolveComponent)("b-tooltip");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: "b-colorpicker-alpha-slider",
        style: (0, _vue.normalizeStyle)(_ctx.style),
        onClick: _cache[0] || (_cache[0] = (...args)=>_ctx.clickAlpha && _ctx.clickAlpha(...args)),
        onKeydown: _cache[1] || (_cache[1] = (...args)=>_ctx.alphaKeyPress && _ctx.alphaKeyPress(...args)),
        onMousedown: _cache[2] || (_cache[2] = (...args)=>_ctx.startMouseCapture && _ctx.startMouseCapture(...args)),
        onTouchstart: _cache[3] || (_cache[3] = (0, _vue.withModifiers)((...args)=>_ctx.startMouseCapture && _ctx.startMouseCapture(...args), [
            "prevent"
        ]))
    }, [
        (0, _vue.createElementVNode)("div", {
            ref: "alphaCursor",
            role: "slider",
            class: "alpha-range-thumb",
            tabindex: "0",
            "aria-label": "Tranparency",
            "aria-valuemin": "0",
            "aria-valuenow": _ctx.percent,
            "aria-valuemax": "100",
            style: (0, _vue.normalizeStyle)({
                left: `${_ctx.percent}%`
            })
        }, [
            (0, _vue.createVNode)(_component_b_tooltip, {
                label: `${_ctx.percent}%`,
                always: _ctx.captureMouse,
                position: "is-top"
            }, {
                default: (0, _vue.withCtx)(()=>[
                        (0, _vue.createTextVNode)(" \xa0 ")
                    ]),
                _: 1
            }, 8, [
                "label",
                "always"
            ])
        ], 12, _hoisted_1$D)
    ], 36);
}
var BColorpickerAlphaSlider = /* @__PURE__ */ _export_sfc(_sfc_main$x, [
    [
        "render",
        _sfc_render$I
    ]
]);
const defaultColorFormatter = (color)=>{
    if (color.alpha < 1) return color.toString("hexa");
    else return color.toString("hex");
};
const defaultColorParser = (color)=>{
    return Color.parse(color);
};
var _sfc_main$w = (0, _vue.defineComponent)({
    name: "BColorpicker",
    components: {
        BColorpickerHSLRepresentationTriangle,
        BColorpickerHSLRepresentationSquare,
        BColorpickerAlphaSlider,
        BInput,
        BField: Field,
        BButton,
        BDropdown,
        BDropdownItem
    },
    mixins: [
        FormElementMixin
    ],
    inheritAttrs: false,
    provide () {
        return {
            $colorpicker: this
        };
    },
    props: {
        modelValue: {
            type: [
                String,
                Object
            ],
            validator (value) {
                return typeof value === "string" || typeof value === "object" && typeof value.red === "number" && typeof value.green === "number" && typeof value.blue === "number";
            }
        },
        mobileNative: {
            type: Boolean,
            default: false
        },
        representation: {
            type: String,
            default: "triangle",
            value (value) {
                return [
                    "triangle",
                    "square"
                ].some((r)=>r === value);
            }
        },
        inline: Boolean,
        disabled: Boolean,
        horizontalColorPicker: {
            type: Boolean,
            default: false
        },
        colorFormatter: {
            type: Function,
            default: (color, vm)=>{
                if (typeof config.defaultColorFormatter === "function") return config.defaultColorFormatter(color);
                else return defaultColorFormatter(color);
            }
        },
        colorParser: {
            type: Function,
            default: (color, vm)=>{
                if (typeof config.defaultColorParser === "function") return config.defaultColorParser(color);
                else return defaultColorParser(color);
            }
        },
        alpha: {
            type: Boolean,
            default: false
        },
        expanded: Boolean,
        position: String,
        mobileModal: {
            type: Boolean,
            default: ()=>config.defaultDatepickerMobileModal
        },
        focusable: {
            type: Boolean,
            default: true
        },
        trapFocus: {
            type: Boolean,
            default: ()=>config.defaultTrapFocus
        },
        openOnFocus: Boolean,
        closeOnClick: Boolean,
        appendToBody: Boolean
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars */ "active-change": (_active)=>true,
        "update:modelValue": (_value)=>true
    },
    data () {
        return {
            color: this.parseColor(this.modelValue)
        };
    },
    computed: {
        computedValue: {
            set (value) {
                this.color = this.parseColor(value);
            },
            get () {
                return this.color;
            }
        },
        background () {
            if (this.alpha) return `linear-gradient(
                    45deg,
                    ${this.computedValue.toString("hex")} 50%,
                    ${this.computedValue.toString("hexa")} 50%
                )`;
            else {
                const hex = this.computedValue.toString("hex");
                return `linear-gradient(
                    45deg,
                    ${hex} 50%,
                    ${hex} 50%
                )`;
            }
        },
        triggerStyle () {
            const { red, green, blue } = this.computedValue;
            const light = red * 0.299 + green * 0.587 + blue * 0.114 > 186;
            return {
                backgroundColor: "#ffffff",
                backgroundImage: `
                    ${this.background},
                    linear-gradient(45deg, #c7c7c7 25%, transparent 25%, transparent 75%, #c7c7c7 75%, #c7c7c7),
                    linear-gradient(45deg, #c7c7c7 25%, transparent 25%, transparent 75%, #c7c7c7 75%, #c7c7c7)
                `,
                backgroundSize: "100% 100%, 16px 16px, 16px 16px",
                backgroundPosition: "0 0, 8px 8px, 0 0",
                color: light ? "#000000" : "#FFFFFF",
                textShadow: `0 0 2px ${light ? "#FFFFFFAA" : "#000000AA"}`
            };
        },
        isMobile () {
            return this.mobileNative && isMobile.any();
        },
        ariaRole () {
            if (!this.inline) return "dialog";
            else return void 0;
        }
    },
    watch: {
        modelValue (value) {
            this.computedValue = new Color(value);
        }
    },
    methods: {
        parseColor (color) {
            try {
                return this.colorParser(color);
            } catch (e) {
                return new Color();
            }
        },
        updateColor (value) {
            value.alpha = this.computedValue.alpha;
            this.computedValue = value;
            this.$emit("update:modelValue", value);
        },
        updateAlpha (alpha) {
            this.computedValue.alpha = alpha;
            this.$emit("update:modelValue", this.computedValue);
        },
        updateRGB () {
            this.$emit("update:modelValue", this.computedValue);
        },
        /*
     * Format color into string
     */ formatValue (value) {
            return value ? this.colorFormatter(value, this) : null;
        },
        /*
     * Toggle datepicker
     */ togglePicker (active) {
            if (this.$refs.dropdown) {
                const isActive = typeof active === "boolean" ? active : !this.$refs.dropdown.isActive;
                if (isActive) this.$refs.dropdown.isActive = isActive;
                else if (this.closeOnClick) this.$refs.dropdown.isActive = isActive;
            }
        },
        /*
     * Call default onFocus method and show datepicker
     */ handleOnFocus (event) {
            this.onFocus(event);
            if (this.openOnFocus) this.togglePicker(true);
        },
        /*
     * Toggle dropdown
     */ // I decided to comment out the following unused method until we come
        // back to deal with the `open-on-focus` and `close-on-click` props
        /*
    toggle() {
        if (this.mobileNative && this.isMobile) {
            const input = this.$refs.input.$refs.input
            input.focus()
            input.click()
            return
        }
        (this.$refs.dropdown as BDropdownInstance).toggle()
    }, */ /*
     * Avoid dropdown toggle when is already visible
     */ onInputClick (event) {
            if (this.$refs.dropdown.isActive) event.stopPropagation();
        },
        /*
     * Keypress event that is bound to the document.
     */ keyPress ({ key }) {
            const dropdown = this.$refs.dropdown;
            if (dropdown && dropdown.isActive && (key === "Escape" || key === "Esc")) this.togglePicker(false);
        },
        /*
     * Emit 'blur' event on dropdown is not active (closed)
     */ onActiveChange (value) {
            if (!value) this.onBlur();
            this.$emit("active-change", value);
        }
    }
});
const _hoisted_1$C = {
    class: "color-name"
};
const _hoisted_2$x = {
    class: "colorpicker-header"
};
const _hoisted_3$k = {
    class: "colorpicker-content"
};
const _hoisted_4$f = {
    class: "colorpicker-footer"
};
function _sfc_render$H(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = (0, _vue.resolveComponent)("b-button");
    const _component_b_colorpicker_h_s_l_representation_square = (0, _vue.resolveComponent)("b-colorpicker-h-s-l-representation-square");
    const _component_b_colorpicker_h_s_l_representation_triangle = (0, _vue.resolveComponent)("b-colorpicker-h-s-l-representation-triangle");
    const _component_b_colorpicker_alpha_slider = (0, _vue.resolveComponent)("b-colorpicker-alpha-slider");
    const _component_b_input = (0, _vue.resolveComponent)("b-input");
    const _component_b_field = (0, _vue.resolveComponent)("b-field");
    const _component_b_dropdown_item = (0, _vue.resolveComponent)("b-dropdown-item");
    const _component_b_dropdown = (0, _vue.resolveComponent)("b-dropdown");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "colorpicker control",
            [
                _ctx.size,
                {
                    "is-expanded": _ctx.expanded
                }
            ]
        ])
    }, [
        !_ctx.isMobile || _ctx.inline ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_dropdown, {
            key: 0,
            ref: "dropdown",
            position: _ctx.position,
            expanded: _ctx.expanded,
            disabled: _ctx.disabled,
            inline: _ctx.inline,
            "mobile-modal": _ctx.mobileModal,
            "trap-focus": _ctx.trapFocus,
            "aria-role": _ctx.ariaRole,
            "append-to-body": _ctx.appendToBody,
            "append-to-body-copy-parent": "",
            onActiveChange: _ctx.onActiveChange
        }, (0, _vue.createSlots)({
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.createVNode)(_component_b_dropdown_item, {
                        disabled: _ctx.disabled,
                        focusable: _ctx.focusable,
                        custom: "",
                        class: (0, _vue.normalizeClass)({
                            "dropdown-horizontal-colorpicker": _ctx.horizontalColorPicker
                        })
                    }, {
                        default: (0, _vue.withCtx)(()=>[
                                (0, _vue.createElementVNode)("div", null, [
                                    (0, _vue.createElementVNode)("header", _hoisted_2$x, [
                                        _ctx.$slots.header !== void 0 && _ctx.$slots.header.length ? (0, _vue.renderSlot)(_ctx.$slots, "header", {
                                            key: 0
                                        }) : (0, _vue.createCommentVNode)("v-if", true)
                                    ]),
                                    (0, _vue.createElementVNode)("div", _hoisted_3$k, [
                                        _ctx.representation === "square" ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_colorpicker_h_s_l_representation_square, {
                                            key: 0,
                                            value: _ctx.computedValue,
                                            onInput: _ctx.updateColor
                                        }, null, 8, [
                                            "value",
                                            "onInput"
                                        ])) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_colorpicker_h_s_l_representation_triangle, {
                                            key: 1,
                                            value: _ctx.computedValue,
                                            onInput: _ctx.updateColor
                                        }, null, 8, [
                                            "value",
                                            "onInput"
                                        ]))
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("footer", _hoisted_4$f, [
                                    _ctx.alpha ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_colorpicker_alpha_slider, {
                                        key: 0,
                                        value: _ctx.computedValue.alpha,
                                        onInput: _ctx.updateAlpha,
                                        color: _ctx.computedValue
                                    }, null, 8, [
                                        "value",
                                        "onInput",
                                        "color"
                                    ])) : (0, _vue.createCommentVNode)("v-if", true),
                                    (0, _vue.renderSlot)(_ctx.$slots, "footer", {
                                        color: _ctx.computedValue
                                    }, ()=>[
                                            (0, _vue.createVNode)(_component_b_field, {
                                                class: "colorpicker-fields",
                                                grouped: ""
                                            }, {
                                                default: (0, _vue.withCtx)(()=>[
                                                        (0, _vue.createVNode)(_component_b_field, {
                                                            horizontal: "",
                                                            label: "R"
                                                        }, {
                                                            default: (0, _vue.withCtx)(()=>[
                                                                    (0, _vue.createVNode)(_component_b_input, {
                                                                        type: "number",
                                                                        modelValue: _ctx.computedValue.red,
                                                                        "onUpdate:modelValue": [
                                                                            _cache[0] || (_cache[0] = ($event)=>_ctx.computedValue.red = $event),
                                                                            _ctx.updateRGB
                                                                        ],
                                                                        modelModifiers: {
                                                                            number: true
                                                                        },
                                                                        size: "is-small",
                                                                        "aria-label": "Red"
                                                                    }, null, 8, [
                                                                        "modelValue",
                                                                        "onUpdate:modelValue"
                                                                    ])
                                                                ]),
                                                            _: 1
                                                        }),
                                                        (0, _vue.createVNode)(_component_b_field, {
                                                            horizontal: "",
                                                            label: "G"
                                                        }, {
                                                            default: (0, _vue.withCtx)(()=>[
                                                                    (0, _vue.createVNode)(_component_b_input, {
                                                                        type: "number",
                                                                        modelValue: _ctx.computedValue.green,
                                                                        "onUpdate:modelValue": [
                                                                            _cache[1] || (_cache[1] = ($event)=>_ctx.computedValue.green = $event),
                                                                            _ctx.updateRGB
                                                                        ],
                                                                        modelModifiers: {
                                                                            number: true
                                                                        },
                                                                        size: "is-small",
                                                                        "aria-label": "Green"
                                                                    }, null, 8, [
                                                                        "modelValue",
                                                                        "onUpdate:modelValue"
                                                                    ])
                                                                ]),
                                                            _: 1
                                                        }),
                                                        (0, _vue.createVNode)(_component_b_field, {
                                                            horizontal: "",
                                                            label: "B"
                                                        }, {
                                                            default: (0, _vue.withCtx)(()=>[
                                                                    (0, _vue.createVNode)(_component_b_input, {
                                                                        type: "number",
                                                                        modelValue: _ctx.computedValue.blue,
                                                                        "onUpdate:modelValue": [
                                                                            _cache[2] || (_cache[2] = ($event)=>_ctx.computedValue.blue = $event),
                                                                            _ctx.updateRGB
                                                                        ],
                                                                        modelModifiers: {
                                                                            number: true
                                                                        },
                                                                        size: "is-small",
                                                                        "aria-label": "Blue"
                                                                    }, null, 8, [
                                                                        "modelValue",
                                                                        "onUpdate:modelValue"
                                                                    ])
                                                                ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                _: 1
                                            })
                                        ])
                                ])
                            ]),
                        _: 3
                    }, 8, [
                        "disabled",
                        "focusable",
                        "class"
                    ])
                ]),
            _: 2
        }, [
            !_ctx.inline ? {
                name: "trigger",
                fn: (0, _vue.withCtx)(()=>[
                        (0, _vue.renderSlot)(_ctx.$slots, "trigger", {}, ()=>[
                                (0, _vue.createVNode)(_component_b_button, {
                                    style: (0, _vue.normalizeStyle)(_ctx.triggerStyle),
                                    expanded: _ctx.expanded,
                                    disabled: _ctx.disabled
                                }, {
                                    default: (0, _vue.withCtx)(()=>[
                                            (0, _vue.createElementVNode)("span", _hoisted_1$C, (0, _vue.toDisplayString)(_ctx.colorFormatter(_ctx.computedValue)), 1)
                                        ]),
                                    _: 1
                                }, 8, [
                                    "style",
                                    "expanded",
                                    "disabled"
                                ])
                            ])
                    ]),
                key: "0"
            } : void 0
        ]), 1032, [
            "position",
            "expanded",
            "disabled",
            "inline",
            "mobile-modal",
            "trap-focus",
            "aria-role",
            "append-to-body",
            "onActiveChange"
        ])) : (0, _vue.createCommentVNode)("v-if", true)
    ], 2);
}
var Colorpicker = /* @__PURE__ */ _export_sfc(_sfc_main$w, [
    [
        "render",
        _sfc_render$H
    ]
]);
const Plugin$w = {
    install (Vue) {
        registerComponent(Vue, Colorpicker);
    }
};
var _sfc_main$v = (0, _vue.defineComponent)({
    name: "BSelect",
    components: {
        BIcon
    },
    mixins: [
        CompatFallthroughMixin,
        FormElementMixin
    ],
    props: {
        modelValue: {
            type: [
                String,
                Number,
                Boolean,
                Object,
                Array,
                Function,
                Date,
                null
            ],
            default: null
        },
        placeholder: String,
        multiple: Boolean,
        nativeSize: [
            String,
            Number
        ]
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars */ blur: (_event)=>true,
        focus: (_event)=>true,
        "update:modelValue": (_value)=>true
    },
    data () {
        return {
            selected: this.modelValue,
            _elementRef: "select"
        };
    },
    computed: {
        computedValue: {
            get () {
                return this.selected;
            },
            set (value) {
                this.selected = value;
                this.$emit("update:modelValue", value);
                !this.isValid && this.checkHtml5Validity();
            }
        },
        spanClasses () {
            return [
                this.size,
                this.statusType,
                {
                    "is-fullwidth": this.expanded,
                    "is-loading": this.loading,
                    "is-multiple": this.multiple,
                    "is-rounded": this.rounded,
                    "is-empty": this.selected === null
                }
            ];
        }
    },
    watch: {
        /*
    * When v-model is changed:
    *   1. Set the selected option.
    *   2. If it's invalid, validate again.
    */ modelValue (value) {
            this.selected = value;
            !this.isValid && this.checkHtml5Validity();
        }
    }
});
const _hoisted_1$B = [
    "multiple",
    "size"
];
const _hoisted_2$w = {
    key: 0,
    value: null,
    disabled: "",
    hidden: ""
};
function _sfc_render$G(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", (0, _vue.mergeProps)({
        class: [
            "control",
            {
                "is-expanded": _ctx.expanded,
                "has-icons-left": _ctx.icon
            }
        ]
    }, _ctx.rootAttrs), [
        (0, _vue.createElementVNode)("span", {
            class: (0, _vue.normalizeClass)([
                "select",
                _ctx.spanClasses
            ])
        }, [
            (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", (0, _vue.mergeProps)({
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.computedValue = $event),
                ref: "select",
                multiple: _ctx.multiple,
                size: _ctx.nativeSize
            }, _ctx.fallthroughAttrs, {
                onBlur: _cache[1] || (_cache[1] = (...args)=>_ctx.onBlur && _ctx.onBlur(...args)),
                onFocus: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit("focus", $event))
            }), [
                _ctx.placeholder ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                    key: 0
                }, [
                    _ctx.computedValue == null ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", _hoisted_2$w, (0, _vue.toDisplayString)(_ctx.placeholder), 1)) : (0, _vue.createCommentVNode)("v-if", true)
                ], 64)) : (0, _vue.createCommentVNode)("v-if", true),
                (0, _vue.renderSlot)(_ctx.$slots, "default")
            ], 16, _hoisted_1$B), [
                [
                    (0, _vue.vModelSelect),
                    _ctx.computedValue
                ]
            ])
        ], 2),
        _ctx.icon ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
            key: 0,
            class: "is-left",
            icon: _ctx.icon,
            pack: _ctx.iconPack,
            size: _ctx.iconSize
        }, null, 8, [
            "icon",
            "pack",
            "size"
        ])) : (0, _vue.createCommentVNode)("v-if", true)
    ], 16);
}
var BSelect = /* @__PURE__ */ _export_sfc(_sfc_main$v, [
    [
        "render",
        _sfc_render$G
    ]
]);
var _sfc_main$u = (0, _vue.defineComponent)({
    name: "BDatepickerTableRow",
    inject: {
        $datepicker: {
            name: "$datepicker",
            default: false
        }
    },
    props: {
        selectedDate: {
            type: [
                Date,
                Array
            ]
        },
        hoveredDateRange: Array,
        day: {
            type: Number
        },
        week: {
            type: Array,
            required: true
        },
        month: {
            type: Number,
            required: true
        },
        minDate: [
            Date,
            null
        ],
        maxDate: [
            Date,
            null
        ],
        disabled: Boolean,
        unselectableDates: [
            Array,
            Function,
            null
        ],
        unselectableDaysOfWeek: [
            Array,
            null
        ],
        selectableDates: [
            Array,
            Function,
            null
        ],
        events: Array,
        indicators: String,
        dateCreator: Function,
        nearbyMonthDays: Boolean,
        nearbySelectableMonthDays: Boolean,
        showWeekNumber: Boolean,
        weekNumberClickable: Boolean,
        range: Boolean,
        multiple: Boolean,
        rulesForFirstWeek: Number,
        firstDayOfWeek: [
            Number,
            null
        ]
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars */ "change-focus": (_day)=>true,
        rangeHoverEndDate: (_day)=>true,
        select: (_day)=>true
    },
    watch: {
        day (day) {
            const refName = `day-${this.month}-${day}`;
            this.$nextTick(()=>{
                let cell;
                if (Array.isArray(this.$refs[refName])) cell = this.$refs[refName][0];
                else cell = this.$refs[refName];
                if (cell) cell.focus();
            });
        }
    },
    methods: {
        firstWeekOffset (year, dow, doy) {
            const fwd = 7 + dow - doy;
            const firstJanuary = new Date(year, 0, fwd);
            const fwdlw = (7 + firstJanuary.getDay() - dow) % 7;
            return -fwdlw + fwd - 1;
        },
        daysInYear (year) {
            return this.isLeapYear(year) ? 366 : 365;
        },
        isLeapYear (year) {
            return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
        },
        getSetDayOfYear (input) {
            return Math.round((+input - +new Date(input.getFullYear(), 0, 1)) / 864e5) + 1;
        },
        weeksInYear (year, dow, doy) {
            const weekOffset = this.firstWeekOffset(year, dow, doy);
            const weekOffsetNext = this.firstWeekOffset(year + 1, dow, doy);
            return (this.daysInYear(year) - weekOffset + weekOffsetNext) / 7;
        },
        getWeekNumber (mom) {
            const dow = this.firstDayOfWeek;
            const doy = this.rulesForFirstWeek;
            const weekOffset = this.firstWeekOffset(mom.getFullYear(), dow, doy);
            const week = Math.floor((this.getSetDayOfYear(mom) - weekOffset - 1) / 7) + 1;
            let resWeek;
            let resYear;
            if (week < 1) {
                resYear = mom.getFullYear() - 1;
                resWeek = week + this.weeksInYear(resYear, dow, doy);
            } else if (week > this.weeksInYear(mom.getFullYear(), dow, doy)) {
                resWeek = week - this.weeksInYear(mom.getFullYear(), dow, doy);
                resYear = mom.getFullYear() + 1;
            } else {
                resYear = mom.getFullYear();
                resWeek = week;
            }
            return {
                week: resWeek,
                year: resYear
            };
        },
        clickWeekNumber (weekData) {
            if (this.weekNumberClickable) this.$datepicker.$emit("week-number-click", weekData.week, weekData.year);
        },
        /*
     * Check that selected day is within earliest/latest params and
     * is within this month
     */ selectableDate (day) {
            const validity = [];
            if (this.minDate) validity.push(day >= this.minDate);
            if (this.maxDate) validity.push(day <= this.maxDate);
            if (this.nearbyMonthDays && !this.nearbySelectableMonthDays) validity.push(day.getMonth() === this.month);
            if (this.selectableDates) {
                if (typeof this.selectableDates === "function") {
                    if (this.selectableDates(day)) return true;
                    else validity.push(false);
                } else for(let i = 0; i < this.selectableDates.length; i++){
                    const enabledDate = this.selectableDates[i];
                    if (day.getDate() === enabledDate.getDate() && day.getFullYear() === enabledDate.getFullYear() && day.getMonth() === enabledDate.getMonth()) return true;
                    else validity.push(false);
                }
            }
            if (this.unselectableDates) {
                if (typeof this.unselectableDates === "function") validity.push(!this.unselectableDates(day));
                else for(let i = 0; i < this.unselectableDates.length; i++){
                    const disabledDate = this.unselectableDates[i];
                    validity.push(day.getDate() !== disabledDate.getDate() || day.getFullYear() !== disabledDate.getFullYear() || day.getMonth() !== disabledDate.getMonth());
                }
            }
            if (this.unselectableDaysOfWeek) for(let i = 0; i < this.unselectableDaysOfWeek.length; i++){
                const dayOfWeek = this.unselectableDaysOfWeek[i];
                validity.push(day.getDay() !== dayOfWeek);
            }
            return validity.indexOf(false) < 0;
        },
        /*
    * Emit select event with chosen date as payload
    */ emitChosenDate (day) {
            if (this.disabled) return;
            if (this.selectableDate(day)) this.$emit("select", day);
        },
        // TODO: return undefined instead of boolean if no events
        eventsDateMatch (day) {
            if (!this.events || !this.events.length) return false;
            const dayEvents = [];
            for(let i = 0; i < this.events.length; i++)if (this.events[i].date.getDay() === day.getDay()) dayEvents.push(this.events[i]);
            if (!dayEvents.length) return false;
            return dayEvents;
        },
        /*
    * Build classObject for cell using validations
    */ classObject (day) {
            function dateMatch(dateOne, dateTwo, multiple) {
                if (!dateOne || !dateTwo || multiple) return false;
                if (Array.isArray(dateTwo)) return dateTwo.some((date)=>dateOne.getDate() === date.getDate() && dateOne.getFullYear() === date.getFullYear() && dateOne.getMonth() === date.getMonth());
                return dateOne.getDate() === dateTwo.getDate() && dateOne.getFullYear() === dateTwo.getFullYear() && dateOne.getMonth() === dateTwo.getMonth();
            }
            function dateWithin(dateOne, dates, multiple) {
                if (!Array.isArray(dates) || multiple) return false;
                return dateOne > dates[0] && dateOne < dates[1];
            }
            return {
                "is-selected": dateMatch(day, this.selectedDate) || dateWithin(day, this.selectedDate, this.multiple),
                "is-first-selected": dateMatch(day, Array.isArray(this.selectedDate) ? this.selectedDate[0] : void 0, this.multiple),
                "is-within-selected": dateWithin(day, this.selectedDate, this.multiple),
                "is-last-selected": dateMatch(day, Array.isArray(this.selectedDate) ? this.selectedDate[1] : void 0, this.multiple),
                "is-within-hovered-range": this.hoveredDateRange && this.hoveredDateRange.length === 2 && (dateMatch(day, this.hoveredDateRange) || dateWithin(day, this.hoveredDateRange)),
                "is-first-hovered": dateMatch(day, Array.isArray(this.hoveredDateRange) ? this.hoveredDateRange[0] : void 0),
                "is-within-hovered": dateWithin(day, this.hoveredDateRange),
                "is-last-hovered": dateMatch(day, Array.isArray(this.hoveredDateRange) ? this.hoveredDateRange[1] : void 0),
                "is-today": dateMatch(day, this.dateCreator()),
                "is-selectable": this.selectableDate(day) && !this.disabled,
                "is-unselectable": !this.selectableDate(day) || this.disabled,
                "is-invisible": !this.nearbyMonthDays && day.getMonth() !== this.month,
                "is-nearby": this.nearbySelectableMonthDays && day.getMonth() !== this.month,
                "has-event": this.eventsDateMatch(day),
                [this.indicators]: this.eventsDateMatch(day)
            };
        },
        setRangeHoverEndDate (day) {
            if (this.range) this.$emit("rangeHoverEndDate", day);
        },
        manageKeydown (event, weekDay) {
            const { key } = event;
            let preventDefault = true;
            switch(key){
                case "Tab":
                    preventDefault = false;
                    break;
                case " ":
                case "Space":
                case "Spacebar":
                case "Enter":
                    this.emitChosenDate(weekDay);
                    break;
                case "ArrowLeft":
                case "Left":
                    this.changeFocus(weekDay, -1);
                    break;
                case "ArrowRight":
                case "Right":
                    this.changeFocus(weekDay, 1);
                    break;
                case "ArrowUp":
                case "Up":
                    this.changeFocus(weekDay, -7);
                    break;
                case "ArrowDown":
                case "Down":
                    this.changeFocus(weekDay, 7);
                    break;
            }
            if (preventDefault) event.preventDefault();
        },
        changeFocus (day, inc) {
            const nextDay = new Date(day.getTime());
            nextDay.setDate(day.getDate() + inc);
            while((!this.minDate || nextDay > this.minDate) && (!this.maxDate || nextDay < this.maxDate) && !this.selectableDate(nextDay))nextDay.setDate(nextDay.getDate() + Math.sign(inc));
            this.setRangeHoverEndDate(nextDay);
            this.$emit("change-focus", nextDay);
        }
    }
});
const _hoisted_1$A = {
    class: "datepicker-row"
};
const _hoisted_2$v = [
    "disabled",
    "onClick",
    "onMouseenter",
    "onKeydown",
    "tabindex"
];
const _hoisted_3$j = {
    key: 0,
    class: "events"
};
const _hoisted_4$e = {
    key: 0,
    class: "events"
};
function _sfc_render$F(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, [
        (0, _vue.createCommentVNode)(" eslint-disable max-len "),
        (0, _vue.createElementVNode)("div", _hoisted_1$A, [
            _ctx.showWeekNumber ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("a", {
                key: 0,
                class: (0, _vue.normalizeClass)([
                    "datepicker-cell is-week-number",
                    {
                        "is-clickable": _ctx.weekNumberClickable
                    }
                ]),
                onClick: _cache[0] || (_cache[0] = (0, _vue.withModifiers)(($event)=>_ctx.clickWeekNumber(_ctx.getWeekNumber(_ctx.week[6])), [
                    "prevent"
                ]))
            }, [
                (0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)(_ctx.getWeekNumber(_ctx.week[6]).week), 1)
            ], 2)) : (0, _vue.createCommentVNode)("v-if", true),
            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.week, (weekDay, index)=>{
                return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                    key: index
                }, [
                    _ctx.selectableDate(weekDay) && !_ctx.disabled ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("a", {
                        key: 0,
                        ref_for: true,
                        ref: `day-${weekDay.getMonth()}-${weekDay.getDate()}`,
                        class: (0, _vue.normalizeClass)([
                            _ctx.classObject(weekDay),
                            "datepicker-cell"
                        ]),
                        role: "button",
                        href: "#",
                        disabled: _ctx.disabled || void 0,
                        onClick: (0, _vue.withModifiers)(($event)=>_ctx.emitChosenDate(weekDay), [
                            "prevent"
                        ]),
                        onMouseenter: ($event)=>_ctx.setRangeHoverEndDate(weekDay),
                        onKeydown: ($event)=>_ctx.manageKeydown($event, weekDay),
                        tabindex: _ctx.day === weekDay.getDate() && _ctx.month === weekDay.getMonth() ? void 0 : -1
                    }, [
                        (0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)(weekDay.getDate()), 1),
                        _ctx.eventsDateMatch(weekDay) ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_3$j, [
                            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.eventsDateMatch(weekDay), (event, evIdx)=>{
                                return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                                    class: (0, _vue.normalizeClass)([
                                        "event",
                                        event.type
                                    ]),
                                    key: evIdx
                                }, null, 2);
                            }), 128))
                        ])) : (0, _vue.createCommentVNode)("v-if", true)
                    ], 42, _hoisted_2$v)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                        key: 1,
                        class: (0, _vue.normalizeClass)([
                            _ctx.classObject(weekDay),
                            "datepicker-cell"
                        ])
                    }, [
                        (0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)(weekDay.getDate()), 1),
                        _ctx.eventsDateMatch(weekDay) ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_4$e, [
                            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.eventsDateMatch(weekDay), (event, evIdx)=>{
                                return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                                    class: (0, _vue.normalizeClass)([
                                        "event",
                                        event.type
                                    ]),
                                    key: evIdx
                                }, null, 2);
                            }), 128))
                        ])) : (0, _vue.createCommentVNode)("v-if", true)
                    ], 2))
                ], 64);
            }), 128))
        ]),
        (0, _vue.createCommentVNode)(" eslint-enable max-len ")
    ], 2112);
}
var BDatepickerTableRow = /* @__PURE__ */ _export_sfc(_sfc_main$u, [
    [
        "render",
        _sfc_render$F
    ]
]);
var _sfc_main$t = (0, _vue.defineComponent)({
    name: "BDatepickerTable",
    components: {
        BDatepickerTableRow
    },
    props: {
        modelValue: {
            type: [
                Date,
                Array,
                null
            ]
        },
        dayNames: [
            Array,
            null
        ],
        monthNames: [
            Array,
            null
        ],
        firstDayOfWeek: [
            Number,
            null
        ],
        events: Array,
        indicators: String,
        minDate: [
            Date,
            null
        ],
        maxDate: [
            Date,
            null
        ],
        focused: Object,
        disabled: Boolean,
        dateCreator: Function,
        unselectableDates: [
            Array,
            Function,
            null
        ],
        unselectableDaysOfWeek: [
            Array,
            null
        ],
        selectableDates: [
            Array,
            Function,
            null
        ],
        nearbyMonthDays: Boolean,
        nearbySelectableMonthDays: Boolean,
        showWeekNumber: Boolean,
        weekNumberClickable: Boolean,
        rulesForFirstWeek: Number,
        range: Boolean,
        multiple: Boolean
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars */ "range-end": (_date)=>true,
        "range-start": (_date)=>true,
        "update:focused": (_focused)=>true,
        "update:modelValue": (_value)=>true
    },
    data () {
        return {
            selectedBeginDate: void 0,
            selectedEndDate: void 0,
            hoveredEndDate: void 0
        };
    },
    computed: {
        multipleSelectedDates: {
            get () {
                return this.multiple && this.modelValue ? this.modelValue : [];
            },
            set (value) {
                this.$emit("update:modelValue", value);
            }
        },
        visibleDayNames () {
            const visibleDayNames = [];
            let index = this.firstDayOfWeek;
            while(visibleDayNames.length < this.dayNames.length){
                const currentDayName = this.dayNames[index % this.dayNames.length];
                visibleDayNames.push(currentDayName);
                index++;
            }
            if (this.showWeekNumber) visibleDayNames.unshift("");
            return visibleDayNames;
        },
        hasEvents () {
            return this.events && this.events.length;
        },
        /*
    * Return array of all events in the specified month
    */ eventsInThisMonth () {
            if (!this.events) return [];
            const monthEvents = [];
            for(let i = 0; i < this.events.length; i++){
                let event = this.events[i];
                if (!Object.prototype.hasOwnProperty.call(event, "date")) event = {
                    date: event,
                    type: "is-primary"
                };
                if (!Object.prototype.hasOwnProperty.call(event, "type")) event.type = "is-primary";
                if (event.date.getMonth() === this.focused.month && event.date.getFullYear() === this.focused.year) monthEvents.push(event);
            }
            return monthEvents;
        },
        /*
    * Return array of all weeks in the specified month
    */ weeksInThisMonth () {
            this.validateFocusedDay();
            const month = this.focused.month;
            const year = this.focused.year;
            const weeksInThisMonth = [];
            let startingDay = 1;
            while(weeksInThisMonth.length < 6){
                const newWeek = this.weekBuilder(startingDay, month, year);
                weeksInThisMonth.push(newWeek);
                startingDay += 7;
            }
            return weeksInThisMonth;
        },
        hoveredDateRange () {
            var _a, _b;
            if (!this.range) return [];
            if (!isNaN((_b = (_a = this.selectedEndDate) == null ? void 0 : _a.valueOf()) != null ? _b : NaN)) return [];
            if (this.hoveredEndDate < this.selectedBeginDate) return [
                this.hoveredEndDate,
                this.selectedBeginDate
            ].filter(isDefined);
            return [
                this.selectedBeginDate,
                this.hoveredEndDate
            ].filter(isDefined);
        },
        disabledOrUndefined () {
            return this.disabled || void 0;
        }
    },
    methods: {
        /*
    * Emit input event with selected date as payload for v-model in parent
    */ updateSelectedDate (date) {
            if (!this.range && !this.multiple) this.$emit("update:modelValue", date);
            else if (this.range) this.handleSelectRangeDate(date);
            else if (this.multiple) this.handleSelectMultipleDates(date);
        },
        /*
    * If both begin and end dates are set, reset the end date and set the begin date.
    * If only begin date is selected, emit an array of the begin date and the new date.
    * If not set, only set the begin date.
    */ handleSelectRangeDate (date) {
            if (this.selectedBeginDate && this.selectedEndDate) {
                this.selectedBeginDate = date;
                this.selectedEndDate = void 0;
                this.$emit("range-start", date);
            } else if (this.selectedBeginDate && !this.selectedEndDate) {
                if (this.selectedBeginDate > date) {
                    this.selectedEndDate = this.selectedBeginDate;
                    this.selectedBeginDate = date;
                } else this.selectedEndDate = date;
                this.$emit("range-end", date);
                this.$emit("update:modelValue", [
                    this.selectedBeginDate,
                    this.selectedEndDate
                ]);
            } else {
                this.selectedBeginDate = date;
                this.$emit("range-start", date);
            }
        },
        /*
    * If selected date already exists list of selected dates, remove it from the list
    * Otherwise, add date to list of selected dates
    */ handleSelectMultipleDates (date) {
            const multipleSelect = this.multipleSelectedDates.filter((selectedDate)=>selectedDate.getDate() === date.getDate() && selectedDate.getFullYear() === date.getFullYear() && selectedDate.getMonth() === date.getMonth());
            if (multipleSelect.length) this.multipleSelectedDates = this.multipleSelectedDates.filter((selectedDate)=>selectedDate.getDate() !== date.getDate() || selectedDate.getFullYear() !== date.getFullYear() || selectedDate.getMonth() !== date.getMonth());
            else this.multipleSelectedDates = [
                ...this.multipleSelectedDates,
                date
            ];
        },
        /*
     * Return array of all days in the week that the startingDate is within
     */ weekBuilder (startingDate, month, year) {
            const thisMonth = new Date(year, month);
            const thisWeek = [];
            const dayOfWeek = new Date(year, month, startingDate).getDay();
            const end = dayOfWeek >= this.firstDayOfWeek ? dayOfWeek - this.firstDayOfWeek : 7 - this.firstDayOfWeek + dayOfWeek;
            let daysAgo = 1;
            for(let i = 0; i < end; i++){
                thisWeek.unshift(new Date(thisMonth.getFullYear(), thisMonth.getMonth(), startingDate - daysAgo));
                daysAgo++;
            }
            thisWeek.push(new Date(year, month, startingDate));
            let daysForward = 1;
            while(thisWeek.length < 7){
                thisWeek.push(new Date(year, month, startingDate + daysForward));
                daysForward++;
            }
            return thisWeek;
        },
        validateFocusedDay () {
            const focusedDate = new Date(this.focused.year, this.focused.month, this.focused.day);
            if (this.selectableDate(focusedDate)) return;
            let day = 0;
            const monthDays = new Date(this.focused.year, this.focused.month + 1, 0).getDate();
            let firstFocusable = null;
            while(!firstFocusable && ++day < monthDays){
                const date = new Date(this.focused.year, this.focused.month, day);
                if (this.selectableDate(date)) {
                    firstFocusable = focusedDate;
                    const focused = {
                        day: date.getDate(),
                        month: date.getMonth(),
                        year: date.getFullYear()
                    };
                    this.$emit("update:focused", focused);
                }
            }
        },
        /*
     * Check that selected day is within earliest/latest params and
     * is within this month
     */ selectableDate (day) {
            const validity = [];
            if (this.minDate) validity.push(day >= this.minDate);
            if (this.maxDate) validity.push(day <= this.maxDate);
            if (this.nearbyMonthDays && !this.nearbySelectableMonthDays) validity.push(day.getMonth() === this.focused.month);
            if (this.selectableDates) {
                if (typeof this.selectableDates === "function") {
                    if (this.selectableDates(day)) return true;
                    else validity.push(false);
                } else for(let i = 0; i < this.selectableDates.length; i++){
                    const enabledDate = this.selectableDates[i];
                    if (day.getDate() === enabledDate.getDate() && day.getFullYear() === enabledDate.getFullYear() && day.getMonth() === enabledDate.getMonth()) return true;
                    else validity.push(false);
                }
            }
            if (this.unselectableDates) {
                if (typeof this.unselectableDates === "function") validity.push(!this.unselectableDates(day));
                else for(let i = 0; i < this.unselectableDates.length; i++){
                    const disabledDate = this.unselectableDates[i];
                    validity.push(day.getDate() !== disabledDate.getDate() || day.getFullYear() !== disabledDate.getFullYear() || day.getMonth() !== disabledDate.getMonth());
                }
            }
            if (this.unselectableDaysOfWeek) for(let i = 0; i < this.unselectableDaysOfWeek.length; i++){
                const dayOfWeek = this.unselectableDaysOfWeek[i];
                validity.push(day.getDay() !== dayOfWeek);
            }
            return validity.indexOf(false) < 0;
        },
        eventsInThisWeek (week) {
            return this.eventsInThisMonth.filter((event)=>{
                const stripped = new Date(Date.parse(event.date + ""));
                stripped.setHours(0, 0, 0, 0);
                const timed = stripped.getTime();
                return week.some((weekDate)=>weekDate.getTime() === timed);
            });
        },
        setRangeHoverEndDate (day) {
            this.hoveredEndDate = day;
        },
        changeFocus (day) {
            const focused = {
                day: day.getDate(),
                month: day.getMonth(),
                year: day.getFullYear()
            };
            this.$emit("update:focused", focused);
        }
    }
});
const _hoisted_1$z = {
    class: "datepicker-table"
};
const _hoisted_2$u = {
    class: "datepicker-header"
};
function _sfc_render$E(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_datepicker_table_row = (0, _vue.resolveComponent)("b-datepicker-table-row");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("section", _hoisted_1$z, [
        (0, _vue.createElementVNode)("header", _hoisted_2$u, [
            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.visibleDayNames, (day, index)=>{
                return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                    key: index,
                    class: "datepicker-cell"
                }, [
                    (0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)(day), 1)
                ]);
            }), 128))
        ]),
        (0, _vue.createElementVNode)("div", {
            class: (0, _vue.normalizeClass)([
                "datepicker-body",
                {
                    "has-events": _ctx.hasEvents
                }
            ])
        }, [
            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.weeksInThisMonth, (week, index)=>{
                return (0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_datepicker_table_row, {
                    key: index,
                    "selected-date": _ctx.modelValue ?? void 0,
                    day: _ctx.focused.day,
                    week,
                    month: _ctx.focused.month,
                    "min-date": _ctx.minDate,
                    "max-date": _ctx.maxDate,
                    disabled: _ctx.disabledOrUndefined,
                    "unselectable-dates": _ctx.unselectableDates,
                    "unselectable-days-of-week": _ctx.unselectableDaysOfWeek,
                    "selectable-dates": _ctx.selectableDates,
                    events: _ctx.eventsInThisWeek(week),
                    indicators: _ctx.indicators,
                    "date-creator": _ctx.dateCreator,
                    "nearby-month-days": _ctx.nearbyMonthDays,
                    "nearby-selectable-month-days": _ctx.nearbySelectableMonthDays,
                    "show-week-number": _ctx.showWeekNumber,
                    "week-number-clickable": _ctx.weekNumberClickable,
                    "first-day-of-week": _ctx.firstDayOfWeek,
                    "rules-for-first-week": _ctx.rulesForFirstWeek,
                    range: _ctx.range,
                    "hovered-date-range": _ctx.hoveredDateRange,
                    onSelect: _ctx.updateSelectedDate,
                    onRangeHoverEndDate: _ctx.setRangeHoverEndDate,
                    multiple: _ctx.multiple,
                    onChangeFocus: _ctx.changeFocus
                }, null, 8, [
                    "selected-date",
                    "day",
                    "week",
                    "month",
                    "min-date",
                    "max-date",
                    "disabled",
                    "unselectable-dates",
                    "unselectable-days-of-week",
                    "selectable-dates",
                    "events",
                    "indicators",
                    "date-creator",
                    "nearby-month-days",
                    "nearby-selectable-month-days",
                    "show-week-number",
                    "week-number-clickable",
                    "first-day-of-week",
                    "rules-for-first-week",
                    "range",
                    "hovered-date-range",
                    "onSelect",
                    "onRangeHoverEndDate",
                    "multiple",
                    "onChangeFocus"
                ]);
            }), 128))
        ], 2)
    ]);
}
var BDatepickerTable = /* @__PURE__ */ _export_sfc(_sfc_main$t, [
    [
        "render",
        _sfc_render$E
    ]
]);
var _sfc_main$s = (0, _vue.defineComponent)({
    name: "BDatepickerMonth",
    props: {
        modelValue: {
            type: [
                Date,
                Array,
                null
            ]
        },
        monthNames: [
            Array,
            null
        ],
        events: Array,
        indicators: String,
        minDate: [
            Date,
            null
        ],
        maxDate: [
            Date,
            null
        ],
        focused: Object,
        disabled: Boolean,
        dateCreator: Function,
        unselectableDates: [
            Array,
            Function,
            null
        ],
        unselectableDaysOfWeek: [
            Array,
            null
        ],
        selectableDates: [
            Array,
            Function,
            null
        ],
        range: Boolean,
        multiple: Boolean
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars */ "change-focus": (_date)=>true,
        "range-end": (_date)=>true,
        "range-start": (_date)=>true,
        "update:modelValue": (_date)=>true
    },
    data () {
        return {
            selectedBeginDate: void 0,
            selectedEndDate: void 0,
            hoveredEndDate: void 0,
            multipleSelectedDates: this.multiple && this.modelValue ? this.modelValue : []
        };
    },
    computed: {
        hasEvents () {
            return this.events && this.events.length;
        },
        /*
    * Return array of all events in the specified month
    */ eventsInThisYear () {
            if (!this.events) return [];
            const yearEvents = [];
            for(let i = 0; i < this.events.length; i++){
                let event = this.events[i];
                if (!Object.prototype.hasOwnProperty.call(event, "date")) event = {
                    date: event,
                    type: "is-primary"
                };
                if (!Object.prototype.hasOwnProperty.call(event, "type")) event.type = "is-primary";
                if (event.date.getFullYear() === this.focused.year) yearEvents.push(event);
            }
            return yearEvents;
        },
        monthDates () {
            const year = this.focused.year;
            const months = [];
            for(let i = 0; i < 12; i++){
                const d = new Date(year, i, 1);
                d.setHours(0, 0, 0, 0);
                months.push(d);
            }
            return months;
        },
        focusedMonth () {
            return this.focused.month;
        },
        hoveredDateRange () {
            var _a, _b;
            if (!this.range) return [];
            if (!isNaN((_b = (_a = this.selectedEndDate) == null ? void 0 : _a.valueOf()) != null ? _b : NaN)) return [];
            if (this.hoveredEndDate < this.selectedBeginDate) return [
                this.hoveredEndDate,
                this.selectedBeginDate
            ].filter(isDefined);
            return [
                this.selectedBeginDate,
                this.hoveredEndDate
            ].filter(isDefined);
        },
        disabledOrUndefined () {
            return this.disabled || void 0;
        }
    },
    watch: {
        focusedMonth (month) {
            const refName = `month-${month}`;
            this.$nextTick(()=>{
                let cell;
                if (Array.isArray(this.$refs[refName])) cell = this.$refs[refName][0];
                else cell = this.$refs[refName];
                if (cell) cell.focus();
            });
        }
    },
    methods: {
        selectMultipleDates (date) {
            const multipleSelect = this.multipleSelectedDates.filter((selectedDate)=>selectedDate.getDate() === date.getDate() && selectedDate.getFullYear() === date.getFullYear() && selectedDate.getMonth() === date.getMonth());
            if (multipleSelect.length) this.multipleSelectedDates = this.multipleSelectedDates.filter((selectedDate)=>selectedDate.getDate() !== date.getDate() || selectedDate.getFullYear() !== date.getFullYear() || selectedDate.getMonth() !== date.getMonth());
            else this.multipleSelectedDates.push(date);
            this.$emit("update:modelValue", this.multipleSelectedDates);
        },
        selectableDate (day) {
            const validity = [];
            if (this.minDate) validity.push(day >= this.minDate);
            if (this.maxDate) validity.push(day <= this.maxDate);
            validity.push(day.getFullYear() === this.focused.year);
            if (this.selectableDates) {
                if (typeof this.selectableDates === "function") {
                    if (this.selectableDates(day)) return true;
                    else validity.push(false);
                } else for(let i = 0; i < this.selectableDates.length; i++){
                    const enabledDate = this.selectableDates[i];
                    if (day.getFullYear() === enabledDate.getFullYear() && day.getMonth() === enabledDate.getMonth()) return true;
                    else validity.push(false);
                }
            }
            if (this.unselectableDates) {
                if (typeof this.unselectableDates === "function") validity.push(!this.unselectableDates(day));
                else for(let i = 0; i < this.unselectableDates.length; i++){
                    const disabledDate = this.unselectableDates[i];
                    validity.push(day.getFullYear() !== disabledDate.getFullYear() || day.getMonth() !== disabledDate.getMonth());
                }
            }
            if (this.unselectableDaysOfWeek) for(let i = 0; i < this.unselectableDaysOfWeek.length; i++){
                const dayOfWeek = this.unselectableDaysOfWeek[i];
                validity.push(day.getDay() !== dayOfWeek);
            }
            return validity.indexOf(false) < 0;
        },
        // TODO: return undefined instead of false if no events
        eventsDateMatch (day) {
            if (!this.eventsInThisYear.length) return false;
            const monthEvents = [];
            for(let i = 0; i < this.eventsInThisYear.length; i++)if (this.eventsInThisYear[i].date.getMonth() === day.getMonth()) monthEvents.push(this.events[i]);
            if (!monthEvents.length) return false;
            return monthEvents;
        },
        /*
    * Build classObject for cell using validations
    */ classObject (day) {
            function dateMatch(dateOne, dateTwo, multiple) {
                if (!dateOne || !dateTwo || multiple) return false;
                if (Array.isArray(dateTwo)) return dateTwo.some((date)=>dateOne.getFullYear() === date.getFullYear() && dateOne.getMonth() === date.getMonth());
                return dateOne.getFullYear() === dateTwo.getFullYear() && dateOne.getMonth() === dateTwo.getMonth();
            }
            function dateWithin(dateOne, dates, multiple) {
                if (!Array.isArray(dates) || multiple) return false;
                return dateOne > dates[0] && dateOne < dates[1];
            }
            function dateMultipleSelected(dateOne, dates, multiple) {
                if (!Array.isArray(dates) || !multiple) return false;
                return dates.some((date)=>dateOne.getDate() === date.getDate() && dateOne.getFullYear() === date.getFullYear() && dateOne.getMonth() === date.getMonth());
            }
            return {
                "is-selected": dateMatch(day, this.modelValue, this.multiple) || dateWithin(day, this.modelValue, this.multiple) || dateMultipleSelected(day, this.multipleSelectedDates, this.multiple),
                "is-first-selected": dateMatch(day, Array.isArray(this.modelValue) ? this.modelValue[0] : void 0, this.multiple),
                "is-within-selected": dateWithin(day, this.modelValue, this.multiple),
                "is-last-selected": dateMatch(day, Array.isArray(this.modelValue) ? this.modelValue[1] : void 0, this.multiple),
                "is-within-hovered-range": this.hoveredDateRange && this.hoveredDateRange.length === 2 && (dateMatch(day, this.hoveredDateRange) || dateWithin(day, this.hoveredDateRange)),
                "is-first-hovered": dateMatch(day, Array.isArray(this.hoveredDateRange) ? this.hoveredDateRange[0] : void 0),
                "is-within-hovered": dateWithin(day, this.hoveredDateRange),
                "is-last-hovered": dateMatch(day, Array.isArray(this.hoveredDateRange) ? this.hoveredDateRange[1] : void 0),
                "is-today": dateMatch(day, this.dateCreator()),
                "is-selectable": this.selectableDate(day) && !this.disabled,
                "is-unselectable": !this.selectableDate(day) || this.disabled
            };
        },
        manageKeydown ({ key }, date) {
            switch(key){
                case " ":
                case "Space":
                case "Spacebar":
                case "Enter":
                    this.updateSelectedDate(date);
                    break;
                case "ArrowLeft":
                case "Left":
                    this.changeFocus(date, -1);
                    break;
                case "ArrowRight":
                case "Right":
                    this.changeFocus(date, 1);
                    break;
                case "ArrowUp":
                case "Up":
                    this.changeFocus(date, -3);
                    break;
                case "ArrowDown":
                case "Down":
                    this.changeFocus(date, 3);
                    break;
            }
        },
        /*
    * Emit input event with selected date as payload for v-model in parent
    */ updateSelectedDate (date) {
            if (!this.range && !this.multiple) this.emitChosenDate(date);
            else if (this.range) this.handleSelectRangeDate(date);
            else if (this.multiple) this.selectMultipleDates(date);
        },
        /*
     * Emit select event with chosen date as payload
     */ emitChosenDate (day) {
            if (this.disabled) return;
            if (!this.multiple) {
                if (this.selectableDate(day)) this.$emit("update:modelValue", day);
            } else this.selectMultipleDates(day);
        },
        /*
    * If both begin and end dates are set, reset the end date and set the begin date.
    * If only begin date is selected, emit an array of the begin date and the new date.
    * If not set, only set the begin date.
    */ handleSelectRangeDate (date) {
            if (this.disabled) return;
            if (this.selectedBeginDate && this.selectedEndDate) {
                this.selectedBeginDate = date;
                this.selectedEndDate = void 0;
                this.$emit("range-start", date);
            } else if (this.selectedBeginDate && !this.selectedEndDate) {
                if (this.selectedBeginDate > date) {
                    this.selectedEndDate = this.selectedBeginDate;
                    this.selectedBeginDate = date;
                } else this.selectedEndDate = date;
                this.$emit("range-end", date);
                this.$emit("update:modelValue", [
                    this.selectedBeginDate,
                    this.selectedEndDate
                ]);
            } else {
                this.selectedBeginDate = date;
                this.$emit("range-start", date);
            }
        },
        setRangeHoverEndDate (day) {
            if (this.range) this.hoveredEndDate = day;
        },
        changeFocus (month, inc) {
            const nextMonth = month;
            nextMonth.setMonth(month.getMonth() + inc);
            this.$emit("change-focus", nextMonth);
        }
    }
});
const _hoisted_1$y = {
    class: "datepicker-table"
};
const _hoisted_2$t = {
    class: "datepicker-months"
};
const _hoisted_3$i = [
    "disabled",
    "onClick",
    "onMouseenter",
    "onKeydown",
    "tabindex"
];
const _hoisted_4$d = {
    key: 0,
    class: "events"
};
function _sfc_render$D(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("section", _hoisted_1$y, [
        (0, _vue.createElementVNode)("div", {
            class: (0, _vue.normalizeClass)([
                "datepicker-body",
                {
                    "has-events": _ctx.hasEvents
                }
            ])
        }, [
            (0, _vue.createElementVNode)("div", _hoisted_2$t, [
                ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.monthDates, (date, index)=>{
                    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                        key: index
                    }, [
                        _ctx.selectableDate(date) && !_ctx.disabled ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("a", {
                            key: 0,
                            ref_for: true,
                            ref: `month-${date.getMonth()}`,
                            class: (0, _vue.normalizeClass)([
                                [
                                    _ctx.classObject(date),
                                    {
                                        "has-event": _ctx.eventsDateMatch(date)
                                    },
                                    _ctx.indicators
                                ],
                                "datepicker-cell"
                            ]),
                            role: "button",
                            href: "#",
                            disabled: _ctx.disabledOrUndefined,
                            onClick: (0, _vue.withModifiers)(($event)=>_ctx.updateSelectedDate(date), [
                                "prevent"
                            ]),
                            onMouseenter: ($event)=>_ctx.setRangeHoverEndDate(date),
                            onKeydown: (0, _vue.withModifiers)(($event)=>_ctx.manageKeydown($event, date), [
                                "prevent"
                            ]),
                            tabindex: _ctx.focused.month === date.getMonth() ? void 0 : -1
                        }, [
                            (0, _vue.createTextVNode)((0, _vue.toDisplayString)(_ctx.monthNames[date.getMonth()]) + " ", 1),
                            _ctx.eventsDateMatch(date) ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_4$d, [
                                ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.eventsDateMatch(date), (event, evIdx)=>{
                                    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                                        class: (0, _vue.normalizeClass)([
                                            "event",
                                            event.type
                                        ]),
                                        key: evIdx
                                    }, null, 2);
                                }), 128))
                            ])) : (0, _vue.createCommentVNode)("v-if", true)
                        ], 42, _hoisted_3$i)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                            key: 1,
                            class: (0, _vue.normalizeClass)([
                                _ctx.classObject(date),
                                "datepicker-cell"
                            ])
                        }, (0, _vue.toDisplayString)(_ctx.monthNames[date.getMonth()]), 3))
                    ], 64);
                }), 128))
            ])
        ], 2)
    ]);
}
var BDatepickerMonth = /* @__PURE__ */ _export_sfc(_sfc_main$s, [
    [
        "render",
        _sfc_render$D
    ]
]);
const defaultDateFormatter = (date, vm)=>{
    const targetDates = Array.isArray(date) ? date : [
        date
    ];
    const dates = targetDates.map((date2)=>{
        const d = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate(), 12);
        return !vm.isTypeMonth ? vm.dtf.format(d) : vm.dtfMonth.format(d);
    });
    return !vm.multiple ? dates.join(" - ") : dates.join(", ");
};
const defaultDateParser = (date, vm)=>{
    if (vm.dtf.formatToParts && typeof vm.dtf.formatToParts === "function") {
        const formatRegex = (vm.isTypeMonth ? vm.dtfMonth : vm.dtf).formatToParts(new Date(2e3, 11, 25)).map((part)=>{
            if (part.type === "literal") return part.value;
            return `((?!=<${part.type}>)\\d+)`;
        }).join("");
        const dateGroups = matchWithGroups(formatRegex, date);
        if (dateGroups.year && dateGroups.year.length === 4 && dateGroups.month && +dateGroups.month <= 12) {
            if (vm.isTypeMonth) return new Date(+dateGroups.year, +dateGroups.month - 1);
            else if (dateGroups.day && +dateGroups.day <= 31) return new Date(+dateGroups.year, +dateGroups.month - 1, +dateGroups.day, 12);
        }
    }
    if (!vm.isTypeMonth) return new Date(Date.parse(date));
    if (date) {
        const s = date.split("/");
        const year = s[0].length === 4 ? s[0] : s[1];
        const month = s[0].length === 2 ? s[0] : s[1];
        if (year && month) return new Date(parseInt(year, 10), parseInt(month, 10) - 1, 1, 0, 0, 0, 0);
    }
    return null;
};
var _sfc_main$r = (0, _vue.defineComponent)({
    name: "BDatepicker",
    components: {
        BDatepickerTable,
        BDatepickerMonth,
        BInput,
        BField: Field,
        BSelect,
        BIcon,
        BDropdown,
        BDropdownItem
    },
    mixins: [
        CompatFallthroughMixin,
        FormElementMixin
    ],
    provide () {
        return {
            $datepicker: this
        };
    },
    props: {
        modelValue: {
            type: [
                Date,
                Array,
                null
            ]
        },
        dayNames: {
            type: [
                Array,
                null
            ],
            default: ()=>{
                if (!Array.isArray(config.defaultDayNames)) return void 0;
                return config.defaultDayNames;
            }
        },
        monthNames: {
            type: [
                Array,
                null
            ],
            default: ()=>{
                if (!Array.isArray(config.defaultMonthNames)) return void 0;
                return config.defaultMonthNames;
            }
        },
        firstDayOfWeek: {
            type: Number,
            default: ()=>{
                if (typeof config.defaultFirstDayOfWeek === "number") return config.defaultFirstDayOfWeek;
                else return 0;
            }
        },
        inline: Boolean,
        minDate: [
            Date,
            null
        ],
        maxDate: [
            Date,
            null
        ],
        focusedDate: Date,
        placeholder: String,
        editable: Boolean,
        disabled: Boolean,
        horizontalTimePicker: Boolean,
        unselectableDates: [
            Array,
            Function
        ],
        unselectableDaysOfWeek: {
            type: [
                Array,
                null
            ],
            default: ()=>config.defaultUnselectableDaysOfWeek
        },
        selectableDates: [
            Array,
            Function
        ],
        dateFormatter: {
            type: Function,
            default: (date, vm)=>{
                if (typeof config.defaultDateFormatter === "function") return config.defaultDateFormatter(date);
                else return defaultDateFormatter(date, vm);
            }
        },
        dateParser: {
            type: Function,
            default: (date, vm)=>{
                if (typeof config.defaultDateParser === "function") return config.defaultDateParser(date);
                else return defaultDateParser(date, vm);
            }
        },
        dateCreator: {
            type: Function,
            default: ()=>{
                if (typeof config.defaultDateCreator === "function") return config.defaultDateCreator();
                else return /* @__PURE__ */ new Date();
            }
        },
        mobileNative: {
            type: Boolean,
            default: ()=>config.defaultDatepickerMobileNative
        },
        position: String,
        iconRight: String,
        iconRightClickable: Boolean,
        events: Array,
        indicators: {
            type: String,
            default: "dots"
        },
        openOnFocus: Boolean,
        iconPrev: {
            type: String,
            default: ()=>config.defaultIconPrev
        },
        iconNext: {
            type: String,
            default: ()=>config.defaultIconNext
        },
        yearsRange: {
            type: Array,
            default: ()=>config.defaultDatepickerYearsRange
        },
        type: {
            type: String,
            validator: (value)=>{
                return [
                    "month"
                ].indexOf(value) >= 0;
            }
        },
        nearbyMonthDays: {
            type: Boolean,
            default: ()=>config.defaultDatepickerNearbyMonthDays
        },
        nearbySelectableMonthDays: {
            type: Boolean,
            default: ()=>config.defaultDatepickerNearbySelectableMonthDays
        },
        showWeekNumber: {
            type: Boolean,
            default: ()=>config.defaultDatepickerShowWeekNumber
        },
        weekNumberClickable: {
            type: Boolean,
            default: ()=>config.defaultDatepickerWeekNumberClickable
        },
        rulesForFirstWeek: {
            type: Number,
            default: ()=>4
        },
        range: {
            type: Boolean,
            default: false
        },
        closeOnClick: {
            type: Boolean,
            default: true
        },
        multiple: {
            type: Boolean,
            default: false
        },
        mobileModal: {
            type: Boolean,
            default: ()=>config.defaultDatepickerMobileModal
        },
        focusable: {
            type: Boolean,
            default: true
        },
        trapFocus: {
            type: Boolean,
            default: ()=>config.defaultTrapFocus
        },
        appendToBody: Boolean,
        ariaNextLabel: String,
        ariaPreviousLabel: String
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars */ "active-change": (_active)=>true,
        "change-month": (_month)=>true,
        "change-year": (_year)=>true,
        "icon-right-click": (_event)=>true,
        "range-end": (_date)=>true,
        "range-start": (_date)=>true,
        "update:modelValue": (_value)=>true,
        "week-number-click": (_week, _year)=>true
    },
    data () {
        const focusedDate = (Array.isArray(this.modelValue) ? this.modelValue[0] : this.modelValue) || this.focusedDate || this.dateCreator();
        if (!this.modelValue && this.maxDate && this.maxDate.getFullYear() < focusedDate.getFullYear()) focusedDate.setFullYear(this.maxDate.getFullYear());
        return {
            dateSelected: this.modelValue,
            focusedDateData: {
                day: focusedDate.getDate(),
                month: focusedDate.getMonth(),
                year: focusedDate.getFullYear()
            },
            _elementRef: "input",
            _isDatepicker: true
        };
    },
    computed: {
        computedValue: {
            get () {
                return this.dateSelected;
            },
            set (value) {
                this.updateInternalState(value);
                if (!this.multiple) this.togglePicker(false);
                this.$emit("update:modelValue", value);
                if (this.useHtml5Validation) this.$nextTick(()=>{
                    this.checkHtml5Validity();
                });
            }
        },
        formattedValue () {
            return this.formatValue(this.computedValue);
        },
        localeOptions () {
            return new Intl.DateTimeFormat(this.locale, {
                year: "numeric",
                month: "numeric"
            }).resolvedOptions();
        },
        dtf () {
            return new Intl.DateTimeFormat(this.locale);
        },
        dtfMonth () {
            return new Intl.DateTimeFormat(this.locale, {
                year: this.localeOptions.year || "numeric",
                month: this.localeOptions.month || "2-digit"
            });
        },
        newMonthNames () {
            if (Array.isArray(this.monthNames)) return this.monthNames;
            return getMonthNames(this.locale);
        },
        newDayNames () {
            if (Array.isArray(this.dayNames)) return this.dayNames;
            return getWeekdayNames(this.locale);
        },
        listOfMonths () {
            let minMonth = 0;
            let maxMonth = 12;
            if (this.minDate && this.focusedDateData.year === this.minDate.getFullYear()) minMonth = this.minDate.getMonth();
            if (this.maxDate && this.focusedDateData.year === this.maxDate.getFullYear()) maxMonth = this.maxDate.getMonth();
            return this.newMonthNames.map((name, index)=>{
                return {
                    name,
                    index,
                    disabled: index < minMonth || index > maxMonth
                };
            });
        },
        /*
     * Returns an array of years for the year dropdown. If earliest/latest
     * dates are set by props, range of years will fall within those dates.
     */ listOfYears () {
            let latestYear = this.focusedDateData.year + this.yearsRange[1];
            if (this.maxDate && this.maxDate.getFullYear() < latestYear) latestYear = Math.max(this.maxDate.getFullYear(), this.focusedDateData.year);
            let earliestYear = this.focusedDateData.year + this.yearsRange[0];
            if (this.minDate && this.minDate.getFullYear() > earliestYear) earliestYear = Math.min(this.minDate.getFullYear(), this.focusedDateData.year);
            const arrayOfYears = [];
            for(let i = earliestYear; i <= latestYear; i++)arrayOfYears.push(i);
            return arrayOfYears.reverse();
        },
        showPrev () {
            if (!this.minDate) return false;
            if (this.isTypeMonth) return this.focusedDateData.year <= this.minDate.getFullYear();
            const dateToCheck = new Date(this.focusedDateData.year, this.focusedDateData.month);
            const date = new Date(this.minDate.getFullYear(), this.minDate.getMonth());
            return dateToCheck <= date;
        },
        showNext () {
            if (!this.maxDate) return false;
            if (this.isTypeMonth) return this.focusedDateData.year >= this.maxDate.getFullYear();
            const dateToCheck = new Date(this.focusedDateData.year, this.focusedDateData.month);
            const date = new Date(this.maxDate.getFullYear(), this.maxDate.getMonth());
            return dateToCheck >= date;
        },
        isMobile () {
            return this.mobileNative && isMobile.any();
        },
        isTypeMonth () {
            return this.type === "month";
        },
        ariaRole () {
            if (!this.inline) return "dialog";
            else return void 0;
        },
        disabledOrUndefined () {
            return this.disabled || void 0;
        }
    },
    watch: {
        /*
     * When v-model is changed:
     *   1. Update internal value.
     *   2. If it's invalid, validate again.
     */ modelValue (value) {
            this.updateInternalState(value);
            if (!this.multiple) this.togglePicker(false);
        },
        focusedDate (value) {
            if (value) this.focusedDateData = {
                day: value.getDate(),
                month: value.getMonth(),
                year: value.getFullYear()
            };
        },
        /*
     * Emit input event on month and/or year change
     */ "focusedDateData.month" (value) {
            this.$emit("change-month", value);
        },
        "focusedDateData.year" (value) {
            this.$emit("change-year", value);
        }
    },
    methods: {
        /*
     * Parse string into date
     */ onChange (value) {
            const date = this.dateParser(value, this);
            if (date && (!isNaN(date.valueOf()) || Array.isArray(date) && date.length === 2 && !isNaN(date[0]) && !isNaN(date[1]))) this.computedValue = date;
            else {
                this.computedValue = null;
                if (this.$refs.input) this.$refs.input.newValue = this.computedValue;
            }
        },
        /*
     * Format date into string
     */ formatValue (value) {
            if (Array.isArray(value)) {
                const isArrayWithValidDates = Array.isArray(value) && value.every((v)=>{
                    var _a;
                    return !isNaN((_a = v == null ? void 0 : v.valueOf()) != null ? _a : NaN);
                });
                return isArrayWithValidDates ? this.dateFormatter([
                    ...value
                ], this) : null;
            }
            return value && !isNaN(value.valueOf()) ? this.dateFormatter(value, this) : null;
        },
        /*
     * Either decrement month by 1 if not January or decrement year by 1
     * and set month to 11 (December) or decrement year when 'month'
     */ prev () {
            if (this.disabled) return;
            if (this.isTypeMonth) this.focusedDateData.year -= 1;
            else if (this.focusedDateData.month > 0) this.focusedDateData.month -= 1;
            else {
                this.focusedDateData.month = 11;
                this.focusedDateData.year -= 1;
            }
        },
        /*
     * Either increment month by 1 if not December or increment year by 1
     * and set month to 0 (January) or increment year when 'month'
     */ next () {
            if (this.disabled) return;
            if (this.isTypeMonth) this.focusedDateData.year += 1;
            else if (this.focusedDateData.month < 11) this.focusedDateData.month += 1;
            else {
                this.focusedDateData.month = 0;
                this.focusedDateData.year += 1;
            }
        },
        formatNative (value) {
            return this.isTypeMonth ? this.formatYYYYMM(value) : this.formatYYYYMMDD(value);
        },
        /*
     * Format date into string 'YYYY-MM-DD'
     */ formatYYYYMMDD (value) {
            const date = new Date(value);
            if (value && !isNaN(date.valueOf())) {
                const year = date.getFullYear();
                const month = date.getMonth() + 1;
                const day = date.getDate();
                return year + "-" + ((month < 10 ? "0" : "") + month) + "-" + ((day < 10 ? "0" : "") + day);
            }
            return "";
        },
        /*
     * Format date into string 'YYYY-MM'
     */ formatYYYYMM (value) {
            const date = new Date(value);
            if (value && !isNaN(date.valueOf())) {
                const year = date.getFullYear();
                const month = date.getMonth() + 1;
                return year + "-" + ((month < 10 ? "0" : "") + month);
            }
            return "";
        },
        /*
     * Parse date from string
     */ onChangeNativePicker (event) {
            const date = event.target.value;
            const s = date ? date.split("-") : [];
            if (s.length === 3) {
                const year = parseInt(s[0], 10);
                const month = parseInt(s[1]) - 1;
                const day = parseInt(s[2]);
                this.computedValue = new Date(year, month, day);
            } else this.computedValue = null;
        },
        updateInternalState (value) {
            if (this.dateSelected === value) return;
            const isArray = Array.isArray(value);
            const currentDate = isArray ? !value.length ? this.dateCreator() : value[value.length - 1] : !value ? this.dateCreator() : value;
            if (!isArray || this.dateSelected && value.length > this.dateSelected.length) this.focusedDateData = {
                day: currentDate.getDate(),
                month: currentDate.getMonth(),
                year: currentDate.getFullYear()
            };
            this.dateSelected = value;
        },
        /*
     * Toggle datepicker
     */ togglePicker (active) {
            if (this.$refs.dropdown) {
                const isActive = typeof active === "boolean" ? active : !this.$refs.dropdown.isActive;
                if (isActive) this.$refs.dropdown.isActive = isActive;
                else if (this.closeOnClick) this.$refs.dropdown.isActive = isActive;
            }
        },
        /*
     * Call default onFocus method and show datepicker
     */ handleOnFocus (event) {
            this.onFocus(event);
            if (this.openOnFocus) this.togglePicker(true);
        },
        /*
     * Toggle dropdown
     */ toggle () {
            if (this.mobileNative && this.isMobile) {
                const input = this.$refs.input.$refs.input;
                input.focus();
                input.click();
                return;
            }
            this.$refs.dropdown.toggle();
        },
        /*
     * Avoid dropdown toggle when is already visible
     */ onInputClick (event) {
            if (this.$refs.dropdown.isActive) event.stopPropagation();
        },
        /*
     * Keypress event that is bound to the document.
     */ keyPress ({ key }) {
            if (this.$refs.dropdown && this.$refs.dropdown.isActive && (key === "Escape" || key === "Esc")) this.togglePicker(false);
        },
        /*
     * Emit 'blur' event on dropdown is not active (closed)
     */ onActiveChange (value) {
            if (!value) this.onBlur();
            this.$emit("active-change", value);
        },
        changeFocus (day) {
            this.focusedDateData = {
                day: day.getDate(),
                month: day.getMonth(),
                year: day.getFullYear()
            };
        }
    },
    created () {
        if (typeof window !== "undefined") document.addEventListener("keyup", this.keyPress);
    },
    beforeUnmount () {
        if (typeof window !== "undefined") document.removeEventListener("keyup", this.keyPress);
    }
});
const _hoisted_1$x = {
    class: "datepicker-header"
};
const _hoisted_2$s = [
    "disabled",
    "aria-label"
];
const _hoisted_3$h = [
    "disabled",
    "aria-label"
];
const _hoisted_4$c = {
    class: "pagination-list"
};
const _hoisted_5$9 = [
    "value",
    "disabled"
];
const _hoisted_6$6 = [
    "value"
];
const _hoisted_7$6 = {
    key: 1
};
function _sfc_render$C(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_input = (0, _vue.resolveComponent)("b-input");
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    const _component_b_select = (0, _vue.resolveComponent)("b-select");
    const _component_b_field = (0, _vue.resolveComponent)("b-field");
    const _component_b_datepicker_table = (0, _vue.resolveComponent)("b-datepicker-table");
    const _component_b_datepicker_month = (0, _vue.resolveComponent)("b-datepicker-month");
    const _component_b_dropdown_item = (0, _vue.resolveComponent)("b-dropdown-item");
    const _component_b_dropdown = (0, _vue.resolveComponent)("b-dropdown");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", (0, _vue.mergeProps)({
        class: [
            "datepicker control",
            [
                _ctx.size,
                {
                    "is-expanded": _ctx.expanded
                }
            ]
        ]
    }, _ctx.rootAttrs), [
        !_ctx.isMobile || _ctx.inline ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_dropdown, {
            key: 0,
            ref: "dropdown",
            position: _ctx.position,
            disabled: _ctx.disabledOrUndefined,
            inline: _ctx.inline,
            "mobile-modal": _ctx.mobileModal,
            "trap-focus": _ctx.trapFocus,
            "aria-role": _ctx.ariaRole,
            "append-to-body": _ctx.appendToBody,
            "append-to-body-copy-parent": "",
            onActiveChange: _ctx.onActiveChange,
            "trigger-tabindex": -1
        }, (0, _vue.createSlots)({
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.createVNode)(_component_b_dropdown_item, {
                        disabled: _ctx.disabledOrUndefined,
                        focusable: _ctx.focusable,
                        custom: "",
                        class: (0, _vue.normalizeClass)({
                            "dropdown-horizontal-timepicker": _ctx.horizontalTimePicker
                        })
                    }, {
                        default: (0, _vue.withCtx)(()=>[
                                (0, _vue.createElementVNode)("div", null, [
                                    (0, _vue.createElementVNode)("header", _hoisted_1$x, [
                                        _ctx.$slots.header !== void 0 && _ctx.$slots.header([]).length ? (0, _vue.renderSlot)(_ctx.$slots, "header", {
                                            key: 0
                                        }) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                                            key: 1,
                                            class: (0, _vue.normalizeClass)([
                                                "pagination field is-centered",
                                                _ctx.size
                                            ])
                                        }, [
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("a", {
                                                class: "pagination-previous",
                                                role: "button",
                                                href: "#",
                                                disabled: _ctx.disabledOrUndefined,
                                                "aria-label": _ctx.ariaPreviousLabel,
                                                onClick: _cache[3] || (_cache[3] = (0, _vue.withModifiers)((...args)=>_ctx.prev && _ctx.prev(...args), [
                                                    "prevent"
                                                ])),
                                                onKeydown: [
                                                    _cache[4] || (_cache[4] = (0, _vue.withKeys)((0, _vue.withModifiers)((...args)=>_ctx.prev && _ctx.prev(...args), [
                                                        "prevent"
                                                    ]), [
                                                        "enter"
                                                    ])),
                                                    _cache[5] || (_cache[5] = (0, _vue.withKeys)((0, _vue.withModifiers)((...args)=>_ctx.prev && _ctx.prev(...args), [
                                                        "prevent"
                                                    ]), [
                                                        "space"
                                                    ]))
                                                ]
                                            }, [
                                                (0, _vue.createVNode)(_component_b_icon, {
                                                    icon: _ctx.iconPrev,
                                                    pack: _ctx.iconPack,
                                                    both: "",
                                                    type: "is-primary is-clickable"
                                                }, null, 8, [
                                                    "icon",
                                                    "pack"
                                                ])
                                            ], 40, _hoisted_2$s), [
                                                [
                                                    (0, _vue.vShow),
                                                    !_ctx.showPrev && !_ctx.disabled
                                                ]
                                            ]),
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("a", {
                                                class: "pagination-next",
                                                role: "button",
                                                href: "#",
                                                disabled: _ctx.disabledOrUndefined,
                                                "aria-label": _ctx.ariaNextLabel,
                                                onClick: _cache[6] || (_cache[6] = (0, _vue.withModifiers)((...args)=>_ctx.next && _ctx.next(...args), [
                                                    "prevent"
                                                ])),
                                                onKeydown: [
                                                    _cache[7] || (_cache[7] = (0, _vue.withKeys)((0, _vue.withModifiers)((...args)=>_ctx.next && _ctx.next(...args), [
                                                        "prevent"
                                                    ]), [
                                                        "enter"
                                                    ])),
                                                    _cache[8] || (_cache[8] = (0, _vue.withKeys)((0, _vue.withModifiers)((...args)=>_ctx.next && _ctx.next(...args), [
                                                        "prevent"
                                                    ]), [
                                                        "space"
                                                    ]))
                                                ]
                                            }, [
                                                (0, _vue.createVNode)(_component_b_icon, {
                                                    icon: _ctx.iconNext,
                                                    pack: _ctx.iconPack,
                                                    both: "",
                                                    type: "is-primary is-clickable"
                                                }, null, 8, [
                                                    "icon",
                                                    "pack"
                                                ])
                                            ], 40, _hoisted_3$h), [
                                                [
                                                    (0, _vue.vShow),
                                                    !_ctx.showNext && !_ctx.disabled
                                                ]
                                            ]),
                                            (0, _vue.createElementVNode)("div", _hoisted_4$c, [
                                                (0, _vue.createVNode)(_component_b_field, null, {
                                                    default: (0, _vue.withCtx)(()=>[
                                                            !_ctx.isTypeMonth ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_select, {
                                                                key: 0,
                                                                modelValue: _ctx.focusedDateData.month,
                                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event)=>_ctx.focusedDateData.month = $event),
                                                                disabled: _ctx.disabledOrUndefined,
                                                                size: _ctx.size
                                                            }, {
                                                                default: (0, _vue.withCtx)(()=>[
                                                                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.listOfMonths, (month)=>{
                                                                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", {
                                                                                value: month.index,
                                                                                key: month.name,
                                                                                disabled: month.disabled || void 0
                                                                            }, (0, _vue.toDisplayString)(month.name), 9, _hoisted_5$9);
                                                                        }), 128))
                                                                    ]),
                                                                _: 1
                                                            }, 8, [
                                                                "modelValue",
                                                                "disabled",
                                                                "size"
                                                            ])) : (0, _vue.createCommentVNode)("v-if", true),
                                                            (0, _vue.createVNode)(_component_b_select, {
                                                                modelValue: _ctx.focusedDateData.year,
                                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event)=>_ctx.focusedDateData.year = $event),
                                                                disabled: _ctx.disabledOrUndefined,
                                                                size: _ctx.size
                                                            }, {
                                                                default: (0, _vue.withCtx)(()=>[
                                                                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.listOfYears, (year)=>{
                                                                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", {
                                                                                value: year,
                                                                                key: year
                                                                            }, (0, _vue.toDisplayString)(year), 9, _hoisted_6$6);
                                                                        }), 128))
                                                                    ]),
                                                                _: 1
                                                            }, 8, [
                                                                "modelValue",
                                                                "disabled",
                                                                "size"
                                                            ])
                                                        ]),
                                                    _: 1
                                                })
                                            ])
                                        ], 2))
                                    ]),
                                    !_ctx.isTypeMonth ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                                        key: 0,
                                        class: (0, _vue.normalizeClass)([
                                            "datepicker-content",
                                            {
                                                "content-horizontal-timepicker": _ctx.horizontalTimePicker
                                            }
                                        ])
                                    }, [
                                        (0, _vue.createVNode)(_component_b_datepicker_table, {
                                            modelValue: _ctx.computedValue,
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event)=>_ctx.computedValue = $event),
                                            "day-names": _ctx.newDayNames,
                                            "month-names": _ctx.newMonthNames,
                                            "first-day-of-week": _ctx.firstDayOfWeek,
                                            "rules-for-first-week": _ctx.rulesForFirstWeek,
                                            "min-date": _ctx.minDate,
                                            "max-date": _ctx.maxDate,
                                            focused: _ctx.focusedDateData,
                                            disabled: _ctx.disabledOrUndefined,
                                            "unselectable-dates": _ctx.unselectableDates,
                                            "unselectable-days-of-week": _ctx.unselectableDaysOfWeek,
                                            "selectable-dates": _ctx.selectableDates,
                                            events: _ctx.events,
                                            indicators: _ctx.indicators,
                                            "date-creator": _ctx.dateCreator,
                                            "type-month": _ctx.isTypeMonth,
                                            "nearby-month-days": _ctx.nearbyMonthDays,
                                            "nearby-selectable-month-days": _ctx.nearbySelectableMonthDays,
                                            "show-week-number": _ctx.showWeekNumber,
                                            "week-number-clickable": _ctx.weekNumberClickable,
                                            range: _ctx.range,
                                            multiple: _ctx.multiple,
                                            onRangeStart: _cache[12] || (_cache[12] = (date)=>_ctx.$emit("range-start", date)),
                                            onRangeEnd: _cache[13] || (_cache[13] = (date)=>_ctx.$emit("range-end", date)),
                                            onClose: _cache[14] || (_cache[14] = ($event)=>_ctx.togglePicker(false)),
                                            "onUpdate:focused": _cache[15] || (_cache[15] = ($event)=>_ctx.focusedDateData = $event)
                                        }, null, 8, [
                                            "modelValue",
                                            "day-names",
                                            "month-names",
                                            "first-day-of-week",
                                            "rules-for-first-week",
                                            "min-date",
                                            "max-date",
                                            "focused",
                                            "disabled",
                                            "unselectable-dates",
                                            "unselectable-days-of-week",
                                            "selectable-dates",
                                            "events",
                                            "indicators",
                                            "date-creator",
                                            "type-month",
                                            "nearby-month-days",
                                            "nearby-selectable-month-days",
                                            "show-week-number",
                                            "week-number-clickable",
                                            "range",
                                            "multiple"
                                        ])
                                    ], 2)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_7$6, [
                                        (0, _vue.createVNode)(_component_b_datepicker_month, {
                                            modelValue: _ctx.computedValue,
                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event)=>_ctx.computedValue = $event),
                                            "month-names": _ctx.newMonthNames,
                                            "min-date": _ctx.minDate,
                                            "max-date": _ctx.maxDate,
                                            focused: _ctx.focusedDateData,
                                            disabled: _ctx.disabledOrUndefined,
                                            "unselectable-dates": _ctx.unselectableDates,
                                            "unselectable-days-of-week": _ctx.unselectableDaysOfWeek,
                                            "selectable-dates": _ctx.selectableDates,
                                            events: _ctx.events,
                                            indicators: _ctx.indicators,
                                            "date-creator": _ctx.dateCreator,
                                            range: _ctx.range,
                                            multiple: _ctx.multiple,
                                            onRangeStart: _cache[17] || (_cache[17] = (date)=>_ctx.$emit("range-start", date)),
                                            onRangeEnd: _cache[18] || (_cache[18] = (date)=>_ctx.$emit("range-end", date)),
                                            onClose: _cache[19] || (_cache[19] = ($event)=>_ctx.togglePicker(false)),
                                            onChangeFocus: _ctx.changeFocus,
                                            "onUpdate:focused": _cache[20] || (_cache[20] = ($event)=>_ctx.focusedDateData = $event)
                                        }, null, 8, [
                                            "modelValue",
                                            "month-names",
                                            "min-date",
                                            "max-date",
                                            "focused",
                                            "disabled",
                                            "unselectable-dates",
                                            "unselectable-days-of-week",
                                            "selectable-dates",
                                            "events",
                                            "indicators",
                                            "date-creator",
                                            "range",
                                            "multiple",
                                            "onChangeFocus"
                                        ])
                                    ]))
                                ]),
                                _ctx.$slots.default !== void 0 && _ctx.$slots.default([]).length ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("footer", {
                                    key: 0,
                                    class: (0, _vue.normalizeClass)([
                                        "datepicker-footer",
                                        {
                                            "footer-horizontal-timepicker": _ctx.horizontalTimePicker
                                        }
                                    ])
                                }, [
                                    (0, _vue.renderSlot)(_ctx.$slots, "default")
                                ], 2)) : (0, _vue.createCommentVNode)("v-if", true)
                            ]),
                        _: 3
                    }, 8, [
                        "disabled",
                        "focusable",
                        "class"
                    ])
                ]),
            _: 2
        }, [
            !_ctx.inline ? {
                name: "trigger",
                fn: (0, _vue.withCtx)((props)=>[
                        (0, _vue.renderSlot)(_ctx.$slots, "trigger", (0, _vue.normalizeProps)((0, _vue.guardReactiveProps)(props)), ()=>[
                                (0, _vue.createVNode)(_component_b_input, (0, _vue.mergeProps)({
                                    ref: "input",
                                    autocomplete: "off",
                                    "model-value": _ctx.formattedValue,
                                    placeholder: _ctx.placeholder,
                                    size: _ctx.size,
                                    icon: _ctx.icon,
                                    "icon-right": _ctx.iconRight,
                                    "icon-right-clickable": _ctx.iconRightClickable,
                                    "icon-pack": _ctx.iconPack,
                                    rounded: _ctx.rounded,
                                    loading: _ctx.loading,
                                    disabled: _ctx.disabledOrUndefined,
                                    readonly: !_ctx.editable
                                }, _ctx.fallthroughAttrs, {
                                    "use-html5-validation": false,
                                    onClick: _ctx.onInputClick,
                                    onIconRightClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit("icon-right-click", $event)),
                                    onKeyup: _cache[1] || (_cache[1] = (0, _vue.withKeys)(($event)=>_ctx.togglePicker(true), [
                                        "enter"
                                    ])),
                                    onChange: _cache[2] || (_cache[2] = ($event)=>_ctx.onChange($event.target.value)),
                                    onFocus: _ctx.handleOnFocus
                                }), null, 16, [
                                    "model-value",
                                    "placeholder",
                                    "size",
                                    "icon",
                                    "icon-right",
                                    "icon-right-clickable",
                                    "icon-pack",
                                    "rounded",
                                    "loading",
                                    "disabled",
                                    "readonly",
                                    "onClick",
                                    "onFocus"
                                ])
                            ])
                    ]),
                key: "0"
            } : void 0
        ]), 1032, [
            "position",
            "disabled",
            "inline",
            "mobile-modal",
            "trap-focus",
            "aria-role",
            "append-to-body",
            "onActiveChange"
        ])) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_input, (0, _vue.mergeProps)({
            key: 1,
            ref: "input",
            type: !_ctx.isTypeMonth ? "date" : "month",
            autocomplete: "off",
            "model-value": _ctx.formatNative(_ctx.computedValue),
            placeholder: _ctx.placeholder,
            size: _ctx.size,
            icon: _ctx.icon,
            "icon-pack": _ctx.iconPack,
            rounded: _ctx.rounded,
            loading: _ctx.loading,
            max: _ctx.formatNative(_ctx.maxDate),
            min: _ctx.formatNative(_ctx.minDate),
            disabled: _ctx.disabledOrUndefined,
            readonly: false
        }, _ctx.fallthroughAttrs, {
            "use-html5-validation": false,
            onChange: _ctx.onChangeNativePicker,
            onFocus: _ctx.onFocus,
            onBlur: _ctx.onBlur
        }), null, 16, [
            "type",
            "model-value",
            "placeholder",
            "size",
            "icon",
            "icon-pack",
            "rounded",
            "loading",
            "max",
            "min",
            "disabled",
            "onChange",
            "onFocus",
            "onBlur"
        ]))
    ], 16);
}
var BDatepicker = /* @__PURE__ */ _export_sfc(_sfc_main$r, [
    [
        "render",
        _sfc_render$C
    ]
]);
const Plugin$v = {
    install (Vue) {
        registerComponent(Vue, BDatepicker);
    }
};
var _sfc_main$q = (0, _vue.defineComponent)({
    name: "BTimepicker",
    components: {
        BInput,
        BField: Field,
        BSelect,
        BDropdown,
        BDropdownItem
    },
    mixins: [
        TimepickerMixin
    ],
    data () {
        return {
            _isTimepicker: true
        };
    },
    computed: {
        nativeStep () {
            if (this.enableSeconds) return "1";
            else return void 0;
        }
    }
});
const _hoisted_1$w = [
    "value",
    "disabled"
];
const _hoisted_2$r = {
    class: "control is-colon"
};
const _hoisted_3$g = [
    "value",
    "disabled"
];
const _hoisted_4$b = {
    class: "control is-colon"
};
const _hoisted_5$8 = [
    "value",
    "disabled"
];
const _hoisted_6$5 = {
    class: "control is-colon"
};
const _hoisted_7$5 = [
    "value"
];
const _hoisted_8$5 = {
    key: 0,
    class: "timepicker-footer"
};
function _sfc_render$B(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_input = (0, _vue.resolveComponent)("b-input");
    const _component_b_select = (0, _vue.resolveComponent)("b-select");
    const _component_b_field = (0, _vue.resolveComponent)("b-field");
    const _component_b_dropdown_item = (0, _vue.resolveComponent)("b-dropdown-item");
    const _component_b_dropdown = (0, _vue.resolveComponent)("b-dropdown");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", (0, _vue.mergeProps)({
        class: [
            "timepicker control",
            [
                _ctx.size,
                {
                    "is-expanded": _ctx.expanded
                }
            ]
        ]
    }, _ctx.rootAttrs), [
        !_ctx.isMobile || _ctx.inline ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_dropdown, {
            key: 0,
            ref: "dropdown",
            position: _ctx.position,
            disabled: _ctx.disabledOrUndefined,
            inline: _ctx.inline,
            "mobile-modal": _ctx.mobileModal,
            "append-to-body": _ctx.appendToBody,
            "append-to-body-copy-parent": "",
            onActiveChange: _ctx.onActiveChange
        }, (0, _vue.createSlots)({
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.createVNode)(_component_b_dropdown_item, {
                        disabled: _ctx.disabledOrUndefined,
                        focusable: _ctx.focusable,
                        custom: ""
                    }, {
                        default: (0, _vue.withCtx)(()=>[
                                (0, _vue.createVNode)(_component_b_field, {
                                    grouped: "",
                                    position: "is-centered"
                                }, {
                                    default: (0, _vue.withCtx)(()=>[
                                            (0, _vue.createVNode)(_component_b_select, {
                                                modelValue: _ctx.hoursSelected,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>_ctx.hoursSelected = $event),
                                                onChange: _cache[3] || (_cache[3] = ($event)=>_ctx.onHoursChange($event.target.value)),
                                                disabled: _ctx.disabledOrUndefined,
                                                placeholder: "00"
                                            }, {
                                                default: (0, _vue.withCtx)(()=>[
                                                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.hours, (hour)=>{
                                                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", {
                                                                value: hour.value,
                                                                key: hour.value,
                                                                disabled: _ctx.isHourDisabled(hour.value) || void 0
                                                            }, (0, _vue.toDisplayString)(hour.label), 9, _hoisted_1$w);
                                                        }), 128))
                                                    ]),
                                                _: 1
                                            }, 8, [
                                                "modelValue",
                                                "disabled"
                                            ]),
                                            (0, _vue.createElementVNode)("span", _hoisted_2$r, (0, _vue.toDisplayString)(_ctx.hourLiteral), 1),
                                            (0, _vue.createVNode)(_component_b_select, {
                                                modelValue: _ctx.minutesSelected,
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>_ctx.minutesSelected = $event),
                                                onChange: _cache[5] || (_cache[5] = ($event)=>_ctx.onMinutesChange($event.target.value)),
                                                disabled: _ctx.disabledOrUndefined,
                                                placeholder: "00"
                                            }, {
                                                default: (0, _vue.withCtx)(()=>[
                                                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.minutes, (minute)=>{
                                                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", {
                                                                value: minute.value,
                                                                key: minute.value,
                                                                disabled: _ctx.isMinuteDisabled(minute.value) || void 0
                                                            }, (0, _vue.toDisplayString)(minute.label), 9, _hoisted_3$g);
                                                        }), 128))
                                                    ]),
                                                _: 1
                                            }, 8, [
                                                "modelValue",
                                                "disabled"
                                            ]),
                                            _ctx.enableSeconds ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                                key: 0
                                            }, [
                                                (0, _vue.createElementVNode)("span", _hoisted_4$b, (0, _vue.toDisplayString)(_ctx.minuteLiteral), 1),
                                                (0, _vue.createVNode)(_component_b_select, {
                                                    modelValue: _ctx.secondsSelected,
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>_ctx.secondsSelected = $event),
                                                    onChange: _cache[7] || (_cache[7] = ($event)=>_ctx.onSecondsChange($event.target.value)),
                                                    disabled: _ctx.disabledOrUndefined,
                                                    placeholder: "00"
                                                }, {
                                                    default: (0, _vue.withCtx)(()=>[
                                                            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.seconds, (second)=>{
                                                                return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", {
                                                                    value: second.value,
                                                                    key: second.value,
                                                                    disabled: _ctx.isSecondDisabled(second.value) || void 0
                                                                }, (0, _vue.toDisplayString)(second.label), 9, _hoisted_5$8);
                                                            }), 128))
                                                        ]),
                                                    _: 1
                                                }, 8, [
                                                    "modelValue",
                                                    "disabled"
                                                ]),
                                                (0, _vue.createElementVNode)("span", _hoisted_6$5, (0, _vue.toDisplayString)(_ctx.secondLiteral), 1)
                                            ], 64)) : (0, _vue.createCommentVNode)("v-if", true),
                                            !_ctx.isHourFormat24 ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_select, {
                                                key: 1,
                                                modelValue: _ctx.meridienSelected,
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event)=>_ctx.meridienSelected = $event),
                                                onChange: _cache[9] || (_cache[9] = ($event)=>_ctx.onMeridienChange($event.target.value)),
                                                disabled: _ctx.disabledOrUndefined
                                            }, {
                                                default: (0, _vue.withCtx)(()=>[
                                                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.meridiens, (meridien)=>{
                                                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", {
                                                                value: meridien,
                                                                key: meridien
                                                            }, (0, _vue.toDisplayString)(meridien), 9, _hoisted_7$5);
                                                        }), 128))
                                                    ]),
                                                _: 1
                                            }, 8, [
                                                "modelValue",
                                                "disabled"
                                            ])) : (0, _vue.createCommentVNode)("v-if", true)
                                        ]),
                                    _: 1
                                }),
                                _ctx.$slots.default !== void 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("footer", _hoisted_8$5, [
                                    (0, _vue.renderSlot)(_ctx.$slots, "default")
                                ])) : (0, _vue.createCommentVNode)("v-if", true)
                            ]),
                        _: 3
                    }, 8, [
                        "disabled",
                        "focusable"
                    ])
                ]),
            _: 2
        }, [
            !_ctx.inline ? {
                name: "trigger",
                fn: (0, _vue.withCtx)(()=>[
                        (0, _vue.renderSlot)(_ctx.$slots, "trigger", {}, ()=>[
                                (0, _vue.createVNode)(_component_b_input, (0, _vue.mergeProps)({
                                    ref: "input",
                                    autocomplete: "off",
                                    "model-value": _ctx.formatValue(_ctx.computedValue),
                                    placeholder: _ctx.placeholder,
                                    size: _ctx.size,
                                    icon: _ctx.icon,
                                    "icon-pack": _ctx.iconPack,
                                    loading: _ctx.loading,
                                    disabled: _ctx.disabledOrUndefined,
                                    readonly: !_ctx.editable || void 0,
                                    rounded: _ctx.rounded
                                }, _ctx.fallthroughAttrs, {
                                    "use-html5-validation": _ctx.useHtml5Validation,
                                    onKeyup: _cache[0] || (_cache[0] = (0, _vue.withKeys)(($event)=>_ctx.toggle(true), [
                                        "enter"
                                    ])),
                                    onChange: _cache[1] || (_cache[1] = ($event)=>_ctx.onChange($event.target.value)),
                                    onFocus: _ctx.handleOnFocus
                                }), null, 16, [
                                    "model-value",
                                    "placeholder",
                                    "size",
                                    "icon",
                                    "icon-pack",
                                    "loading",
                                    "disabled",
                                    "readonly",
                                    "rounded",
                                    "use-html5-validation",
                                    "onFocus"
                                ])
                            ])
                    ]),
                key: "0"
            } : void 0
        ]), 1032, [
            "position",
            "disabled",
            "inline",
            "mobile-modal",
            "append-to-body",
            "onActiveChange"
        ])) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_input, (0, _vue.mergeProps)({
            key: 1,
            ref: "input",
            type: "time",
            step: _ctx.nativeStep,
            autocomplete: "off",
            "model-value": _ctx.formatHHMMSS(_ctx.computedValue),
            placeholder: _ctx.placeholder,
            size: _ctx.size,
            icon: _ctx.icon,
            "icon-pack": _ctx.iconPack,
            rounded: _ctx.rounded,
            loading: _ctx.loading,
            max: _ctx.formatHHMMSS(_ctx.maxTime),
            min: _ctx.formatHHMMSS(_ctx.minTime),
            disabled: _ctx.disabledOrUndefined,
            readonly: false
        }, _ctx.fallthroughAttrs, {
            "use-html5-validation": _ctx.useHtml5Validation,
            onChange: _cache[10] || (_cache[10] = ($event)=>_ctx.onChange($event.target.value)),
            onFocus: _ctx.handleOnFocus,
            onBlur: _cache[11] || (_cache[11] = ($event)=>_ctx.onBlur() && _ctx.checkHtml5Validity())
        }), null, 16, [
            "step",
            "model-value",
            "placeholder",
            "size",
            "icon",
            "icon-pack",
            "rounded",
            "loading",
            "max",
            "min",
            "disabled",
            "use-html5-validation",
            "onFocus"
        ]))
    ], 16);
}
var Timepicker = /* @__PURE__ */ _export_sfc(_sfc_main$q, [
    [
        "render",
        _sfc_render$B
    ]
]);
const AM = "AM";
const PM = "PM";
var _sfc_main$p = (0, _vue.defineComponent)({
    name: "BDatetimepicker",
    components: {
        BDatepicker,
        BInput,
        BTimepicker: Timepicker
    },
    mixins: [
        FormElementMixin
    ],
    inheritAttrs: false,
    props: {
        modelValue: {
            type: [
                Date,
                null
            ]
        },
        editable: {
            type: Boolean,
            default: false
        },
        placeholder: String,
        horizontalTimePicker: Boolean,
        disabled: Boolean,
        firstDayOfWeek: {
            type: Number,
            default: ()=>{
                if (typeof config.defaultFirstDayOfWeek === "number") return config.defaultFirstDayOfWeek;
                else return 0;
            }
        },
        rulesForFirstWeek: {
            type: Number,
            default: ()=>4
        },
        icon: String,
        iconRight: String,
        iconRightClickable: Boolean,
        iconPack: String,
        inline: Boolean,
        openOnFocus: Boolean,
        position: String,
        mobileNative: {
            type: Boolean,
            default: true
        },
        minDatetime: Date,
        maxDatetime: Date,
        nearbyMonthDays: {
            type: Boolean,
            default: config.defaultDatepickerNearbyMonthDays
        },
        datetimeFormatter: {
            type: Function
        },
        datetimeParser: {
            type: Function
        },
        datetimeCreator: {
            type: Function,
            default: (date)=>{
                if (typeof config.defaultDatetimeCreator === "function") return config.defaultDatetimeCreator(date);
                else return date;
            }
        },
        datepicker: Object,
        timepicker: Object,
        tzOffset: {
            type: Number,
            default: 0
        },
        focusable: {
            type: Boolean,
            default: true
        },
        appendToBody: Boolean
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars */ "active-change": (_active)=>true,
        "change-month": (_month)=>true,
        "change-year": (_year)=>true,
        "icon-right-click": ()=>true,
        "update:modelValue": (_value)=>true
    },
    data () {
        return {
            newValue: this.adjustValue(this.modelValue)
        };
    },
    computed: {
        computedValue: {
            get () {
                return this.newValue;
            },
            set (value) {
                if (value) {
                    let val = new Date(value.getTime());
                    if (this.newValue) {
                        if ((value.getDate() !== this.newValue.getDate() || value.getMonth() !== this.newValue.getMonth() || value.getFullYear() !== this.newValue.getFullYear()) && value.getHours() === 0 && value.getMinutes() === 0 && value.getSeconds() === 0) val.setHours(this.newValue.getHours(), this.newValue.getMinutes(), this.newValue.getSeconds(), 0);
                    } else val = this.datetimeCreator(value);
                    if (this.minDatetime && val < this.adjustValue(this.minDatetime)) val = this.adjustValue(this.minDatetime);
                    else if (this.maxDatetime && val > this.adjustValue(this.maxDatetime)) val = this.adjustValue(this.maxDatetime);
                    this.newValue = new Date(val.getTime());
                } else this.newValue = this.adjustValue(value);
                const adjustedValue = this.adjustValue(this.newValue, true);
                this.$emit("update:modelValue", adjustedValue);
            }
        },
        localeOptions () {
            return new Intl.DateTimeFormat(this.locale, {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                second: this.enableSeconds() ? "numeric" : void 0
            }).resolvedOptions();
        },
        dtf () {
            return new Intl.DateTimeFormat(this.locale, {
                year: this.localeOptions.year || "numeric",
                month: this.localeOptions.month || "numeric",
                day: this.localeOptions.day || "numeric",
                hour: this.localeOptions.hour || "numeric",
                minute: this.localeOptions.minute || "numeric",
                second: this.enableSeconds() ? this.localeOptions.second || "numeric" : void 0,
                hourCycle: !this.isHourFormat24() ? "h12" : "h23"
            });
        },
        isMobileNative () {
            return this.mobileNative && this.tzOffset === 0;
        },
        isMobile () {
            return this.isMobileNative && isMobile.any();
        },
        minDate () {
            if (!this.minDatetime) return this.datepicker ? this.adjustValue(this.datepicker.minDate) : null;
            const adjMinDatetime = this.adjustValue(this.minDatetime);
            return new Date(adjMinDatetime.getFullYear(), adjMinDatetime.getMonth(), adjMinDatetime.getDate(), 0, 0, 0, 0);
        },
        maxDate () {
            if (!this.maxDatetime) return this.datepicker ? this.adjustValue(this.datepicker.maxDate) : null;
            const adjMaxDatetime = this.adjustValue(this.maxDatetime);
            return new Date(adjMaxDatetime.getFullYear(), adjMaxDatetime.getMonth(), adjMaxDatetime.getDate(), 0, 0, 0, 0);
        },
        minTime () {
            if (!this.minDatetime || this.newValue === null || typeof this.newValue === "undefined") return this.timepicker ? this.adjustValue(this.timepicker.minTime) : null;
            const adjMinDatetime = this.adjustValue(this.minDatetime);
            if (adjMinDatetime.getFullYear() === this.newValue.getFullYear() && adjMinDatetime.getMonth() === this.newValue.getMonth() && adjMinDatetime.getDate() === this.newValue.getDate()) return adjMinDatetime;
            return void 0;
        },
        maxTime () {
            if (!this.maxDatetime || this.newValue === null || typeof this.newValue === "undefined") return this.timepicker ? this.adjustValue(this.timepicker.maxTime) : null;
            const adjMaxDatetime = this.adjustValue(this.maxDatetime);
            if (adjMaxDatetime.getFullYear() === this.newValue.getFullYear() && adjMaxDatetime.getMonth() === this.newValue.getMonth() && adjMaxDatetime.getDate() === this.newValue.getDate()) return adjMaxDatetime;
            return void 0;
        },
        datepickerSize () {
            return this.datepicker && this.datepicker.size ? this.datepicker.size : this.size;
        },
        timepickerSize () {
            return this.timepicker && this.timepicker.size ? this.timepicker.size : this.size;
        },
        timepickerDisabled () {
            return this.timepicker && this.timepicker.disabled ? this.timepicker.disabled : this.disabled;
        },
        disabledOrUndefined () {
            return this.disabled || void 0;
        }
    },
    watch: {
        modelValue () {
            this.newValue = this.adjustValue(this.modelValue);
        },
        tzOffset () {
            this.newValue = this.adjustValue(this.modelValue);
        }
    },
    methods: {
        enableSeconds () {
            if (this.$refs.timepicker) return this.$refs.timepicker.enableSeconds;
            return false;
        },
        isHourFormat24 () {
            if (this.$refs.timepicker) return this.$refs.timepicker.isHourFormat24;
            return !this.localeOptions.hour12;
        },
        adjustValue (value, reverse = false) {
            if (!value) return value;
            if (reverse) return new Date(value.getTime() - this.tzOffset * 6e4);
            else return new Date(value.getTime() + this.tzOffset * 6e4);
        },
        defaultDatetimeParser (date) {
            if (typeof this.datetimeParser === "function") return this.datetimeParser(date);
            else if (typeof config.defaultDatetimeParser === "function") return config.defaultDatetimeParser(date);
            else {
                if (this.dtf.formatToParts && typeof this.dtf.formatToParts === "function") {
                    const dayPeriods = [
                        AM,
                        PM,
                        AM.toLowerCase(),
                        PM.toLowerCase()
                    ];
                    if (this.$refs.timepicker) {
                        dayPeriods.push(this.$refs.timepicker.amString);
                        dayPeriods.push(this.$refs.timepicker.pmString);
                    }
                    const parts = this.dtf.formatToParts(/* @__PURE__ */ new Date());
                    const formatRegex = parts.map((part, idx)=>{
                        if (part.type === "literal") {
                            if (idx + 1 < parts.length && parts[idx + 1].type === "hour") return "[^\\d]+";
                            return part.value.replace(/ /g, "\\s?");
                        } else if (part.type === "dayPeriod") return `((?!=<${part.type}>)(${dayPeriods.join("|")})?)`;
                        return `((?!=<${part.type}>)\\d+)`;
                    }).join("");
                    const datetimeGroups = matchWithGroups(formatRegex, date);
                    if (datetimeGroups.year && datetimeGroups.year.length === 4 && datetimeGroups.month && +datetimeGroups.month <= 12 && datetimeGroups.day && +datetimeGroups.day <= 31 && datetimeGroups.hour && +datetimeGroups.hour >= 0 && +datetimeGroups.hour < 24 && datetimeGroups.minute && +datetimeGroups.minute >= 0 && +datetimeGroups.minute <= 59) {
                        const d = new Date(+datetimeGroups.year, +datetimeGroups.month - 1, +datetimeGroups.day, +datetimeGroups.hour, +datetimeGroups.minute, +(datetimeGroups.second || 0));
                        return d;
                    }
                }
                return new Date(Date.parse(date));
            }
        },
        defaultDatetimeFormatter (date) {
            date;
            if (typeof this.datetimeFormatter === "function") return this.datetimeFormatter(date);
            else if (typeof config.defaultDatetimeFormatter === "function") return config.defaultDatetimeFormatter(date);
            else return this.dtf.format(date);
        },
        /*
    * Parse date from string
    */ onChangeNativePicker (event) {
            const date = event.target.value;
            const s = date ? date.split(/\D/) : [];
            if (s.length >= 5) {
                const year = parseInt(s[0], 10);
                const month = parseInt(s[1], 10) - 1;
                const day = parseInt(s[2], 10);
                const hours = parseInt(s[3], 10);
                const minutes = parseInt(s[4], 10);
                this.computedValue = new Date(year, month, day, hours, minutes);
            } else this.computedValue = null;
        },
        /*
     * Emit 'active-change' on datepicker active state change
     */ onActiveChange (value) {
            this.$emit("active-change", value);
        },
        formatNative (value) {
            const date = new Date(value);
            if (value && !isNaN(date.valueOf())) {
                const year = date.getFullYear();
                const month = date.getMonth() + 1;
                const day = date.getDate();
                const hours = date.getHours();
                const minutes = date.getMinutes();
                const seconds = date.getSeconds();
                return year + "-" + ((month < 10 ? "0" : "") + month) + "-" + ((day < 10 ? "0" : "") + day) + "T" + ((hours < 10 ? "0" : "") + hours) + ":" + ((minutes < 10 ? "0" : "") + minutes) + ":" + ((seconds < 10 ? "0" : "") + seconds);
            }
            return "";
        },
        toggle () {
            this.$refs.datepicker.toggle();
        }
    },
    mounted () {
        if (!this.isMobile || this.inline) {
            if (this.newValue) this.$refs.datepicker.$forceUpdate();
        }
    }
});
const _hoisted_1$v = {
    class: "level is-mobile"
};
const _hoisted_2$q = {
    key: 0,
    class: "level-item has-text-centered"
};
const _hoisted_3$f = {
    class: "level-item has-text-centered"
};
const _hoisted_4$a = {
    key: 1,
    class: "level-item has-text-centered"
};
function _sfc_render$A(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_timepicker = (0, _vue.resolveComponent)("b-timepicker");
    const _component_b_datepicker = (0, _vue.resolveComponent)("b-datepicker");
    const _component_b_input = (0, _vue.resolveComponent)("b-input");
    return !_ctx.isMobile || _ctx.inline ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_datepicker, (0, _vue.mergeProps)({
        key: 0,
        ref: "datepicker",
        modelValue: _ctx.computedValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>_ctx.computedValue = $event)
    }, _ctx.datepicker, {
        rounded: _ctx.rounded,
        "open-on-focus": _ctx.openOnFocus,
        position: _ctx.position,
        loading: _ctx.loading,
        inline: _ctx.inline,
        editable: _ctx.editable,
        expanded: _ctx.expanded,
        "close-on-click": false,
        "first-day-of-week": _ctx.firstDayOfWeek,
        "rules-for-first-week": _ctx.rulesForFirstWeek,
        "date-formatter": _ctx.defaultDatetimeFormatter,
        "date-parser": _ctx.defaultDatetimeParser,
        "min-date": _ctx.minDate,
        "max-date": _ctx.maxDate,
        "nearby-month-days": _ctx.nearbyMonthDays,
        icon: _ctx.icon,
        "icon-right": _ctx.iconRight,
        "icon-right-clickable": _ctx.iconRightClickable,
        "icon-pack": _ctx.iconPack,
        size: _ctx.datepickerSize,
        placeholder: _ctx.placeholder,
        "horizontal-time-picker": _ctx.horizontalTimePicker,
        range: false,
        disabled: _ctx.disabledOrUndefined,
        "mobile-native": _ctx.isMobileNative,
        locale: _ctx.locale,
        focusable: _ctx.focusable,
        "append-to-body": _ctx.appendToBody,
        onFocus: _ctx.onFocus,
        onBlur: _ctx.onBlur,
        onActiveChange: _ctx.onActiveChange,
        onIconRightClick: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit("icon-right-click")),
        onChangeMonth: _cache[3] || (_cache[3] = ($event)=>_ctx.$emit("change-month", $event)),
        onChangeYear: _cache[4] || (_cache[4] = ($event)=>_ctx.$emit("change-year", $event))
    }), {
        default: (0, _vue.withCtx)(()=>[
                (0, _vue.createElementVNode)("nav", _hoisted_1$v, [
                    _ctx.$slots.left !== void 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_2$q, [
                        (0, _vue.renderSlot)(_ctx.$slots, "left")
                    ])) : (0, _vue.createCommentVNode)("v-if", true),
                    (0, _vue.createElementVNode)("div", _hoisted_3$f, [
                        (0, _vue.createVNode)(_component_b_timepicker, (0, _vue.mergeProps)({
                            ref: "timepicker"
                        }, _ctx.timepicker, {
                            modelValue: _ctx.computedValue,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.computedValue = $event),
                            inline: "",
                            editable: _ctx.editable,
                            "min-time": _ctx.minTime,
                            "max-time": _ctx.maxTime,
                            size: _ctx.timepickerSize,
                            disabled: _ctx.timepickerDisabled || void 0,
                            focusable: _ctx.focusable,
                            "mobile-native": _ctx.isMobileNative,
                            locale: _ctx.locale
                        }), null, 16, [
                            "modelValue",
                            "editable",
                            "min-time",
                            "max-time",
                            "size",
                            "disabled",
                            "focusable",
                            "mobile-native",
                            "locale"
                        ])
                    ]),
                    _ctx.$slots.right !== void 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_4$a, [
                        (0, _vue.renderSlot)(_ctx.$slots, "right")
                    ])) : (0, _vue.createCommentVNode)("v-if", true)
                ])
            ]),
        _: 3
    }, 16, [
        "modelValue",
        "rounded",
        "open-on-focus",
        "position",
        "loading",
        "inline",
        "editable",
        "expanded",
        "first-day-of-week",
        "rules-for-first-week",
        "date-formatter",
        "date-parser",
        "min-date",
        "max-date",
        "nearby-month-days",
        "icon",
        "icon-right",
        "icon-right-clickable",
        "icon-pack",
        "size",
        "placeholder",
        "horizontal-time-picker",
        "disabled",
        "mobile-native",
        "locale",
        "focusable",
        "append-to-body",
        "onFocus",
        "onBlur",
        "onActiveChange"
    ])) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_input, (0, _vue.mergeProps)({
        key: 1,
        ref: "input",
        type: "datetime-local",
        autocomplete: "off",
        "model-value": _ctx.formatNative(_ctx.computedValue),
        placeholder: _ctx.placeholder,
        size: _ctx.size,
        icon: _ctx.icon,
        "icon-pack": _ctx.iconPack,
        rounded: _ctx.rounded,
        loading: _ctx.loading,
        max: _ctx.formatNative(_ctx.maxDate),
        min: _ctx.formatNative(_ctx.minDate),
        disabled: _ctx.disabledOrUndefined,
        readonly: false
    }, _ctx.$attrs, {
        "use-html5-validation": _ctx.useHtml5Validation,
        onChange: _ctx.onChangeNativePicker,
        onFocus: _ctx.onFocus,
        onBlur: _ctx.onBlur
    }), null, 16, [
        "model-value",
        "placeholder",
        "size",
        "icon",
        "icon-pack",
        "rounded",
        "loading",
        "max",
        "min",
        "disabled",
        "use-html5-validation",
        "onChange",
        "onFocus",
        "onBlur"
    ]));
}
var Datetimepicker = /* @__PURE__ */ _export_sfc(_sfc_main$p, [
    [
        "render",
        _sfc_render$A
    ]
]);
const Plugin$u = {
    install (Vue) {
        registerComponent(Vue, Datetimepicker);
    }
};
const MODAL_SCROLLS = [
    "clip",
    "keep"
];
const MODAL_ARIA_ROLES = [
    "dialog",
    "alertdialog"
];
const Modal$1 = (0, _vue.defineComponent)({
    name: "BModal",
    directives: {
        trapFocus: directive$1
    },
    props: {
        modelValue: Boolean,
        component: [
            Object,
            Function,
            String
        ],
        content: {
            type: [
                String,
                Object,
                Array
            ]
        },
        programmatic: Boolean,
        props: Object,
        events: {
            type: Object,
            default () {
                return {};
            }
        },
        width: {
            type: [
                String,
                Number
            ],
            default: 960
        },
        hasModalCard: Boolean,
        animation: {
            type: String,
            default: "zoom-out"
        },
        canCancel: {
            type: [
                Array,
                Boolean
            ],
            default: ()=>{
                return config.defaultModalCanCancel;
            }
        },
        cancelCallback: {
            type: Function,
            default: ()=>{}
        },
        scroll: {
            type: String,
            default: ()=>{
                return config.defaultModalScroll ? config.defaultModalScroll : "clip";
            },
            validator: (value)=>{
                return MODAL_SCROLLS.indexOf(value) >= 0;
            }
        },
        fullScreen: Boolean,
        trapFocus: {
            type: Boolean,
            default: ()=>{
                return config.defaultTrapFocus;
            }
        },
        autoFocus: {
            type: Boolean,
            default: ()=>{
                return config.defaultAutoFocus;
            }
        },
        customClass: String,
        customContentClass: [
            String,
            Array,
            Object
        ],
        ariaRole: {
            type: String,
            validator: (value)=>{
                return MODAL_ARIA_ROLES.indexOf(value) >= 0;
            }
        },
        ariaModal: Boolean,
        ariaLabel: {
            type: String,
            validator: (value)=>{
                return Boolean(value);
            }
        },
        closeButtonAriaLabel: String,
        destroyOnHide: {
            type: Boolean,
            default: true
        },
        renderOnMounted: {
            type: Boolean,
            default: false
        }
    },
    emits: {
        "after-enter": ()=>true,
        "after-leave": ()=>true,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        cancel: (method)=>true,
        close: ()=>true,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        "update:modelValue": (active)=>true
    },
    data () {
        return {
            isActive: this.modelValue || false,
            savedScrollTop: null,
            newWidth: typeof this.width === "number" ? this.width + "px" : this.width,
            animating: !this.modelValue,
            destroyed: !(this.modelValue || this.renderOnMounted)
        };
    },
    computed: {
        cancelOptions () {
            return typeof this.canCancel === "boolean" ? this.canCancel ? config.defaultModalCanCancel : [] : this.canCancel;
        },
        showX () {
            return this.cancelOptions.indexOf("x") >= 0;
        },
        customStyle () {
            if (!this.fullScreen) return {
                maxWidth: this.newWidth
            };
            return null;
        }
    },
    watch: {
        modelValue (value) {
            this.isActive = value;
        },
        isActive (value) {
            if (value) this.destroyed = false;
            this.handleScroll();
            this.$nextTick(()=>{
                if (value && this.$el && this.$el.focus && this.autoFocus) this.$el.focus();
            });
        }
    },
    methods: {
        handleScroll () {
            if (typeof window === "undefined") return;
            if (this.scroll === "clip") {
                if (this.isActive) document.documentElement.classList.add("is-clipped");
                else document.documentElement.classList.remove("is-clipped");
                return;
            }
            this.savedScrollTop = !this.savedScrollTop ? document.documentElement.scrollTop : this.savedScrollTop;
            if (this.isActive) document.body.classList.add("is-noscroll");
            else document.body.classList.remove("is-noscroll");
            if (this.isActive) {
                document.body.style.top = `-${this.savedScrollTop}px`;
                return;
            }
            document.documentElement.scrollTop = this.savedScrollTop;
            document.body.style.top = "";
            this.savedScrollTop = null;
        },
        /*
    * Close the Modal if canCancel and call the cancelCallback prop (function).
    */ cancel (method) {
            if (this.cancelOptions.indexOf(method) < 0) return;
            this.$emit("cancel", method);
            this.cancelCallback.apply(null, [
                method
            ]);
            this.close();
        },
        /*
    * Call the cancelCallback prop (function).
    * Emit events, and destroy modal if it's programmatic.
    */ close () {
            this.$emit("close");
            this.$emit("update:modelValue", false);
            if (this.programmatic) {
                this.isActive = false;
                setTimeout(()=>{
                    removeElement(this.$el);
                }, 150);
            }
        },
        /*
    * Keypress event that is bound to the document.
    */ keyPress ({ key }) {
            if (this.isActive && (key === "Escape" || key === "Esc")) this.cancel("escape");
        },
        /*
    * Transition after-enter hook
    */ afterEnter () {
            this.animating = false;
            this.$emit("after-enter");
        },
        /*
    * Transition before-leave hook
    */ beforeLeave () {
            this.animating = true;
        },
        /*
    * Transition after-leave hook
    */ afterLeave () {
            if (this.destroyOnHide) this.destroyed = true;
            this.$emit("after-leave");
        }
    },
    created () {
        if (typeof window !== "undefined") document.addEventListener("keyup", this.keyPress);
    },
    mounted () {
        if (this.programmatic) {
            document.body.appendChild(this.$el);
            this.isActive = true;
        } else if (this.isActive) this.handleScroll();
    },
    beforeUnmount () {
        if (typeof window !== "undefined") {
            document.removeEventListener("keyup", this.keyPress);
            document.documentElement.classList.remove("is-clipped");
            const savedScrollTop = !this.savedScrollTop ? document.documentElement.scrollTop : this.savedScrollTop;
            document.body.classList.remove("is-noscroll");
            document.documentElement.scrollTop = savedScrollTop;
            document.body.style.top = "";
        }
    }
});
const _hoisted_1$u = [
    "role",
    "aria-label",
    "aria-modal"
];
const _hoisted_2$p = [
    "innerHTML"
];
const _hoisted_3$e = [
    "aria-label"
];
function _sfc_render$z(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_trap_focus = (0, _vue.resolveDirective)("trap-focus");
    return (0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.Transition), {
        name: _ctx.animation,
        onAfterEnter: _ctx.afterEnter,
        onBeforeLeave: _ctx.beforeLeave,
        onAfterLeave: _ctx.afterLeave
    }, {
        default: (0, _vue.withCtx)(()=>[
                !_ctx.destroyed ? (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                    key: 0,
                    class: (0, _vue.normalizeClass)([
                        "modal is-active",
                        [
                            {
                                "is-full-screen": _ctx.fullScreen
                            },
                            _ctx.customClass
                        ]
                    ]),
                    tabindex: "-1",
                    role: _ctx.ariaRole,
                    "aria-label": _ctx.ariaLabel,
                    "aria-modal": _ctx.ariaModal || void 0
                }, [
                    (0, _vue.createElementVNode)("div", {
                        class: "modal-background",
                        onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.cancel("outside"))
                    }),
                    (0, _vue.createElementVNode)("div", {
                        class: (0, _vue.normalizeClass)([
                            "animation-content",
                            [
                                {
                                    "modal-content": !_ctx.hasModalCard
                                },
                                _ctx.customContentClass
                            ]
                        ]),
                        style: (0, _vue.normalizeStyle)(_ctx.customStyle)
                    }, [
                        _ctx.component ? ((0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.resolveDynamicComponent)(_ctx.component), (0, _vue.mergeProps)({
                            key: 0
                        }, _ctx.props, (0, _vue.toHandlers)(_ctx.events), {
                            "can-cancel": _ctx.canCancel,
                            onClose: _ctx.close
                        }), null, 16, [
                            "can-cancel",
                            "onClose"
                        ])) : _ctx.content ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                            key: 1
                        }, [
                            (0, _vue.createCommentVNode)(" eslint-disable-next-line vue/no-v-html "),
                            (0, _vue.createElementVNode)("div", {
                                innerHTML: _ctx.content
                            }, null, 8, _hoisted_2$p)
                        ], 64)) : (0, _vue.renderSlot)(_ctx.$slots, "default", {
                            key: 2,
                            canCancel: _ctx.canCancel,
                            close: _ctx.close
                        }),
                        _ctx.showX ? (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                            key: 3,
                            type: "button",
                            class: "modal-close is-large",
                            "aria-label": _ctx.closeButtonAriaLabel,
                            onClick: _cache[1] || (_cache[1] = ($event)=>_ctx.cancel("x"))
                        }, null, 8, _hoisted_3$e)), [
                            [
                                (0, _vue.vShow),
                                !_ctx.animating
                            ]
                        ]) : (0, _vue.createCommentVNode)("v-if", true)
                    ], 6)
                ], 10, _hoisted_1$u)), [
                    [
                        (0, _vue.vShow),
                        _ctx.isActive
                    ],
                    [
                        _directive_trap_focus,
                        _ctx.trapFocus
                    ]
                ]) : (0, _vue.createCommentVNode)("v-if", true)
            ]),
        _: 3
    }, 8, [
        "name",
        "onAfterEnter",
        "onBeforeLeave",
        "onAfterLeave"
    ]);
}
var Modal = /* @__PURE__ */ _export_sfc(Modal$1, [
    [
        "render",
        _sfc_render$z
    ]
]);
var __defProp$7 = Object.defineProperty;
var __getOwnPropSymbols$7 = Object.getOwnPropertySymbols;
var __hasOwnProp$7 = Object.prototype.hasOwnProperty;
var __propIsEnum$7 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7 = (obj, key, value)=>key in obj ? __defProp$7(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues$7 = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp$7.call(b, prop)) __defNormalProp$7(a, prop, b[prop]);
    if (__getOwnPropSymbols$7) {
        for (var prop of __getOwnPropSymbols$7(b))if (__propIsEnum$7.call(b, prop)) __defNormalProp$7(a, prop, b[prop]);
    }
    return a;
};
const Dialog$1 = (0, _vue.defineComponent)({
    name: "BDialog",
    components: {
        BIcon,
        BButton
    },
    directives: {
        trapFocus: directive$1
    },
    extends: Modal,
    props: {
        title: String,
        message: [
            String,
            Array
        ],
        icon: String,
        iconPack: String,
        hasIcon: Boolean,
        type: {
            type: String,
            default: "is-primary"
        },
        size: String,
        confirmText: {
            type: String,
            default: ()=>{
                return config.defaultDialogConfirmText ? config.defaultDialogConfirmText : "OK";
            }
        },
        cancelText: {
            type: String,
            default: ()=>{
                return config.defaultDialogCancelText ? config.defaultDialogCancelText : "Cancel";
            }
        },
        hasInput: Boolean,
        // Used internally to know if it's prompt
        inputAttrs: {
            type: Object,
            default: ()=>({})
        },
        confirmCallback: {
            // I was not able to figure out how to specify the "self" type here
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            type: Function,
            default: ()=>{}
        },
        closeOnConfirm: {
            type: Boolean,
            default: true
        },
        container: {
            type: String,
            default: ()=>{
                return config.defaultContainerElement;
            }
        },
        focusOn: {
            type: String,
            default: "confirm"
        }
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any */ // second parameter is the dialog instance but typed any
        // because I was not able to figure out how to specify the "self" type here
        confirm: (value, dialog)=>true
    },
    data () {
        const prompt = this.hasInput ? this.inputAttrs.value || "" : "";
        return {
            prompt,
            isActive: false,
            validationMessage: "",
            isCompositing: false,
            isLoading: false
        };
    },
    computed: {
        // `safeInputAttrs` is a shallow copy of `inputAttrs` except for `value`
        // `value` should not be specified to `v-bind` of the input element
        // because it inhibits `v-model` of the input on Vue 3
        safeInputAttrs () {
            const attrs = __spreadValues$7({}, this.inputAttrs);
            delete attrs.value;
            if (typeof attrs.required === "undefined") attrs.required = true;
            return attrs;
        },
        dialogClass () {
            return [
                this.size,
                {
                    "has-custom-container": this.container !== null
                }
            ];
        },
        /*
    * Icon name (MDI) based on the type.
    */ iconByType () {
            switch(this.type){
                case "is-info":
                    return "information";
                case "is-success":
                    return "check-circle";
                case "is-warning":
                    return "alert";
                case "is-danger":
                    return "alert-circle";
                default:
                    return null;
            }
        },
        showCancel () {
            return this.cancelOptions.indexOf("button") >= 0;
        }
    },
    methods: {
        /*
    * If it's a prompt Dialog, validate the input.
    * Call the confirmCallback prop (function) and close the Dialog.
    */ confirm () {
            const input = this.$refs.input;
            if (input != null) {
                if (this.isCompositing) return;
                if (!input.checkValidity()) {
                    this.validationMessage = input.validationMessage;
                    this.$nextTick(()=>input.select());
                    return;
                }
            }
            this.$emit("confirm", this.prompt, this);
            this.confirmCallback(this.prompt, this);
            if (this.closeOnConfirm) this.close();
        },
        /*
    * Close the Dialog.
    */ close () {
            this.isActive = false;
            this.isLoading = false;
            setTimeout(()=>{
                removeElement(this.$el);
            }, 150);
        },
        /*
    * Start the Loading.
    */ startLoading () {
            this.isLoading = true;
        },
        /*
    * Cancel the Loading.
    */ cancelLoading () {
            this.isLoading = false;
        }
    },
    beforeMount () {
        if (typeof window !== "undefined") this.$nextTick(()=>{
            const container = document.querySelector(this.container) || document.body;
            container.appendChild(this.$el);
        });
    },
    mounted () {
        this.isActive = true;
        this.$nextTick(()=>{
            if (this.hasInput) this.$refs.input.focus();
            else if (this.focusOn === "cancel" && this.showCancel) this.$refs.cancelButton.$el.focus();
            else this.$refs.confirmButton.$el.focus();
        });
    }
});
const _hoisted_1$t = [
    "role",
    "aria-modal"
];
const _hoisted_2$o = {
    class: "modal-card animation-content"
};
const _hoisted_3$d = {
    key: 0,
    class: "modal-card-head"
};
const _hoisted_4$9 = {
    class: "modal-card-title"
};
const _hoisted_5$7 = {
    class: "media"
};
const _hoisted_6$4 = {
    key: 0,
    class: "media-left"
};
const _hoisted_7$4 = {
    class: "media-content"
};
const _hoisted_8$4 = [
    "innerHTML"
];
const _hoisted_9$3 = {
    key: 0,
    class: "field"
};
const _hoisted_10$2 = {
    class: "control"
};
const _hoisted_11$2 = {
    class: "help is-danger"
};
const _hoisted_12$2 = {
    class: "modal-card-foot"
};
function _sfc_render$y(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    const _component_b_button = (0, _vue.resolveComponent)("b-button");
    const _directive_trap_focus = (0, _vue.resolveDirective)("trap-focus");
    return (0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.Transition), {
        name: _ctx.animation
    }, {
        default: (0, _vue.withCtx)(()=>[
                _ctx.isActive ? (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                    key: 0,
                    class: (0, _vue.normalizeClass)([
                        "dialog modal is-active",
                        _ctx.dialogClass
                    ]),
                    role: _ctx.ariaRole,
                    "aria-modal": _ctx.ariaModal
                }, [
                    (0, _vue.createElementVNode)("div", {
                        class: "modal-background",
                        onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.cancel("outside"))
                    }),
                    (0, _vue.createElementVNode)("div", _hoisted_2$o, [
                        _ctx.title ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("header", _hoisted_3$d, [
                            (0, _vue.createElementVNode)("p", _hoisted_4$9, (0, _vue.toDisplayString)(_ctx.title), 1)
                        ])) : (0, _vue.createCommentVNode)("v-if", true),
                        (0, _vue.createElementVNode)("section", {
                            class: (0, _vue.normalizeClass)([
                                "modal-card-body",
                                {
                                    "is-titleless": !_ctx.title,
                                    "is-flex": _ctx.hasIcon
                                }
                            ])
                        }, [
                            (0, _vue.createElementVNode)("div", _hoisted_5$7, [
                                _ctx.hasIcon && (_ctx.icon || _ctx.iconByType) ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_6$4, [
                                    (0, _vue.createVNode)(_component_b_icon, {
                                        icon: _ctx.icon ? _ctx.icon : _ctx.iconByType,
                                        pack: _ctx.iconPack,
                                        type: _ctx.type,
                                        both: !_ctx.icon,
                                        size: "is-large"
                                    }, null, 8, [
                                        "icon",
                                        "pack",
                                        "type",
                                        "both"
                                    ])
                                ])) : (0, _vue.createCommentVNode)("v-if", true),
                                (0, _vue.createElementVNode)("div", _hoisted_7$4, [
                                    (0, _vue.createElementVNode)("p", null, [
                                        _ctx.$slots.default ? (0, _vue.renderSlot)(_ctx.$slots, "default", {
                                            key: 0
                                        }) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                            key: 1
                                        }, [
                                            (0, _vue.createCommentVNode)(" eslint-disable-next-line vue/no-v-html "),
                                            (0, _vue.createElementVNode)("div", {
                                                innerHTML: _ctx.message
                                            }, null, 8, _hoisted_8$4)
                                        ], 64))
                                    ]),
                                    _ctx.hasInput ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_9$3, [
                                        (0, _vue.createElementVNode)("div", _hoisted_10$2, [
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", (0, _vue.mergeProps)({
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>_ctx.prompt = $event),
                                                class: [
                                                    "input",
                                                    {
                                                        "is-danger": _ctx.validationMessage
                                                    }
                                                ],
                                                ref: "input"
                                            }, _ctx.safeInputAttrs, {
                                                onCompositionstart: _cache[2] || (_cache[2] = ($event)=>_ctx.isCompositing = true),
                                                onCompositionend: _cache[3] || (_cache[3] = ($event)=>_ctx.isCompositing = false),
                                                onKeydown: _cache[4] || (_cache[4] = (0, _vue.withKeys)((...args)=>_ctx.confirm && _ctx.confirm(...args), [
                                                    "enter"
                                                ]))
                                            }), null, 16), [
                                                [
                                                    (0, _vue.vModelDynamic),
                                                    _ctx.prompt
                                                ]
                                            ])
                                        ]),
                                        (0, _vue.createElementVNode)("p", _hoisted_11$2, (0, _vue.toDisplayString)(_ctx.validationMessage), 1)
                                    ])) : (0, _vue.createCommentVNode)("v-if", true)
                                ])
                            ])
                        ], 2),
                        (0, _vue.createElementVNode)("footer", _hoisted_12$2, [
                            _ctx.showCancel ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_button, {
                                key: 0,
                                ref: "cancelButton",
                                disabled: _ctx.isLoading,
                                onClick: _cache[5] || (_cache[5] = ($event)=>_ctx.cancel("button"))
                            }, {
                                default: (0, _vue.withCtx)(()=>[
                                        (0, _vue.createTextVNode)((0, _vue.toDisplayString)(_ctx.cancelText), 1)
                                    ]),
                                _: 1
                            }, 8, [
                                "disabled"
                            ])) : (0, _vue.createCommentVNode)("v-if", true),
                            (0, _vue.createVNode)(_component_b_button, {
                                type: _ctx.type,
                                ref: "confirmButton",
                                loading: _ctx.isLoading,
                                onClick: _ctx.confirm
                            }, {
                                default: (0, _vue.withCtx)(()=>[
                                        (0, _vue.createTextVNode)((0, _vue.toDisplayString)(_ctx.confirmText), 1)
                                    ]),
                                _: 1
                            }, 8, [
                                "type",
                                "loading",
                                "onClick"
                            ])
                        ])
                    ])
                ], 10, _hoisted_1$t)), [
                    [
                        _directive_trap_focus,
                        _ctx.trapFocus
                    ]
                ]) : (0, _vue.createCommentVNode)("v-if", true)
            ]),
        _: 3
    }, 8, [
        "name"
    ]);
}
var Dialog = /* @__PURE__ */ _export_sfc(Dialog$1, [
    [
        "render",
        _sfc_render$y
    ]
]);
var __defProp$6 = Object.defineProperty;
var __defProps$6 = Object.defineProperties;
var __getOwnPropDescs$6 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6 = (obj, key, value)=>key in obj ? __defProp$6(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues$6 = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp$6.call(b, prop)) __defNormalProp$6(a, prop, b[prop]);
    if (__getOwnPropSymbols$6) {
        for (var prop of __getOwnPropSymbols$6(b))if (__propIsEnum$6.call(b, prop)) __defNormalProp$6(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps$6 = (a, b)=>__defProps$6(a, __getOwnPropDescs$6(b));
var __publicField$5 = (obj, key, value)=>__defNormalProp$6(obj, key + "", value);
function open(propsData, app) {
    let slot;
    if (Array.isArray(propsData.message)) {
        slot = propsData.message;
        delete propsData.message;
    }
    function createDialog(onConfirm, onCancel) {
        const container = document.createElement("div");
        const vueInstance = (0, _vue.createApp)({
            data () {
                return {
                    dialogVNode: null
                };
            },
            methods: {
                close () {
                    const dialog = getComponentFromVNode(this.dialogVNode);
                    if (dialog) dialog.close();
                },
                startLoading () {
                    const dialog = getComponentFromVNode(this.dialogVNode);
                    if (dialog) dialog.startLoading();
                },
                cancelLoading () {
                    const dialog = getComponentFromVNode(this.dialogVNode);
                    if (dialog) dialog.cancelLoading();
                }
            },
            render () {
                this.dialogVNode = (0, _vue.h)(Dialog, __spreadProps$6(__spreadValues$6({}, propsData), {
                    // intentionally overrides propsData.onConfirm
                    // to prevent propsData.onConfirm from receiving a "confirm" event
                    onConfirm: (value)=>{
                        if (onConfirm != null) onConfirm(value);
                    },
                    // intentionally override propsData.onCancel
                    // to prevent propsData.onCancel from receiving a "cancel" event
                    onCancel: (method)=>{
                        if (onCancel != null) onCancel(method);
                        vueInstance.unmount();
                    },
                    confirmCallback: (value, dialog)=>{
                        if (propsData.onConfirm != null) propsData.onConfirm(value, dialog);
                    },
                    cancelCallback: (method)=>{
                        if (propsData.onCancel != null) propsData.onCancel(method);
                    }
                }), slot ? {
                    default: ()=>slot
                } : void 0);
                return this.dialogVNode;
            }
        });
        if (app) copyAppContext(app, vueInstance);
        return vueInstance.mount(container);
    }
    if (!config.defaultProgrammaticPromise) return createDialog();
    else return new Promise((resolve)=>{
        const dialog = createDialog((event)=>resolve({
                result: event || true,
                dialog
            }), ()=>resolve({
                result: false,
                dialog
            }));
    });
}
class DialogProgrammatic {
    constructor(app){
        __publicField$5(this, "app");
        this.app = app;
    }
    alert(params) {
        let newParams;
        if (typeof params === "string") newParams = {
            message: params
        };
        else newParams = params;
        newParams = __spreadValues$6({
            canCancel: false
        }, newParams);
        return open(newParams, this.app);
    }
    confirm(params) {
        return open(params, this.app);
    }
    prompt(params) {
        return open(__spreadValues$6({
            hasInput: true
        }, params), this.app);
    }
}
const Plugin$t = {
    install (Vue) {
        registerComponent(Vue, Dialog);
        registerComponentProgrammatic(Vue, "dialog", new DialogProgrammatic(Vue));
    }
};
const Plugin$s = {
    install (Vue) {
        registerComponent(Vue, Field);
    }
};
const Plugin$r = {
    install (Vue) {
        registerComponent(Vue, BIcon);
    }
};
const Plugin$q = {
    install (Vue) {
        registerComponent(Vue, Image$1);
    }
};
const isSSR = typeof window === "undefined";
const HTMLElement = isSSR ? Object : window.HTMLElement;
const File = isSSR ? Object : window.File;
const Loading = (0, _vue.defineComponent)({
    name: "BLoading",
    props: {
        modelValue: Boolean,
        programmatic: Boolean,
        container: [
            Object,
            Function,
            HTMLElement
        ],
        isFullPage: {
            type: Boolean,
            default: true
        },
        animation: {
            type: String,
            default: "fade"
        },
        canCancel: {
            type: Boolean,
            default: false
        },
        onCancel: {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            type: Function,
            default: ()=>{}
        }
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars */ close: ()=>true,
        "update:is-full-page": (_flag)=>true,
        "update:modelValue": (_flag)=>true
    },
    data () {
        return {
            isActive: this.modelValue || false,
            displayInFullPage: this.isFullPage
        };
    },
    watch: {
        modelValue (value) {
            this.isActive = value;
        },
        isFullPage (value) {
            this.displayInFullPage = value;
        }
    },
    methods: {
        /*
    * Close the Modal if canCancel.
    */ cancel () {
            if (!this.canCancel || !this.isActive) return;
            this.close();
        },
        /*
    * Emit events, and destroy modal if it's programmatic.
    */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
        close (...args) {
            this.onCancel.apply(null, args);
            this.$emit("close");
            this.$emit("update:modelValue", false);
            if (this.programmatic) {
                this.isActive = false;
                setTimeout(()=>{
                    removeElement(this.$el);
                }, 150);
            }
        },
        /*
    * Keypress event that is bound to the document.
    */ keyPress ({ key }) {
            if (key === "Escape" || key === "Esc") this.cancel();
        }
    },
    created () {
        if (typeof window !== "undefined") document.addEventListener("keyup", this.keyPress);
    },
    mounted () {
        if (this.programmatic) {
            if (!this.container) document.body.appendChild(this.$el);
            else {
                this.displayInFullPage = false;
                this.$emit("update:is-full-page", false);
                this.container.appendChild(this.$el);
            }
            this.isActive = true;
        }
    },
    beforeUnmount () {
        if (typeof window !== "undefined") document.removeEventListener("keyup", this.keyPress);
    }
});
const _hoisted_1$s = /* @__PURE__ */ (0, _vue.createElementVNode)("div", {
    class: "loading-icon"
}, null, -1);
function _sfc_render$x(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.Transition), {
        name: _ctx.animation
    }, {
        default: (0, _vue.withCtx)(()=>[
                _ctx.isActive ? (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                    key: 0,
                    class: (0, _vue.normalizeClass)([
                        "loading-overlay is-active",
                        {
                            "is-full-page": _ctx.displayInFullPage
                        }
                    ])
                }, [
                    (0, _vue.createElementVNode)("div", {
                        class: "loading-background",
                        onClick: _cache[0] || (_cache[0] = (...args)=>_ctx.cancel && _ctx.cancel(...args))
                    }),
                    (0, _vue.renderSlot)(_ctx.$slots, "default", {}, ()=>[
                            _hoisted_1$s
                        ])
                ], 2)), [
                    [
                        (0, _vue.vShow),
                        _ctx.isActive
                    ]
                ]) : (0, _vue.createCommentVNode)("v-if", true)
            ]),
        _: 3
    }, 8, [
        "name"
    ]);
}
var BLoading = /* @__PURE__ */ _export_sfc(Loading, [
    [
        "render",
        _sfc_render$x
    ]
]);
var __defProp$5 = Object.defineProperty;
var __defProps$5 = Object.defineProperties;
var __getOwnPropDescs$5 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = (obj, key, value)=>key in obj ? __defProp$5(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues$5 = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp$5.call(b, prop)) __defNormalProp$5(a, prop, b[prop]);
    if (__getOwnPropSymbols$5) {
        for (var prop of __getOwnPropSymbols$5(b))if (__propIsEnum$5.call(b, prop)) __defNormalProp$5(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps$5 = (a, b)=>__defProps$5(a, __getOwnPropDescs$5(b));
var __publicField$4 = (obj, key, value)=>__defNormalProp$5(obj, key + "", value);
class LoadingProgrammatic {
    constructor(app){
        __publicField$4(this, "app");
        this.app = app;
    }
    open(params) {
        const propsData = params;
        const container = document.createElement("div");
        const vueInstance = (0, _vue.createApp)({
            data () {
                return {
                    loadingVNode: null
                };
            },
            methods: {
                close () {
                    const loading = getComponentFromVNode(this.loadingVNode);
                    if (loading) loading.close();
                }
            },
            render () {
                this.loadingVNode = (0, _vue.h)(BLoading, __spreadProps$5(__spreadValues$5({}, propsData), {
                    programmatic: true,
                    onClose (...args) {
                        if (propsData.onClose) propsData.onClose(...args);
                        setTimeout(()=>{
                            vueInstance.unmount();
                        }, 150);
                    }
                }));
                return this.loadingVNode;
            }
        });
        if (this.app) copyAppContext(this.app, vueInstance);
        return vueInstance.mount(container);
    }
}
const Plugin$p = {
    install (Vue) {
        registerComponent(Vue, BLoading);
        registerComponentProgrammatic(Vue, "loading", new LoadingProgrammatic(Vue));
    }
};
var MenuItemContainerMixin = (0, _vue.defineComponent)({
    provide () {
        return {
            BMenuItemContainer: this
        };
    },
    data () {
        return {
            menuItems: []
        };
    },
    methods: {
        appendMenuItem (item) {
            this.menuItems.push(item);
        },
        removeMenuItem (item) {
            const index = this.menuItems.indexOf(item);
            if (index !== -1) this.menuItems.splice(index, 1);
        }
    }
});
var _sfc_main$o = (0, _vue.defineComponent)({
    name: "BMenu",
    mixins: [
        MenuItemContainerMixin
    ],
    props: {
        accordion: {
            type: Boolean,
            default: true
        },
        activable: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            _isMenu: true
        };
    }
});
const _hoisted_1$r = {
    class: "menu"
};
function _sfc_render$w(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1$r, [
        (0, _vue.renderSlot)(_ctx.$slots, "default")
    ]);
}
var Menu = /* @__PURE__ */ _export_sfc(_sfc_main$o, [
    [
        "render",
        _sfc_render$w
    ]
]);
var _sfc_main$n = (0, _vue.defineComponent)({
    name: "BMenuList",
    components: {
        BIcon
    },
    props: {
        label: String,
        icon: String,
        iconPack: String,
        ariaRole: {
            type: String,
            default: ""
        },
        size: {
            type: String,
            default: "is-small"
        }
    }
});
const _hoisted_1$q = {
    key: 0,
    class: "menu-label"
};
const _hoisted_2$n = [
    "role"
];
function _sfc_render$v(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, [
        _ctx.label || _ctx.$slots.label ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_1$q, [
            _ctx.label ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                key: 0
            }, [
                _ctx.icon ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                    key: 0
                }, [
                    (0, _vue.createVNode)(_component_b_icon, {
                        icon: _ctx.icon,
                        pack: _ctx.iconPack,
                        size: _ctx.size
                    }, null, 8, [
                        "icon",
                        "pack",
                        "size"
                    ]),
                    (0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)(_ctx.label), 1)
                ], 64)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                    key: 1
                }, [
                    (0, _vue.createTextVNode)((0, _vue.toDisplayString)(_ctx.label), 1)
                ], 64))
            ], 64)) : (0, _vue.renderSlot)(_ctx.$slots, "label", {
                key: 1
            })
        ])) : (0, _vue.createCommentVNode)("v-if", true),
        (0, _vue.createElementVNode)("ul", {
            class: "menu-list",
            role: _ctx.ariaRole === "menu" ? _ctx.ariaRole : void 0
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "default")
        ], 8, _hoisted_2$n)
    ], 64);
}
var MenuList = /* @__PURE__ */ _export_sfc(_sfc_main$n, [
    [
        "render",
        _sfc_render$v
    ]
]);
var _sfc_main$m = (0, _vue.defineComponent)({
    name: "BMenuItem",
    components: {
        BIcon
    },
    mixins: [
        CompatFallthroughMixin,
        MenuItemContainerMixin
    ],
    inject: {
        parent: {
            from: "BMenuItemContainer",
            default: null
        }
    },
    // deprecated, to replace with default 'value' in the next breaking change
    props: {
        label: String,
        modelValue: Boolean,
        expanded: Boolean,
        disabled: Boolean,
        iconPack: String,
        icon: String,
        animation: {
            type: String,
            default: "slide"
        },
        tag: {
            type: [
                String,
                Object
            ],
            default: "a",
            validator: (value)=>{
                return typeof value === "object" || config.defaultLinkTags.indexOf(value) >= 0;
            }
        },
        ariaRole: {
            type: String,
            default: ""
        },
        size: {
            type: String,
            default: "is-small"
        }
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars */ "update:modelValue": (_isActive)=>true,
        "update:expanded": (_isExpanded)=>true
    },
    data () {
        return {
            newActive: this.modelValue,
            newExpanded: this.expanded
        };
    },
    computed: {
        ariaRoleMenu () {
            return this.ariaRole === "menuitem" ? this.ariaRole : void 0;
        }
    },
    watch: {
        modelValue (value) {
            this.newActive = value;
        },
        expanded (value) {
            this.newExpanded = value;
        }
    },
    methods: {
        onClick () {
            if (this.disabled) return;
            const menu = this.getMenu();
            this.reset(this.parent, menu);
            this.newExpanded = this.$props.expanded || !this.newExpanded;
            this.$emit("update:expanded", this.newExpanded);
            if (menu && menu.activable) {
                this.newActive = true;
                this.$emit("update:modelValue", this.newActive);
            }
        },
        reset (parent, menu) {
            if (parent == null) return;
            parent.menuItems.forEach((item)=>{
                if (item !== this) {
                    this.reset(item, menu);
                    if (!parent.$data._isMenu || parent.$data._isMenu && parent.accordion) {
                        item.newExpanded = false;
                        item.$emit("update:expanded", item.newExpanded);
                    }
                    if (menu && menu.activable) {
                        item.newActive = false;
                        item.$emit("update:modelValue", item.newActive);
                    }
                }
            });
        },
        getMenu () {
            let parent = this.parent;
            while(parent && !parent.$data._isMenu)parent = parent.parent;
            return parent;
        }
    },
    mounted () {
        if (this.parent) this.parent.appendMenuItem(this);
    },
    beforeUnmount () {
        if (this.parent) this.parent.removeMenuItem(this);
    }
});
const _hoisted_1$p = [
    "role"
];
const _hoisted_2$m = {
    key: 1
};
function _sfc_render$u(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", (0, _vue.mergeProps)({
        role: _ctx.ariaRoleMenu
    }, _ctx.rootAttrs), [
        ((0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.resolveDynamicComponent)(_ctx.tag), (0, _vue.mergeProps)(_ctx.fallthroughAttrs, {
            class: {
                "is-active": _ctx.newActive,
                "is-expanded": _ctx.newExpanded,
                "is-disabled": _ctx.disabled,
                "icon-text": _ctx.icon
            },
            onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.onClick())
        }), {
            default: (0, _vue.withCtx)(()=>[
                    _ctx.icon ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
                        key: 0,
                        icon: _ctx.icon,
                        pack: _ctx.iconPack,
                        size: _ctx.size
                    }, null, 8, [
                        "icon",
                        "pack",
                        "size"
                    ])) : (0, _vue.createCommentVNode)("v-if", true),
                    _ctx.label ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_2$m, (0, _vue.toDisplayString)(_ctx.label), 1)) : (0, _vue.renderSlot)(_ctx.$slots, "label", {
                        key: 2,
                        expanded: _ctx.newExpanded,
                        active: _ctx.newActive
                    })
                ]),
            _: 3
        }, 16, [
            "class"
        ])),
        (0, _vue.createCommentVNode)(" sub menu items "),
        _ctx.$slots.default ? ((0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.Transition), {
            key: 0,
            name: _ctx.animation,
            persisted: ""
        }, {
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("ul", null, [
                        (0, _vue.renderSlot)(_ctx.$slots, "default")
                    ], 512), [
                        [
                            (0, _vue.vShow),
                            _ctx.newExpanded
                        ]
                    ])
                ]),
            _: 3
        }, 8, [
            "name"
        ])) : (0, _vue.createCommentVNode)("v-if", true)
    ], 16, _hoisted_1$p);
}
var MenuItem = /* @__PURE__ */ _export_sfc(_sfc_main$m, [
    [
        "render",
        _sfc_render$u
    ]
]);
const Plugin$o = {
    install (Vue) {
        registerComponent(Vue, Menu);
        registerComponent(Vue, MenuList, "BMenuList");
        registerComponent(Vue, MenuItem);
    }
};
var MessageMixin = (0, _vue.defineComponent)({
    props: {
        modelValue: {
            type: Boolean,
            default: true
        },
        title: String,
        closable: {
            type: Boolean,
            default: true
        },
        message: String,
        type: String,
        hasIcon: Boolean,
        size: String,
        icon: String,
        iconPack: String,
        iconSize: String,
        autoClose: {
            type: Boolean,
            default: false
        },
        duration: {
            type: Number,
            default: 2e3
        },
        progressBar: {
            type: Boolean,
            default: false
        }
    },
    emits: {
        click: ()=>true,
        close: ()=>true,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        "update:modelValue": (value)=>true
    },
    data () {
        return {
            isActive: this.modelValue,
            remainingTime: this.duration / 1e3,
            // in seconds
            newIconSize: this.iconSize || this.size || "is-large",
            timer: void 0
        };
    },
    computed: {
        /*
     * Icon name (MDI) based on type.
     */ computedIcon () {
            if (this.icon) return this.icon;
            switch(this.type){
                case "is-info":
                    return "information";
                case "is-success":
                    return "check-circle";
                case "is-warning":
                    return "alert";
                case "is-danger":
                    return "alert-circle";
                default:
                    return null;
            }
        }
    },
    watch: {
        modelValue (value) {
            this.isActive = value;
        },
        isActive (value) {
            if (value) {
                this.setAutoClose();
                this.setDurationProgress();
            } else if (this.timer) clearTimeout(this.timer);
        }
    },
    methods: {
        /*
     * Close the Message and emit events.
     */ close () {
            this.isActive = false;
            this.resetDurationProgress();
            this.$emit("close");
            this.$emit("update:modelValue", false);
        },
        click () {
            this.$emit("click");
        },
        /*
     * Set timer to auto close message
     */ setAutoClose () {
            if (this.autoClose) this.timer = setTimeout(()=>{
                if (this.isActive) this.close();
            }, this.duration);
        },
        setDurationProgress () {
            if (this.progressBar || this.autoClose) this.$buefy.globalNoticeInterval = setInterval(()=>{
                if (this.remainingTime !== 0) this.remainingTime -= 1;
                else this.resetDurationProgress();
            }, 1e3);
        },
        resetDurationProgress () {
            setTimeout(()=>{
                this.remainingTime = this.duration / 1e3;
                clearInterval(this.$buefy.globalNoticeInterval);
            }, 100);
        }
    },
    mounted () {
        this.setAutoClose();
    }
});
const PROGRESS_INJECTION_KEY = Symbol("bprogress");
const Progress$1 = (0, _vue.defineComponent)({
    name: "BProgress",
    provide () {
        return {
            [PROGRESS_INJECTION_KEY]: this
        };
    },
    props: {
        type: {
            type: [
                String,
                Object
            ],
            default: "is-darkgrey"
        },
        size: {
            type: String
        },
        rounded: {
            type: Boolean,
            default: true
        },
        value: {
            type: Number,
            default: void 0
        },
        max: {
            type: Number,
            default: 100
        },
        showValue: {
            type: Boolean,
            default: false
        },
        format: {
            type: String,
            default: "raw",
            validator: (value)=>{
                return [
                    "raw",
                    "percent"
                ].indexOf(value) >= 0;
            }
        },
        precision: {
            type: Number,
            default: 2
        },
        keepTrailingZeroes: {
            type: Boolean,
            default: false
        },
        locale: {
            type: [
                String,
                Array
            ],
            default: ()=>{
                return config.defaultLocale;
            },
            validator: (value)=>{
                if (Array.isArray(value)) return value.every((item)=>typeof item === "string");
                return typeof value === "string";
            }
        }
    },
    computed: {
        isIndeterminate () {
            return this.value === void 0 || this.value === null;
        },
        newType () {
            return [
                this.size,
                this.type,
                {
                    "is-more-than-half": this.value && this.value > this.max / 2
                }
            ];
        },
        newValue () {
            return this.calculateValue(this.value);
        },
        isNative () {
            return this.$slots.bar === void 0;
        },
        wrapperClasses () {
            return {
                "is-not-native": !this.isNative,
                [this.size === void 0 ? "" : this.size]: typeof this.size === "string" && !this.isNative
            };
        }
    },
    watch: {
        /*
     * When value is changed back to undefined, value of native progress get reset to 0.
     * Need to add and remove the value attribute to have the indeterminate or not.
     */ isIndeterminate (indeterminate) {
            this.$nextTick(()=>{
                if (this.$refs.progress) {
                    if (indeterminate) this.$refs.progress.removeAttribute("value");
                    else this.$refs.progress.setAttribute("value", this.value.toString());
                }
            });
        }
    },
    methods: {
        calculateValue (value) {
            if (value === void 0 || value === null || isNaN(value)) return void 0;
            const minimumFractionDigits = this.keepTrailingZeroes ? this.precision : 0;
            const maximumFractionDigits = this.precision;
            if (this.format === "percent") return new Intl.NumberFormat(this.locale, {
                style: "percent",
                minimumFractionDigits,
                maximumFractionDigits
            }).format(value / this.max);
            return new Intl.NumberFormat(this.locale, {
                minimumFractionDigits,
                maximumFractionDigits
            }).format(value);
        }
    }
});
const _hoisted_1$o = [
    "max",
    "value"
];
const _hoisted_2$l = {
    key: 2,
    class: "progress-value"
};
function _sfc_render$t(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "progress-wrapper",
            [
                _ctx.wrapperClasses,
                {
                    "is-squared": !_ctx.rounded
                }
            ]
        ])
    }, [
        _ctx.isNative ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("progress", {
            key: 0,
            ref: "progress",
            class: (0, _vue.normalizeClass)([
                "progress",
                [
                    _ctx.newType,
                    {
                        "is-squared": !_ctx.rounded
                    }
                ]
            ]),
            max: _ctx.max,
            value: _ctx.value
        }, (0, _vue.toDisplayString)(_ctx.newValue), 11, _hoisted_1$o)) : (0, _vue.renderSlot)(_ctx.$slots, "bar", {
            key: 1
        }),
        _ctx.isNative && _ctx.showValue ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_2$l, [
            (0, _vue.renderSlot)(_ctx.$slots, "default", {}, ()=>[
                    (0, _vue.createTextVNode)((0, _vue.toDisplayString)(_ctx.newValue), 1)
                ])
        ])) : (0, _vue.createCommentVNode)("v-if", true)
    ], 2);
}
var Progress = /* @__PURE__ */ _export_sfc(Progress$1, [
    [
        "render",
        _sfc_render$t
    ]
]);
const Message$1 = (0, _vue.defineComponent)({
    name: "BMessage",
    components: {
        BIcon,
        BProgress: Progress
    },
    mixins: [
        MessageMixin
    ],
    props: {
        ariaCloseLabel: String
    }
});
const _hoisted_1$n = {
    key: 0,
    class: "message-header"
};
const _hoisted_2$k = {
    key: 0
};
const _hoisted_3$c = {
    key: 1
};
const _hoisted_4$8 = [
    "aria-label"
];
const _hoisted_5$6 = {
    key: 1,
    class: "message-body"
};
const _hoisted_6$3 = {
    class: "media"
};
const _hoisted_7$3 = {
    key: 0,
    class: "media-left"
};
const _hoisted_8$3 = {
    class: "media-content"
};
function _sfc_render$s(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    const _component_b_progress = (0, _vue.resolveComponent)("b-progress");
    return (0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.Transition), {
        name: "fade",
        persisted: ""
    }, {
        default: (0, _vue.withCtx)(()=>[
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("article", {
                    class: (0, _vue.normalizeClass)([
                        "message",
                        [
                            _ctx.type,
                            _ctx.size
                        ]
                    ])
                }, [
                    _ctx.$slots.header || _ctx.title ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("header", _hoisted_1$n, [
                        _ctx.$slots.header ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_2$k, [
                            (0, _vue.renderSlot)(_ctx.$slots, "header")
                        ])) : _ctx.title ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_3$c, (0, _vue.toDisplayString)(_ctx.title), 1)) : (0, _vue.createCommentVNode)("v-if", true),
                        _ctx.closable ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                            key: 2,
                            type: "button",
                            class: "delete",
                            onClick: _cache[0] || (_cache[0] = (...args)=>_ctx.close && _ctx.close(...args)),
                            "aria-label": _ctx.ariaCloseLabel
                        }, null, 8, _hoisted_4$8)) : (0, _vue.createCommentVNode)("v-if", true)
                    ])) : (0, _vue.createCommentVNode)("v-if", true),
                    _ctx.$slots.default ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("section", _hoisted_5$6, [
                        (0, _vue.createElementVNode)("div", _hoisted_6$3, [
                            _ctx.computedIcon && _ctx.hasIcon ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_7$3, [
                                (0, _vue.createVNode)(_component_b_icon, {
                                    icon: _ctx.computedIcon,
                                    pack: _ctx.iconPack,
                                    class: (0, _vue.normalizeClass)(_ctx.type),
                                    both: "",
                                    size: _ctx.newIconSize
                                }, null, 8, [
                                    "icon",
                                    "pack",
                                    "class",
                                    "size"
                                ])
                            ])) : (0, _vue.createCommentVNode)("v-if", true),
                            (0, _vue.createElementVNode)("div", _hoisted_8$3, [
                                (0, _vue.renderSlot)(_ctx.$slots, "default")
                            ])
                        ])
                    ])) : (0, _vue.createCommentVNode)("v-if", true),
                    _ctx.progressBar ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_progress, {
                        key: 2,
                        class: "auto-close-progress",
                        value: _ctx.remainingTime - 1,
                        max: _ctx.duration / 1e3 - 1,
                        type: _ctx.type,
                        rounded: false
                    }, null, 8, [
                        "value",
                        "max",
                        "type"
                    ])) : (0, _vue.createCommentVNode)("v-if", true)
                ], 2), [
                    [
                        (0, _vue.vShow),
                        _ctx.isActive
                    ]
                ])
            ]),
        _: 3
    });
}
var Message = /* @__PURE__ */ _export_sfc(Message$1, [
    [
        "render",
        _sfc_render$s
    ]
]);
const Plugin$n = {
    install (Vue) {
        registerComponent(Vue, Message);
    }
};
var __defProp$4 = Object.defineProperty;
var __defProps$4 = Object.defineProperties;
var __getOwnPropDescs$4 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = (obj, key, value)=>key in obj ? __defProp$4(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues$4 = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
    if (__getOwnPropSymbols$4) {
        for (var prop of __getOwnPropSymbols$4(b))if (__propIsEnum$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps$4 = (a, b)=>__defProps$4(a, __getOwnPropDescs$4(b));
var __publicField$3 = (obj, key, value)=>__defNormalProp$4(obj, key + "", value);
class ModalProgrammatic {
    constructor(app){
        __publicField$3(this, "app");
        this.app = app;
    }
    open(params) {
        if (typeof params === "string") params = {
            content: params
        };
        let slot;
        if (Array.isArray(params.content)) {
            slot = params.content;
            delete params.content;
        }
        const propsData = params;
        const container = document.createElement("div");
        const vueInstance = (0, _vue.createApp)({
            data () {
                return {
                    modalVNode: null
                };
            },
            methods: {
                close () {
                    const modal = getComponentFromVNode(this.modalVNode);
                    if (modal) modal.close();
                }
            },
            render () {
                this.modalVNode = (0, _vue.h)(Modal, __spreadProps$4(__spreadValues$4({}, propsData), {
                    programmatic: true,
                    onClose: ()=>{
                        vueInstance.unmount();
                    },
                    // intentionally overrides propsData.onCancel
                    // to prevent propsData.onCancel from receiving a "cancel" event
                    onCancel: ()=>{},
                    cancelCallback: (method)=>{
                        if (propsData.onCancel != null) propsData.onCancel(method);
                    }
                }), slot ? {
                    default: ()=>slot
                } : void 0);
                return this.modalVNode;
            }
        });
        if (this.app) copyAppContext(this.app, vueInstance);
        return vueInstance.mount(container);
    }
}
const Plugin$m = {
    install (Vue) {
        registerComponent(Vue, Modal);
        registerComponentProgrammatic(Vue, "modal", new ModalProgrammatic(Vue));
    }
};
const Notification$1 = (0, _vue.defineComponent)({
    name: "BNotification",
    components: {
        BIcon,
        // directly registers Progress
        // in case Notification is programmatically opened
        BProgress: Progress
    },
    mixins: [
        MessageMixin
    ],
    props: {
        position: String,
        ariaCloseLabel: String,
        animation: {
            type: String,
            default: "fade"
        }
    }
});
const _hoisted_1$m = [
    "aria-label"
];
const _hoisted_2$j = {
    key: 1,
    class: "media"
};
const _hoisted_3$b = {
    key: 0,
    class: "media-left"
};
const _hoisted_4$7 = {
    class: "media-content"
};
const _hoisted_5$5 = [
    "innerHTML"
];
function _sfc_render$r(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    const _component_b_progress = (0, _vue.resolveComponent)("b-progress");
    return (0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.Transition), {
        name: _ctx.animation,
        persisted: ""
    }, {
        default: (0, _vue.withCtx)(()=>[
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("article", {
                    class: (0, _vue.normalizeClass)([
                        "notification",
                        [
                            _ctx.type,
                            _ctx.position
                        ]
                    ]),
                    onClick: _cache[1] || (_cache[1] = (...args)=>_ctx.click && _ctx.click(...args))
                }, [
                    _ctx.closable ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                        key: 0,
                        class: "delete",
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = (...args)=>_ctx.close && _ctx.close(...args)),
                        "aria-label": _ctx.ariaCloseLabel
                    }, null, 8, _hoisted_1$m)) : (0, _vue.createCommentVNode)("v-if", true),
                    _ctx.$slots.default || _ctx.message ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_2$j, [
                        _ctx.computedIcon && _ctx.hasIcon ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_3$b, [
                            (0, _vue.createVNode)(_component_b_icon, {
                                icon: _ctx.computedIcon,
                                pack: _ctx.iconPack,
                                size: _ctx.newIconSize,
                                both: "",
                                "aria-hidden": ""
                            }, null, 8, [
                                "icon",
                                "pack",
                                "size"
                            ])
                        ])) : (0, _vue.createCommentVNode)("v-if", true),
                        (0, _vue.createElementVNode)("div", _hoisted_4$7, [
                            _ctx.$slots.default ? (0, _vue.renderSlot)(_ctx.$slots, "default", {
                                key: 0
                            }) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                key: 1
                            }, [
                                (0, _vue.createCommentVNode)(" eslint-disable-next-line vue/no-v-html "),
                                (0, _vue.createElementVNode)("p", {
                                    class: "text",
                                    innerHTML: _ctx.message
                                }, null, 8, _hoisted_5$5)
                            ], 64))
                        ])
                    ])) : (0, _vue.createCommentVNode)("v-if", true),
                    _ctx.progressBar ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_progress, {
                        key: 2,
                        class: "auto-close-progress",
                        value: _ctx.remainingTime - 1,
                        max: _ctx.duration / 1e3 - 1,
                        type: _ctx.type,
                        rounded: false
                    }, null, 8, [
                        "value",
                        "max",
                        "type"
                    ])) : (0, _vue.createCommentVNode)("v-if", true)
                ], 2), [
                    [
                        (0, _vue.vShow),
                        _ctx.isActive
                    ]
                ])
            ]),
        _: 3
    }, 8, [
        "name"
    ]);
}
var Notification = /* @__PURE__ */ _export_sfc(Notification$1, [
    [
        "render",
        _sfc_render$r
    ]
]);
var NoticeMixin = (0, _vue.defineComponent)({
    props: {
        type: {
            type: String,
            default: "is-dark"
        },
        message: [
            String,
            Array
        ],
        duration: Number,
        queue: {
            type: Boolean,
            default: void 0
        },
        indefinite: {
            type: Boolean,
            default: false
        },
        pauseOnHover: {
            type: Boolean,
            default: false
        },
        position: {
            type: String,
            default: "is-top",
            validator (value) {
                return NOTICE_POSITIONS.indexOf(value) > -1;
            }
        },
        container: String
    },
    emits: {
        click: ()=>true,
        close: ()=>true
    },
    data () {
        return {
            isActive: false,
            isPaused: false,
            parentTop: null,
            parentBottom: null,
            newContainer: this.container || config.defaultContainerElement,
            timer: void 0,
            // host container should override `newDuration`
            newDuration: this.duration || 0
        };
    },
    computed: {
        correctParent () {
            switch(this.position){
                case "is-top-right":
                case "is-top":
                case "is-top-left":
                    return this.parentTop;
                case "is-bottom-right":
                case "is-bottom":
                case "is-bottom-left":
                    return this.parentBottom;
                default:
                    {
                        const exhaustiveCheck = this.position;
                        throw new RangeError(`invalid position: ${exhaustiveCheck}`);
                    }
            }
        },
        transition () {
            switch(this.position){
                case "is-top-right":
                case "is-top":
                case "is-top-left":
                    return {
                        enter: "fadeInDown",
                        leave: "fadeOut"
                    };
                case "is-bottom-right":
                case "is-bottom":
                case "is-bottom-left":
                    return {
                        enter: "fadeInUp",
                        leave: "fadeOut"
                    };
                default:
                    {
                        const exhaustiveCheck = this.position;
                        throw new RangeError(`invalid position: ${exhaustiveCheck}`);
                    }
            }
        }
    },
    methods: {
        pause () {
            if (this.pauseOnHover && !this.indefinite) {
                this.isPaused = true;
                clearInterval(this.$buefy.globalNoticeInterval);
            }
        },
        removePause () {
            if (this.pauseOnHover && !this.indefinite) {
                this.isPaused = false;
                this.close();
            }
        },
        shouldQueue () {
            const queue = this.queue !== void 0 ? this.queue : config.defaultNoticeQueue;
            if (!queue) return false;
            return this.parentTop.childElementCount > 0 || this.parentBottom.childElementCount > 0;
        },
        click () {
            this.$emit("click");
        },
        close () {
            if (!this.isPaused) {
                clearTimeout(this.timer);
                this.isActive = false;
                this.$emit("close");
                setTimeout(()=>{
                    removeElement(this.$el);
                }, 150);
            }
        },
        timeoutCallback () {
            return this.close();
        },
        showNotice () {
            if (this.shouldQueue()) this.correctParent.innerHTML = "";
            this.correctParent.insertAdjacentElement("afterbegin", this.$el);
            this.isActive = true;
            if (!this.indefinite) this.timer = setTimeout(()=>this.timeoutCallback(), this.newDuration);
        },
        setupContainer () {
            this.parentTop = document.querySelector((this.newContainer ? this.newContainer : "body") + ">.notices.is-top");
            this.parentBottom = document.querySelector((this.newContainer ? this.newContainer : "body") + ">.notices.is-bottom");
            if (this.parentTop && this.parentBottom) return;
            if (!this.parentTop) {
                this.parentTop = document.createElement("div");
                this.parentTop.className = "notices is-top";
            }
            if (!this.parentBottom) {
                this.parentBottom = document.createElement("div");
                this.parentBottom.className = "notices is-bottom";
            }
            const container = document.querySelector(this.newContainer) || document.body;
            container.appendChild(this.parentTop);
            container.appendChild(this.parentBottom);
            if (this.newContainer) {
                this.parentTop.classList.add("has-custom-container");
                this.parentBottom.classList.add("has-custom-container");
            }
        }
    },
    beforeMount () {
        this.setupContainer();
    },
    mounted () {
        this.showNotice();
    }
});
const NotificationNotice$1 = (0, _vue.defineComponent)({
    name: "BNotificationNotice",
    components: {
        BNotification: Notification
    },
    mixins: [
        NoticeMixin
    ],
    data () {
        return {
            newDuration: this.duration || config.defaultNotificationDuration
        };
    },
    emits: {
        close: ()=>true
    },
    methods: {
        close () {
            if (!this.isPaused) {
                clearTimeout(this.timer);
                this.$refs.notification.isActive = false;
                this.$emit("close");
                setTimeout(()=>{
                    removeElement(this.$el);
                }, 150);
            }
        }
    }
});
function _sfc_render$q(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_notification = (0, _vue.resolveComponent)("b-notification");
    return _ctx.$slots.default != null ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_notification, (0, _vue.mergeProps)({
        key: 0,
        ref: "notification",
        position: _ctx.position,
        "model-value": _ctx.isActive,
        type: _ctx.type,
        message: _ctx.message,
        duration: _ctx.duration
    }, _ctx.$attrs, {
        onClick: _ctx.click,
        onClose: _ctx.close,
        onMouseenter: _ctx.pause,
        onMouseleave: _ctx.removePause
    }), {
        default: (0, _vue.withCtx)(()=>[
                (0, _vue.renderSlot)(_ctx.$slots, "default")
            ]),
        _: 3
    }, 16, [
        "position",
        "model-value",
        "type",
        "message",
        "duration",
        "onClick",
        "onClose",
        "onMouseenter",
        "onMouseleave"
    ])) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_notification, (0, _vue.mergeProps)({
        key: 1,
        ref: "notification",
        position: _ctx.position,
        "model-value": _ctx.isActive,
        type: _ctx.type,
        message: _ctx.message,
        duration: _ctx.duration
    }, _ctx.$attrs, {
        onClick: _ctx.click,
        onClose: _ctx.close,
        onMouseenter: _ctx.pause,
        onMouseleave: _ctx.removePause
    }), null, 16, [
        "position",
        "model-value",
        "type",
        "message",
        "duration",
        "onClick",
        "onClose",
        "onMouseenter",
        "onMouseleave"
    ]));
}
var NotificationNotice = /* @__PURE__ */ _export_sfc(NotificationNotice$1, [
    [
        "render",
        _sfc_render$q
    ]
]);
var __defProp$3 = Object.defineProperty;
var __defProps$3 = Object.defineProperties;
var __getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value)=>key in obj ? __defProp$3(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues$3 = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
    if (__getOwnPropSymbols$3) {
        for (var prop of __getOwnPropSymbols$3(b))if (__propIsEnum$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps$3 = (a, b)=>__defProps$3(a, __getOwnPropDescs$3(b));
var __objRest$2 = (source, exclude)=>{
    var target = {};
    for(var prop in source)if (__hasOwnProp$3.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$3) {
        for (var prop of __getOwnPropSymbols$3(source))if (exclude.indexOf(prop) < 0 && __propIsEnum$3.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var __publicField$2 = (obj, key, value)=>__defNormalProp$3(obj, key + "", value);
class NotificationProgrammatic {
    constructor(app){
        __publicField$2(this, "app");
        this.app = app;
    }
    open(params) {
        if (typeof params === "string") params = {
            message: params
        };
        let slot;
        let _a = params, { message } = _a, restParams = __objRest$2(_a, [
            "message"
        ]);
        if (typeof message !== "string") {
            slot = message;
            message = void 0;
        }
        const propsData = __spreadValues$3({
            position: config.defaultNotificationPosition || "is-top-right",
            message
        }, restParams);
        const container = document.createElement("div");
        const vueInstance = (0, _vue.createApp)({
            data () {
                return {
                    noticeVNode: null
                };
            },
            methods: {
                close () {
                    const notice = getComponentFromVNode(this.noticeVNode);
                    if (notice) notice.close();
                }
            },
            render () {
                this.noticeVNode = (0, _vue.h)(NotificationNotice, __spreadProps$3(__spreadValues$3({}, propsData), {
                    onClose: ()=>{
                        if (propsData.onClose != null) propsData.onClose();
                        setTimeout(()=>{
                            vueInstance.unmount();
                        }, 150);
                    }
                }), slot != null ? {
                    default: ()=>slot
                } : void 0);
                return this.noticeVNode;
            }
        });
        if (this.app) copyAppContext(this.app, vueInstance);
        else vueInstance.config.globalProperties.$buefy = {};
        return vueInstance.mount(container);
    }
}
const Plugin$l = {
    install (Vue) {
        registerComponent(Vue, Notification);
        registerComponentProgrammatic(Vue, "notification", new NotificationProgrammatic(Vue));
    }
};
var _sfc_main$l = (0, _vue.defineComponent)({
    name: "NavbarBurger",
    props: {
        isOpened: {
            type: Boolean,
            default: false
        }
    }
});
const _hoisted_1$l = [
    "aria-expanded"
];
const _hoisted_2$i = /* @__PURE__ */ (0, _vue.createElementVNode)("span", {
    "aria-hidden": "true"
}, null, -1);
const _hoisted_3$a = /* @__PURE__ */ (0, _vue.createElementVNode)("span", {
    "aria-hidden": "true"
}, null, -1);
const _hoisted_4$6 = /* @__PURE__ */ (0, _vue.createElementVNode)("span", {
    "aria-hidden": "true"
}, null, -1);
const _hoisted_5$4 = [
    _hoisted_2$i,
    _hoisted_3$a,
    _hoisted_4$6
];
function _sfc_render$p(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("a", (0, _vue.mergeProps)({
        role: "button",
        class: [
            "navbar-burger burger",
            {
                "is-active": _ctx.isOpened
            }
        ],
        "aria-label": "menu",
        "aria-expanded": _ctx.isOpened || void 0
    }, _ctx.$attrs, {
        tabindex: "0"
    }), [
        ..._hoisted_5$4
    ], 16, _hoisted_1$l);
}
var NavbarBurger = /* @__PURE__ */ _export_sfc(_sfc_main$l, [
    [
        "render",
        _sfc_render$p
    ]
]);
const isTouch = typeof window !== "undefined" && ("ontouchstart" in window || navigator.maxTouchPoints > 0);
const events = isTouch ? [
    "touchstart",
    "click"
] : [
    "click"
];
const instances = [];
function processArgs(bindingValue) {
    const isFunction = typeof bindingValue === "function";
    if (!isFunction && typeof bindingValue !== "object") throw new Error(`v-click-outside: Binding value should be a function or an object, ${typeof bindingValue} given`);
    return {
        handler: isFunction ? bindingValue : bindingValue.handler,
        middleware: !isFunction && bindingValue.middleware || ((isClickOutside)=>!!isClickOutside),
        events: !isFunction && bindingValue.events || events
    };
}
function onEvent({ el, event, handler, middleware }) {
    const isClickOutside = event.target !== el && !el.contains(event.target);
    if (!isClickOutside || !middleware(event, el)) return;
    handler(event, el);
}
function toggleEventListeners({ eventHandlers }, action) {
    eventHandlers.forEach(({ event, handler })=>{
        document[`${action}EventListener`](event, handler);
    });
}
function beforeMount(el, { value }) {
    const { handler, middleware, events: events2 } = processArgs(value);
    const instance = {
        el,
        eventHandlers: events2.map((eventName)=>({
                event: eventName,
                handler: (event)=>onEvent({
                        event,
                        el,
                        handler,
                        middleware
                    })
            }))
    };
    toggleEventListeners(instance, "add");
    instances.push(instance);
}
function updated(el, { value }) {
    const { handler, middleware, events: events2 } = processArgs(value);
    const instance = instances.filter((instance2)=>instance2.el === el)[0];
    toggleEventListeners(instance, "remove");
    instance.eventHandlers = events2.map((eventName)=>({
            event: eventName,
            handler: (event)=>onEvent({
                    event,
                    el,
                    handler,
                    middleware
                })
        }));
    toggleEventListeners(instance, "add");
}
function unmounted(el) {
    const instance = instances.filter((instance2)=>instance2.el === el)[0];
    toggleEventListeners(instance, "remove");
}
const directive = {
    beforeMount,
    updated,
    unmounted
};
const FIXED_TOP_CLASS = "is-fixed-top";
const BODY_FIXED_TOP_CLASS = "has-navbar-fixed-top";
const BODY_SPACED_FIXED_TOP_CLASS = "has-spaced-navbar-fixed-top";
const FIXED_BOTTOM_CLASS = "is-fixed-bottom";
const BODY_FIXED_BOTTOM_CLASS = "has-navbar-fixed-bottom";
const BODY_SPACED_FIXED_BOTTOM_CLASS = "has-spaced-navbar-fixed-bottom";
const BODY_CENTERED_CLASS = "has-navbar-centered";
const isFilled = (str)=>!!str;
var _sfc_main$k = (0, _vue.defineComponent)({
    name: "BNavbar",
    components: {
        NavbarBurger
    },
    directives: {
        clickOutside: directive
    },
    props: {
        type: [
            String,
            Object
        ],
        transparent: {
            type: Boolean,
            default: false
        },
        fixedTop: {
            type: Boolean,
            default: false
        },
        fixedBottom: {
            type: Boolean,
            default: false
        },
        modelValue: {
            type: Boolean,
            default: false
        },
        centered: {
            type: Boolean,
            default: false
        },
        wrapperClass: {
            type: [
                String,
                Array,
                Object
            ]
        },
        closeOnClick: {
            type: Boolean,
            default: true
        },
        mobileBurger: {
            type: Boolean,
            default: true
        },
        spaced: Boolean,
        shadow: Boolean
    },
    emits: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        "update:modelValue": (_value)=>true
    },
    data () {
        return {
            internalIsActive: this.modelValue,
            _isNavBar: true
        };
    },
    computed: {
        isOpened () {
            return this.internalIsActive;
        },
        computedClasses () {
            return [
                this.type,
                {
                    [FIXED_TOP_CLASS]: this.fixedTop,
                    [FIXED_BOTTOM_CLASS]: this.fixedBottom,
                    [BODY_CENTERED_CLASS]: this.centered,
                    "is-spaced": this.spaced,
                    "has-shadow": this.shadow,
                    "is-transparent": this.transparent
                }
            ];
        }
    },
    watch: {
        modelValue: {
            handler (active) {
                this.internalIsActive = active;
            },
            immediate: true
        },
        fixedTop (isSet) {
            this.setBodyFixedTopClass(isSet);
        },
        bottomTop (isSet) {
            this.setBodyFixedBottomClass(isSet);
        }
    },
    methods: {
        toggleActive () {
            this.internalIsActive = !this.internalIsActive;
            this.emitUpdateParentEvent();
        },
        closeMenu () {
            if (this.closeOnClick && this.internalIsActive) {
                this.internalIsActive = false;
                this.emitUpdateParentEvent();
            }
        },
        emitUpdateParentEvent () {
            this.$emit("update:modelValue", this.internalIsActive);
        },
        setBodyClass (className) {
            if (typeof window !== "undefined") document.body.classList.add(className);
        },
        removeBodyClass (className) {
            if (typeof window !== "undefined") document.body.classList.remove(className);
        },
        checkIfFixedPropertiesAreColliding () {
            const areColliding = this.fixedTop && this.fixedBottom;
            if (areColliding) throw new Error("You should choose if the BNavbar is fixed bottom or fixed top, but not both");
        },
        genNavbar () {
            const navBarSlots = [
                this.genNavbarBrandNode(),
                this.genNavbarSlotsNode()
            ];
            if (!isFilled(this.wrapperClass)) return this.genNavbarSlots(navBarSlots);
            const navWrapper = (0, _vue.h)("div", {
                class: this.wrapperClass
            }, navBarSlots);
            return this.genNavbarSlots([
                navWrapper
            ]);
        },
        genNavbarSlots (slots) {
            const vnode = (0, _vue.h)("nav", {
                class: [
                    "navbar",
                    this.computedClasses
                ],
                role: "navigation",
                "aria-label": "main navigation"
            }, slots);
            return (0, _vue.withDirectives)(vnode, [
                [
                    (0, _vue.resolveDirective)("click-outside"),
                    this.closeMenu
                ]
            ]);
        },
        genNavbarBrandNode () {
            const children = this.$slots.brand != null ? [
                this.$slots.brand(),
                this.genBurgerNode()
            ] : this.genBurgerNode();
            return (0, _vue.h)("div", {
                class: "navbar-brand"
            }, children);
        },
        genBurgerNode () {
            if (this.mobileBurger) {
                const defaultBurgerNode = (0, _vue.h)((0, _vue.resolveComponent)("navbar-burger"), {
                    isOpened: this.isOpened,
                    onClick: this.toggleActive,
                    onKeyup: (event)=>{
                        if (event.keyCode !== 13) return;
                        this.toggleActive();
                    }
                });
                const hasBurgerSlot = !!this.$slots.burger;
                return hasBurgerSlot ? this.$slots.burger({
                    isOpened: this.isOpened,
                    toggleActive: this.toggleActive
                }) : defaultBurgerNode;
            }
        },
        genNavbarSlotsNode () {
            return (0, _vue.h)("div", {
                class: [
                    "navbar-menu",
                    {
                        "is-active": this.isOpened
                    }
                ]
            }, [
                this.genMenuPosition("start"),
                this.genMenuPosition("end")
            ]);
        },
        genMenuPosition (positionName) {
            return (0, _vue.h)("div", {
                class: `navbar-${positionName}`
            }, this.$slots[positionName] != null ? this.$slots[positionName]() : []);
        },
        setBodyFixedTopClass (isSet) {
            this.checkIfFixedPropertiesAreColliding();
            if (isSet) {
                this.setBodyClass(BODY_FIXED_TOP_CLASS);
                this.spaced && this.setBodyClass(BODY_SPACED_FIXED_TOP_CLASS);
            } else {
                this.removeBodyClass(BODY_FIXED_TOP_CLASS);
                this.removeBodyClass(BODY_SPACED_FIXED_TOP_CLASS);
            }
        },
        setBodyFixedBottomClass (isSet) {
            this.checkIfFixedPropertiesAreColliding();
            if (isSet) {
                this.setBodyClass(BODY_FIXED_BOTTOM_CLASS);
                this.spaced && this.setBodyClass(BODY_SPACED_FIXED_BOTTOM_CLASS);
            } else {
                this.removeBodyClass(BODY_FIXED_BOTTOM_CLASS);
                this.removeBodyClass(BODY_SPACED_FIXED_BOTTOM_CLASS);
            }
        }
    },
    beforeMount () {
        this.fixedTop && this.setBodyFixedTopClass(true);
        this.fixedBottom && this.setBodyFixedBottomClass(true);
    },
    beforeUnmount () {
        if (this.fixedTop) {
            const className = this.spaced ? BODY_SPACED_FIXED_TOP_CLASS : BODY_FIXED_TOP_CLASS;
            this.removeBodyClass(className);
        } else if (this.fixedBottom) {
            const className = this.spaced ? BODY_SPACED_FIXED_BOTTOM_CLASS : BODY_FIXED_BOTTOM_CLASS;
            this.removeBodyClass(className);
        }
    },
    render () {
        return this.genNavbar();
    }
});
const clickableWhiteList = [
    "div",
    "span",
    "input"
];
var _sfc_main$j = (0, _vue.defineComponent)({
    name: "BNavbarItem",
    inheritAttrs: false,
    props: {
        tag: {
            type: [
                String,
                Object
            ],
            default: "a"
        },
        active: Boolean
    },
    methods: {
        /*
     * Keypress event that is bound to the document
     */ keyPress ({ key }) {
            if (key === "Escape" || key === "Esc") this.closeMenuRecursive(this, [
                "NavBar"
            ]);
        },
        /*
     * Close parent if clicked outside.
     */ handleClickEvent (event) {
            const isOnWhiteList = clickableWhiteList.some((item)=>item === event.target.localName);
            if (!isOnWhiteList) {
                const parent = this.closeMenuRecursive(this, [
                    "NavbarDropdown",
                    "NavBar"
                ]);
                if (parent && parent.$data._isNavbarDropdown) this.closeMenuRecursive(parent, [
                    "NavBar"
                ]);
            }
        },
        /*
     * Close parent recursively
     */ closeMenuRecursive (current, targetComponents) {
            const parent = current.$parent;
            if (!parent) return null;
            const foundItem = targetComponents.reduce((acc, item)=>{
                if (parent.$data[`_is${item}`]) {
                    parent.closeMenu();
                    return parent;
                }
                return acc;
            }, null);
            return foundItem || this.closeMenuRecursive(parent, targetComponents);
        }
    },
    mounted () {
        if (typeof window !== "undefined") {
            this.$el.addEventListener("click", this.handleClickEvent);
            document.addEventListener("keyup", this.keyPress);
        }
    },
    beforeUnmount () {
        if (typeof window !== "undefined") {
            this.$el.removeEventListener("click", this.handleClickEvent);
            document.removeEventListener("keyup", this.keyPress);
        }
    }
});
function _sfc_render$o(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.resolveDynamicComponent)(_ctx.tag), (0, _vue.mergeProps)({
        class: [
            "navbar-item",
            {
                "is-active": _ctx.active
            }
        ]
    }, _ctx.$attrs), {
        default: (0, _vue.withCtx)(()=>[
                (0, _vue.renderSlot)(_ctx.$slots, "default")
            ]),
        _: 3
    }, 16, [
        "class"
    ]);
}
var NavbarItem = /* @__PURE__ */ _export_sfc(_sfc_main$j, [
    [
        "render",
        _sfc_render$o
    ]
]);
var _sfc_main$i = (0, _vue.defineComponent)({
    name: "BNavbarDropdown",
    directives: {
        clickOutside: directive
    },
    mixins: [
        CompatFallthroughMixin
    ],
    props: {
        label: String,
        hoverable: Boolean,
        active: Boolean,
        right: Boolean,
        arrowless: Boolean,
        boxed: Boolean,
        closeOnClick: {
            type: Boolean,
            default: true
        },
        collapsible: Boolean,
        tag: {
            type: [
                String,
                Object
            ],
            default: "a"
        }
    },
    emits: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        "active-change": (_active)=>true
    },
    data () {
        return {
            newActive: this.active,
            isHoverable: this.hoverable,
            _isNavbarDropdown: true
        };
    },
    watch: {
        active (value) {
            this.newActive = value;
        },
        newActive (value) {
            this.$emit("active-change", value);
        }
    },
    methods: {
        toggleMenu () {
            this.newActive = !this.newActive;
        },
        showMenu () {
            this.newActive = true;
        },
        /*
    * See naming convetion of navbaritem
    */ closeMenu () {
            this.newActive = !this.closeOnClick;
            if (this.hoverable && this.closeOnClick) this.isHoverable = false;
        },
        checkHoverable () {
            if (this.hoverable) this.isHoverable = true;
        }
    }
});
function _sfc_render$n(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_click_outside = (0, _vue.resolveDirective)("click-outside");
    return (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", (0, _vue.mergeProps)({
        class: [
            "navbar-item has-dropdown",
            {
                "is-hoverable": _ctx.isHoverable,
                "is-active": _ctx.newActive
            }
        ],
        onMouseenter: _cache[0] || (_cache[0] = (...args)=>_ctx.checkHoverable && _ctx.checkHoverable(...args))
    }, _ctx.rootAttrs), [
        ((0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.resolveDynamicComponent)(_ctx.tag), (0, _vue.mergeProps)({
            class: [
                "navbar-link",
                {
                    "is-arrowless": _ctx.arrowless,
                    "is-active": _ctx.newActive && _ctx.collapsible
                }
            ]
        }, _ctx.fallthroughAttrs, {
            "aria-haspopup": "true",
            onClick: (0, _vue.withModifiers)(_ctx.toggleMenu, [
                "prevent"
            ]),
            onKeyup: (0, _vue.withKeys)(_ctx.toggleMenu, [
                "enter"
            ]),
            tabindex: "0"
        }), {
            default: (0, _vue.withCtx)(()=>[
                    _ctx.label ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                        key: 0
                    }, [
                        (0, _vue.createTextVNode)((0, _vue.toDisplayString)(_ctx.label), 1)
                    ], 64)) : (0, _vue.renderSlot)(_ctx.$slots, "label", {
                        key: 1
                    })
                ]),
            _: 3
        }, 16, [
            "class",
            "onClick",
            "onKeyup"
        ])),
        (0, _vue.createElementVNode)("div", {
            class: (0, _vue.normalizeClass)([
                "navbar-dropdown",
                {
                    "is-right": _ctx.right,
                    "is-boxed": _ctx.boxed,
                    "is-hidden-touch": _ctx.collapsible && !_ctx.newActive
                }
            ])
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "default")
        ], 2)
    ], 16)), [
        [
            _directive_click_outside,
            _ctx.closeMenu
        ]
    ]);
}
var NavbarDropdown = /* @__PURE__ */ _export_sfc(_sfc_main$i, [
    [
        "render",
        _sfc_render$n
    ]
]);
const Plugin$k = {
    install (Vue) {
        registerComponent(Vue, _sfc_main$k);
        registerComponent(Vue, NavbarItem);
        registerComponent(Vue, NavbarDropdown);
    }
};
const CONTROLS_ALIGNMENTS = [
    "left",
    "right",
    "center"
];
var _sfc_main$h = (0, _vue.defineComponent)({
    name: "BNumberinput",
    components: {
        BIcon,
        BInput
    },
    mixins: [
        CompatFallthroughMixin,
        FormElementMixin
    ],
    inject: {
        field: {
            from: "BField",
            default: false
        }
    },
    props: {
        modelValue: [
            Number,
            null
        ],
        min: {
            type: [
                Number,
                String
            ]
        },
        max: [
            Number,
            String
        ],
        step: [
            Number,
            String
        ],
        minStep: [
            Number,
            String
        ],
        exponential: [
            Boolean,
            Number
        ],
        disabled: Boolean,
        type: {
            type: String,
            default: "is-primary"
        },
        editable: {
            type: Boolean,
            default: true
        },
        controls: {
            type: Boolean,
            default: true
        },
        controlsAlignment: {
            type: String,
            default: "center",
            validator: (value)=>{
                return CONTROLS_ALIGNMENTS.indexOf(value) >= 0;
            }
        },
        controlsRounded: {
            type: Boolean,
            default: false
        },
        controlsPosition: String,
        placeholder: [
            Number,
            String
        ],
        ariaMinusLabel: String,
        ariaPlusLabel: String,
        longPress: {
            type: Boolean,
            default: true
        },
        // Native options to use in HTML5 validation
        autocomplete: String
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars */ blur: (_event)=>true,
        focus: (_event)=>true,
        "update:modelValue": (_value)=>true
    },
    data () {
        return {
            newValue: this.modelValue,
            newStep: this.step || 1,
            newMinStep: this.minStep,
            timesPressed: 1,
            _elementRef: "input",
            _$intervalRef: void 0
        };
    },
    computed: {
        computedValue: {
            // getter has to include `string` in the return type so that the
            // setter can accept `string`
            get () {
                return this.newValue;
            },
            set (value) {
                let newValue = Number(value) === 0 ? 0 : Number(value) || null;
                if (value === "" || value === void 0 || value === null) newValue = null;
                this.newValue = newValue;
                if (newValue === null) this.$emit("update:modelValue", newValue);
                else if (!isNaN(newValue)) this.$emit("update:modelValue", Number(newValue));
                this.$nextTick(()=>{
                    if (this.$refs.input) this.$refs.input.checkHtml5Validity();
                });
            }
        },
        controlsLeft () {
            if (this.controls && this.controlsAlignment !== "right") return this.controlsAlignment === "left" ? [
                "minus",
                "plus"
            ] : [
                "minus"
            ];
            return [];
        },
        controlsRight () {
            if (this.controls && this.controlsAlignment !== "left") return this.controlsAlignment === "right" ? [
                "minus",
                "plus"
            ] : [
                "plus"
            ];
            return [];
        },
        fieldClasses () {
            return [
                {
                    "has-addons": this.controlsPosition === "compact"
                },
                {
                    "is-grouped": this.controlsPosition !== "compact"
                },
                {
                    "is-expanded": this.expanded
                }
            ];
        },
        buttonClasses () {
            return [
                this.type,
                this.size,
                {
                    "is-rounded": this.controlsRounded
                }
            ];
        },
        minNumber () {
            return typeof this.min === "string" ? parseFloat(this.min) : this.min;
        },
        maxNumber () {
            return typeof this.max === "string" ? parseFloat(this.max) : this.max;
        },
        stepNumber () {
            if (this.newStep === "any") return 1;
            return typeof this.newStep === "string" ? parseFloat(this.newStep) : this.newStep;
        },
        minStepNumber () {
            if (this.newStep === "any" && typeof this.newMinStep === "undefined") return "any";
            const step = typeof this.newMinStep !== "undefined" ? this.newMinStep : this.newStep;
            return typeof step === "string" ? parseFloat(step) : step;
        },
        disabledMin () {
            return +this.computedValue - this.stepNumber < this.minNumber;
        },
        disabledMax () {
            return +this.computedValue + this.stepNumber > this.maxNumber;
        },
        stepDecimals () {
            const step = this.minStepNumber.toString();
            const index = step.indexOf(".");
            if (index >= 0) return step.substring(index + 1).length;
            return 0;
        },
        disabledOrUndefined () {
            return this.disabled || void 0;
        }
    },
    watch: {
        /*
     * When v-model is changed:
     *   1. Set internal value.
     */ modelValue: {
            immediate: true,
            handler (value) {
                this.newValue = value;
            }
        },
        step (value) {
            this.newStep = value;
        },
        minStep (value) {
            this.newMinStep = value;
        }
    },
    methods: {
        isDisabled (control) {
            return this.disabled || (control === "plus" ? this.disabledMax : this.disabledMin);
        },
        decrement () {
            if (this.computedValue === null || typeof this.computedValue === "undefined") {
                if (this.maxNumber !== null && typeof this.maxNumber !== "undefined") {
                    this.computedValue = this.maxNumber;
                    return;
                }
                this.computedValue = 0;
            }
            if (typeof this.minNumber === "undefined" || +this.computedValue - this.stepNumber >= this.minNumber) {
                const value = +this.computedValue - this.stepNumber;
                this.computedValue = parseFloat(value.toFixed(this.stepDecimals));
            }
        },
        increment () {
            if (this.computedValue === null || typeof this.computedValue === "undefined" || +this.computedValue < this.minNumber) {
                if (this.minNumber !== null && typeof this.minNumber !== "undefined") {
                    this.computedValue = this.minNumber;
                    return;
                }
                this.computedValue = 0;
            }
            if (typeof this.maxNumber === "undefined" || +this.computedValue + this.stepNumber <= this.maxNumber) {
                const value = +this.computedValue + this.stepNumber;
                this.computedValue = parseFloat(value.toFixed(this.stepDecimals));
            }
        },
        onControlClick (event, inc) {
            if (event.detail !== 0 || event.type !== "click") return;
            if (inc) this.increment();
            else this.decrement();
        },
        longPressTick (inc) {
            if (inc) this.increment();
            else this.decrement();
            if (!this.longPress) return;
            this._$intervalRef = setTimeout(()=>{
                this.longPressTick(inc);
            }, this.exponential ? 250 / (+this.exponential * this.timesPressed++) : 250);
        },
        onStartLongPress (event, inc) {
            if (event.button !== 0 && event.type !== "touchstart") return;
            clearTimeout(this._$intervalRef);
            this.longPressTick(inc);
        },
        onStopLongPress () {
            if (!this._$intervalRef) return;
            this.timesPressed = 1;
            clearTimeout(this._$intervalRef);
            this._$intervalRef = void 0;
        }
    },
    mounted () {
        if (this.field === this.$parent) this.$parent.wrapNumberinput({
            controlsPosition: this.controlsPosition,
            size: this.size
        });
    },
    beforeUnmount () {
        clearTimeout(this._$intervalRef);
    }
});
const _hoisted_1$k = [
    "disabled",
    "aria-label",
    "onMousedown",
    "onTouchstart",
    "onClick"
];
const _hoisted_2$h = [
    "disabled",
    "aria-label",
    "onMousedown",
    "onTouchstart",
    "onClick"
];
function _sfc_render$m(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    const _component_b_input = (0, _vue.resolveComponent)("b-input");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", (0, _vue.mergeProps)({
        class: [
            "b-numberinput field",
            _ctx.fieldClasses
        ]
    }, _ctx.rootAttrs), [
        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.controlsLeft, (control)=>{
            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", {
                key: control,
                class: (0, _vue.normalizeClass)([
                    "control",
                    control
                ]),
                onMouseup: _cache[0] || (_cache[0] = (...args)=>_ctx.onStopLongPress && _ctx.onStopLongPress(...args)),
                onMouseleave: _cache[1] || (_cache[1] = (...args)=>_ctx.onStopLongPress && _ctx.onStopLongPress(...args)),
                onTouchend: _cache[2] || (_cache[2] = (...args)=>_ctx.onStopLongPress && _ctx.onStopLongPress(...args)),
                onTouchcancel: _cache[3] || (_cache[3] = (...args)=>_ctx.onStopLongPress && _ctx.onStopLongPress(...args))
            }, [
                (0, _vue.createElementVNode)("button", {
                    type: "button",
                    class: (0, _vue.normalizeClass)([
                        "button",
                        _ctx.buttonClasses
                    ]),
                    disabled: _ctx.isDisabled(control) || void 0,
                    "aria-label": control === "plus" ? _ctx.ariaPlusLabel : _ctx.ariaMinusLabel,
                    onMousedown: ($event)=>!_ctx.isDisabled(control) && _ctx.onStartLongPress($event, control === "plus"),
                    onTouchstart: (0, _vue.withModifiers)(($event)=>!_ctx.isDisabled(control) && _ctx.onStartLongPress($event, control === "plus"), [
                        "prevent"
                    ]),
                    onClick: ($event)=>!_ctx.isDisabled(control) && _ctx.onControlClick($event, control === "plus")
                }, [
                    (0, _vue.createVNode)(_component_b_icon, {
                        both: "",
                        icon: control,
                        pack: _ctx.iconPack,
                        size: _ctx.iconSize
                    }, null, 8, [
                        "icon",
                        "pack",
                        "size"
                    ])
                ], 42, _hoisted_1$k)
            ], 34);
        }), 128)),
        (0, _vue.createVNode)(_component_b_input, (0, _vue.mergeProps)({
            type: "number",
            ref: "input",
            modelValue: _ctx.computedValue,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>_ctx.computedValue = $event)
        }, _ctx.fallthroughAttrs, {
            step: _ctx.minStepNumber,
            max: _ctx.max,
            min: _ctx.min,
            size: _ctx.size,
            disabled: _ctx.disabledOrUndefined,
            readonly: !_ctx.editable,
            loading: _ctx.loading,
            rounded: _ctx.rounded,
            icon: _ctx.icon,
            "icon-pack": _ctx.iconPack,
            autocomplete: _ctx.autocomplete,
            expanded: _ctx.expanded,
            placeholder: _ctx.placeholder,
            "use-html5-validation": _ctx.useHtml5Validation,
            onFocus: _cache[5] || (_cache[5] = ($event)=>_ctx.$emit("focus", $event)),
            onBlur: _cache[6] || (_cache[6] = ($event)=>_ctx.$emit("blur", $event))
        }), null, 16, [
            "modelValue",
            "step",
            "max",
            "min",
            "size",
            "disabled",
            "readonly",
            "loading",
            "rounded",
            "icon",
            "icon-pack",
            "autocomplete",
            "expanded",
            "placeholder",
            "use-html5-validation"
        ]),
        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.controlsRight, (control)=>{
            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", {
                key: control,
                class: (0, _vue.normalizeClass)([
                    "control",
                    control
                ]),
                onMouseup: _cache[7] || (_cache[7] = (...args)=>_ctx.onStopLongPress && _ctx.onStopLongPress(...args)),
                onMouseleave: _cache[8] || (_cache[8] = (...args)=>_ctx.onStopLongPress && _ctx.onStopLongPress(...args)),
                onTouchend: _cache[9] || (_cache[9] = (...args)=>_ctx.onStopLongPress && _ctx.onStopLongPress(...args)),
                onTouchcancel: _cache[10] || (_cache[10] = (...args)=>_ctx.onStopLongPress && _ctx.onStopLongPress(...args))
            }, [
                (0, _vue.createElementVNode)("button", {
                    type: "button",
                    class: (0, _vue.normalizeClass)([
                        "button",
                        _ctx.buttonClasses
                    ]),
                    disabled: _ctx.isDisabled(control) || void 0,
                    "aria-label": control === "plus" ? _ctx.ariaPlusLabel : _ctx.ariaMinusLabel,
                    onMousedown: ($event)=>!_ctx.isDisabled(control) && _ctx.onStartLongPress($event, control === "plus"),
                    onTouchstart: (0, _vue.withModifiers)(($event)=>!_ctx.isDisabled(control) && _ctx.onStartLongPress($event, control === "plus"), [
                        "prevent"
                    ]),
                    onClick: ($event)=>!_ctx.isDisabled(control) && _ctx.onControlClick($event, control === "plus")
                }, [
                    (0, _vue.createVNode)(_component_b_icon, {
                        both: "",
                        icon: control,
                        pack: _ctx.iconPack,
                        size: _ctx.iconSize
                    }, null, 8, [
                        "icon",
                        "pack",
                        "size"
                    ])
                ], 42, _hoisted_2$h)
            ], 34);
        }), 128))
    ], 16);
}
var Numberinput = /* @__PURE__ */ _export_sfc(_sfc_main$h, [
    [
        "render",
        _sfc_render$m
    ]
]);
const Plugin$j = {
    install (Vue) {
        registerComponent(Vue, Numberinput);
    }
};
var _sfc_main$g = (0, _vue.defineComponent)({
    name: "BPaginationButton",
    props: {
        page: {
            type: Object,
            required: true
        },
        tag: {
            type: [
                String,
                Object
            ],
            default: "a",
            validator: (value)=>{
                return typeof value === "object" || config.defaultLinkTags.indexOf(value) >= 0;
            }
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        href () {
            if (this.tag === "a") return "#";
            else return void 0;
        },
        isDisabled () {
            return this.disabled || this.page.disabled;
        },
        disabledOrUndefined () {
            return this.isDisabled || void 0;
        }
    }
});
function _sfc_render$l(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.resolveDynamicComponent)(_ctx.tag), (0, _vue.mergeProps)({
        role: "button",
        href: _ctx.href,
        disabled: _ctx.disabledOrUndefined,
        class: [
            "pagination-link",
            {
                "is-current": _ctx.page.isCurrent,
                [_ctx.page.class]: true
            }
        ]
    }, _ctx.$attrs, {
        onClick: (0, _vue.withModifiers)(_ctx.page.click, [
            "prevent"
        ]),
        "aria-label": _ctx.page["aria-label"],
        "aria-current": _ctx.page.isCurrent || void 0
    }), {
        default: (0, _vue.withCtx)(()=>[
                (0, _vue.renderSlot)(_ctx.$slots, "default", {}, ()=>[
                        (0, _vue.createTextVNode)((0, _vue.toDisplayString)(_ctx.page.number), 1)
                    ])
            ]),
        _: 3
    }, 16, [
        "href",
        "disabled",
        "class",
        "onClick",
        "aria-label",
        "aria-current"
    ]);
}
var PaginationButton = /* @__PURE__ */ _export_sfc(_sfc_main$g, [
    [
        "render",
        _sfc_render$l
    ]
]);
function debounce(func, wait, immediate) {
    let timeout;
    return function(...args) {
        const context = this;
        const later = function() {
            timeout = void 0;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
var _sfc_main$f = (0, _vue.defineComponent)({
    name: "BPagination",
    components: {
        BIcon,
        BPaginationButton: PaginationButton
    },
    props: {
        total: [
            Number,
            String
        ],
        perPage: {
            type: [
                Number,
                String
            ],
            default: 20
        },
        modelValue: {
            type: [
                Number,
                String
            ],
            default: 1
        },
        rangeBefore: {
            type: [
                Number,
                String
            ],
            default: 1
        },
        rangeAfter: {
            type: [
                Number,
                String
            ],
            default: 1
        },
        size: String,
        simple: Boolean,
        rounded: Boolean,
        order: String,
        iconPack: String,
        iconPrev: {
            type: String,
            default: ()=>{
                return config.defaultIconPrev;
            }
        },
        iconNext: {
            type: String,
            default: ()=>{
                return config.defaultIconNext;
            }
        },
        ariaNextLabel: String,
        ariaPreviousLabel: String,
        ariaPageLabel: String,
        ariaCurrentLabel: String,
        pageInput: {
            type: Boolean,
            default: false
        },
        pageInputPosition: String,
        debouncePageInput: [
            Number,
            String
        ]
    },
    data () {
        return {
            inputValue: this.modelValue,
            debounceHandlePageInput: void 0
        };
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars */ change: (_num)=>true,
        "update:modelValue": (_num)=>true
    },
    computed: {
        rootClasses () {
            return [
                this.order,
                this.size,
                this.pageInputPosition,
                {
                    "is-simple": this.simple,
                    "is-rounded": this.rounded,
                    "has-input": this.pageInput
                }
            ];
        },
        beforeCurrent () {
            return parseInt(this.rangeBefore + "");
        },
        afterCurrent () {
            return parseInt(this.rangeAfter + "");
        },
        /*
    * Total page size (count).
    */ pageCount () {
            return Math.ceil(+this.total / +this.perPage);
        },
        /*
    * First item of the page (count).
    */ firstItem () {
            const firstItem = +this.modelValue * +this.perPage - +this.perPage + 1;
            return firstItem >= 0 ? firstItem : 0;
        },
        /*
    * Check if previous button is available.
    */ hasPrev () {
            return +this.modelValue > 1;
        },
        /*
     * Check if first page button should be visible.
    */ hasFirst () {
            return +this.modelValue >= 2 + this.beforeCurrent;
        },
        /*
    * Check if first ellipsis should be visible.
    */ hasFirstEllipsis () {
            return +this.modelValue >= this.beforeCurrent + 4;
        },
        /*
    * Check if last page button should be visible.
    */ hasLast () {
            return +this.modelValue <= this.pageCount - (1 + this.afterCurrent);
        },
        /*
    * Check if last ellipsis should be visible.
    */ hasLastEllipsis () {
            return +this.modelValue < this.pageCount - (2 + this.afterCurrent);
        },
        /*
    * Check if next button is available.
    */ hasNext () {
            return +this.modelValue < this.pageCount;
        },
        /*
    * Get near pages, 1 before and 1 after the current.
    * Also add the click event to the array.
    */ pagesInRange () {
            if (this.simple) return;
            let left = Math.max(1, +this.modelValue - this.beforeCurrent);
            if (left - 1 === 2) left--;
            let right = Math.min(+this.modelValue + this.afterCurrent, this.pageCount);
            if (this.pageCount - right === 2) right++;
            const pages = [];
            for(let i = left; i <= right; i++)pages.push(this.getPage(i));
            return pages;
        }
    },
    watch: {
        /*
    * If current page is trying to be greater than page count, set to last.
    */ pageCount (value) {
            if (this.modelValue > value) this.last();
        },
        modelValue (value) {
            this.inputValue = value;
        },
        debouncePageInput: {
            handler (value) {
                this.debounceHandlePageInput = debounce(this.handleOnInputPageChange, value);
            },
            immediate: true
        }
    },
    methods: {
        /*
    * Previous button click listener.
    */ prev (event) {
            this.changePage(+this.modelValue - 1, event);
        },
        /*
     * Next button click listener.
    */ next (event) {
            this.changePage(+this.modelValue + 1, event);
        },
        /*
     * First button click listener.
    */ first (event) {
            this.changePage(1, event);
        },
        /*
    * Last button click listener.
    */ last (event) {
            this.changePage(this.pageCount, event);
        },
        changePage (num, event) {
            if (this.modelValue === num || num < 1 || num > this.pageCount) return;
            this.$emit("update:modelValue", num);
            this.$emit("change", num);
            if (event && event.target) this.$nextTick(()=>event.target.focus());
        },
        getPage (num, options = {}) {
            return {
                number: num,
                isCurrent: this.modelValue === num,
                click: (event)=>this.changePage(num, event),
                input: (event, inputNum)=>this.changePage(+inputNum, event),
                disabled: options.disabled || false,
                class: options.class || "",
                "aria-label": options["aria-label"] || this.getAriaPageLabel(num, this.modelValue === num)
            };
        },
        /*
    * Get text for aria-label according to page number.
    */ getAriaPageLabel (pageNumber, isCurrent) {
            if (this.ariaPageLabel && (!isCurrent || !this.ariaCurrentLabel)) return this.ariaPageLabel + " " + pageNumber + ".";
            else if (this.ariaPageLabel && isCurrent && this.ariaCurrentLabel) return this.ariaCurrentLabel + ", " + this.ariaPageLabel + " " + pageNumber + ".";
            return null;
        },
        handleOnInputPageChange (event) {
            this.getPage(+this.inputValue).input(event, this.inputValue);
        },
        handleOnInputDebounce (event) {
            if (this.debouncePageInput) this.debounceHandlePageInput(event);
            else this.handleOnInputPageChange(event);
        },
        handleOnKeyPress (event) {
            const ASCIICode = event.which || event.keyCode;
            if (ASCIICode >= 48 && ASCIICode <= 57) return true;
            else return event.preventDefault();
        },
        handleAllowableInputPageRange (event) {
            const target = event.target;
            if (+target.value > 0 && +target.value <= this.pageCount) this.handleOnInputValue(event);
            else {
                this.inputValue = 1;
                this.inputValue = "";
            }
        },
        handleOnInputValue (event) {
            const inputValue = +event.target.value;
            this.inputValue = inputValue;
            if (Number.isInteger(this.inputValue)) this.handleOnInputDebounce(event);
            else this.inputValue = this.modelValue;
        }
    }
});
const _hoisted_1$j = {
    class: "control pagination-input"
};
const _hoisted_2$g = [
    "value",
    "size",
    "maxlength"
];
const _hoisted_3$9 = {
    key: 4,
    class: "info"
};
const _hoisted_4$5 = {
    key: 5,
    class: "pagination-list"
};
const _hoisted_5$3 = {
    key: 0
};
const _hoisted_6$2 = {
    key: 1
};
const _hoisted_7$2 = /* @__PURE__ */ (0, _vue.createElementVNode)("span", {
    class: "pagination-ellipsis"
}, "\u2026", -1);
const _hoisted_8$2 = [
    _hoisted_7$2
];
const _hoisted_9$2 = {
    key: 2
};
const _hoisted_10$1 = /* @__PURE__ */ (0, _vue.createElementVNode)("span", {
    class: "pagination-ellipsis"
}, "\u2026", -1);
const _hoisted_11$1 = [
    _hoisted_10$1
];
const _hoisted_12$1 = {
    key: 3
};
function _sfc_render$k(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    const _component_BPaginationButton = (0, _vue.resolveComponent)("BPaginationButton");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("nav", {
        class: (0, _vue.normalizeClass)([
            "pagination",
            _ctx.rootClasses
        ])
    }, [
        _ctx.$slots.previous ? (0, _vue.renderSlot)(_ctx.$slots, "previous", {
            key: 0,
            page: _ctx.getPage(+_ctx.modelValue - 1, {
                disabled: !_ctx.hasPrev,
                class: "pagination-previous",
                "aria-label": _ctx.ariaPreviousLabel
            })
        }, ()=>[
                (0, _vue.createVNode)(_component_b_icon, {
                    icon: _ctx.iconPrev,
                    pack: _ctx.iconPack,
                    both: "",
                    "aria-hidden": "true"
                }, null, 8, [
                    "icon",
                    "pack"
                ])
            ]) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_BPaginationButton, {
            key: 1,
            class: "pagination-previous",
            disabled: !_ctx.hasPrev,
            page: _ctx.getPage(+_ctx.modelValue - 1),
            "aria-label": _ctx.ariaPreviousLabel
        }, {
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.createVNode)(_component_b_icon, {
                        icon: _ctx.iconPrev,
                        pack: _ctx.iconPack,
                        both: "",
                        "aria-hidden": "true"
                    }, null, 8, [
                        "icon",
                        "pack"
                    ])
                ]),
            _: 1
        }, 8, [
            "disabled",
            "page",
            "aria-label"
        ])),
        _ctx.$slots.next ? (0, _vue.renderSlot)(_ctx.$slots, "next", {
            key: 2,
            page: _ctx.getPage(+_ctx.modelValue + 1, {
                disabled: !_ctx.hasNext,
                class: "pagination-next",
                "aria-label": _ctx.ariaNextLabel
            })
        }, ()=>[
                (0, _vue.createVNode)(_component_b_icon, {
                    icon: _ctx.iconNext,
                    pack: _ctx.iconPack,
                    both: "",
                    "aria-hidden": "true"
                }, null, 8, [
                    "icon",
                    "pack"
                ])
            ]) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_BPaginationButton, {
            key: 3,
            class: "pagination-next",
            disabled: !_ctx.hasNext,
            page: _ctx.getPage(+_ctx.modelValue + 1),
            "aria-label": _ctx.ariaNextLabel
        }, {
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.createVNode)(_component_b_icon, {
                        icon: _ctx.iconNext,
                        pack: _ctx.iconPack,
                        both: "",
                        "aria-hidden": "true"
                    }, null, 8, [
                        "icon",
                        "pack"
                    ])
                ]),
            _: 1
        }, 8, [
            "disabled",
            "page",
            "aria-label"
        ])),
        (0, _vue.createElementVNode)("div", _hoisted_1$j, [
            _ctx.pageInput ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("input", {
                key: 0,
                class: "input",
                value: _ctx.inputValue,
                onInput: _cache[0] || (_cache[0] = (...args)=>_ctx.handleAllowableInputPageRange && _ctx.handleAllowableInputPageRange(...args)),
                onKeypress: _cache[1] || (_cache[1] = (...args)=>_ctx.handleOnKeyPress && _ctx.handleOnKeyPress(...args)),
                size: _ctx.pageCount.toString().length,
                maxlength: _ctx.pageCount.toString().length
            }, null, 40, _hoisted_2$g)) : (0, _vue.createCommentVNode)("v-if", true)
        ]),
        _ctx.simple ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("small", _hoisted_3$9, [
            _ctx.perPage == 1 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                key: 0
            }, [
                (0, _vue.createTextVNode)((0, _vue.toDisplayString)(_ctx.firstItem) + " / " + (0, _vue.toDisplayString)(_ctx.total), 1)
            ], 64)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                key: 1
            }, [
                (0, _vue.createTextVNode)((0, _vue.toDisplayString)(_ctx.firstItem) + "-" + (0, _vue.toDisplayString)(Math.min(+_ctx.modelValue * +_ctx.perPage, +_ctx.total)) + " / " + (0, _vue.toDisplayString)(_ctx.total), 1)
            ], 64))
        ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("ul", _hoisted_4$5, [
            (0, _vue.createCommentVNode)("First"),
            _ctx.hasFirst ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_5$3, [
                _ctx.$slots.default ? (0, _vue.renderSlot)(_ctx.$slots, "default", {
                    key: 0,
                    page: _ctx.getPage(1)
                }) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_BPaginationButton, {
                    key: 1,
                    page: _ctx.getPage(1)
                }, null, 8, [
                    "page"
                ]))
            ])) : (0, _vue.createCommentVNode)("v-if", true),
            _ctx.hasFirstEllipsis ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_6$2, [
                ..._hoisted_8$2
            ])) : (0, _vue.createCommentVNode)("v-if", true),
            (0, _vue.createCommentVNode)("Pages"),
            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.pagesInRange, (page)=>{
                return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", {
                    key: page.number
                }, [
                    _ctx.$slots.default ? (0, _vue.renderSlot)(_ctx.$slots, "default", {
                        key: 0,
                        page
                    }) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_BPaginationButton, {
                        key: 1,
                        page
                    }, null, 8, [
                        "page"
                    ]))
                ]);
            }), 128)),
            (0, _vue.createCommentVNode)("Last"),
            _ctx.hasLastEllipsis ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_9$2, [
                ..._hoisted_11$1
            ])) : (0, _vue.createCommentVNode)("v-if", true),
            _ctx.hasLast ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_12$1, [
                _ctx.$slots.default ? (0, _vue.renderSlot)(_ctx.$slots, "default", {
                    key: 0,
                    page: _ctx.getPage(_ctx.pageCount)
                }) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_BPaginationButton, {
                    key: 1,
                    page: _ctx.getPage(_ctx.pageCount)
                }, null, 8, [
                    "page"
                ]))
            ])) : (0, _vue.createCommentVNode)("v-if", true)
        ]))
    ], 2);
}
var BPagination = /* @__PURE__ */ _export_sfc(_sfc_main$f, [
    [
        "render",
        _sfc_render$k
    ]
]);
const Plugin$i = {
    install (Vue) {
        registerComponent(Vue, BPagination);
        registerComponent(Vue, PaginationButton);
    }
};
const ProgressBar$1 = (0, _vue.defineComponent)({
    name: "BProgressBar",
    inject: {
        parent: {
            from: PROGRESS_INJECTION_KEY,
            default: void 0
        }
    },
    props: {
        type: {
            type: [
                String
            ],
            default: void 0
        },
        value: {
            type: Number,
            default: void 0
        },
        showValue: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        parentProgress () {
            return this.parent;
        },
        newType () {
            return [
                this.parentProgress.size,
                this.type || this.parentProgress.type
            ];
        },
        newShowValue () {
            return this.showValue || this.parentProgress.showValue;
        },
        newValue () {
            return this.parentProgress.calculateValue(this.value);
        },
        barWidth () {
            return `${(this.value === void 0 ? 0 : this.value) * 100 / this.parentProgress.max}%`;
        }
    }
});
const _hoisted_1$i = [
    "aria-valuenow",
    "aria-valuemax"
];
const _hoisted_2$f = {
    key: 0,
    class: "progress-value"
};
function _sfc_render$j(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "progress-bar",
            _ctx.newType
        ]),
        role: "progressbar",
        "aria-valuenow": _ctx.value,
        "aria-valuemax": _ctx.parentProgress.max,
        "aria-valuemin": "0",
        style: (0, _vue.normalizeStyle)({
            width: _ctx.barWidth
        })
    }, [
        _ctx.newShowValue ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_2$f, [
            (0, _vue.renderSlot)(_ctx.$slots, "default", {}, ()=>[
                    (0, _vue.createTextVNode)((0, _vue.toDisplayString)(_ctx.newValue), 1)
                ])
        ])) : (0, _vue.createCommentVNode)("v-if", true)
    ], 14, _hoisted_1$i);
}
var ProgressBar = /* @__PURE__ */ _export_sfc(ProgressBar$1, [
    [
        "render",
        _sfc_render$j
    ]
]);
const Plugin$h = {
    install (Vue) {
        registerComponent(Vue, Progress);
        registerComponent(Vue, ProgressBar);
    }
};
const Radio$1 = (0, _vue.defineComponent)({
    name: "BRadio",
    mixins: [
        CheckRadioMixin
    ]
});
const _hoisted_1$h = [
    "disabled"
];
const _hoisted_2$e = [
    "disabled",
    "required",
    "name",
    "value"
];
const _hoisted_3$8 = {
    class: "control-label"
};
function _sfc_render$i(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("label", {
        class: (0, _vue.normalizeClass)([
            "b-radio radio",
            [
                _ctx.size,
                {
                    "is-disabled": _ctx.disabled
                }
            ]
        ]),
        ref: "label",
        disabled: _ctx.disabledOrUndefined,
        onClick: _cache[2] || (_cache[2] = (...args)=>_ctx.focus && _ctx.focus(...args)),
        onKeydown: _cache[3] || (_cache[3] = (0, _vue.withKeys)((0, _vue.withModifiers)(($event)=>_ctx.$refs.label.click(), [
            "prevent"
        ]), [
            "enter"
        ]))
    }, [
        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.computedValue = $event),
            type: "radio",
            ref: "input",
            onClick: _cache[1] || (_cache[1] = (0, _vue.withModifiers)(()=>{}, [
                "stop"
            ])),
            disabled: _ctx.disabledOrUndefined,
            required: _ctx.requiredOrUndefined,
            name: _ctx.name,
            value: _ctx.nativeValue
        }, null, 8, _hoisted_2$e), [
            [
                (0, _vue.vModelRadio),
                _ctx.computedValue
            ]
        ]),
        (0, _vue.createElementVNode)("span", {
            class: (0, _vue.normalizeClass)([
                "check",
                _ctx.type
            ])
        }, null, 2),
        (0, _vue.createElementVNode)("span", _hoisted_3$8, [
            (0, _vue.renderSlot)(_ctx.$slots, "default")
        ])
    ], 42, _hoisted_1$h);
}
var Radio = /* @__PURE__ */ _export_sfc(Radio$1, [
    [
        "render",
        _sfc_render$i
    ]
]);
const RadioButon = (0, _vue.defineComponent)({
    name: "BRadioButton",
    mixins: [
        CheckRadioMixin
    ],
    props: {
        type: {
            type: String,
            default: "is-primary"
        },
        expanded: Boolean
    },
    data () {
        return {
            isFocused: false
        };
    },
    computed: {
        isSelected () {
            return this.newValue === this.nativeValue;
        },
        labelClass () {
            return [
                this.isSelected ? this.type : null,
                this.size,
                {
                    "is-selected": this.isSelected,
                    "is-disabled": this.disabled,
                    "is-focused": this.isFocused
                }
            ];
        }
    }
});
const _hoisted_1$g = [
    "disabled"
];
const _hoisted_2$d = [
    "disabled",
    "required",
    "name",
    "value"
];
function _sfc_render$h(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "control",
            {
                "is-expanded": _ctx.expanded
            }
        ])
    }, [
        (0, _vue.createElementVNode)("label", {
            class: (0, _vue.normalizeClass)([
                "b-radio radio button",
                _ctx.labelClass
            ]),
            ref: "label",
            disabled: _ctx.disabledOrUndefined,
            onClick: _cache[4] || (_cache[4] = (...args)=>_ctx.focus && _ctx.focus(...args)),
            onKeydown: _cache[5] || (_cache[5] = (0, _vue.withKeys)((0, _vue.withModifiers)(($event)=>_ctx.$refs.label.click(), [
                "prevent"
            ]), [
                "enter"
            ]))
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "default"),
            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.computedValue = $event),
                type: "radio",
                ref: "input",
                onClick: _cache[1] || (_cache[1] = (0, _vue.withModifiers)(()=>{}, [
                    "stop"
                ])),
                disabled: _ctx.disabledOrUndefined,
                required: _ctx.requiredOrUndefined,
                name: _ctx.name,
                value: _ctx.nativeValue,
                onFocus: _cache[2] || (_cache[2] = ($event)=>_ctx.isFocused = true),
                onBlur: _cache[3] || (_cache[3] = ($event)=>_ctx.isFocused = false)
            }, null, 40, _hoisted_2$d), [
                [
                    (0, _vue.vModelRadio),
                    _ctx.computedValue
                ]
            ])
        ], 42, _hoisted_1$g)
    ], 2);
}
var RadioButton = /* @__PURE__ */ _export_sfc(RadioButon, [
    [
        "render",
        _sfc_render$h
    ]
]);
const Plugin$g = {
    install (Vue) {
        registerComponent(Vue, Radio);
        registerComponent(Vue, RadioButton);
    }
};
const Rate$1 = (0, _vue.defineComponent)({
    name: "BRate",
    components: {
        BIcon
    },
    props: {
        modelValue: {
            type: Number,
            default: 0
        },
        max: {
            type: Number,
            default: 5
        },
        icon: {
            type: String,
            default: "star"
        },
        iconPack: String,
        size: String,
        spaced: Boolean,
        rtl: Boolean,
        disabled: Boolean,
        showScore: Boolean,
        showText: Boolean,
        customText: String,
        texts: Array,
        locale: {
            type: [
                String,
                Array
            ],
            default: ()=>{
                return config.defaultLocale;
            }
        }
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars */ change: (newValue)=>true,
        "update:modelValue": (newValue)=>true
    },
    data () {
        return {
            newValue: this.modelValue,
            hoverValue: 0
        };
    },
    computed: {
        halfStyle () {
            return `width:${this.valueDecimal}%`;
        },
        showMe () {
            let result = "";
            if (this.showScore) {
                result = this.disabled ? this.modelValue.toString() : this.newValue.toString();
                if (Number(result) === 0) result = "";
                else result = new Intl.NumberFormat(this.locale).format(this.modelValue);
            } else if (this.showText && this.texts) result = this.texts[Math.ceil(this.newValue) - 1];
            return result;
        },
        valueDecimal () {
            return this.modelValue * 100 - Math.floor(this.modelValue) * 100;
        }
    },
    watch: {
        // When v-model is changed set the new value.
        modelValue (value) {
            this.newValue = value;
        }
    },
    methods: {
        resetNewValue () {
            if (this.disabled) return;
            this.hoverValue = 0;
        },
        previewRate (index, event) {
            if (this.disabled) return;
            this.hoverValue = index;
            event.stopPropagation();
        },
        confirmValue (index) {
            if (this.disabled) return;
            this.newValue = index;
            this.$emit("change", this.newValue);
            this.$emit("update:modelValue", this.newValue);
        },
        checkHalf (index) {
            const showWhenDisabled = this.disabled && this.valueDecimal > 0 && index - 1 < this.modelValue && index > this.modelValue;
            return showWhenDisabled;
        },
        rateClass (index) {
            let output = "";
            const currentValue = this.hoverValue !== 0 ? this.hoverValue : this.newValue;
            if (index <= currentValue) output = "set-on";
            else if (this.disabled && Math.ceil(this.modelValue) === index) output = "set-half";
            return output;
        }
    }
});
const _hoisted_1$f = [
    "onMousemove",
    "onClick"
];
const _hoisted_2$c = {
    key: 0
};
function _sfc_render$g(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "rate",
            {
                "is-disabled": _ctx.disabled,
                "is-spaced": _ctx.spaced,
                "is-rtl": _ctx.rtl
            }
        ])
    }, [
        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.max, (item, index)=>{
            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                class: (0, _vue.normalizeClass)([
                    "rate-item",
                    _ctx.rateClass(item)
                ]),
                key: index,
                onMousemove: ($event)=>_ctx.previewRate(item, $event),
                onMouseleave: _cache[0] || (_cache[0] = (...args)=>_ctx.resetNewValue && _ctx.resetNewValue(...args)),
                onClick: (0, _vue.withModifiers)(($event)=>_ctx.confirmValue(item), [
                    "prevent"
                ])
            }, [
                (0, _vue.createVNode)(_component_b_icon, {
                    pack: _ctx.iconPack,
                    icon: _ctx.icon,
                    size: _ctx.size
                }, null, 8, [
                    "pack",
                    "icon",
                    "size"
                ]),
                _ctx.checkHalf(item) ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
                    key: 0,
                    class: "is-half",
                    pack: _ctx.iconPack,
                    icon: _ctx.icon,
                    size: _ctx.size,
                    style: (0, _vue.normalizeStyle)(_ctx.halfStyle)
                }, null, 8, [
                    "pack",
                    "icon",
                    "size",
                    "style"
                ])) : (0, _vue.createCommentVNode)("v-if", true)
            ], 42, _hoisted_1$f);
        }), 128)),
        _ctx.showText || _ctx.showScore || _ctx.customText ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
            key: 0,
            class: (0, _vue.normalizeClass)([
                "rate-text",
                _ctx.size
            ])
        }, [
            (0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)(_ctx.showMe), 1),
            _ctx.customText && !_ctx.showText ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_2$c, (0, _vue.toDisplayString)(_ctx.customText), 1)) : (0, _vue.createCommentVNode)("v-if", true)
        ], 2)) : (0, _vue.createCommentVNode)("v-if", true)
    ], 2);
}
var Rate = /* @__PURE__ */ _export_sfc(Rate$1, [
    [
        "render",
        _sfc_render$g
    ]
]);
const Plugin$f = {
    install (Vue) {
        registerComponent(Vue, Rate);
    }
};
const Plugin$e = {
    install (Vue) {
        registerComponent(Vue, BSelect);
    }
};
const SKELETON_POSITIONS = [
    "",
    "is-centered",
    "is-right"
];
const BSkeleton = (props)=>{
    if (!props.active) return;
    const items = [];
    const width = props.width;
    const height = props.height;
    for(let i = 0; i < props.count; i++)items.push((0, _vue.h)("div", {
        class: [
            "b-skeleton-item",
            {
                "is-rounded": props.rounded
            }
        ],
        key: i,
        style: {
            height: height === void 0 ? null : isNaN(+height) ? height : height + "px",
            width: width === void 0 ? null : isNaN(+width) ? width : width + "px",
            borderRadius: props.circle ? "50%" : null
        }
    }));
    return (0, _vue.h)("div", {
        class: [
            "b-skeleton",
            props.size,
            props.position,
            {
                "is-animated": props.animated
            }
        ]
    }, items);
};
BSkeleton.props = {
    active: {
        type: Boolean,
        default: true
    },
    animated: {
        type: Boolean,
        default: true
    },
    width: [
        Number,
        String
    ],
    height: [
        Number,
        String
    ],
    circle: Boolean,
    rounded: {
        type: Boolean,
        default: true
    },
    count: {
        type: Number,
        default: 1
    },
    position: {
        type: String,
        default: "",
        validator (value) {
            return SKELETON_POSITIONS.indexOf(value) > -1;
        }
    },
    size: String
};
const Plugin$d = {
    install (Vue) {
        registerComponent(Vue, BSkeleton, "BSkeleton");
    }
};
const SIDEBAR_POSITIONS = [
    "fixed",
    "absolute",
    "static"
];
const SCROLL_BEHAVIORS = [
    "clip",
    "keep"
];
var _sfc_main$e = (0, _vue.defineComponent)({
    name: "BSidebar",
    props: {
        modelValue: Boolean,
        type: [
            String,
            Object
        ],
        overlay: Boolean,
        position: {
            type: String,
            default: "fixed",
            validator: (value)=>{
                return SIDEBAR_POSITIONS.indexOf(value) >= 0;
            }
        },
        fullheight: Boolean,
        fullwidth: Boolean,
        right: Boolean,
        mobile: {
            type: String
        },
        reduce: Boolean,
        expandOnHover: Boolean,
        expandOnHoverFixed: Boolean,
        delay: {
            type: [
                Number,
                null
            ],
            default: ()=>config.defaultSidebarDelay
        },
        canCancel: {
            type: [
                Array,
                Boolean
            ],
            default: ()=>[
                    "escape",
                    "outside"
                ]
        },
        onCancel: {
            type: Function,
            default: ()=>{}
        },
        scroll: {
            type: String,
            default: ()=>{
                return config.defaultModalScroll ? config.defaultModalScroll : "clip";
            },
            validator: (value)=>{
                return SCROLL_BEHAVIORS.indexOf(value) >= 0;
            }
        }
    },
    emits: {
        close: ()=>true,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        "update:modelValue": (_value)=>true
    },
    data () {
        return {
            isOpen: this.modelValue,
            isDelayOver: false,
            transitionName: void 0,
            animating: true,
            savedScrollTop: null,
            hasLeaved: false,
            timer: void 0
        };
    },
    computed: {
        rootClasses () {
            return [
                this.type,
                {
                    "is-fixed": this.isFixed,
                    "is-static": this.isStatic,
                    "is-absolute": this.isAbsolute,
                    "is-fullheight": this.fullheight,
                    "is-fullwidth": this.fullwidth,
                    "is-right": this.right,
                    "is-mini": this.reduce && !this.isDelayOver,
                    "is-mini-expand": this.expandOnHover || this.isDelayOver,
                    "is-mini-expand-fixed": this.expandOnHover && this.expandOnHoverFixed || this.isDelayOver,
                    "is-mini-delayed": this.delay !== null,
                    "is-mini-mobile": this.mobile === "reduce",
                    "is-hidden-mobile": this.mobile === "hide",
                    "is-fullwidth-mobile": this.mobile === "fullwidth"
                }
            ];
        },
        cancelOptions () {
            return typeof this.canCancel === "boolean" ? this.canCancel ? [
                "escape",
                "outside"
            ] : [] : this.canCancel;
        },
        isStatic () {
            return this.position === "static";
        },
        isFixed () {
            return this.position === "fixed";
        },
        isAbsolute () {
            return this.position === "absolute";
        }
    },
    watch: {
        modelValue: {
            handler (value) {
                this.isOpen = value;
                if (this.overlay) this.handleScroll();
                const open = this.right ? !value : value;
                this.transitionName = !open ? "slide-prev" : "slide-next";
            },
            immediate: true
        }
    },
    methods: {
        /*
    * Keypress event that is bound to the document.
    */ keyPress ({ key }) {
            if (this.isFixed) {
                if (this.isOpen && (key === "Escape" || key === "Esc")) this.cancel("escape");
            }
        },
        /*
    * Close the Sidebar if canCancel and call the onCancel prop (function).
    */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
        cancel (method, ...args) {
            if (this.cancelOptions.indexOf(method) < 0) return;
            if (this.isStatic) return;
            this.onCancel.call(null, method, ...args);
            this.close();
        },
        /*
    * Call the onCancel prop (function) and emit events
    */ close () {
            this.isOpen = false;
            this.$emit("close");
            this.$emit("update:modelValue", false);
        },
        /*
     * Close fixed sidebar if clicked outside.
     */ clickedOutside (event) {
            if (!this.isFixed || !this.isOpen || this.animating) return;
            if (!event.composedPath().includes(this.$refs.sidebarContent)) this.cancel("outside");
        },
        /*
    * Transition before-enter hook
    */ beforeEnter () {
            this.animating = true;
        },
        /*
    * Transition after-leave hook
    */ afterEnter () {
            this.animating = false;
        },
        handleScroll () {
            if (typeof window === "undefined") return;
            if (this.scroll === "clip") {
                if (this.modelValue) document.documentElement.classList.add("is-clipped");
                else document.documentElement.classList.remove("is-clipped");
                return;
            }
            this.savedScrollTop = !this.savedScrollTop ? document.documentElement.scrollTop : this.savedScrollTop;
            if (this.modelValue) document.body.classList.add("is-noscroll");
            else document.body.classList.remove("is-noscroll");
            if (this.modelValue) {
                document.body.style.top = `-${this.savedScrollTop}px`;
                return;
            }
            document.documentElement.scrollTop = this.savedScrollTop;
            document.body.style.top = "";
            this.savedScrollTop = null;
        },
        onHover () {
            if (this.delay) {
                this.hasLeaved = false;
                this.timer = setTimeout(()=>{
                    if (!this.hasLeaved) this.isDelayOver = true;
                    this.timer = void 0;
                }, this.delay);
            } else this.isDelayOver = false;
        },
        onHoverLeave () {
            this.hasLeaved = true;
            this.timer = void 0;
            this.isDelayOver = false;
        },
        /*
     * Close sidebar if close button is clicked.
     */ clickedCloseButton () {
            if (this.isFixed) {
                if (this.isOpen && this.fullwidth) this.cancel("outside");
            }
        }
    },
    created () {
        if (typeof window !== "undefined") {
            document.addEventListener("keyup", this.keyPress);
            document.addEventListener("click", this.clickedOutside);
        }
    },
    mounted () {
        if (typeof window !== "undefined") {
            if (this.isFixed) document.body.appendChild(this.$el);
        }
        if (this.overlay && this.modelValue) this.handleScroll();
    },
    beforeUnmount () {
        if (typeof window !== "undefined") {
            document.removeEventListener("keyup", this.keyPress);
            document.removeEventListener("click", this.clickedOutside);
            if (this.overlay) {
                document.documentElement.classList.remove("is-clipped");
                const savedScrollTop = !this.savedScrollTop ? document.documentElement.scrollTop : this.savedScrollTop;
                document.body.classList.remove("is-noscroll");
                document.documentElement.scrollTop = savedScrollTop;
                document.body.style.top = "";
            }
        }
        if (this.isFixed) removeElement(this.$el);
        clearTimeout(this.timer);
    }
});
const _hoisted_1$e = {
    class: "b-sidebar"
};
const _hoisted_2$b = {
    key: 0,
    class: "sidebar-background"
};
function _sfc_render$f(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1$e, [
        _ctx.overlay && _ctx.isOpen ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_2$b)) : (0, _vue.createCommentVNode)("v-if", true),
        (0, _vue.createVNode)((0, _vue.Transition), {
            name: _ctx.transitionName,
            onBeforeEnter: _ctx.beforeEnter,
            onAfterEnter: _ctx.afterEnter,
            persisted: ""
        }, {
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("div", {
                        ref: "sidebarContent",
                        class: (0, _vue.normalizeClass)([
                            "sidebar-content",
                            _ctx.rootClasses
                        ]),
                        onMouseenter: _cache[1] || (_cache[1] = (...args)=>_ctx.onHover && _ctx.onHover(...args)),
                        onMouseleave: _cache[2] || (_cache[2] = (...args)=>_ctx.onHoverLeave && _ctx.onHoverLeave(...args))
                    }, [
                        _ctx.fullwidth ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                            key: 0,
                            type: "button",
                            onClick: _cache[0] || (_cache[0] = (...args)=>_ctx.clickedCloseButton && _ctx.clickedCloseButton(...args)),
                            class: "modal-close is-large sidebar-close",
                            "aria-label": "Close"
                        })) : (0, _vue.createCommentVNode)("v-if", true),
                        (0, _vue.renderSlot)(_ctx.$slots, "default")
                    ], 34), [
                        [
                            (0, _vue.vShow),
                            _ctx.isOpen
                        ]
                    ])
                ]),
            _: 3
        }, 8, [
            "name",
            "onBeforeEnter",
            "onAfterEnter"
        ])
    ]);
}
var Sidebar = /* @__PURE__ */ _export_sfc(_sfc_main$e, [
    [
        "render",
        _sfc_render$f
    ]
]);
const Plugin$c = {
    install (Vue) {
        registerComponent(Vue, Sidebar);
    }
};
const DISPLAY_FORMATS = [
    "raw",
    "percent"
];
var _sfc_main$d = (0, _vue.defineComponent)({
    name: "BSliderThumb",
    components: {
        BTooltip: Tooltip
    },
    mixins: [
        CompatFallthroughMixin
    ],
    props: {
        modelValue: {
            type: Number,
            default: 0
        },
        type: {
            type: String,
            default: ""
        },
        tooltip: {
            type: Boolean,
            default: true
        },
        indicator: {
            type: Boolean,
            default: false
        },
        customFormatter: Function,
        format: {
            type: String,
            default: "raw",
            validator: (value)=>{
                return DISPLAY_FORMATS.indexOf(value) >= 0;
            }
        },
        locale: {
            type: [
                String,
                Array
            ],
            default: ()=>{
                return config.defaultLocale;
            }
        },
        tooltipAlways: {
            type: Boolean,
            default: false
        }
    },
    emits: {
        dragend: ()=>true,
        dragstart: ()=>true,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        "update:modelValue": (_value)=>true
    },
    data () {
        return {
            isFocused: false,
            dragging: false,
            startX: 0,
            startPosition: 0,
            newPosition: null,
            oldValue: this.modelValue
        };
    },
    computed: {
        parent () {
            return this.$parent;
        },
        disabled () {
            return this.parent.disabled;
        },
        max () {
            return this.parent.max;
        },
        min () {
            return this.parent.min;
        },
        step () {
            return this.parent.step;
        },
        precision () {
            return this.parent.precision;
        },
        currentPosition () {
            return `${(this.modelValue - this.min) / (this.max - this.min) * 100}%`;
        },
        wrapperStyle () {
            return {
                left: this.currentPosition
            };
        },
        formattedValue () {
            if (typeof this.customFormatter !== "undefined") return this.customFormatter(this.modelValue);
            if (this.format === "percent") return new Intl.NumberFormat(this.locale, {
                style: "percent"
            }).format((this.modelValue - this.min) / (this.max - this.min));
            return new Intl.NumberFormat(this.locale).format(this.modelValue);
        }
    },
    methods: {
        onFocus () {
            this.isFocused = true;
        },
        onBlur () {
            this.isFocused = false;
        },
        onButtonDown (event) {
            if (this.disabled) return;
            event.preventDefault();
            this.onDragStart(event);
            if (typeof window !== "undefined") {
                document.addEventListener("mousemove", this.onDragging);
                document.addEventListener("touchmove", this.onDragging);
                document.addEventListener("mouseup", this.onDragEnd);
                document.addEventListener("touchend", this.onDragEnd);
                document.addEventListener("contextmenu", this.onDragEnd);
            }
        },
        onLeftKeyDown () {
            if (this.disabled || this.modelValue === this.min) return;
            this.newPosition = parseFloat(this.currentPosition) - this.step / (this.max - this.min) * 100;
            this.setPosition(this.newPosition);
            this.parent.emitValue("change");
        },
        onRightKeyDown () {
            if (this.disabled || this.modelValue === this.max) return;
            this.newPosition = parseFloat(this.currentPosition) + this.step / (this.max - this.min) * 100;
            this.setPosition(this.newPosition);
            this.parent.emitValue("change");
        },
        onHomeKeyDown () {
            if (this.disabled || this.modelValue === this.min) return;
            this.newPosition = 0;
            this.setPosition(this.newPosition);
            this.parent.emitValue("change");
        },
        onEndKeyDown () {
            if (this.disabled || this.modelValue === this.max) return;
            this.newPosition = 100;
            this.setPosition(this.newPosition);
            this.parent.emitValue("change");
        },
        onDragStart (event) {
            this.dragging = true;
            this.$emit("dragstart");
            this.startX = event.type === "touchstart" ? event.touches[0].clientX : event.clientX;
            this.startPosition = parseFloat(this.currentPosition);
            this.newPosition = this.startPosition;
        },
        onDragging (event) {
            if (this.dragging) {
                const clientX = event.type === "touchmove" ? event.touches[0].clientX : event.clientX;
                const diff = (clientX - this.startX) / this.parent.sliderSize() * 100;
                this.newPosition = this.startPosition + diff;
                this.setPosition(this.newPosition);
            }
        },
        onDragEnd () {
            this.dragging = false;
            this.$emit("dragend");
            if (this.modelValue !== this.oldValue) this.parent.emitValue("change");
            this.setPosition(this.newPosition);
            if (typeof window !== "undefined") {
                document.removeEventListener("mousemove", this.onDragging);
                document.removeEventListener("touchmove", this.onDragging);
                document.removeEventListener("mouseup", this.onDragEnd);
                document.removeEventListener("touchend", this.onDragEnd);
                document.removeEventListener("contextmenu", this.onDragEnd);
            }
        },
        setPosition (percent) {
            if (percent === null || isNaN(percent)) return;
            if (percent < 0) percent = 0;
            else if (percent > 100) percent = 100;
            const stepLength = 100 / ((this.max - this.min) / this.step);
            const steps = Math.round(percent / stepLength);
            let value = steps * stepLength / 100 * (this.max - this.min) + this.min;
            value = parseFloat(value.toFixed(this.precision));
            this.$emit("update:modelValue", value);
            if (!this.dragging && value !== this.oldValue) this.oldValue = value;
        }
    },
    beforeUnmount () {
        document.removeEventListener("mousemove", this.onDragging);
        document.removeEventListener("touchmove", this.onDragging);
        document.removeEventListener("mouseup", this.onDragEnd);
        document.removeEventListener("touchend", this.onDragEnd);
        document.removeEventListener("contextmenu", this.onDragEnd);
    }
});
const _hoisted_1$d = [
    "tabindex"
];
const _hoisted_2$a = {
    key: 0
};
function _sfc_render$e(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_tooltip = (0, _vue.resolveComponent)("b-tooltip");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", (0, _vue.mergeProps)({
        class: [
            "b-slider-thumb-wrapper",
            {
                "is-dragging": _ctx.dragging,
                "has-indicator": _ctx.indicator
            }
        ],
        style: _ctx.wrapperStyle
    }, _ctx.rootAttrs), [
        (0, _vue.createVNode)(_component_b_tooltip, {
            label: _ctx.formattedValue,
            type: _ctx.type,
            always: _ctx.dragging || _ctx.isFocused || _ctx.tooltipAlways,
            active: !_ctx.disabled && _ctx.tooltip
        }, {
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.createElementVNode)("div", (0, _vue.mergeProps)({
                        class: "b-slider-thumb",
                        tabindex: _ctx.disabled ? void 0 : 0
                    }, _ctx.fallthroughAttrs, {
                        onMousedown: _cache[0] || (_cache[0] = (...args)=>_ctx.onButtonDown && _ctx.onButtonDown(...args)),
                        onTouchstart: _cache[1] || (_cache[1] = (...args)=>_ctx.onButtonDown && _ctx.onButtonDown(...args)),
                        onFocus: _cache[2] || (_cache[2] = (...args)=>_ctx.onFocus && _ctx.onFocus(...args)),
                        onBlur: _cache[3] || (_cache[3] = (...args)=>_ctx.onBlur && _ctx.onBlur(...args)),
                        onKeydown: [
                            _cache[4] || (_cache[4] = (0, _vue.withKeys)((0, _vue.withModifiers)((...args)=>_ctx.onLeftKeyDown && _ctx.onLeftKeyDown(...args), [
                                "prevent"
                            ]), [
                                "left"
                            ])),
                            _cache[5] || (_cache[5] = (0, _vue.withKeys)((0, _vue.withModifiers)((...args)=>_ctx.onRightKeyDown && _ctx.onRightKeyDown(...args), [
                                "prevent"
                            ]), [
                                "right"
                            ])),
                            _cache[6] || (_cache[6] = (0, _vue.withKeys)((0, _vue.withModifiers)((...args)=>_ctx.onLeftKeyDown && _ctx.onLeftKeyDown(...args), [
                                "prevent"
                            ]), [
                                "down"
                            ])),
                            _cache[7] || (_cache[7] = (0, _vue.withKeys)((0, _vue.withModifiers)((...args)=>_ctx.onRightKeyDown && _ctx.onRightKeyDown(...args), [
                                "prevent"
                            ]), [
                                "up"
                            ])),
                            _cache[8] || (_cache[8] = (0, _vue.withKeys)((0, _vue.withModifiers)((...args)=>_ctx.onHomeKeyDown && _ctx.onHomeKeyDown(...args), [
                                "prevent"
                            ]), [
                                "home"
                            ])),
                            _cache[9] || (_cache[9] = (0, _vue.withKeys)((0, _vue.withModifiers)((...args)=>_ctx.onEndKeyDown && _ctx.onEndKeyDown(...args), [
                                "prevent"
                            ]), [
                                "end"
                            ]))
                        ]
                    }), [
                        _ctx.indicator ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_2$a, (0, _vue.toDisplayString)(_ctx.formattedValue), 1)) : (0, _vue.createCommentVNode)("v-if", true)
                    ], 16, _hoisted_1$d)
                ]),
            _: 1
        }, 8, [
            "label",
            "type",
            "always",
            "active"
        ])
    ], 16);
}
var BSliderThumb = /* @__PURE__ */ _export_sfc(_sfc_main$d, [
    [
        "render",
        _sfc_render$e
    ]
]);
var _sfc_main$c = (0, _vue.defineComponent)({
    name: "BSliderTick",
    props: {
        value: {
            type: Number,
            default: 0
        }
    },
    computed: {
        parent () {
            return this.$parent;
        },
        position () {
            const pos = (this.value - this.parent.min) / (this.parent.max - this.parent.min) * 100;
            return pos >= 0 && pos <= 100 ? pos : 0;
        },
        hidden () {
            return this.value === this.parent.min || this.value === this.parent.max;
        }
    },
    methods: {
        getTickStyle (position) {
            return {
                left: position + "%"
            };
        }
    },
    created () {
        if (!this.parent.$data._isSlider) throw new Error("You should wrap bSliderTick on a bSlider");
    }
});
const _hoisted_1$c = {
    key: 0,
    class: "b-slider-tick-label"
};
function _sfc_render$d(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "b-slider-tick",
            {
                "is-tick-hidden": _ctx.hidden
            }
        ]),
        style: (0, _vue.normalizeStyle)(_ctx.getTickStyle(_ctx.position))
    }, [
        _ctx.$slots.default ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_1$c, [
            (0, _vue.renderSlot)(_ctx.$slots, "default")
        ])) : (0, _vue.createCommentVNode)("v-if", true)
    ], 6);
}
var SliderTick = /* @__PURE__ */ _export_sfc(_sfc_main$c, [
    [
        "render",
        _sfc_render$d
    ]
]);
var _sfc_main$b = (0, _vue.defineComponent)({
    name: "BSlider",
    components: {
        BSliderThumb,
        BSliderTick: SliderTick
    },
    props: {
        modelValue: {
            type: [
                Number,
                Array
            ],
            default: 0
        },
        min: {
            type: Number,
            default: 0
        },
        max: {
            type: Number,
            default: 100
        },
        step: {
            type: Number,
            default: 1
        },
        type: {
            type: String,
            default: "is-primary"
        },
        size: String,
        ticks: {
            type: Boolean,
            default: false
        },
        tooltip: {
            type: Boolean,
            default: true
        },
        tooltipType: String,
        rounded: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        lazy: {
            type: Boolean,
            default: false
        },
        customFormatter: Function,
        ariaLabel: [
            String,
            Array
        ],
        biggerSliderFocus: {
            type: Boolean,
            default: false
        },
        indicator: {
            type: Boolean,
            default: false
        },
        format: {
            type: String,
            default: "raw",
            validator: (value)=>{
                return DISPLAY_FORMATS.indexOf(value) >= 0;
            }
        },
        locale: {
            type: [
                String,
                Array
            ],
            default: ()=>{
                return config.defaultLocale;
            }
        },
        tooltipAlways: {
            type: Boolean,
            default: false
        }
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars */ change: (_value)=>true,
        dragend: ()=>true,
        dragging: (_value)=>true,
        dragstart: ()=>true,
        "update:modelValue": (_value)=>true
    },
    data () {
        return {
            value1: void 0,
            value2: void 0,
            // internal is used to update value1 and value2 with a single shot.
            // internal is also used to stop unnecessary propagation of update.
            internal: {
                value1: void 0,
                value2: void 0
            },
            dragging: false,
            isRange: false,
            isThumbReversed: false,
            isTrackClickDisabled: false,
            _isSlider: true,
            // Used by Thumb and Tick
            timeOutID: void 0
        };
    },
    computed: {
        newTooltipType () {
            return this.tooltipType ? this.tooltipType : this.type;
        },
        tickValues () {
            if (!this.ticks || this.min > this.max || this.step === 0) return [];
            const result = [];
            for(let i = this.min + this.step; i < this.max; i = i + this.step)result.push(i);
            return result;
        },
        minValue () {
            return Math.min(this.value1, this.value2);
        },
        maxValue () {
            return Math.max(this.value1, this.value2);
        },
        barSize () {
            return this.isRange ? `${100 * (this.maxValue - this.minValue) / (this.max - this.min)}%` : `${100 * (this.value1 - this.min) / (this.max - this.min)}%`;
        },
        barStart () {
            return this.isRange ? `${100 * (this.minValue - this.min) / (this.max - this.min)}%` : "0%";
        },
        precision () {
            const precisions = [
                this.min,
                this.max,
                this.step
            ].map((item)=>{
                const decimal = ("" + item).split(".")[1];
                return decimal ? decimal.length : 0;
            });
            return Math.max(...precisions);
        },
        barStyle () {
            return {
                width: this.barSize,
                left: this.barStart
            };
        },
        rootClasses () {
            return {
                "is-rounded": this.rounded,
                "is-dragging": this.dragging,
                "is-disabled": this.disabled,
                "slider-focus": this.biggerSliderFocus
            };
        }
    },
    watch: {
        /*
    * When v-model is changed set the new active step.
    */ modelValue (value) {
            this.setValues(value);
        },
        internal ({ value1, value2 }) {
            this.value1 = value1;
            this.value2 = value2;
        },
        value1 (newValue) {
            if (this.internal.value1 !== newValue) this.onInternalValueUpdate();
        },
        value2 (newValue) {
            if (this.internal.value2 !== newValue) this.onInternalValueUpdate();
        },
        min () {
            this.setValues(this.modelValue);
        },
        max () {
            this.setValues(this.modelValue);
        }
    },
    methods: {
        setValues (newValue) {
            if (this.min > this.max) return;
            if (Array.isArray(newValue)) {
                this.isRange = true;
                const smallValue = typeof newValue[0] !== "number" || isNaN(newValue[0]) ? this.min : bound(newValue[0], this.min, this.max);
                const largeValue = typeof newValue[1] !== "number" || isNaN(newValue[1]) ? this.max : bound(newValue[1], this.min, this.max);
                this.internal = {
                    value1: this.isThumbReversed ? largeValue : smallValue,
                    value2: this.isThumbReversed ? smallValue : largeValue
                };
            } else {
                this.isRange = false;
                this.internal = {
                    value1: isNaN(newValue) ? this.min : bound(newValue, this.min, this.max),
                    value2: void 0
                };
            }
        },
        onInternalValueUpdate () {
            if (this.isRange) this.isThumbReversed = this.value1 > this.value2;
            if (!this.lazy || !this.dragging) this.emitValue("update:modelValue");
            if (this.dragging) this.emitValue("dragging");
        },
        sliderSize () {
            return this.$refs.slider.getBoundingClientRect().width;
        },
        onSliderClick (event) {
            if (this.disabled || this.isTrackClickDisabled) return;
            const sliderOffsetLeft = this.$refs.slider.getBoundingClientRect().left;
            const percent = (event.clientX - sliderOffsetLeft) / this.sliderSize() * 100;
            const targetValue = this.min + percent * (this.max - this.min) / 100;
            const diffFirst = Math.abs(targetValue - this.value1);
            if (!this.isRange) {
                if (diffFirst < this.step / 2) return;
                this.$refs.button1.setPosition(percent);
            } else {
                const diffSecond = Math.abs(targetValue - this.value2);
                if (diffFirst <= diffSecond) {
                    if (diffFirst < this.step / 2) return;
                    this.$refs.button1.setPosition(percent);
                } else {
                    if (diffSecond < this.step / 2) return;
                    this.$refs.button2.setPosition(percent);
                }
            }
            this.emitValue("change");
        },
        onDragStart () {
            this.dragging = true;
            this.$emit("dragstart");
        },
        onDragEnd () {
            this.isTrackClickDisabled = true;
            this.timeOutID = setTimeout(()=>{
                this.isTrackClickDisabled = false;
            }, 0);
            this.dragging = false;
            this.$emit("dragend");
            if (this.lazy) this.emitValue("update:modelValue");
        },
        emitValue (type) {
            const emittedValue = this.isRange ? [
                this.minValue,
                this.maxValue
            ] : this.value1;
            switch(type){
                case "change":
                    this.$emit(type, emittedValue);
                    break;
                case "dragging":
                    this.$emit(type, emittedValue);
                    break;
                case "update:modelValue":
                    this.$emit(type, emittedValue);
                    break;
            }
        }
    },
    created () {
        this.isThumbReversed = false;
        this.isTrackClickDisabled = false;
        this.setValues(this.modelValue);
    },
    beforeUnmount () {
        clearTimeout(this.timeOutID);
    }
});
const _hoisted_1$b = {
    class: "b-slider-track",
    ref: "slider"
};
function _sfc_render$c(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_slider_tick = (0, _vue.resolveComponent)("b-slider-tick");
    const _component_b_slider_thumb = (0, _vue.resolveComponent)("b-slider-thumb");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "b-slider",
            [
                _ctx.size,
                _ctx.type,
                _ctx.rootClasses
            ]
        ]),
        onClick: _cache[2] || (_cache[2] = (...args)=>_ctx.onSliderClick && _ctx.onSliderClick(...args))
    }, [
        (0, _vue.createElementVNode)("div", _hoisted_1$b, [
            (0, _vue.createElementVNode)("div", {
                class: "b-slider-fill",
                style: (0, _vue.normalizeStyle)(_ctx.barStyle)
            }, null, 4),
            _ctx.ticks ? ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                key: 0
            }, (0, _vue.renderList)(_ctx.tickValues, (val, key)=>{
                return (0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_slider_tick, {
                    key,
                    value: val
                }, null, 8, [
                    "value"
                ]);
            }), 128)) : (0, _vue.createCommentVNode)("v-if", true),
            (0, _vue.renderSlot)(_ctx.$slots, "default"),
            (0, _vue.createVNode)(_component_b_slider_thumb, {
                "tooltip-always": _ctx.tooltipAlways,
                modelValue: _ctx.value1,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.value1 = $event),
                type: _ctx.newTooltipType,
                tooltip: _ctx.tooltip,
                "custom-formatter": _ctx.customFormatter,
                indicator: _ctx.indicator,
                format: _ctx.format,
                locale: _ctx.locale,
                ref: "button1",
                role: "slider",
                "aria-valuenow": _ctx.value1,
                "aria-valuemin": _ctx.min,
                "aria-valuemax": _ctx.max,
                "aria-orientation": "horizontal",
                "aria-label": Array.isArray(_ctx.ariaLabel) ? _ctx.ariaLabel[0] : _ctx.ariaLabel,
                "aria-disabled": _ctx.disabled || void 0,
                onDragstart: _ctx.onDragStart,
                onDragend: _ctx.onDragEnd
            }, null, 8, [
                "tooltip-always",
                "modelValue",
                "type",
                "tooltip",
                "custom-formatter",
                "indicator",
                "format",
                "locale",
                "aria-valuenow",
                "aria-valuemin",
                "aria-valuemax",
                "aria-label",
                "aria-disabled",
                "onDragstart",
                "onDragend"
            ]),
            _ctx.isRange ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_slider_thumb, {
                key: 1,
                "tooltip-always": _ctx.tooltipAlways,
                modelValue: _ctx.value2,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>_ctx.value2 = $event),
                type: _ctx.newTooltipType,
                tooltip: _ctx.tooltip,
                "custom-formatter": _ctx.customFormatter,
                indicator: _ctx.indicator,
                format: _ctx.format,
                locale: _ctx.locale,
                ref: "button2",
                role: "slider",
                "aria-valuenow": _ctx.value2,
                "aria-valuemin": _ctx.min,
                "aria-valuemax": _ctx.max,
                "aria-orientation": "horizontal",
                "aria-label": Array.isArray(_ctx.ariaLabel) ? _ctx.ariaLabel[1] : "",
                "aria-disabled": _ctx.disabled || void 0,
                onDragstart: _ctx.onDragStart,
                onDragend: _ctx.onDragEnd
            }, null, 8, [
                "tooltip-always",
                "modelValue",
                "type",
                "tooltip",
                "custom-formatter",
                "indicator",
                "format",
                "locale",
                "aria-valuenow",
                "aria-valuemin",
                "aria-valuemax",
                "aria-label",
                "aria-disabled",
                "onDragstart",
                "onDragend"
            ])) : (0, _vue.createCommentVNode)("v-if", true)
        ], 512)
    ], 2);
}
var Slider = /* @__PURE__ */ _export_sfc(_sfc_main$b, [
    [
        "render",
        _sfc_render$c
    ]
]);
const Plugin$b = {
    install (Vue) {
        registerComponent(Vue, Slider);
        registerComponent(Vue, SliderTick);
    }
};
const Snackbar$1 = (0, _vue.defineComponent)({
    name: "BSnackbar",
    mixins: [
        NoticeMixin
    ],
    props: {
        actionText: {
            type: String,
            default: "OK"
        },
        onAction: {
            type: Function,
            default: ()=>{}
        },
        cancelText: {
            type: String,
            default: null
        }
    },
    data () {
        return {
            newDuration: this.duration || config.defaultSnackbarDuration
        };
    },
    methods: {
        /*
    * Click listener.
    * Call action prop before closing (from Mixin).
    */ action () {
            this.onAction();
            this.close();
        }
    }
});
const _hoisted_1$a = [
    "role"
];
const _hoisted_2$9 = [
    "innerHTML"
];
const _hoisted_3$7 = {
    class: "button"
};
const _hoisted_4$4 = {
    class: "button"
};
function _sfc_render$b(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.Transition), {
        "enter-active-class": _ctx.transition.enter,
        "leave-active-class": _ctx.transition.leave,
        persisted: ""
    }, {
        default: (0, _vue.withCtx)(()=>[
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("div", {
                    class: (0, _vue.normalizeClass)([
                        "snackbar",
                        [
                            _ctx.type,
                            _ctx.position
                        ]
                    ]),
                    onMouseenter: _cache[2] || (_cache[2] = (...args)=>_ctx.pause && _ctx.pause(...args)),
                    onMouseleave: _cache[3] || (_cache[3] = (...args)=>_ctx.removePause && _ctx.removePause(...args)),
                    role: _ctx.actionText ? "alertdialog" : "alert"
                }, [
                    _ctx.$slots.default ? (0, _vue.renderSlot)(_ctx.$slots, "default", {
                        key: 0
                    }) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                        key: 1
                    }, [
                        (0, _vue.createCommentVNode)(" eslint-disable-next-line vue/no-v-html "),
                        (0, _vue.createElementVNode)("div", {
                            class: "text",
                            innerHTML: _ctx.message
                        }, null, 8, _hoisted_2$9)
                    ], 64)),
                    _ctx.cancelText ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                        key: 2,
                        class: "action is-light is-cancel",
                        onClick: _cache[0] || (_cache[0] = (...args)=>_ctx.close && _ctx.close(...args))
                    }, [
                        (0, _vue.createElementVNode)("button", _hoisted_3$7, (0, _vue.toDisplayString)(_ctx.cancelText), 1)
                    ])) : (0, _vue.createCommentVNode)("v-if", true),
                    _ctx.actionText ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                        key: 3,
                        class: (0, _vue.normalizeClass)([
                            "action",
                            _ctx.type
                        ]),
                        onClick: _cache[1] || (_cache[1] = (...args)=>_ctx.action && _ctx.action(...args))
                    }, [
                        (0, _vue.createElementVNode)("button", _hoisted_4$4, (0, _vue.toDisplayString)(_ctx.actionText), 1)
                    ], 2)) : (0, _vue.createCommentVNode)("v-if", true)
                ], 42, _hoisted_1$a), [
                    [
                        (0, _vue.vShow),
                        _ctx.isActive
                    ]
                ])
            ]),
        _: 3
    }, 8, [
        "enter-active-class",
        "leave-active-class"
    ]);
}
var Snackbar = /* @__PURE__ */ _export_sfc(Snackbar$1, [
    [
        "render",
        _sfc_render$b
    ]
]);
var __defProp$2 = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value)=>key in obj ? __defProp$2(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues$2 = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
    if (__getOwnPropSymbols$2) {
        for (var prop of __getOwnPropSymbols$2(b))if (__propIsEnum$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps$2 = (a, b)=>__defProps$2(a, __getOwnPropDescs$2(b));
var __objRest$1 = (source, exclude)=>{
    var target = {};
    for(var prop in source)if (__hasOwnProp$2.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$2) {
        for (var prop of __getOwnPropSymbols$2(source))if (exclude.indexOf(prop) < 0 && __propIsEnum$2.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var __publicField$1 = (obj, key, value)=>__defNormalProp$2(obj, key + "", value);
class SnackbarProgrammatic {
    // may be undefined in the testing environment
    constructor(app){
        __publicField$1(this, "app");
        this.app = app;
    }
    open(params) {
        if (typeof params === "string") params = {
            message: params
        };
        let slot;
        let _a = params, { message } = _a, restParams = __objRest$1(_a, [
            "message"
        ]);
        if (typeof message !== "string") {
            slot = message;
            message = void 0;
        }
        const propsData = __spreadValues$2({
            type: "is-success",
            position: config.defaultSnackbarPosition || "is-bottom-right",
            queue: true,
            message
        }, restParams);
        const container = document.createElement("div");
        const vueInstance = (0, _vue.createApp)({
            data () {
                return {
                    snackbarVNode: null
                };
            },
            methods: {
                close () {
                    const snackbar = getComponentFromVNode(this.snackbarVNode);
                    if (snackbar) snackbar.close();
                }
            },
            render () {
                this.snackbarVNode = (0, _vue.h)(Snackbar, __spreadProps$2(__spreadValues$2({}, propsData), {
                    onClose () {
                        if (typeof propsData.onClose === "function") propsData.onClose();
                        setTimeout(()=>{
                            vueInstance.unmount();
                        }, 150);
                    }
                }), slot != null ? {
                    default: ()=>slot
                } : void 0);
                return this.snackbarVNode;
            }
        });
        if (this.app) copyAppContext(this.app, vueInstance);
        else vueInstance.config.globalProperties.$buefy = {};
        return vueInstance.mount(container);
    }
}
const Plugin$a = {
    install (Vue) {
        registerComponentProgrammatic(Vue, "snackbar", new SnackbarProgrammatic(Vue));
    }
};
var BSlotComponent = (0, _vue.defineComponent)({
    name: "BSlotComponent",
    props: {
        component: {
            type: Object,
            required: true
        },
        name: {
            type: String,
            default: "default"
        },
        scoped: {
            type: Boolean
        },
        props: {
            type: Object
        },
        tag: {
            type: [
                String,
                Object
            ],
            default: "div"
        }
    },
    methods: {
        refresh () {
            this.$forceUpdate();
        }
    },
    render () {
        return (0, _vue.h)(this.tag, {}, this.component.$slots ? this.scoped ? this.component.$slots[this.name](this.props) : this.component.$slots[this.name]() : void 0);
    }
});
var TabbedMixin = (cmp)=>(0, _vue.defineComponent)({
        components: {
            BIcon,
            BSlotComponent
        },
        mixins: [
            ProviderParentMixin(cmp, Sorted$1)
        ],
        props: {
            modelValue: {
                type: [
                    String,
                    Number,
                    null
                ],
                default: void 0
            },
            size: String,
            animated: {
                type: Boolean,
                default: true
            },
            animation: String,
            animateInitially: Boolean,
            vertical: {
                type: Boolean,
                default: false
            },
            position: String,
            destroyOnHide: {
                type: Boolean,
                default: false
            }
        },
        emits: {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            "update:modelValue": (_value)=>true
        },
        data () {
            return {
                activeId: this.modelValue,
                // Internal state
                defaultSlots: [],
                contentHeight: 0,
                isTransitioning: false
            };
        },
        computed: {
            activeItem () {
                const childItems = this.childItems;
                return this.activeId === void 0 ? this.items[0] : this.activeId === null ? null : childItems.find((i)=>i.uniqueValue === this.activeId);
            },
            items () {
                return this.sortedItems;
            }
        },
        watch: {
            /*
     * When v-model is changed set the new active tab.
     */ modelValue (value) {
                if (typeof value === "number") {
                    value = bound(value, 0, this.items.length - 1);
                    this.activeId = this.items[value].uniqueValue;
                } else this.activeId = value;
            },
            /*
     * Sync internal state with external state
     */ activeId (val, oldValue) {
                const oldTab = oldValue !== void 0 && oldValue !== null ? this.childItems.find((i)=>i.uniqueValue === oldValue) : null;
                if (oldTab && this.activeItem) {
                    oldTab.deactivate(this.activeItem.index);
                    this.activeItem.activate(oldTab.index);
                }
                val = this.activeItem ? typeof this.modelValue === "number" ? this.items.indexOf(this.activeItem) : this.activeItem.uniqueValue : void 0;
                if (val !== this.modelValue) this.$emit("update:modelValue", val);
            }
        },
        methods: {
            /*
    * Child click listener, emit input event and change active child.
    */ childClick (child) {
                this.activeId = child.uniqueValue;
            },
            getNextItemIdx (fromIdx, skipDisabled = false) {
                let nextItemIdx = null;
                for(let i = 0; i < this.items.length; i++){
                    const item = this.items[i];
                    if (fromIdx < item.index && item.visible && (!skipDisabled || skipDisabled && !item.disabled)) {
                        nextItemIdx = item.index;
                        break;
                    }
                }
                return nextItemIdx;
            },
            getPrevItemIdx (fromIdx, skipDisabled = false) {
                let prevItemIdx = null;
                for(let i = this.items.length - 1; i >= 0; i--){
                    const item = this.items[i];
                    if (item.index < fromIdx && item.visible && (!skipDisabled || skipDisabled && !item.disabled)) {
                        prevItemIdx = item.index;
                        break;
                    }
                }
                return prevItemIdx;
            }
        },
        mounted () {
            if (typeof this.modelValue === "number") {
                const value = bound(this.modelValue, 0, this.items.length - 1);
                this.activeId = this.items[value].uniqueValue;
            } else this.activeId = this.modelValue;
        }
    });
const LABEL_POSITIONS = [
    "bottom",
    "right",
    "left"
];
const MOBILE_MODES = [
    "minimalist",
    "compact"
];
var _sfc_main$a = (0, _vue.defineComponent)({
    name: "BSteps",
    components: {
        BIcon
    },
    mixins: [
        TabbedMixin("step")
    ],
    props: {
        type: [
            String,
            Object
        ],
        iconPack: String,
        iconPrev: {
            type: String,
            default: ()=>{
                return config.defaultIconPrev;
            }
        },
        iconNext: {
            type: String,
            default: ()=>{
                return config.defaultIconNext;
            }
        },
        hasNavigation: {
            type: Boolean,
            default: true
        },
        labelPosition: {
            type: String,
            validator (value) {
                return LABEL_POSITIONS.indexOf(value) > -1;
            },
            default: "bottom"
        },
        rounded: {
            type: Boolean,
            default: true
        },
        mobileMode: {
            type: String,
            validator (value) {
                return MOBILE_MODES.indexOf(value) > -1;
            },
            default: "minimalist"
        },
        ariaNextLabel: String,
        ariaPreviousLabel: String
    },
    computed: {
        // Override mixin implementation to always have a value
        activeItem () {
            return this.childItems.filter((i)=>i.uniqueValue === this.activeId)[0] || this.items[0];
        },
        wrapperClasses () {
            return [
                this.size,
                {
                    "is-vertical": this.vertical,
                    [this.position]: this.position && this.vertical
                }
            ];
        },
        mainClasses () {
            return [
                this.type,
                {
                    "has-label-right": this.labelPosition === "right",
                    "has-label-left": this.labelPosition === "left",
                    "is-animated": this.animated,
                    "is-rounded": this.rounded,
                    [`mobile-${this.mobileMode}`]: this.mobileMode !== null
                }
            ];
        },
        /*
     * Check if previous button is available.
     */ hasPrev () {
            return this.prevItemIdx !== null;
        },
        /*
     * Retrieves the next visible item index
     */ nextItemIdx () {
            const idx = this.activeItem ? this.activeItem.index : 0;
            return this.getNextItemIdx(idx);
        },
        /*
     * Retrieves the next visible item
     */ nextItem () {
            let nextItem = null;
            if (this.nextItemIdx !== null) nextItem = this.items.find((i)=>i.index === this.nextItemIdx);
            return nextItem;
        },
        /*
    * Retrieves the next visible item index
    */ prevItemIdx () {
            if (!this.activeItem) return null;
            const idx = this.activeItem.index;
            return this.getPrevItemIdx(idx);
        },
        /*
     * Retrieves the previous visible item
     */ prevItem () {
            if (!this.activeItem) return null;
            let prevItem = null;
            if (this.prevItemIdx !== null) prevItem = this.items.find((i)=>i.index === this.prevItemIdx);
            return prevItem;
        },
        /*
     * Check if next button is available.
     */ hasNext () {
            return this.nextItemIdx !== null;
        },
        navigationProps () {
            return {
                previous: {
                    disabled: !this.hasPrev,
                    action: this.prev
                },
                next: {
                    disabled: !this.hasNext,
                    action: this.next
                }
            };
        }
    },
    methods: {
        /*
     * Return if the step should be clickable or not.
     */ isItemClickable (stepItem) {
            if (stepItem.clickable === void 0) return stepItem.index < this.activeItem.index;
            return stepItem.clickable;
        },
        /*
     * Previous button click listener.
     */ prev () {
            if (this.hasPrev) this.activeId = this.prevItem.uniqueValue;
        },
        /*
     * Previous button click listener.
     */ next () {
            if (this.hasNext) this.activeId = this.nextItem.uniqueValue;
        }
    }
});
const _hoisted_1$9 = {
    class: "step-items"
};
const _hoisted_2$8 = [
    "onClick"
];
const _hoisted_3$6 = {
    class: "step-marker"
};
const _hoisted_4$3 = {
    key: 1
};
const _hoisted_5$2 = {
    class: "step-details"
};
const _hoisted_6$1 = {
    class: "step-title"
};
const _hoisted_7$1 = {
    key: 0,
    class: "step-navigation"
};
const _hoisted_8$1 = [
    "disabled",
    "aria-label"
];
const _hoisted_9$1 = [
    "disabled",
    "aria-label"
];
function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "b-steps",
            _ctx.wrapperClasses
        ])
    }, [
        (0, _vue.createElementVNode)("nav", {
            class: (0, _vue.normalizeClass)([
                "steps",
                _ctx.mainClasses
            ])
        }, [
            (0, _vue.createElementVNode)("ul", _hoisted_1$9, [
                ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.items, (childItem)=>{
                    return (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", {
                        key: childItem.uniqueValue,
                        class: (0, _vue.normalizeClass)([
                            "step-item",
                            [
                                childItem.type || _ctx.type,
                                childItem.headerClass,
                                {
                                    "is-active": childItem.isActive,
                                    "is-previous": _ctx.activeItem.index > childItem.index
                                }
                            ]
                        ])
                    }, [
                        (0, _vue.createElementVNode)("a", {
                            class: (0, _vue.normalizeClass)([
                                "step-link",
                                {
                                    "is-clickable": _ctx.isItemClickable(childItem)
                                }
                            ]),
                            onClick: ($event)=>_ctx.isItemClickable(childItem) && _ctx.childClick(childItem)
                        }, [
                            (0, _vue.createElementVNode)("div", _hoisted_3$6, [
                                childItem.icon ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
                                    key: 0,
                                    icon: childItem.icon,
                                    pack: childItem.iconPack,
                                    size: _ctx.size
                                }, null, 8, [
                                    "icon",
                                    "pack",
                                    "size"
                                ])) : childItem.step ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_4$3, (0, _vue.toDisplayString)(childItem.step), 1)) : (0, _vue.createCommentVNode)("v-if", true)
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_5$2, [
                                (0, _vue.createElementVNode)("span", _hoisted_6$1, (0, _vue.toDisplayString)(childItem.label), 1)
                            ])
                        ], 10, _hoisted_2$8)
                    ], 2)), [
                        [
                            (0, _vue.vShow),
                            childItem.visible
                        ]
                    ]);
                }), 128))
            ])
        ], 2),
        (0, _vue.createElementVNode)("section", {
            class: (0, _vue.normalizeClass)([
                "step-content",
                {
                    "is-transitioning": _ctx.isTransitioning
                }
            ])
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "default")
        ], 2),
        (0, _vue.renderSlot)(_ctx.$slots, "navigation", {
            previous: _ctx.navigationProps.previous,
            next: _ctx.navigationProps.next
        }, ()=>[
                _ctx.hasNavigation ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("nav", _hoisted_7$1, [
                    (0, _vue.createElementVNode)("a", {
                        role: "button",
                        class: "pagination-previous",
                        disabled: _ctx.navigationProps.previous.disabled || void 0,
                        onClick: _cache[0] || (_cache[0] = (0, _vue.withModifiers)((...args)=>_ctx.navigationProps.previous.action && _ctx.navigationProps.previous.action(...args), [
                            "prevent"
                        ])),
                        "aria-label": _ctx.ariaPreviousLabel
                    }, [
                        (0, _vue.createVNode)(_component_b_icon, {
                            icon: _ctx.iconPrev,
                            pack: _ctx.iconPack,
                            both: "",
                            "aria-hidden": "true"
                        }, null, 8, [
                            "icon",
                            "pack"
                        ])
                    ], 8, _hoisted_8$1),
                    (0, _vue.createElementVNode)("a", {
                        role: "button",
                        class: "pagination-next",
                        disabled: _ctx.navigationProps.next.disabled || void 0,
                        onClick: _cache[1] || (_cache[1] = (0, _vue.withModifiers)((...args)=>_ctx.navigationProps.next.action && _ctx.navigationProps.next.action(...args), [
                            "prevent"
                        ])),
                        "aria-label": _ctx.ariaNextLabel
                    }, [
                        (0, _vue.createVNode)(_component_b_icon, {
                            icon: _ctx.iconNext,
                            pack: _ctx.iconPack,
                            both: "",
                            "aria-hidden": "true"
                        }, null, 8, [
                            "icon",
                            "pack"
                        ])
                    ], 8, _hoisted_9$1)
                ])) : (0, _vue.createCommentVNode)("v-if", true)
            ])
    ], 2);
}
var Steps = /* @__PURE__ */ _export_sfc(_sfc_main$a, [
    [
        "render",
        _sfc_render$a
    ]
]);
var TabbedChildMixin = (parentCmp)=>(0, _vue.defineComponent)({
        mixins: [
            InjectedChildMixin(parentCmp, Sorted)
        ],
        props: {
            label: String,
            icon: String,
            iconPack: String,
            visible: {
                type: Boolean,
                default: true
            },
            headerClass: {
                type: [
                    String,
                    Array,
                    Object
                ],
                default: null
            }
        },
        data () {
            return {
                transitionName: null,
                elementClass: "item",
                elementRole: null
            };
        },
        computed: {
            isActive () {
                return this.parent.activeItem === this;
            }
        },
        methods: {
            /*
     * Activate element, alter animation name based on the index.
     */ activate (oldIndex) {
                this.transitionName = this.index < oldIndex ? this.parent.vertical ? "slide-down" : "slide-next" : this.parent.vertical ? "slide-up" : "slide-prev";
            },
            /*
     * Deactivate element, alter animation name based on the index.
     */ deactivate (newIndex) {
                this.transitionName = newIndex < this.index ? this.parent.vertical ? "slide-down" : "slide-next" : this.parent.vertical ? "slide-up" : "slide-prev";
            }
        },
        render () {
            var _a;
            if (this.parent.destroyOnHide) {
                if (!this.isActive || !this.visible) return;
            }
            const vnode = (0, _vue.withDirectives)((0, _vue.h)("div", {
                // NOTE: possible regression of #3272
                // https://github.com/buefy/buefy/issues/3272
                class: this.elementClass,
                role: this.elementRole,
                id: `${this.uniqueValue}-content`,
                "aria-labelledby": this.elementRole ? `${this.uniqueValue}-label` : null,
                tabindex: this.isActive ? 0 : -1
            }, this.$slots), [
                [
                    (0, _vue.vShow),
                    this.isActive && this.visible
                ]
            ]);
            if (this.parent.animated) return (0, _vue.h)((0, _vue.Transition), {
                name: (_a = this.parent.animation || this.transitionName) != null ? _a : void 0,
                appear: this.parent.animateInitially === true || void 0,
                onBeforeEnter: ()=>{
                    this.parent.isTransitioning = true;
                },
                onAfterEnter: ()=>{
                    this.parent.isTransitioning = false;
                }
            }, {
                default: ()=>vnode
            });
            return vnode;
        }
    });
var _sfc_main$9 = (0, _vue.defineComponent)({
    name: "BStepItem",
    mixins: [
        TabbedChildMixin("step")
    ],
    props: {
        step: [
            String,
            Number
        ],
        type: [
            String,
            Object
        ],
        clickable: {
            type: Boolean,
            default: void 0
        }
    },
    data () {
        return {
            elementClass: "step-item"
        };
    }
});
const Plugin$9 = {
    install (Vue) {
        registerComponent(Vue, Steps);
        registerComponent(Vue, _sfc_main$9);
    }
};
const Switch$1 = (0, _vue.defineComponent)({
    name: "BSwitch",
    props: {
        modelValue: [
            String,
            Number,
            Boolean,
            Function,
            Object,
            Array,
            Date
        ],
        nativeValue: [
            String,
            Number,
            Boolean,
            Function,
            Object,
            Array,
            Date
        ],
        disabled: Boolean,
        type: String,
        passiveType: String,
        name: String,
        required: Boolean,
        size: String,
        ariaLabelledby: String,
        trueValue: {
            type: [
                String,
                Number,
                Boolean,
                Function,
                Object,
                Array,
                Date
            ],
            default: true
        },
        falseValue: {
            type: [
                String,
                Number,
                Boolean,
                Function,
                Object,
                Array,
                Date
            ],
            default: false
        },
        rounded: {
            type: Boolean,
            default: ()=>{
                return config.defaultSwitchRounded;
            }
        },
        outlined: {
            type: Boolean,
            default: false
        },
        leftLabel: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        "update:modelValue"
    ],
    data () {
        return {
            newValue: this.modelValue,
            isMouseDown: false
        };
    },
    computed: {
        computedValue: {
            get () {
                return this.newValue;
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            set (value) {
                this.newValue = value;
                this.$emit("update:modelValue", value);
            }
        },
        newClass () {
            return [
                this.size,
                {
                    "is-disabled": this.disabled,
                    "is-rounded": this.rounded,
                    "is-outlined": this.outlined,
                    "has-left-label": this.leftLabel
                }
            ];
        },
        checkClasses () {
            return [
                {
                    "is-elastic": this.isMouseDown && !this.disabled
                },
                this.passiveType && `${this.passiveType}-passive`,
                this.type
            ];
        },
        showControlLabel () {
            return !!this.$slots.default;
        },
        disabledOrUndefined () {
            return this.disabled || void 0;
        }
    },
    watch: {
        /*
    * When v-model change, set internal value.
    */ modelValue (value) {
            this.newValue = value;
        }
    },
    methods: {
        focus () {
            this.$refs.input.focus();
        }
    }
});
const _hoisted_1$8 = [
    "disabled"
];
const _hoisted_2$7 = [
    "disabled",
    "name",
    "required",
    "value",
    "true-value",
    "false-value",
    "aria-labelledby"
];
const _hoisted_3$5 = [
    "id"
];
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("label", {
        class: (0, _vue.normalizeClass)([
            "switch",
            _ctx.newClass
        ]),
        ref: "label",
        disabled: _ctx.disabledOrUndefined,
        onClick: _cache[2] || (_cache[2] = (...args)=>_ctx.focus && _ctx.focus(...args)),
        onKeydown: _cache[3] || (_cache[3] = (0, _vue.withKeys)((0, _vue.withModifiers)(($event)=>_ctx.$refs.label.click(), [
            "prevent"
        ]), [
            "enter"
        ])),
        onMousedown: _cache[4] || (_cache[4] = ($event)=>_ctx.isMouseDown = true),
        onMouseup: _cache[5] || (_cache[5] = ($event)=>_ctx.isMouseDown = false),
        onMouseout: _cache[6] || (_cache[6] = ($event)=>_ctx.isMouseDown = false),
        onBlur: _cache[7] || (_cache[7] = ($event)=>_ctx.isMouseDown = false)
    }, [
        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.computedValue = $event),
            type: "checkbox",
            ref: "input",
            onClick: _cache[1] || (_cache[1] = (0, _vue.withModifiers)(()=>{}, [
                "stop"
            ])),
            disabled: _ctx.disabledOrUndefined,
            name: _ctx.name,
            required: _ctx.required,
            value: _ctx.nativeValue,
            "true-value": _ctx.trueValue,
            "false-value": _ctx.falseValue,
            "aria-labelledby": _ctx.ariaLabelledby
        }, null, 8, _hoisted_2$7), [
            [
                (0, _vue.vModelCheckbox),
                _ctx.computedValue
            ]
        ]),
        (0, _vue.createElementVNode)("span", {
            class: (0, _vue.normalizeClass)([
                "check",
                _ctx.checkClasses
            ])
        }, null, 2),
        _ctx.showControlLabel ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", {
            key: 0,
            id: _ctx.ariaLabelledby,
            class: "control-label"
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "default")
        ], 8, _hoisted_3$5)) : (0, _vue.createCommentVNode)("v-if", true)
    ], 42, _hoisted_1$8);
}
var Switch = /* @__PURE__ */ _export_sfc(Switch$1, [
    [
        "render",
        _sfc_render$9
    ]
]);
const Plugin$8 = {
    install (Vue) {
        registerComponent(Vue, Switch);
    }
};
var _sfc_main$8 = (0, _vue.defineComponent)({
    name: "BTableMobileSort",
    components: {
        BSelect,
        BIcon
    },
    props: {
        currentSortColumn: Object,
        sortMultipleData: Array,
        isAsc: Boolean,
        columns: Array,
        placeholder: String,
        iconPack: String,
        sortIcon: {
            type: String,
            default: "arrow-up"
        },
        sortIconSize: {
            type: String,
            default: "is-small"
        },
        sortMultiple: {
            type: Boolean,
            default: false
        }
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars */ removePriority: (_column)=>true,
        sort: (_column, _event)=>true
    },
    data () {
        return {
            sortMultipleSelect: null,
            sortMultipleSelectIndex: -1,
            mobileSort: this.currentSortColumn,
            mobileSortIndex: this.columns ? this.columns.indexOf(this.currentSortColumn) : -1,
            defaultEvent: {
                shiftKey: true,
                altKey: true,
                ctrlKey: true
            },
            ignoreSort: false
        };
    },
    computed: {
        showPlaceholder () {
            return !this.columns || !this.columns.some((column)=>column === this.mobileSort);
        },
        sortableColumns () {
            return this.columns && this.columns.filter((column)=>column.sortable);
        }
    },
    watch: {
        sortMultipleSelect (column) {
            if (this.ignoreSort) this.ignoreSort = false;
            else this.$emit("sort", column, this.defaultEvent);
        },
        sortMultipleSelectIndex (index) {
            if (index !== -1) this.sortMultipleSelect = this.columns[index];
            else this.sortMultipleSelect = null;
        },
        mobileSort (column) {
            if (this.currentSortColumn === column) return;
            this.$emit("sort", column, this.defaultEvent);
        },
        mobileSortIndex (index) {
            if (index !== -1) this.mobileSort = this.columns[index];
        },
        currentSortColumn (column) {
            this.mobileSort = column;
            this.mobileSortIndex = this.columns ? this.columns.indexOf(column) : -1;
        },
        columns (newColumns) {
            if (this.sortMultiple) this.sortMultipleSelectIndex = newColumns.indexOf(this.sortMultipleSelect);
            else this.mobileSortIndex = newColumns.indexOf(this.mobileSort);
        }
    },
    methods: {
        removePriority () {
            this.$emit("removePriority", this.sortMultipleSelect);
            this.ignoreSort = true;
            const remainingFields = this.sortMultipleData.filter((data)=>data.field !== this.sortMultipleSelect.field).map((data)=>data.field);
            this.sortMultipleSelectIndex = this.columns.findIndex((column)=>remainingFields.includes(column.field));
        },
        getSortingObjectOfColumn (column) {
            return this.sortMultipleData.filter((i)=>i.field === column.field)[0];
        },
        columnIsDesc (column) {
            const sortingObject = column && this.getSortingObjectOfColumn(column);
            if (sortingObject) return !!(sortingObject.order && sortingObject.order === "desc");
            return true;
        },
        getLabel (column) {
            const sortingObject = this.getSortingObjectOfColumn(column);
            if (sortingObject) return column.label + "(" + (this.sortMultipleData.indexOf(sortingObject) + 1) + ")";
            return column.label;
        },
        sort () {
            this.$emit("sort", this.sortMultiple ? this.sortMultipleSelect : this.mobileSort, this.defaultEvent);
        }
    }
});
const _hoisted_1$7 = {
    class: "field table-mobile-sort"
};
const _hoisted_2$6 = {
    class: "field has-addons"
};
const _hoisted_3$4 = [
    "value"
];
const _hoisted_4$2 = [
    "value"
];
const _hoisted_5$1 = {
    class: "control"
};
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_select = (0, _vue.resolveComponent)("b-select");
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1$7, [
        (0, _vue.createElementVNode)("div", _hoisted_2$6, [
            _ctx.sortMultiple ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_select, {
                key: 0,
                modelValue: _ctx.sortMultipleSelectIndex,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.sortMultipleSelectIndex = $event),
                expanded: ""
            }, {
                default: (0, _vue.withCtx)(()=>[
                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.sortableColumns, (column, index)=>{
                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", {
                                key: index,
                                value: index
                            }, [
                                (0, _vue.createTextVNode)((0, _vue.toDisplayString)(_ctx.getLabel(column)) + " ", 1),
                                _ctx.getSortingObjectOfColumn(column) ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                    key: 0
                                }, [
                                    _ctx.columnIsDesc(column) ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                        key: 0
                                    }, [
                                        (0, _vue.createTextVNode)(" \u2193 ")
                                    ], 64)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                        key: 1
                                    }, [
                                        (0, _vue.createTextVNode)(" \u2191 ")
                                    ], 64))
                                ], 64)) : (0, _vue.createCommentVNode)("v-if", true)
                            ], 8, _hoisted_3$4);
                        }), 128))
                    ]),
                _: 1
            }, 8, [
                "modelValue"
            ])) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_select, {
                key: 1,
                modelValue: _ctx.mobileSortIndex,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>_ctx.mobileSortIndex = $event),
                expanded: ""
            }, {
                default: (0, _vue.withCtx)(()=>[
                        _ctx.placeholder ? (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", {
                            key: 0,
                            value: {},
                            selected: "",
                            disabled: "",
                            hidden: ""
                        }, (0, _vue.toDisplayString)(_ctx.placeholder), 513)), [
                            [
                                (0, _vue.vShow),
                                _ctx.showPlaceholder
                            ]
                        ]) : (0, _vue.createCommentVNode)("v-if", true),
                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.sortableColumns, (column, index)=>{
                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", {
                                key: index,
                                value: index
                            }, (0, _vue.toDisplayString)(column.label), 9, _hoisted_4$2);
                        }), 128))
                    ]),
                _: 1
            }, 8, [
                "modelValue"
            ])),
            (0, _vue.createElementVNode)("div", _hoisted_5$1, [
                _ctx.sortMultiple && _ctx.sortMultipleData.length > 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                    key: 0
                }, [
                    (0, _vue.createElementVNode)("button", {
                        class: "button is-primary",
                        onClick: _cache[2] || (_cache[2] = (...args)=>_ctx.sort && _ctx.sort(...args))
                    }, [
                        (0, _vue.createVNode)(_component_b_icon, {
                            class: (0, _vue.normalizeClass)({
                                "is-desc": _ctx.columnIsDesc(_ctx.sortMultipleSelect)
                            }),
                            icon: _ctx.sortIcon,
                            pack: _ctx.iconPack,
                            size: _ctx.sortIconSize,
                            both: ""
                        }, null, 8, [
                            "class",
                            "icon",
                            "pack",
                            "size"
                        ])
                    ]),
                    (0, _vue.createElementVNode)("button", {
                        class: "button is-primary",
                        onClick: _cache[3] || (_cache[3] = (...args)=>_ctx.removePriority && _ctx.removePriority(...args))
                    }, [
                        (0, _vue.createVNode)(_component_b_icon, {
                            icon: "delete",
                            size: _ctx.sortIconSize,
                            both: ""
                        }, null, 8, [
                            "size"
                        ])
                    ])
                ], 64)) : !_ctx.sortMultiple ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                    key: 1,
                    class: "button is-primary",
                    onClick: _cache[4] || (_cache[4] = (...args)=>_ctx.sort && _ctx.sort(...args))
                }, [
                    (0, _vue.withDirectives)((0, _vue.createVNode)(_component_b_icon, {
                        class: (0, _vue.normalizeClass)({
                            "is-desc": !_ctx.isAsc
                        }),
                        icon: _ctx.sortIcon,
                        pack: _ctx.iconPack,
                        size: _ctx.sortIconSize,
                        both: ""
                    }, null, 8, [
                        "class",
                        "icon",
                        "pack",
                        "size"
                    ]), [
                        [
                            (0, _vue.vShow),
                            _ctx.currentSortColumn === _ctx.mobileSort
                        ]
                    ])
                ])) : (0, _vue.createCommentVNode)("v-if", true)
            ])
        ])
    ]);
}
var BTableMobileSort = /* @__PURE__ */ _export_sfc(_sfc_main$8, [
    [
        "render",
        _sfc_render$8
    ]
]);
var _sfc_main$7 = (0, _vue.defineComponent)({
    name: "BTablePagination",
    components: {
        BPagination
    },
    props: {
        paginated: Boolean,
        total: [
            Number,
            String
        ],
        perPage: [
            Number,
            String
        ],
        currentPage: [
            Number,
            String
        ],
        paginationSimple: Boolean,
        paginationSize: String,
        rounded: Boolean,
        iconPack: String,
        ariaNextLabel: String,
        ariaPreviousLabel: String,
        ariaPageLabel: String,
        ariaCurrentLabel: String,
        pageInput: Boolean,
        paginationOrder: String,
        pageInputPosition: String,
        debouncePageInput: [
            Number,
            String
        ]
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars */ "page-change": (_page)=>true,
        "update:currentPage": (_page)=>true
    },
    data () {
        return {
            newCurrentPage: this.currentPage
        };
    },
    watch: {
        currentPage (newVal) {
            this.newCurrentPage = newVal;
        }
    },
    methods: {
        /*
    * Paginator change listener.
    */ pageChanged (page) {
            this.newCurrentPage = page > 0 ? page : 1;
            this.$emit("update:currentPage", this.newCurrentPage);
            this.$emit("page-change", this.newCurrentPage);
        }
    }
});
const _hoisted_1$6 = {
    class: "top level"
};
const _hoisted_2$5 = {
    class: "level-left"
};
const _hoisted_3$3 = {
    class: "level-right"
};
const _hoisted_4$1 = {
    key: 0,
    class: "level-item"
};
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_pagination = (0, _vue.resolveComponent)("b-pagination");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1$6, [
        (0, _vue.createElementVNode)("div", _hoisted_2$5, [
            (0, _vue.renderSlot)(_ctx.$slots, "default")
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_3$3, [
            _ctx.paginated ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_4$1, [
                (0, _vue.createVNode)(_component_b_pagination, {
                    "icon-pack": _ctx.iconPack,
                    total: _ctx.total,
                    "per-page": _ctx.perPage,
                    simple: _ctx.paginationSimple,
                    size: _ctx.paginationSize,
                    "model-value": _ctx.newCurrentPage,
                    rounded: _ctx.rounded,
                    onChange: _ctx.pageChanged,
                    "aria-next-label": _ctx.ariaNextLabel,
                    "aria-previous-label": _ctx.ariaPreviousLabel,
                    "aria-page-label": _ctx.ariaPageLabel,
                    "aria-current-label": _ctx.ariaCurrentLabel,
                    "page-input": _ctx.pageInput,
                    order: _ctx.paginationOrder,
                    "page-input-position": _ctx.pageInputPosition,
                    "debounce-page-input": _ctx.debouncePageInput
                }, null, 8, [
                    "icon-pack",
                    "total",
                    "per-page",
                    "simple",
                    "size",
                    "model-value",
                    "rounded",
                    "onChange",
                    "aria-next-label",
                    "aria-previous-label",
                    "aria-page-label",
                    "aria-current-label",
                    "page-input",
                    "order",
                    "page-input-position",
                    "debounce-page-input"
                ])
            ])) : (0, _vue.createCommentVNode)("v-if", true)
        ])
    ]);
}
var BTablePagination = /* @__PURE__ */ _export_sfc(_sfc_main$7, [
    [
        "render",
        _sfc_render$7
    ]
]);
var __defProp$1 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value)=>key in obj ? __defProp$1(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues$1 = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
    if (__getOwnPropSymbols$1) {
        for (var prop of __getOwnPropSymbols$1(b))if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps$1 = (a, b)=>__defProps$1(a, __getOwnPropDescs$1(b));
function mockTableColumn(table, column) {
    const defaultProps = {
        label: void 0,
        customKey: void 0,
        field: void 0,
        meta: void 0,
        width: void 0,
        numeric: void 0,
        centered: void 0,
        searchable: void 0,
        sortable: void 0,
        visible: true,
        subheading: void 0,
        customSort: void 0,
        customSearch: void 0,
        sticky: void 0,
        headerSelectable: void 0,
        headerClass: void 0,
        /* eslint-disable @typescript-eslint/no-explicit-any */ thAttrs: ()=>({}),
        tdAttrs: ()=>({})
    };
    return __spreadProps$1(__spreadValues$1(__spreadValues$1({}, defaultProps), column), {
        // data
        newKey: column.customKey || column.label,
        _isTableColumn: true,
        // public computed
        get thClasses () {
            const attrs = this.thAttrs(this);
            const classes = [
                this.headerClass,
                {
                    "is-sortable": this.sortable,
                    "is-sticky": this.sticky,
                    "is-unselectable": this.isHeaderUnSelectable
                }
            ];
            if (attrs && attrs.class) classes.push(attrs.class);
            return classes;
        },
        get thStyle () {
            const attrs = this.thAttrs(this);
            const style = [
                this.style
            ];
            if (attrs && attrs.style) style.push(attrs.style);
            return style;
        },
        get thWrapStyle () {
            return this.style;
        },
        get style () {
            var _a;
            return {
                width: (_a = toCssWidth(this.width)) != null ? _a : void 0
            };
        },
        getRootClasses (row) {
            const attrs = this.tdAttrs(row, this);
            const classes = [
                this.rootClasses
            ];
            if (attrs && attrs.class) classes.push(attrs.class);
            return classes;
        },
        getRootStyle (row) {
            const attrs = this.tdAttrs(row, this);
            const style = [];
            if (attrs && attrs.style) style.push(attrs.style);
            return style;
        },
        $slots: {
            default: (props)=>{
                const vnode = (0, _vue.h)("span", {
                    innerHTML: getValueByPath(props.row, column.field)
                });
                return [
                    vnode
                ];
            }
        },
        // private properties
        get rootClasses () {
            return [
                this.cellClass,
                {
                    "has-text-right": this.numeric && !this.centered,
                    "has-text-centered": this.centered,
                    "is-sticky": this.sticky
                }
            ];
        },
        get isHeaderUnSelectable () {
            return !this.headerSelectable && !!this.sortable;
        }
    });
}
const BLANK_COLUMN = {
    thAttrs: ()=>({}),
    tdAttrs: ()=>({}),
    getRootClasses: ()=>[],
    getRootStyle: ()=>void 0,
    $slots: {}
};
var _sfc_main$6 = (0, _vue.defineComponent)({
    name: "BTable",
    components: {
        BCheckbox,
        BIcon,
        BInput,
        BLoading,
        BSlotComponent,
        BTableMobileSort,
        BTablePagination
    },
    mixins: [
        CompatFallthroughMixin
    ],
    provide () {
        return {
            $table: this
        };
    },
    props: {
        data: {
            type: Array,
            default: ()=>[]
        },
        columns: {
            type: Array,
            default: ()=>[]
        },
        bordered: Boolean,
        striped: Boolean,
        narrowed: Boolean,
        hoverable: Boolean,
        loading: Boolean,
        detailed: Boolean,
        checkable: Boolean,
        headerCheckable: {
            type: Boolean,
            default: true
        },
        checkboxType: {
            type: String,
            default: "is-primary"
        },
        checkboxPosition: {
            type: String,
            default: "left",
            validator: (value)=>{
                return [
                    "left",
                    "right"
                ].indexOf(value) >= 0;
            }
        },
        stickyCheckbox: {
            type: Boolean,
            default: false
        },
        selected: Object,
        isRowSelectable: {
            type: Function,
            default: ()=>true
        },
        focusable: Boolean,
        customIsChecked: Function,
        isRowCheckable: {
            type: Function,
            default: ()=>true
        },
        checkedRows: {
            type: Array,
            default: ()=>[]
        },
        mobileCards: {
            type: Boolean,
            default: true
        },
        defaultSort: [
            String,
            Array
        ],
        defaultSortDirection: {
            type: String,
            default: "asc"
        },
        sortIcon: {
            type: String,
            default: "arrow-up"
        },
        sortIconSize: {
            type: String,
            default: "is-small"
        },
        sortMultiple: {
            type: Boolean,
            default: false
        },
        sortMultipleData: {
            type: Array,
            default: ()=>[]
        },
        sortMultipleKey: {
            type: String,
            default: null
        },
        paginated: Boolean,
        currentPage: {
            type: Number,
            default: 1
        },
        perPage: {
            type: [
                Number,
                String
            ],
            default: 20
        },
        showDetailIcon: {
            type: Boolean,
            default: true
        },
        detailIcon: {
            type: String,
            default: "chevron-right"
        },
        paginationPosition: {
            type: String,
            default: "bottom",
            validator: (value)=>{
                return [
                    "bottom",
                    "top",
                    "both"
                ].indexOf(value) >= 0;
            }
        },
        paginationRounded: Boolean,
        backendSorting: Boolean,
        backendFiltering: Boolean,
        rowClass: {
            type: Function,
            default: ()=>""
        },
        openedDetailed: {
            type: Array,
            default: ()=>[]
        },
        hasDetailedVisible: {
            type: Function,
            default: ()=>true
        },
        detailKey: {
            type: String,
            default: ""
        },
        detailTransition: {
            type: String,
            default: ""
        },
        customDetailRow: {
            type: Boolean,
            default: false
        },
        backendPagination: Boolean,
        total: {
            type: [
                Number,
                String
            ],
            default: 0
        },
        iconPack: String,
        mobileSortPlaceholder: String,
        customRowKey: String,
        draggable: {
            type: Boolean,
            default: false
        },
        draggableColumn: {
            type: Boolean,
            default: false
        },
        scrollable: Boolean,
        ariaNextLabel: String,
        ariaPreviousLabel: String,
        ariaPageLabel: String,
        ariaCurrentLabel: String,
        stickyHeader: Boolean,
        height: [
            Number,
            String
        ],
        filtersEvent: {
            type: String,
            default: ""
        },
        cardLayout: Boolean,
        showHeader: {
            type: Boolean,
            default: true
        },
        debounceSearch: Number,
        caption: String,
        showCaption: {
            type: Boolean,
            default: true
        },
        pageInput: {
            type: Boolean,
            default: false
        },
        paginationOrder: String,
        pageInputPosition: String,
        debouncePageInput: [
            Number,
            String
        ]
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars */ cellclick: (_row, _column, _rowIndex, _colIndex)=>true,
        check: (_checkedRows, _row)=>true,
        "check-all": (_rows)=>true,
        click: (_row)=>true,
        columndragend: (_event)=>true,
        columndragleave: (_event)=>true,
        columndragover: (_event)=>true,
        columndragstart: (_event)=>true,
        columndrop: (_event)=>true,
        contextmenu: (_row, _event)=>true,
        dblclick: (_row)=>true,
        "details-close": (_row)=>true,
        "details-open": (_row)=>true,
        dragend: (_event)=>true,
        dragleave: (_event)=>true,
        dragover: (_event)=>true,
        dragstart: (_event)=>true,
        drop: (_event)=>true,
        "filters-change": (_value)=>true,
        "page-change": (_page)=>true,
        select: (_new, _old)=>true,
        sort: (_field, _order, _event)=>true,
        "sorting-priority-removed": (_field)=>true,
        "update:checkedRows": (_rows)=>true,
        "update:currentPage": (_page)=>true,
        "update:openedDetailed": (_rows)=>true,
        "update:selected": (_row)=>true
    },
    data () {
        return {
            sortMultipleDataLocal: [],
            getValueByPath,
            visibleDetailRows: this.openedDetailed,
            newData: this.data,
            newDataTotal: this.backendPagination ? this.total : this.data.length,
            newCheckedRows: [
                ...this.checkedRows
            ],
            lastCheckedRowIndex: null,
            newCurrentPage: this.currentPage,
            currentSortColumn: {},
            isAsc: true,
            filters: {},
            defaultSlots: [],
            firstTimeSort: true,
            // Used by first time initSort
            isDraggingRow: false,
            isDraggingColumn: false,
            debouncedHandleFiltersChange: void 0,
            // for touch-enabled devices
            _selectedRow: null,
            mayBeTouchDragging: false,
            touchDragoverTarget: null,
            _draggedCellEl: void 0,
            draggedCellContent: ""
        };
    },
    computed: {
        sortMultipleDataComputed () {
            return this.backendSorting ? this.sortMultipleData : this.sortMultipleDataLocal;
        },
        tableClasses () {
            return {
                "is-bordered": this.bordered,
                "is-striped": this.striped,
                "is-narrow": this.narrowed,
                "is-hoverable": (this.hoverable || this.focusable) && this.visibleData.length
            };
        },
        tableWrapperClasses () {
            return {
                "has-mobile-cards": this.mobileCards,
                "has-sticky-header": this.stickyHeader,
                "is-card-list": this.cardLayout,
                "table-container": this.isScrollable
            };
        },
        tableStyle () {
            return {
                height: toCssWidth(this.height)
            };
        },
        touchDraggedCellClasses () {
            return {
                "has-mobile-cards": this.mobileCards
            };
        },
        /*
    * Splitted data based on the pagination.
    */ visibleData () {
            if (!this.paginated) return this.newData;
            const currentPage = this.newCurrentPage;
            const perPage = +this.perPage;
            if (this.newData.length <= perPage) return this.newData;
            else {
                const start = (currentPage - 1) * perPage;
                const end = parseInt(start + "", 10) + parseInt(perPage + "", 10);
                return this.newData.slice(start, end);
            }
        },
        visibleColumns () {
            if (!this.newColumns) return this.newColumns;
            return this.newColumns.filter((column)=>{
                return column.visible || column.visible === void 0;
            });
        },
        /*
    * Check if all rows in the page are checked.
    */ isAllChecked () {
            const validVisibleData = this.visibleData.filter((row)=>this.isRowCheckable(row));
            if (validVisibleData.length === 0) return false;
            const isAllChecked = validVisibleData.some((currentVisibleRow)=>{
                return indexOf(this.newCheckedRows, currentVisibleRow, this.customIsChecked) < 0;
            });
            return !isAllChecked;
        },
        /*
    * Check if all rows in the page are checkable.
    */ isAllUncheckable () {
            const validVisibleData = this.visibleData.filter((row)=>this.isRowCheckable(row));
            return validVisibleData.length === 0;
        },
        /*
    * Check if has any sortable column.
    */ hasSortablenewColumns () {
            return this.newColumns.some((column)=>{
                return column.sortable;
            });
        },
        /*
    * Check if has any searchable column.
    */ hasSearchablenewColumns () {
            return this.newColumns.some((column)=>{
                return column.searchable;
            });
        },
        /*
    * Check if has any column using subheading.
    */ hasCustomSubheadings () {
            if (this.$slots && this.$slots.subheading) return true;
            return this.newColumns.some((column)=>{
                return column.subheading || column.$slots.subheading;
            });
        },
        /*
    * Return total column count based if it's checkable or expanded
    */ columnCount () {
            let count = this.visibleColumns.length;
            count += this.checkable ? 1 : 0;
            count += this.detailed && this.showDetailIcon ? 1 : 0;
            return count;
        },
        /*
    * return if detailed row tabled
    * will be with chevron column & icon or not
    */ showDetailRowIcon () {
            return this.detailed && this.showDetailIcon;
        },
        /*
    * return if scrollable table
    */ isScrollable () {
            if (this.scrollable) return true;
            if (!this.newColumns) return false;
            return this.newColumns.some((column)=>{
                return column.sticky;
            });
        },
        newColumns () {
            if (this.columns && this.columns.length) return this.columns.map((column)=>{
                return mockTableColumn(this, column);
            });
            return this.defaultSlots;
        },
        canDragRow () {
            return this.draggable && !this.isDraggingColumn;
        },
        canDragColumn () {
            return this.draggableColumn && !this.isDraggingRow;
        }
    },
    watch: {
        /*
    * When data prop change:
    *   1. Update internal value.
    *   2. Filter data if it's not backend-filtered.
    *   3. Sort again if it's not backend-sorted.
    *   4. Set new total if it's not backend-paginated.
    */ data (value) {
            this.newData = value;
            if (!this.backendFiltering) this.newData = value.filter((row)=>this.isRowFiltered(row));
            if (!this.backendSorting) this.sort(this.currentSortColumn, true);
            if (!this.backendPagination) this.newDataTotal = this.newData.length;
        },
        /*
    * When Pagination total change, update internal total
    * only if it's backend-paginated.
    */ total (newTotal) {
            if (!this.backendPagination) return;
            this.newDataTotal = newTotal;
        },
        currentPage (newVal) {
            this.newCurrentPage = newVal;
        },
        newCurrentPage (newVal) {
            this.$emit("update:currentPage", newVal);
        },
        /*
    * When checkedRows prop change, update internal value without
    * mutating original data.
    */ checkedRows (rows) {
            this.newCheckedRows = [
                ...rows
            ];
        },
        debounceSearch: {
            handler (value) {
                this.debouncedHandleFiltersChange = debounce(this.handleFiltersChange, value);
            },
            immediate: true
        },
        filters: {
            handler (value) {
                if (this.debounceSearch) this.debouncedHandleFiltersChange(value);
                else this.handleFiltersChange(value);
            },
            deep: true
        },
        /*
    * When the user wants to control the detailed rows via props.
    * Or wants to open the details of certain row with the router for example.
    */ openedDetailed (expandedRows) {
            this.visibleDetailRows = expandedRows;
        }
    },
    methods: {
        onFiltersEvent (event) {
            this.$emit(`filters-event-${this.filtersEvent}`, {
                event,
                filters: this.filters
            });
        },
        handleFiltersChange (value) {
            if (this.backendFiltering) this.$emit("filters-change", value);
            else {
                this.newData = this.data.filter((row)=>this.isRowFiltered(row));
                if (!this.backendPagination) this.newDataTotal = this.newData.length;
                if (!this.backendSorting) {
                    if (this.sortMultiple && this.sortMultipleDataLocal && this.sortMultipleDataLocal.length > 0) this.doSortMultiColumn();
                    else if (Object.keys(this.currentSortColumn).length > 0) this.doSortSingleColumn(this.currentSortColumn);
                }
            }
        },
        findIndexOfSortData (column) {
            const sortObj = this.sortMultipleDataComputed.filter((i)=>i.field === column.field)[0];
            return this.sortMultipleDataComputed.indexOf(sortObj) + 1;
        },
        removeSortingPriority (column) {
            if (this.backendSorting) this.$emit("sorting-priority-removed", column.field);
            else {
                this.sortMultipleDataLocal = this.sortMultipleDataLocal.filter((priority)=>priority.field !== column.field);
                if (this.sortMultipleDataLocal.length === 0) this.resetMultiSorting();
                else this.newData = multiColumnSort(this.newData, this.sortMultipleDataLocal);
            }
        },
        resetMultiSorting () {
            this.sortMultipleDataLocal = [];
            this.currentSortColumn = BLANK_COLUMN;
            this.newData = this.data;
        },
        /*
    * Sort an array by key without mutating original data.
    * Call the user sort function if it was passed.
    */ sortBy (array, key, fn, isAsc) {
            let sorted = [];
            if (fn && typeof fn === "function") sorted = [
                ...array
            ].sort((a, b)=>fn(a, b, isAsc));
            else sorted = [
                ...array
            ].sort((a, b)=>{
                let newA = getValueByPath(a, key);
                let newB = getValueByPath(b, key);
                if (typeof newA === "boolean" && typeof newB === "boolean") return isAsc ? +newA - +newB : +newB - +newA;
                if (!isNil(newB) && isNil(newA)) return isAsc ? 1 : -1;
                if (!isNil(newA) && isNil(newB)) return isAsc ? -1 : 1;
                if (newA === newB) return 0;
                newA = typeof newA === "string" ? newA.toUpperCase() : newA;
                newB = typeof newB === "string" ? newB.toUpperCase() : newB;
                return isAsc ? newA > newB ? 1 : -1 : newA > newB ? -1 : 1;
            });
            return sorted;
        },
        sortMultiColumn (column) {
            this.currentSortColumn = BLANK_COLUMN;
            if (!this.backendSorting) {
                const existingPriority = this.sortMultipleDataLocal.filter((i)=>i.field === column.field)[0];
                if (existingPriority) existingPriority.order = existingPriority.order === "desc" ? "asc" : "desc";
                else this.sortMultipleDataLocal.push({
                    field: column.field,
                    order: this.isAsc ? "asc" : "desc",
                    customSort: column.customSort
                });
                this.doSortMultiColumn();
            }
        },
        doSortMultiColumn () {
            this.newData = multiColumnSort(this.newData, this.sortMultipleDataLocal);
        },
        /*
    * Sort the column.
    * Toggle current direction on column if it's sortable
    * and not just updating the prop.
    */ sort (column, updatingData = false, event = null) {
            if (!column || !column.sortable) return;
            if (// if backend sorting is enabled, just emit the sort press like usual
            // if the correct key combination isnt pressed, sort like usual
            !this.backendSorting && this.sortMultiple && (this.sortMultipleKey && event[this.sortMultipleKey] || !this.sortMultipleKey)) {
                if (updatingData) this.doSortMultiColumn();
                else this.sortMultiColumn(column);
            } else {
                if (this.sortMultiple) this.sortMultipleDataLocal = [];
                if (!updatingData) this.isAsc = (0, _vue.toRaw)(column) === (0, _vue.toRaw)(this.currentSortColumn) ? !this.isAsc : this.defaultSortDirection.toLowerCase() !== "desc";
                if (!this.firstTimeSort) this.$emit("sort", column.field, this.isAsc ? "asc" : "desc", event);
                if (!this.backendSorting) this.doSortSingleColumn(column);
                this.currentSortColumn = column;
            }
        },
        doSortSingleColumn (column) {
            this.newData = this.sortBy(this.newData, column.field, column.customSort, this.isAsc);
        },
        isRowSelected (row, selected) {
            if (!selected) return false;
            if (this.customRowKey) return row[this.customRowKey] === selected[this.customRowKey];
            return row === selected;
        },
        /*
    * Check if the row is checked (is added to the array).
    */ isRowChecked (row) {
            return indexOf(this.newCheckedRows, row, this.customIsChecked) >= 0;
        },
        /*
    * Remove a checked row from the array.
    */ removeCheckedRow (row) {
            const index = indexOf(this.newCheckedRows, row, this.customIsChecked);
            if (index >= 0) this.newCheckedRows.splice(index, 1);
        },
        /*
    * Header checkbox click listener.
    * Add or remove all rows in current page.
    */ checkAll () {
            const isAllChecked = this.isAllChecked;
            this.visibleData.forEach((currentRow)=>{
                if (this.isRowCheckable(currentRow)) this.removeCheckedRow(currentRow);
                if (!isAllChecked) {
                    if (this.isRowCheckable(currentRow)) this.newCheckedRows.push(currentRow);
                }
            });
            this.$emit("check", this.newCheckedRows);
            this.$emit("check-all", this.newCheckedRows);
            this.$emit("update:checkedRows", this.newCheckedRows);
        },
        /*
    * Row checkbox click listener.
    */ checkRow (row, index, event) {
            if (!this.isRowCheckable(row)) return;
            const lastIndex = this.lastCheckedRowIndex;
            this.lastCheckedRowIndex = index;
            if (event.shiftKey && lastIndex !== null && index !== lastIndex) this.shiftCheckRow(row, index, lastIndex);
            else if (!this.isRowChecked(row)) this.newCheckedRows.push(row);
            else this.removeCheckedRow(row);
            this.$emit("check", this.newCheckedRows, row);
            this.$emit("update:checkedRows", this.newCheckedRows);
        },
        /*
     * Check row when shift is pressed.
     */ shiftCheckRow (row, index, lastCheckedRowIndex) {
            const subset = this.visibleData.slice(Math.min(index, lastCheckedRowIndex), Math.max(index, lastCheckedRowIndex) + 1);
            const shouldCheck = !this.isRowChecked(row);
            subset.forEach((item)=>{
                this.removeCheckedRow(item);
                if (shouldCheck && this.isRowCheckable(item)) this.newCheckedRows.push(item);
            });
        },
        /*
    * Row click listener.
    * Emit all necessary events.
    */ selectRow (row) {
            this.$emit("click", row);
            this._selectedRow = row;
            if (this.selected === row) return;
            if (!this.isRowSelectable(row)) return;
            this.$emit("select", row, this.selected);
            this.$emit("update:selected", row);
        },
        /*
    * Toggle to show/hide details slot
    */ toggleDetails (obj) {
            const found = this.isVisibleDetailRow(obj);
            if (found) {
                this.closeDetailRow(obj);
                this.$emit("details-close", obj);
            } else {
                this.openDetailRow(obj);
                this.$emit("details-open", obj);
            }
            this.$emit("update:openedDetailed", this.visibleDetailRows);
        },
        openDetailRow (obj) {
            const index = this.handleDetailKey(obj);
            this.visibleDetailRows.push(index);
        },
        closeDetailRow (obj) {
            const index = this.handleDetailKey(obj);
            const i = this.visibleDetailRows.indexOf(index);
            if (i >= 0) this.visibleDetailRows.splice(i, 1);
        },
        isVisibleDetailRow (obj) {
            const index = this.handleDetailKey(obj);
            return this.visibleDetailRows.indexOf(index) >= 0;
        },
        isActiveDetailRow (row) {
            return this.detailed && !this.customDetailRow && this.isVisibleDetailRow(row);
        },
        isActiveCustomDetailRow (row) {
            return this.detailed && this.customDetailRow && this.isVisibleDetailRow(row);
        },
        isRowFiltered (row) {
            for(const key in this.filters){
                if (!this.filters[key]) continue;
                const input = this.filters[key];
                const column = this.newColumns.filter((c)=>c.field === key)[0];
                if (column && column.customSearch && typeof column.customSearch === "function") {
                    if (!column.customSearch(row, input)) return false;
                } else {
                    const value = this.getValueByPath(row, key);
                    if (value == null) return false;
                    if (Number.isInteger(value)) {
                        if (value !== Number(input)) return false;
                    } else {
                        const re = new RegExp(escapeRegExpChars(input + ""), "i");
                        if (Array.isArray(value)) {
                            const valid = value.some((val)=>re.test(removeDiacriticsFromString(val)) || re.test(val));
                            if (!valid) return false;
                        } else {
                            if (!re.test(removeDiacriticsFromString(value)) && !re.test(value)) return false;
                        }
                    }
                }
            }
            return true;
        },
        /*
    * When the detailKey is defined we use the object[detailKey] as index.
    * If not, use the object reference by default.
    */ handleDetailKey (index) {
            const key = this.detailKey;
            return !key.length || !index ? index : index[key];
        },
        checkPredefinedDetailedRows () {
            const defaultExpandedRowsDefined = this.openedDetailed.length > 0;
            if (defaultExpandedRowsDefined && !this.detailKey.length) throw new Error('If you set a predefined opened-detailed, you must provide a unique key using the prop "detail-key"');
        },
        /*
    * Call initSort only first time (For example async data).
    */ checkSort () {
            if (this.newColumns.length && this.firstTimeSort) {
                this.initSort();
                this.firstTimeSort = false;
            } else if (this.newColumns.length) {
                if ((0, _vue.toRaw)(this.currentSortColumn) !== BLANK_COLUMN) {
                    for(let i = 0; i < this.newColumns.length; i++)if (this.newColumns[i].field === this.currentSortColumn.field) {
                        this.currentSortColumn = this.newColumns[i];
                        break;
                    }
                }
            }
        },
        /*
    * Check if footer slot has custom content.
    *
    * Assumes that `$slots.footer` is specified.
    */ hasCustomFooterSlot () {
            var _a;
            const footer = this.$slots.footer();
            if (footer.length > 1) return true;
            if (isFragment(footer[0])) return true;
            const tag = (_a = footer[0].el) == null ? void 0 : _a.tag;
            if (tag !== "th" && tag !== "td") return false;
            return true;
        },
        /*
    * Check if bottom-left slot exists.
    */ hasBottomLeftSlot () {
            return typeof this.$slots["bottom-left"] !== "undefined";
        },
        /*
    * Table arrow keys listener, change selection.
    */ pressedArrow (pos) {
            if (!this.visibleData.length) return;
            let index = this.visibleData.indexOf(this.selected) + pos;
            index = index < 0 ? 0 : index > this.visibleData.length - 1 ? this.visibleData.length - 1 : index;
            const row = this.visibleData[index];
            if (!this.isRowSelectable(row)) {
                let newIndex = null;
                if (pos > 0) {
                    for(let i = index; i < this.visibleData.length && newIndex === null; i++)if (this.isRowSelectable(this.visibleData[i])) newIndex = i;
                } else {
                    for(let i = index; i >= 0 && newIndex === null; i--)if (this.isRowSelectable(this.visibleData[i])) newIndex = i;
                }
                if (newIndex >= 0) this.selectRow(this.visibleData[newIndex]);
            } else this.selectRow(row);
        },
        /*
    * Focus table element if has selected prop.
    */ focus () {
            if (!this.focusable) return;
            this.$el.querySelector("table").focus();
        },
        /*
    * Initial sorted column based on the default-sort prop.
    */ initSort () {
            if (this.sortMultiple && this.sortMultipleData) this.sortMultipleData.forEach((column)=>{
                this.sortMultiColumn(column);
            });
            else {
                if (!this.defaultSort) return;
                let sortField = "";
                let sortDirection = this.defaultSortDirection;
                if (Array.isArray(this.defaultSort)) {
                    sortField = this.defaultSort[0];
                    if (this.defaultSort[1]) sortDirection = this.defaultSort[1];
                } else sortField = this.defaultSort;
                const sortColumn = this.newColumns.filter((column)=>column.field === sortField)[0];
                if (sortColumn) {
                    this.isAsc = sortDirection.toLowerCase() !== "desc";
                    this.sort(sortColumn, true);
                }
            }
        },
        /*
    * Emits drag start event (row)
    */ handleDragStart (event, row, index) {
            if (!this.canDragRow) return;
            this.isDraggingRow = true;
            this.$emit("dragstart", {
                event,
                row,
                index
            });
        },
        /*
    * Emits drag leave event (row)
    */ handleDragEnd (event, row, index) {
            if (!this.canDragRow) return;
            this.isDraggingRow = false;
            this.$emit("dragend", {
                event,
                row,
                index
            });
        },
        /*
    * Emits drop event (row)
    */ handleDrop (event, row, index) {
            if (!this.canDragRow) return;
            this.$emit("drop", {
                event,
                row,
                index
            });
        },
        /*
    * Emits drag over event (row)
    */ handleDragOver (event, row, index) {
            if (!this.canDragRow) return;
            this.$emit("dragover", {
                event,
                row,
                index
            });
        },
        /*
    * Emits drag leave event (row)
    */ handleDragLeave (event, row, index) {
            if (!this.canDragRow) return;
            this.$emit("dragleave", {
                event,
                row,
                index
            });
        },
        // FIXME: this method may emit events not listed in `emits`.
        // I decided not to list them to check if event listeners are actually
        // set in `$attrs`. The original idea of this method was to address
        // some performance issues and introduced at the commit:
        // https://github.com/ntohq/buefy-next/commit/e38726497785145195e9605840e33980fd4ae9e0
        // I am not sure whether the justification at https://github.com/buefy/buefy/pull/2150
        // is still relevant with Vue 3.
        emitEventForRow (eventName, event, row) {
            return this.$attrs[`on${eventName}`] ? this.$emit(eventName, row, event) : null;
        },
        /*
    * Emits drag start event (column)
    */ handleColumnDragStart (event, column, index) {
            if (!this.canDragColumn) return;
            this.isDraggingColumn = true;
            this.$emit("columndragstart", {
                event,
                column,
                index
            });
        },
        /*
    * Emits drag leave event (column)
    */ handleColumnDragEnd (event, column, index) {
            if (!this.canDragColumn) return;
            this.isDraggingColumn = false;
            this.$emit("columndragend", {
                event,
                column,
                index
            });
        },
        /*
    * Emits drop event (column)
    */ handleColumnDrop (event, column, index) {
            if (!this.canDragColumn) return;
            this.$emit("columndrop", {
                event,
                column,
                index
            });
        },
        /*
    * Emits drag over event (column)
    */ handleColumnDragOver (event, column, index) {
            if (!this.canDragColumn) return;
            this.$emit("columndragover", {
                event,
                column,
                index
            });
        },
        /*
    * Emits drag leave event (column)
    */ handleColumnDragLeave (event, column, index) {
            if (!this.canDragColumn) return;
            this.$emit("columndragleave", {
                event,
                column,
                index
            });
        },
        /*
    * Starts monitoring drag-by-touch events (row on touch-enabled devices)
    */ handleTouchStart (event, row) {
            if (!this.canDragRow) return;
            if (this.isDraggingColumn) return;
            if (this._selectedRow !== row) return;
            event.preventDefault();
            this.mayBeTouchDragging = true;
        },
        /*
    * Emits dragover and dragleave events (row on touch-enabled devices)
    *
    * Emits also dragstart if this is the first touchmove after touchstart.
    */ handleTouchMove (event) {
            if (!this.canDragRow) return;
            if (!this.mayBeTouchDragging) return;
            if (!this.isDraggingRow) {
                const eventTarget = event.target;
                const tr = eventTarget.closest("tr");
                this.draggedCellContent = tr ? `<table class="table"><tr>${tr.innerHTML}</tr></table>` : eventTarget.innerHTML;
                this.$refs.draggedCell.style.width = tr ? `${tr.offsetWidth}px` : `${eventTarget.offsetWidth}px`;
                eventTarget.dispatchEvent(translateTouchAsDragEvent(event, {
                    type: "dragstart"
                }));
            }
            const touch = event.touches[0];
            const target = document.elementFromPoint(touch.clientX, touch.clientY);
            if (target != null) {
                if (target !== this.touchDragoverTarget) {
                    if (this.touchDragoverTarget != null) this.touchDragoverTarget.dispatchEvent(translateTouchAsDragEvent(event, {
                        type: "dragleave",
                        target: this.touchDragoverTarget
                    }));
                    this.touchDragoverTarget = target;
                    target.dispatchEvent(translateTouchAsDragEvent(event, {
                        type: "dragover",
                        target
                    }));
                }
            } else if (this.touchDragoverTarget != null) {
                this.touchDragoverTarget.dispatchEvent(translateTouchAsDragEvent(event, {
                    type: "dragleave",
                    target: this.touchDragoverTarget
                }));
                this.touchDragoverTarget = null;
            }
            this.updateDraggedCell(touch);
        },
        /*
    * Emits drop and dragend events (row on touch-enabled devices)
    */ handleTouchEnd (event) {
            if (!this.canDragRow) return;
            if (this.isDraggingRow) {
                const touch = event.changedTouches[0];
                const target = document.elementFromPoint(touch.clientX, touch.clientY);
                if (target != null) target.dispatchEvent(translateTouchAsDragEvent(event, {
                    type: "drop",
                    target
                }));
                event.target.dispatchEvent(translateTouchAsDragEvent(event, {
                    type: "dragend"
                }));
                this._selectedRow = null;
            }
            this.mayBeTouchDragging = false;
        },
        /*
    * Starts monitoring drag-by-touch events (column on touch-enabled devices)
    */ handleColumnTouchStart (event) {
            if (!this.canDragColumn) return;
            if (this.isDraggingRow) return;
            event.preventDefault();
            this.mayBeTouchDragging = true;
        },
        /*
    * Emits dragover and dragleave events (column on touch-enabled devices)
    *
    * Also emits dragstart if this is the first touchmove after touchstart.
    */ handleColumnTouchMove (event) {
            if (!this.canDragColumn) return;
            if (!this.mayBeTouchDragging) return;
            if (!this.isDraggingColumn) {
                const eventTarget = event.target;
                this.draggedCellContent = eventTarget.innerHTML;
                this.$refs.draggedCell.style.width = `${eventTarget.offsetWidth}px`;
                eventTarget.dispatchEvent(translateTouchAsDragEvent(event, {
                    type: "dragstart"
                }));
            }
            const touch = event.touches[0];
            const target = document.elementFromPoint(touch.clientX, touch.clientY);
            if (target != null) {
                if (target !== this.touchDragoverTarget) {
                    if (this.touchDragoverTarget != null) this.touchDragoverTarget.dispatchEvent(translateTouchAsDragEvent(event, {
                        type: "dragleave",
                        target: this.touchDragoverTarget
                    }));
                    this.touchDragoverTarget = target;
                    target.dispatchEvent(translateTouchAsDragEvent(event, {
                        type: "dragover",
                        target
                    }));
                }
            } else if (this.touchDragoverTarget != null) {
                this.touchDragoverTarget.dispatchEvent(translateTouchAsDragEvent(event, {
                    type: "dragleave",
                    target: this.touchDragoverTarget
                }));
                this.touchDragoverTarget = null;
            }
            this.updateDraggedCell(touch);
        },
        /*
    * Emits drop and dragend events (column on touch-enabled devices)
    */ handleColumnTouchEnd (event) {
            if (!this.canDragColumn) return;
            if (this.isDraggingColumn) {
                const touch = event.changedTouches[0];
                const target = document.elementFromPoint(touch.clientX, touch.clientY);
                if (target != null) target.dispatchEvent(translateTouchAsDragEvent(event, {
                    type: "drop",
                    target
                }));
                event.target.dispatchEvent(translateTouchAsDragEvent(event, {
                    type: "dragend"
                }));
            }
            this.mayBeTouchDragging = false;
        },
        updateDraggedCell ({ clientX, clientY }) {
            const cellRect = this.$refs.draggedCell.getBoundingClientRect();
            const top = clientY + window.scrollY - cellRect.height / 2;
            const left = clientX + window.scrollX - cellRect.width / 2;
            this.$refs.draggedCell.style.top = `calc(${top}px)`;
            this.$refs.draggedCell.style.left = `calc(${left}px)`;
        },
        _registerTableColumn (column) {
            if (column._isTableColumn) this.defaultSlots.push(column);
        },
        _unregisterTableColumn (column) {
            const index = this.defaultSlots.indexOf(column);
            if (index !== -1) this.defaultSlots.splice(index, 1);
        }
    },
    mounted () {
        this.checkPredefinedDetailedRows();
        this.checkSort();
        const prepareDraggedCell = (isDraggable)=>{
            if (isDraggable && this.$data._draggedCellEl == null) this.$data._draggedCellEl = createAbsoluteElement(this.$refs.draggedCell);
        };
        this.$watch("draggable", prepareDraggedCell, {
            immediate: true
        });
        this.$watch("draggableColumn", prepareDraggedCell, {
            immediate: true
        });
    },
    beforeUnmount () {
        if (this.$data._draggedCellEl) removeElement(this.$data._draggedCellEl);
    }
});
const _hoisted_1$5 = [
    "tabindex"
];
const _hoisted_2$4 = {
    key: 1
};
const _hoisted_3$2 = {
    key: 0,
    width: "40px"
};
const _hoisted_4 = [
    "onClick",
    "draggable",
    "onDragstart",
    "onDragend",
    "onDrop",
    "onDragover",
    "onDragleave"
];
const _hoisted_5 = {
    key: 0,
    class: "multi-sort-icons"
};
const _hoisted_6 = [
    "onClick"
];
const _hoisted_7 = {
    key: 0,
    class: "is-subheading"
};
const _hoisted_8 = {
    key: 0,
    width: "40px"
};
const _hoisted_9 = {
    key: 1
};
const _hoisted_10 = {
    key: 2
};
const _hoisted_11 = {
    key: 1
};
const _hoisted_12 = {
    key: 0,
    width: "40px"
};
const _hoisted_13 = {
    key: 1
};
const _hoisted_14 = {
    key: 2
};
const _hoisted_15 = [
    "onClick",
    "onDblclick",
    "onMouseenter",
    "onMouseleave",
    "onContextmenu",
    "draggable",
    "onDragstart",
    "onDragend",
    "onDrop",
    "onDragover",
    "onDragleave",
    "onTouchstart"
];
const _hoisted_16 = {
    key: 0,
    class: "chevron-cell"
};
const _hoisted_17 = [
    "onClick"
];
const _hoisted_18 = {
    key: 0,
    class: "detail"
};
const _hoisted_19 = [
    "colspan"
];
const _hoisted_20 = {
    class: "detail-container"
};
const _hoisted_21 = {
    key: 0,
    class: "is-empty"
};
const _hoisted_22 = [
    "colspan"
];
const _hoisted_23 = {
    key: 2
};
const _hoisted_24 = {
    class: "table-footer"
};
const _hoisted_25 = [
    "colspan"
];
const _hoisted_26 = [
    "innerHTML"
];
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_table_mobile_sort = (0, _vue.resolveComponent)("b-table-mobile-sort");
    const _component_b_table_pagination = (0, _vue.resolveComponent)("b-table-pagination");
    const _component_b_checkbox = (0, _vue.resolveComponent)("b-checkbox");
    const _component_b_slot_component = (0, _vue.resolveComponent)("b-slot-component");
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    const _component_b_input = (0, _vue.resolveComponent)("b-input");
    const _component_b_loading = (0, _vue.resolveComponent)("b-loading");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", (0, _vue.mergeProps)({
        class: "b-table"
    }, _ctx.rootAttrs), [
        (0, _vue.renderSlot)(_ctx.$slots, "default"),
        _ctx.mobileCards && _ctx.hasSortablenewColumns ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_table_mobile_sort, {
            key: 0,
            "current-sort-column": _ctx.currentSortColumn,
            "sort-multiple": _ctx.sortMultiple,
            "sort-multiple-data": _ctx.sortMultipleDataComputed,
            "is-asc": _ctx.isAsc,
            columns: _ctx.newColumns,
            placeholder: _ctx.mobileSortPlaceholder,
            "icon-pack": _ctx.iconPack,
            "sort-icon": _ctx.sortIcon,
            "sort-icon-size": _ctx.sortIconSize,
            onSort: _cache[0] || (_cache[0] = (column, event)=>_ctx.sort(column, null, event)),
            onRemovePriority: _cache[1] || (_cache[1] = (column)=>_ctx.removeSortingPriority(column))
        }, null, 8, [
            "current-sort-column",
            "sort-multiple",
            "sort-multiple-data",
            "is-asc",
            "columns",
            "placeholder",
            "icon-pack",
            "sort-icon",
            "sort-icon-size"
        ])) : (0, _vue.createCommentVNode)("v-if", true),
        _ctx.paginated && (_ctx.paginationPosition === "top" || _ctx.paginationPosition === "both") ? (0, _vue.renderSlot)(_ctx.$slots, "pagination", {
            key: 1
        }, ()=>[
                (0, _vue.createVNode)(_component_b_table_pagination, (0, _vue.mergeProps)(_ctx.fallthroughAttrs, {
                    "per-page": _ctx.perPage,
                    paginated: _ctx.paginated,
                    rounded: _ctx.paginationRounded,
                    "icon-pack": _ctx.iconPack,
                    total: _ctx.newDataTotal,
                    "current-page": _ctx.newCurrentPage,
                    "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event)=>_ctx.newCurrentPage = $event),
                    "aria-next-label": _ctx.ariaNextLabel,
                    "aria-previous-label": _ctx.ariaPreviousLabel,
                    "aria-page-label": _ctx.ariaPageLabel,
                    "aria-current-label": _ctx.ariaCurrentLabel,
                    onPageChange: _cache[3] || (_cache[3] = (event)=>_ctx.$emit("page-change", event)),
                    "page-input": _ctx.pageInput,
                    "pagination-order": _ctx.paginationOrder,
                    "page-input-position": _ctx.pageInputPosition,
                    "debounce-page-input": _ctx.debouncePageInput
                }), {
                    default: (0, _vue.withCtx)(()=>[
                            (0, _vue.renderSlot)(_ctx.$slots, "top-left")
                        ]),
                    _: 3
                }, 16, [
                    "per-page",
                    "paginated",
                    "rounded",
                    "icon-pack",
                    "total",
                    "current-page",
                    "aria-next-label",
                    "aria-previous-label",
                    "aria-page-label",
                    "aria-current-label",
                    "page-input",
                    "pagination-order",
                    "page-input-position",
                    "debounce-page-input"
                ])
            ]) : (0, _vue.createCommentVNode)("v-if", true),
        (0, _vue.createElementVNode)("div", {
            class: (0, _vue.normalizeClass)([
                "table-wrapper",
                _ctx.tableWrapperClasses
            ]),
            style: (0, _vue.normalizeStyle)(_ctx.tableStyle)
        }, [
            (0, _vue.createElementVNode)("table", {
                class: (0, _vue.normalizeClass)([
                    "table",
                    _ctx.tableClasses
                ]),
                tabindex: !_ctx.focusable ? void 0 : 0,
                onKeydown: [
                    _cache[9] || (_cache[9] = (0, _vue.withKeys)((0, _vue.withModifiers)(($event)=>_ctx.pressedArrow(-1), [
                        "self",
                        "prevent"
                    ]), [
                        "up"
                    ])),
                    _cache[10] || (_cache[10] = (0, _vue.withKeys)((0, _vue.withModifiers)(($event)=>_ctx.pressedArrow(1), [
                        "self",
                        "prevent"
                    ]), [
                        "down"
                    ]))
                ]
            }, [
                _ctx.caption ? (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("caption", {
                    key: 0
                }, (0, _vue.toDisplayString)(_ctx.caption), 513)), [
                    [
                        (0, _vue.vShow),
                        _ctx.showCaption
                    ]
                ]) : (0, _vue.createCommentVNode)("v-if", true),
                _ctx.newColumns.length && _ctx.showHeader ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("thead", _hoisted_2$4, [
                    (0, _vue.createElementVNode)("tr", null, [
                        _ctx.showDetailRowIcon ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", _hoisted_3$2)) : (0, _vue.createCommentVNode)("v-if", true),
                        _ctx.checkable && _ctx.checkboxPosition === "left" ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", {
                            key: 1,
                            class: (0, _vue.normalizeClass)([
                                "checkbox-cell",
                                {
                                    "is-sticky": _ctx.stickyCheckbox
                                }
                            ])
                        }, [
                            _ctx.headerCheckable ? (0, _vue.renderSlot)(_ctx.$slots, "check-all", {
                                key: 0,
                                isAllChecked: _ctx.isAllChecked,
                                isAllUncheckable: _ctx.isAllUncheckable,
                                checkAll: _ctx.checkAll
                            }, ()=>[
                                    (0, _vue.createVNode)(_component_b_checkbox, {
                                        autocomplete: "off",
                                        "model-value": _ctx.isAllChecked,
                                        type: _ctx.checkboxType,
                                        disabled: _ctx.isAllUncheckable,
                                        onChange: _ctx.checkAll
                                    }, null, 8, [
                                        "model-value",
                                        "type",
                                        "disabled",
                                        "onChange"
                                    ])
                                ]) : (0, _vue.createCommentVNode)("v-if", true)
                        ], 2)) : (0, _vue.createCommentVNode)("v-if", true),
                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.visibleColumns, (column, index)=>{
                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", (0, _vue.mergeProps)({
                                key: column.newKey + ":" + index + "header"
                            }, column.thAttrs(column), {
                                class: [
                                    column.thClasses,
                                    {
                                        "is-current-sort": !_ctx.sortMultiple && _ctx.currentSortColumn === column
                                    }
                                ],
                                style: column.thStyle,
                                onClick: (0, _vue.withModifiers)(($event)=>_ctx.sort(column, null, $event), [
                                    "stop"
                                ]),
                                draggable: _ctx.canDragColumn,
                                onDragstart: ($event)=>_ctx.handleColumnDragStart($event, column, index),
                                onDragend: ($event)=>_ctx.handleColumnDragEnd($event, column, index),
                                onDrop: ($event)=>_ctx.handleColumnDrop($event, column, index),
                                onDragover: ($event)=>_ctx.handleColumnDragOver($event, column, index),
                                onDragleave: ($event)=>_ctx.handleColumnDragLeave($event, column, index),
                                onTouchstart: _cache[4] || (_cache[4] = ($event)=>_ctx.handleColumnTouchStart($event)),
                                onTouchmove: _cache[5] || (_cache[5] = ($event)=>_ctx.handleColumnTouchMove($event)),
                                onTouchend: _cache[6] || (_cache[6] = ($event)=>_ctx.handleColumnTouchEnd($event))
                            }), [
                                (0, _vue.createElementVNode)("div", {
                                    class: (0, _vue.normalizeClass)([
                                        "th-wrap is-relative",
                                        {
                                            "is-numeric": column.numeric,
                                            "is-centered": column.centered
                                        }
                                    ]),
                                    style: (0, _vue.normalizeStyle)(column.thWrapStyle)
                                }, [
                                    column.$slots.header ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_slot_component, {
                                        key: 0,
                                        component: column,
                                        scoped: "",
                                        name: "header",
                                        tag: "span",
                                        props: {
                                            column,
                                            index
                                        }
                                    }, null, 8, [
                                        "component",
                                        "props"
                                    ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                        key: 1
                                    }, [
                                        (0, _vue.createTextVNode)((0, _vue.toDisplayString)(column.label) + " ", 1),
                                        _ctx.sortMultiple && _ctx.sortMultipleDataComputed && _ctx.sortMultipleDataComputed.length > 0 && _ctx.sortMultipleDataComputed.filter((i)=>i.field === column.field).length > 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_5, [
                                            (0, _vue.createVNode)(_component_b_icon, {
                                                icon: _ctx.sortIcon,
                                                pack: _ctx.iconPack,
                                                both: "",
                                                size: _ctx.sortIconSize,
                                                class: (0, _vue.normalizeClass)({
                                                    "is-desc": _ctx.sortMultipleDataComputed.filter((i)=>i.field === column.field)[0].order === "desc"
                                                })
                                            }, null, 8, [
                                                "icon",
                                                "pack",
                                                "size",
                                                "class"
                                            ]),
                                            (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)(_ctx.findIndexOfSortData(column)) + " ", 1),
                                            (0, _vue.createElementVNode)("button", {
                                                class: "delete is-small multi-sort-cancel-icon",
                                                type: "button",
                                                onClick: (0, _vue.withModifiers)(($event)=>_ctx.removeSortingPriority(column), [
                                                    "stop"
                                                ])
                                            }, null, 8, _hoisted_6)
                                        ])) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
                                            key: 1,
                                            icon: _ctx.sortIcon,
                                            pack: _ctx.iconPack,
                                            both: "",
                                            size: _ctx.sortIconSize,
                                            class: (0, _vue.normalizeClass)([
                                                "sort-icon",
                                                {
                                                    "is-desc": !_ctx.isAsc,
                                                    "is-invisible": _ctx.currentSortColumn !== column
                                                }
                                            ])
                                        }, null, 8, [
                                            "icon",
                                            "pack",
                                            "size",
                                            "class"
                                        ]))
                                    ], 64))
                                ], 6)
                            ], 16, _hoisted_4);
                        }), 128)),
                        _ctx.checkable && _ctx.checkboxPosition === "right" ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", {
                            key: 2,
                            class: (0, _vue.normalizeClass)([
                                "checkbox-cell",
                                {
                                    "is-sticky": _ctx.stickyCheckbox
                                }
                            ])
                        }, [
                            _ctx.headerCheckable ? (0, _vue.renderSlot)(_ctx.$slots, "check-all", {
                                key: 0,
                                isAllChecked: _ctx.isAllChecked,
                                isAllUncheckable: _ctx.isAllUncheckable,
                                checkAll: _ctx.checkAll
                            }, ()=>[
                                    (0, _vue.createVNode)(_component_b_checkbox, {
                                        autocomplete: "off",
                                        "model-value": _ctx.isAllChecked,
                                        type: _ctx.checkboxType,
                                        disabled: _ctx.isAllUncheckable,
                                        onChange: _ctx.checkAll
                                    }, null, 8, [
                                        "model-value",
                                        "type",
                                        "disabled",
                                        "onChange"
                                    ])
                                ]) : (0, _vue.createCommentVNode)("v-if", true)
                        ], 2)) : (0, _vue.createCommentVNode)("v-if", true)
                    ]),
                    _ctx.hasCustomSubheadings ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("tr", _hoisted_7, [
                        _ctx.showDetailRowIcon ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", _hoisted_8)) : (0, _vue.createCommentVNode)("v-if", true),
                        _ctx.checkable && _ctx.checkboxPosition === "left" ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", _hoisted_9)) : (0, _vue.createCommentVNode)("v-if", true),
                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.visibleColumns, (column, index)=>{
                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", {
                                key: column.newKey + ":" + index + "subheading",
                                style: (0, _vue.normalizeStyle)(column.style)
                            }, [
                                (0, _vue.createElementVNode)("div", {
                                    class: (0, _vue.normalizeClass)([
                                        "th-wrap",
                                        {
                                            "is-numeric": column.numeric,
                                            "is-centered": column.centered
                                        }
                                    ]),
                                    style: (0, _vue.normalizeStyle)(column.thWrapStyle)
                                }, [
                                    column.$slots.subheading ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_slot_component, {
                                        key: 0,
                                        component: column,
                                        scoped: "",
                                        name: "subheading",
                                        tag: "span",
                                        props: {
                                            column,
                                            index
                                        }
                                    }, null, 8, [
                                        "component",
                                        "props"
                                    ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                        key: 1
                                    }, [
                                        (0, _vue.createTextVNode)((0, _vue.toDisplayString)(column.subheading), 1)
                                    ], 64))
                                ], 6)
                            ], 4);
                        }), 128)),
                        _ctx.checkable && _ctx.checkboxPosition === "right" ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", _hoisted_10)) : (0, _vue.createCommentVNode)("v-if", true)
                    ])) : (0, _vue.createCommentVNode)("v-if", true),
                    _ctx.hasSearchablenewColumns ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("tr", _hoisted_11, [
                        _ctx.showDetailRowIcon ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", _hoisted_12)) : (0, _vue.createCommentVNode)("v-if", true),
                        _ctx.checkable && _ctx.checkboxPosition === "left" ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", _hoisted_13)) : (0, _vue.createCommentVNode)("v-if", true),
                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.visibleColumns, (column, index)=>{
                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", (0, _vue.mergeProps)({
                                key: column.newKey + ":" + index + "searchable"
                            }, column.thAttrs(column), {
                                style: column.thStyle,
                                class: {
                                    "is-sticky": column.sticky
                                }
                            }), [
                                (0, _vue.createElementVNode)("div", {
                                    class: "th-wrap",
                                    style: (0, _vue.normalizeStyle)(column.thWrapStyle)
                                }, [
                                    column.searchable ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                        key: 0
                                    }, [
                                        column.$slots.searchable ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_slot_component, {
                                            key: 0,
                                            component: column,
                                            scoped: true,
                                            name: "searchable",
                                            tag: "span",
                                            props: {
                                                column,
                                                filters: _ctx.filters
                                            }
                                        }, null, 8, [
                                            "component",
                                            "props"
                                        ])) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_input, (0, _vue.mergeProps)({
                                            key: 1,
                                            [(0, _vue.toHandlerKey)(_ctx.filtersEvent)]: _ctx.onFiltersEvent
                                        }, {
                                            modelValue: _ctx.filters[column.field],
                                            "onUpdate:modelValue": ($event)=>_ctx.filters[column.field] = $event,
                                            type: column.numeric ? "number" : "text"
                                        }), null, 16, [
                                            "modelValue",
                                            "onUpdate:modelValue",
                                            "type"
                                        ]))
                                    ], 64)) : (0, _vue.createCommentVNode)("v-if", true)
                                ], 4)
                            ], 16);
                        }), 128)),
                        _ctx.checkable && _ctx.checkboxPosition === "right" ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", _hoisted_14)) : (0, _vue.createCommentVNode)("v-if", true)
                    ])) : (0, _vue.createCommentVNode)("v-if", true)
                ])) : (0, _vue.createCommentVNode)("v-if", true),
                (0, _vue.createElementVNode)("tbody", null, [
                    ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.visibleData, (row, index)=>{
                        return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                            key: _ctx.customRowKey ? row[_ctx.customRowKey] : index
                        }, [
                            (0, _vue.createElementVNode)("tr", {
                                class: (0, _vue.normalizeClass)([
                                    _ctx.rowClass(row, index),
                                    {
                                        "is-selected": _ctx.isRowSelected(row, _ctx.selected),
                                        "is-checked": _ctx.isRowChecked(row)
                                    }
                                ]),
                                onClick: ($event)=>_ctx.selectRow(row),
                                onDblclick: ($event)=>_ctx.$emit("dblclick", row),
                                onMouseenter: ($event)=>_ctx.emitEventForRow("mouseenter", $event, row),
                                onMouseleave: ($event)=>_ctx.emitEventForRow("mouseleave", $event, row),
                                onContextmenu: ($event)=>_ctx.$emit("contextmenu", row, $event),
                                draggable: _ctx.canDragRow,
                                onDragstart: ($event)=>_ctx.handleDragStart($event, row, index),
                                onDragend: ($event)=>_ctx.handleDragEnd($event, row, index),
                                onDrop: ($event)=>_ctx.handleDrop($event, row, index),
                                onDragover: ($event)=>_ctx.handleDragOver($event, row, index),
                                onDragleave: ($event)=>_ctx.handleDragLeave($event, row, index),
                                onTouchstart: ($event)=>_ctx.handleTouchStart($event, row),
                                onTouchmove: _cache[7] || (_cache[7] = ($event)=>_ctx.handleTouchMove($event)),
                                onTouchend: _cache[8] || (_cache[8] = ($event)=>_ctx.handleTouchEnd($event))
                            }, [
                                _ctx.showDetailRowIcon ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("td", _hoisted_16, [
                                    _ctx.hasDetailedVisible(row) ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("a", {
                                        key: 0,
                                        role: "button",
                                        onClick: (0, _vue.withModifiers)(($event)=>_ctx.toggleDetails(row), [
                                            "stop"
                                        ])
                                    }, [
                                        (0, _vue.createVNode)(_component_b_icon, {
                                            icon: _ctx.detailIcon,
                                            pack: _ctx.iconPack,
                                            both: "",
                                            class: (0, _vue.normalizeClass)({
                                                "is-expanded": _ctx.isVisibleDetailRow(row)
                                            })
                                        }, null, 8, [
                                            "icon",
                                            "pack",
                                            "class"
                                        ])
                                    ], 8, _hoisted_17)) : (0, _vue.createCommentVNode)("v-if", true)
                                ])) : (0, _vue.createCommentVNode)("v-if", true),
                                _ctx.checkable && _ctx.checkboxPosition === "left" ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("td", {
                                    key: 1,
                                    class: (0, _vue.normalizeClass)([
                                        "checkbox-cell",
                                        {
                                            "is-sticky": _ctx.stickyCheckbox
                                        }
                                    ])
                                }, [
                                    (0, _vue.createVNode)(_component_b_checkbox, {
                                        autocomplete: "off",
                                        "model-value": _ctx.isRowChecked(row),
                                        type: _ctx.checkboxType,
                                        disabled: !_ctx.isRowCheckable(row),
                                        onClick: (0, _vue.withModifiers)(($event)=>_ctx.checkRow(row, index, $event), [
                                            "prevent",
                                            "stop"
                                        ])
                                    }, null, 8, [
                                        "model-value",
                                        "type",
                                        "disabled",
                                        "onClick"
                                    ])
                                ], 2)) : (0, _vue.createCommentVNode)("v-if", true),
                                ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.visibleColumns, (column, colindex)=>{
                                    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                        key: column.newKey + ":" + index + ":" + colindex
                                    }, [
                                        column.$slots.default ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_slot_component, (0, _vue.mergeProps)({
                                            key: 0,
                                            component: column
                                        }, column.tdAttrs(row, column), {
                                            scoped: "",
                                            name: "default",
                                            tag: "td",
                                            class: column.getRootClasses(row),
                                            style: column.getRootStyle(row),
                                            "data-label": column.label,
                                            props: {
                                                row,
                                                column,
                                                index,
                                                colindex,
                                                toggleDetails: _ctx.toggleDetails,
                                                isActiveDetailRow: _ctx.isActiveDetailRow
                                            },
                                            onClick: ($event)=>_ctx.$emit("cellclick", row, column, index, colindex)
                                        }), null, 16, [
                                            "component",
                                            "class",
                                            "style",
                                            "data-label",
                                            "props",
                                            "onClick"
                                        ])) : (0, _vue.createCommentVNode)("v-if", true)
                                    ], 64);
                                }), 128)),
                                _ctx.checkable && _ctx.checkboxPosition === "right" ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("td", {
                                    key: 2,
                                    class: (0, _vue.normalizeClass)([
                                        "checkbox-cell",
                                        {
                                            "is-sticky": _ctx.stickyCheckbox
                                        }
                                    ])
                                }, [
                                    (0, _vue.createVNode)(_component_b_checkbox, {
                                        autocomplete: "off",
                                        "model-value": _ctx.isRowChecked(row),
                                        type: _ctx.checkboxType,
                                        disabled: !_ctx.isRowCheckable(row),
                                        onClick: (0, _vue.withModifiers)(($event)=>_ctx.checkRow(row, index, $event), [
                                            "prevent",
                                            "stop"
                                        ])
                                    }, null, 8, [
                                        "model-value",
                                        "type",
                                        "disabled",
                                        "onClick"
                                    ])
                                ], 2)) : (0, _vue.createCommentVNode)("v-if", true)
                            ], 42, _hoisted_15),
                            (0, _vue.createVNode)((0, _vue.Transition), {
                                name: _ctx.detailTransition
                            }, {
                                default: (0, _vue.withCtx)(()=>[
                                        _ctx.isActiveDetailRow(row) ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("tr", _hoisted_18, [
                                            (0, _vue.createElementVNode)("td", {
                                                colspan: _ctx.columnCount
                                            }, [
                                                (0, _vue.createElementVNode)("div", _hoisted_20, [
                                                    (0, _vue.renderSlot)(_ctx.$slots, "detail", {
                                                        row,
                                                        index
                                                    })
                                                ])
                                            ], 8, _hoisted_19)
                                        ])) : (0, _vue.createCommentVNode)("v-if", true)
                                    ]),
                                _: 2
                            }, 1032, [
                                "name"
                            ]),
                            _ctx.isActiveCustomDetailRow(row) ? (0, _vue.renderSlot)(_ctx.$slots, "detail", {
                                key: 0,
                                row,
                                index
                            }) : (0, _vue.createCommentVNode)("v-if", true)
                        ], 64);
                    }), 128)),
                    !_ctx.visibleData.length ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("tr", _hoisted_21, [
                        (0, _vue.createElementVNode)("td", {
                            colspan: _ctx.columnCount
                        }, [
                            (0, _vue.renderSlot)(_ctx.$slots, "empty")
                        ], 8, _hoisted_22)
                    ])) : (0, _vue.createCommentVNode)("v-if", true)
                ]),
                _ctx.$slots.footer !== void 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("tfoot", _hoisted_23, [
                    (0, _vue.createElementVNode)("tr", _hoisted_24, [
                        _ctx.hasCustomFooterSlot() ? (0, _vue.renderSlot)(_ctx.$slots, "footer", {
                            key: 0
                        }) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", {
                            key: 1,
                            colspan: _ctx.columnCount
                        }, [
                            (0, _vue.renderSlot)(_ctx.$slots, "footer")
                        ], 8, _hoisted_25))
                    ])
                ])) : (0, _vue.createCommentVNode)("v-if", true)
            ], 42, _hoisted_1$5),
            _ctx.loading ? (0, _vue.renderSlot)(_ctx.$slots, "loading", {
                key: 0
            }, ()=>[
                    (0, _vue.createVNode)(_component_b_loading, {
                        "is-full-page": false,
                        "model-value": _ctx.loading
                    }, null, 8, [
                        "model-value"
                    ])
                ]) : (0, _vue.createCommentVNode)("v-if", true)
        ], 6),
        _ctx.checkable && _ctx.hasBottomLeftSlot() || _ctx.paginated && (_ctx.paginationPosition === "bottom" || _ctx.paginationPosition === "both") ? (0, _vue.renderSlot)(_ctx.$slots, "pagination", {
            key: 2
        }, ()=>[
                (0, _vue.createVNode)(_component_b_table_pagination, (0, _vue.mergeProps)(_ctx.fallthroughAttrs, {
                    "per-page": _ctx.perPage,
                    paginated: _ctx.paginated,
                    rounded: _ctx.paginationRounded,
                    "icon-pack": _ctx.iconPack,
                    total: _ctx.newDataTotal,
                    "current-page": _ctx.newCurrentPage,
                    "onUpdate:currentPage": _cache[11] || (_cache[11] = ($event)=>_ctx.newCurrentPage = $event),
                    "aria-next-label": _ctx.ariaNextLabel,
                    "aria-previous-label": _ctx.ariaPreviousLabel,
                    "aria-page-label": _ctx.ariaPageLabel,
                    "aria-current-label": _ctx.ariaCurrentLabel,
                    onPageChange: _cache[12] || (_cache[12] = (event)=>_ctx.$emit("page-change", event)),
                    "page-input": _ctx.pageInput,
                    "pagination-order": _ctx.paginationOrder,
                    "page-input-position": _ctx.pageInputPosition,
                    "debounce-page-input": _ctx.debouncePageInput
                }), {
                    default: (0, _vue.withCtx)(()=>[
                            (0, _vue.renderSlot)(_ctx.$slots, "bottom-left")
                        ]),
                    _: 3
                }, 16, [
                    "per-page",
                    "paginated",
                    "rounded",
                    "icon-pack",
                    "total",
                    "current-page",
                    "aria-next-label",
                    "aria-previous-label",
                    "aria-page-label",
                    "aria-current-label",
                    "page-input",
                    "pagination-order",
                    "page-input-position",
                    "debounce-page-input"
                ])
            ]) : (0, _vue.createCommentVNode)("v-if", true),
        (0, _vue.createCommentVNode)(" eslint-disable vue/no-v-html "),
        (0, _vue.withDirectives)((0, _vue.createElementVNode)("div", {
            ref: "draggedCell",
            class: (0, _vue.normalizeClass)([
                "touch-dragged-cell",
                _ctx.touchDraggedCellClasses
            ]),
            innerHTML: _ctx.draggedCellContent
        }, null, 10, _hoisted_26), [
            [
                (0, _vue.vShow),
                _ctx.mayBeTouchDragging && (_ctx.isDraggingRow || _ctx.isDraggingColumn)
            ]
        ]),
        (0, _vue.createCommentVNode)(" eslint-enable vue/no-v-html ")
    ], 16);
}
var Table = /* @__PURE__ */ _export_sfc(_sfc_main$6, [
    [
        "render",
        _sfc_render$6
    ]
]);
var _sfc_main$5 = (0, _vue.defineComponent)({
    name: "BTableColumn",
    inject: {
        $table: {
            name: "$table",
            default: false
        }
    },
    props: {
        label: String,
        customKey: [
            String,
            Number
        ],
        field: String,
        meta: [
            String,
            Number,
            Boolean,
            Function,
            Object,
            Array
        ],
        width: [
            Number,
            String
        ],
        numeric: Boolean,
        centered: Boolean,
        searchable: Boolean,
        sortable: Boolean,
        visible: {
            type: Boolean,
            default: true
        },
        subheading: [
            String,
            Number
        ],
        customSort: Function,
        customSearch: Function,
        sticky: Boolean,
        headerSelectable: Boolean,
        headerClass: String,
        cellClass: String,
        thAttrs: {
            type: Function,
            default: ()=>({})
        },
        tdAttrs: {
            type: Function,
            default: ()=>({})
        }
    },
    data () {
        return {
            newKey: this.customKey || this.label,
            _isTableColumn: true
        };
    },
    computed: {
        thClasses () {
            const attrs = this.thAttrs(this);
            const classes = [
                this.headerClass,
                {
                    "is-sortable": this.sortable,
                    "is-sticky": this.sticky,
                    "is-unselectable": this.isHeaderUnSelectable
                }
            ];
            if (attrs && attrs.class) classes.push(attrs.class);
            return classes;
        },
        thStyle () {
            const attrs = this.thAttrs(this);
            const style = [
                this.style
            ];
            if (attrs && attrs.style) style.push(attrs.style);
            return style;
        },
        thWrapStyle () {
            const width = toCssWidth(this.width);
            if (width != null && !width.trim().endsWith("%")) return {
                width
            };
            else return {};
        },
        rootClasses () {
            return [
                this.cellClass,
                {
                    "has-text-right": this.numeric && !this.centered,
                    "has-text-centered": this.centered,
                    "is-sticky": this.sticky
                }
            ];
        },
        style () {
            var _a;
            return {
                width: (_a = toCssWidth(this.width)) != null ? _a : void 0
            };
        },
        hasDefaultSlot () {
            return !!this.$slots.default;
        },
        /*
     * Return if column header is un-selectable
     */ isHeaderUnSelectable () {
            return !this.headerSelectable && this.sortable;
        }
    },
    methods: {
        getRootClasses (row) {
            const attrs = this.tdAttrs(row, this);
            const classes = [
                this.rootClasses
            ];
            if (attrs && attrs.class) classes.push(attrs.class);
            return classes;
        },
        getRootStyle (row) {
            const attrs = this.tdAttrs(row, this);
            const style = [];
            if (attrs && attrs.style) style.push(attrs.style);
            return style;
        }
    },
    created () {
        if (!this.$table) throw new Error("You should wrap bTableColumn on a bTable");
        this.$table._registerTableColumn(this);
    },
    beforeUnmount () {
        this.$table._unregisterTableColumn(this);
    },
    render () {
        return null;
    }
});
const Plugin$7 = {
    install (Vue) {
        registerComponent(Vue, Table);
        registerComponent(Vue, _sfc_main$5);
    }
};
var _sfc_main$4 = (0, _vue.defineComponent)({
    name: "BTabs",
    components: {
        BIcon,
        BSlotComponent
    },
    mixins: [
        TabbedMixin("tab")
    ],
    props: {
        expanded: {
            type: Boolean,
            default: ()=>{
                return config.defaultTabsExpanded;
            }
        },
        type: {
            type: [
                String,
                Object
            ],
            default: ()=>{
                return config.defaultTabsType;
            }
        },
        animated: {
            type: Boolean,
            default: ()=>{
                return config.defaultTabsAnimated;
            }
        },
        multiline: Boolean
    },
    data () {
        return {
            currentFocus: null
        };
    },
    computed: {
        mainClasses () {
            return {
                "is-fullwidth": this.expanded,
                "is-vertical": this.vertical,
                "is-multiline": this.multiline,
                [this.position]: this.position && this.vertical
            };
        },
        navClasses () {
            return [
                this.type,
                this.size,
                {
                    [this.position]: this.position && !this.vertical,
                    "is-fullwidth": this.expanded,
                    "is-toggle": this.type === "is-toggle-rounded"
                }
            ];
        }
    },
    methods: {
        giveFocusToTab (tab) {
            if (Array.isArray(tab)) {
                tab = tab[0];
                if (tab == null) return;
            }
            if (tab.$el && tab.$el.focus) tab.$el.focus();
            else if (tab.focus) tab.focus();
        },
        manageTablistKeydown (event) {
            const { key } = event;
            switch(key){
                case this.vertical ? "ArrowUp" : "ArrowLeft":
                case this.vertical ? "Up" : "Left":
                    {
                        let prevIdx = this.getPrevItemIdx(this.currentFocus, true);
                        if (prevIdx === null) prevIdx = this.getPrevItemIdx(Infinity, true);
                        const prevItem = this.items.find((i)=>i.index === prevIdx);
                        if (prevItem && this.$refs[`tabLink${prevIdx}`] && !prevItem.disabled) this.giveFocusToTab(this.$refs[`tabLink${prevIdx}`]);
                        event.preventDefault();
                        break;
                    }
                case this.vertical ? "ArrowDown" : "ArrowRight":
                case this.vertical ? "Down" : "Right":
                    {
                        let nextIdx = this.getNextItemIdx(this.currentFocus, true);
                        if (nextIdx === null) nextIdx = this.getNextItemIdx(-1, true);
                        const nextItem = this.items.find((i)=>i.index === nextIdx);
                        if (nextItem && this.$refs[`tabLink${nextIdx}`] && !nextItem.disabled) this.giveFocusToTab(this.$refs[`tabLink${nextIdx}`]);
                        event.preventDefault();
                        break;
                    }
            }
        },
        manageTabKeydown (event, childItem) {
            const { key } = event;
            switch(key){
                case " ":
                case "Space":
                case "Spacebar":
                case "Enter":
                    this.childClick(childItem);
                    event.preventDefault();
                    break;
            }
        }
    }
});
const _hoisted_1$4 = [
    "aria-orientation"
];
const _hoisted_2$3 = [
    "aria-controls",
    "aria-selected"
];
const _hoisted_3$1 = [
    "id",
    "tabindex",
    "onFocus",
    "onClick",
    "onKeydown"
];
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_slot_component = (0, _vue.resolveComponent)("b-slot-component");
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "b-tabs",
            _ctx.mainClasses
        ])
    }, [
        (0, _vue.createElementVNode)("nav", {
            class: (0, _vue.normalizeClass)([
                "tabs",
                _ctx.navClasses
            ]),
            onKeydown: _cache[0] || (_cache[0] = (...args)=>_ctx.manageTablistKeydown && _ctx.manageTablistKeydown(...args))
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "start"),
            (0, _vue.createElementVNode)("ul", {
                "aria-orientation": _ctx.vertical ? "vertical" : "horizontal",
                role: "tablist"
            }, [
                ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.items, (childItem)=>{
                    return (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", {
                        key: childItem.uniqueValue,
                        class: (0, _vue.normalizeClass)([
                            childItem.headerClass,
                            {
                                "is-active": childItem.isActive,
                                "is-disabled": childItem.disabled
                            }
                        ]),
                        role: "tab",
                        "aria-controls": `${childItem.uniqueValue}-content`,
                        "aria-selected": `${childItem.isActive}`
                    }, [
                        childItem.$slots.header ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_slot_component, {
                            key: 0,
                            ref_for: true,
                            ref: `tabLink${childItem.index}`,
                            component: childItem,
                            name: "header",
                            tag: "a",
                            id: `${childItem.uniqueValue}-label`,
                            tabindex: childItem.isActive ? 0 : -1,
                            onFocus: ($event)=>_ctx.currentFocus = childItem.index,
                            onClick: ($event)=>_ctx.childClick(childItem),
                            onKeydown: ($event)=>_ctx.manageTabKeydown($event, childItem)
                        }, null, 8, [
                            "component",
                            "id",
                            "tabindex",
                            "onFocus",
                            "onClick",
                            "onKeydown"
                        ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("a", {
                            key: 1,
                            ref_for: true,
                            ref: `tabLink${childItem.index}`,
                            id: `${childItem.uniqueValue}-label`,
                            tabindex: childItem.isActive ? 0 : -1,
                            onFocus: ($event)=>_ctx.currentFocus = childItem.index,
                            onClick: ($event)=>_ctx.childClick(childItem),
                            onKeydown: ($event)=>_ctx.manageTabKeydown($event, childItem)
                        }, [
                            childItem.icon ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
                                key: 0,
                                icon: childItem.icon,
                                pack: childItem.iconPack,
                                size: _ctx.size
                            }, null, 8, [
                                "icon",
                                "pack",
                                "size"
                            ])) : (0, _vue.createCommentVNode)("v-if", true),
                            (0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)(childItem.label), 1)
                        ], 40, _hoisted_3$1))
                    ], 10, _hoisted_2$3)), [
                        [
                            (0, _vue.vShow),
                            childItem.visible
                        ]
                    ]);
                }), 128))
            ], 8, _hoisted_1$4),
            (0, _vue.renderSlot)(_ctx.$slots, "end")
        ], 34),
        (0, _vue.createElementVNode)("section", {
            class: (0, _vue.normalizeClass)([
                "tab-content",
                {
                    "is-transitioning": _ctx.isTransitioning
                }
            ])
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "default")
        ], 2)
    ], 2);
}
var Tabs = /* @__PURE__ */ _export_sfc(_sfc_main$4, [
    [
        "render",
        _sfc_render$5
    ]
]);
var _sfc_main$3 = (0, _vue.defineComponent)({
    name: "BTabItem",
    mixins: [
        TabbedChildMixin("tab")
    ],
    props: {
        disabled: Boolean
    },
    data () {
        return {
            elementClass: "tab-item",
            elementRole: "tabpanel"
        };
    }
});
const Plugin$6 = {
    install (Vue) {
        registerComponent(Vue, Tabs);
        registerComponent(Vue, _sfc_main$3);
    }
};
var _sfc_main$2 = (0, _vue.defineComponent)({
    name: "BTag",
    components: {
        BIcon
    },
    props: {
        attached: Boolean,
        closable: Boolean,
        type: [
            String,
            Object
        ],
        size: String,
        rounded: Boolean,
        disabled: Boolean,
        ellipsis: Boolean,
        tabstop: {
            type: Boolean,
            default: true
        },
        ariaCloseLabel: String,
        icon: String,
        iconType: String,
        iconPack: String,
        closeType: String,
        closeIcon: String,
        closeIconPack: String,
        closeIconType: String
    },
    emits: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        click: (_)=>true,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        close: (_)=>true
    },
    computed: {
        // setting a boolean attribute `false` does not remove it on Vue 3.
        // `null` or `undefined` has to be given to remove it.
        disabledOrUndefined () {
            return this.disabled || void 0;
        }
    },
    methods: {
        /*
    * Emit close event when delete button is clicked
    * or delete key is pressed.
    */ close (event) {
            if (this.disabled) return;
            this.$emit("close", event);
        },
        /*
    * Emit click event when tag is clicked.
    */ click (event) {
            if (this.disabled) return;
            this.$emit("click", event);
        }
    }
});
const _hoisted_1$3 = {
    key: 0,
    class: "tags has-addons inline-tags"
};
const _hoisted_2$2 = [
    "aria-label",
    "tabindex",
    "disabled"
];
const _hoisted_3 = [
    "aria-label",
    "disabled",
    "tabindex"
];
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    return _ctx.attached && _ctx.closable ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1$3, [
        (0, _vue.createElementVNode)("span", {
            class: (0, _vue.normalizeClass)([
                "tag",
                [
                    _ctx.type,
                    _ctx.size,
                    {
                        "is-rounded": _ctx.rounded
                    }
                ]
            ])
        }, [
            _ctx.icon ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
                key: 0,
                icon: _ctx.icon,
                size: _ctx.size,
                type: _ctx.iconType,
                pack: _ctx.iconPack
            }, null, 8, [
                "icon",
                "size",
                "type",
                "pack"
            ])) : (0, _vue.createCommentVNode)("v-if", true),
            (0, _vue.createElementVNode)("span", {
                class: (0, _vue.normalizeClass)({
                    "has-ellipsis": _ctx.ellipsis
                }),
                onClick: _cache[0] || (_cache[0] = (...args)=>_ctx.click && _ctx.click(...args))
            }, [
                (0, _vue.renderSlot)(_ctx.$slots, "default")
            ], 2)
        ], 2),
        (0, _vue.createElementVNode)("a", {
            class: (0, _vue.normalizeClass)([
                "tag",
                [
                    _ctx.size,
                    _ctx.closeType,
                    {
                        "is-rounded": _ctx.rounded
                    },
                    _ctx.closeIcon ? "has-delete-icon" : "is-delete"
                ]
            ]),
            role: "button",
            "aria-label": _ctx.ariaCloseLabel,
            tabindex: _ctx.tabstop ? 0 : void 0,
            disabled: _ctx.disabledOrUndefined,
            onClick: _cache[1] || (_cache[1] = (...args)=>_ctx.close && _ctx.close(...args)),
            onKeyup: _cache[2] || (_cache[2] = (0, _vue.withKeys)((0, _vue.withModifiers)((...args)=>_ctx.close && _ctx.close(...args), [
                "prevent"
            ]), [
                "delete"
            ]))
        }, [
            _ctx.closeIcon ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
                key: 0,
                "custom-class": "",
                icon: _ctx.closeIcon,
                size: _ctx.size,
                type: _ctx.closeIconType,
                pack: _ctx.closeIconPack
            }, null, 8, [
                "icon",
                "size",
                "type",
                "pack"
            ])) : (0, _vue.createCommentVNode)("v-if", true)
        ], 42, _hoisted_2$2)
    ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", {
        key: 1,
        class: (0, _vue.normalizeClass)([
            "tag",
            [
                _ctx.type,
                _ctx.size,
                {
                    "is-rounded": _ctx.rounded
                }
            ]
        ])
    }, [
        _ctx.icon ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
            key: 0,
            icon: _ctx.icon,
            size: _ctx.size,
            type: _ctx.iconType,
            pack: _ctx.iconPack
        }, null, 8, [
            "icon",
            "size",
            "type",
            "pack"
        ])) : (0, _vue.createCommentVNode)("v-if", true),
        (0, _vue.createElementVNode)("span", {
            class: (0, _vue.normalizeClass)({
                "has-ellipsis": _ctx.ellipsis
            }),
            onClick: _cache[3] || (_cache[3] = (...args)=>_ctx.click && _ctx.click(...args))
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "default")
        ], 2),
        _ctx.closable ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("a", {
            key: 1,
            role: "button",
            "aria-label": _ctx.ariaCloseLabel,
            class: (0, _vue.normalizeClass)([
                "delete is-small",
                _ctx.closeType
            ]),
            disabled: _ctx.disabledOrUndefined,
            tabindex: _ctx.tabstop ? 0 : void 0,
            onClick: _cache[4] || (_cache[4] = (...args)=>_ctx.close && _ctx.close(...args)),
            onKeyup: _cache[5] || (_cache[5] = (0, _vue.withKeys)((0, _vue.withModifiers)((...args)=>_ctx.close && _ctx.close(...args), [
                "prevent"
            ]), [
                "delete"
            ]))
        }, null, 42, _hoisted_3)) : (0, _vue.createCommentVNode)("v-if", true)
    ], 2));
}
var BTag = /* @__PURE__ */ _export_sfc(_sfc_main$2, [
    [
        "render",
        _sfc_render$4
    ]
]);
var _sfc_main$1 = (0, _vue.defineComponent)({
    name: "BTaglist",
    props: {
        attached: Boolean
    }
});
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "tags",
            {
                "has-addons": _ctx.attached
            }
        ])
    }, [
        (0, _vue.renderSlot)(_ctx.$slots, "default")
    ], 2);
}
var Taglist = /* @__PURE__ */ _export_sfc(_sfc_main$1, [
    [
        "render",
        _sfc_render$3
    ]
]);
const Plugin$5 = {
    install (Vue) {
        registerComponent(Vue, BTag);
        registerComponent(Vue, Taglist);
    }
};
var _sfc_main = (0, _vue.defineComponent)({
    name: "BTaginput",
    components: {
        BAutocomplete,
        BTag
    },
    mixins: [
        CompatFallthroughMixin,
        FormElementMixin
    ],
    props: {
        modelValue: {
            type: Array,
            default: ()=>[]
        },
        data: {
            type: Array,
            default: ()=>[]
        },
        type: String,
        closeType: String,
        attached: {
            type: Boolean,
            default: false
        },
        maxtags: Number,
        hasCounter: {
            type: Boolean,
            default: ()=>config.defaultTaginputHasCounter
        },
        field: {
            type: String,
            default: "value"
        },
        autocomplete: Boolean,
        groupField: String,
        groupOptions: String,
        nativeAutocomplete: String,
        openOnFocus: Boolean,
        keepOpen: {
            type: Boolean,
            default: true
        },
        keepFirst: Boolean,
        disabled: Boolean,
        ellipsis: Boolean,
        closable: {
            type: Boolean,
            default: true
        },
        ariaCloseLabel: String,
        confirmKeys: {
            type: Array,
            default: ()=>[
                    ",",
                    "Tab",
                    "Enter"
                ]
        },
        removeOnKeys: {
            type: Array,
            default: ()=>[
                    "Backspace"
                ]
        },
        allowNew: Boolean,
        onPasteSeparators: {
            type: Array,
            default: ()=>[
                    ","
                ]
        },
        beforeAdding: {
            type: Function,
            default: ()=>true
        },
        allowDuplicates: {
            type: Boolean,
            default: false
        },
        checkInfiniteScroll: {
            type: Boolean,
            default: false
        },
        createTag: {
            type: Function,
            default: (tag)=>tag
        },
        appendToBody: Boolean
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars */ add: (tag)=>true,
        "infinite-scroll": ()=>true,
        remove: (tag)=>true,
        typing: (value)=>true,
        "update:modelValue": (tags)=>true
    },
    data () {
        return {
            tags: Array.isArray(this.modelValue) ? this.modelValue.slice(0) : this.modelValue || [],
            newTag: "",
            isComposing: false,
            _elementRef: "autocomplete",
            _isTaginput: true,
            requestID: null
        };
    },
    computed: {
        rootClasses () {
            return {
                "is-expanded": this.expanded
            };
        },
        containerClasses () {
            return {
                "is-focused": this.isFocused,
                "is-focusable": this.hasInput
            };
        },
        valueLength () {
            return this.newTag.trim().length;
        },
        hasDefaultSlot () {
            return !!this.$slots.default;
        },
        hasEmptySlot () {
            return !!this.$slots.empty;
        },
        hasHeaderSlot () {
            return !!this.$slots.header;
        },
        hasFooterSlot () {
            return !!this.$slots.footer;
        },
        /*
     * Show the input field if a maxtags hasn't been set or reached.
     */ hasInput () {
            return this.maxtags == null || this.maxtags === 1 || this.tagsLength < this.maxtags;
        },
        tagsLength () {
            return this.tags.length;
        },
        /*
     * If Taginput has onPasteSeparators prop,
     * returning new RegExp used to split pasted string.
     */ separatorsAsRegExp () {
            const sep = this.onPasteSeparators;
            return sep.length ? new RegExp(sep.map((s)=>{
                return s ? s.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&") : null;
            }).join("|"), "g") : null;
        },
        disabledOrUndefined () {
            return this.disabled || void 0;
        }
    },
    watch: {
        /*
     * When v-model is changed set internal value.
     */ modelValue (value) {
            this.tags = Array.isArray(value) ? value.slice(0) : value || [];
        },
        hasInput () {
            if (!this.hasInput) this.onBlur();
        }
    },
    methods: {
        addTag (tag) {
            const tagToAdd = tag || this.newTag.trim();
            if (tagToAdd) {
                if (!this.autocomplete) {
                    const reg = this.separatorsAsRegExp;
                    if (reg && tagToAdd.match(reg)) {
                        tagToAdd.split(reg).map((t)=>t.trim()).filter((t)=>t.length !== 0).map(this.addTag);
                        return;
                    }
                }
                const add = !this.allowDuplicates ? this.tags.indexOf(tagToAdd) === -1 : true;
                if (add && this.beforeAdding(tagToAdd)) {
                    if (this.maxtags === 1) this.tags = [];
                    this.tags.push(this.createTag(tagToAdd));
                    this.$emit("update:modelValue", this.tags);
                    this.$emit("add", tagToAdd);
                }
                this.requestID = requestAnimationFrame(()=>{
                    this.newTag = "";
                    this.$emit("typing", "");
                });
            }
        },
        getNormalizedTagText (tag) {
            if (typeof tag === "object") tag = getValueByPath(tag, this.field);
            return `${tag}`;
        },
        customOnBlur (event) {
            if (!this.autocomplete) this.addTag();
            this.onBlur(event);
        },
        onSelect (option) {
            if (!option) return;
            this.addTag(option);
            this.$nextTick(()=>{
                this.newTag = "";
            });
        },
        removeTag (index, event) {
            const tag = this.tags.splice(index, 1)[0];
            this.$emit("update:modelValue", this.tags);
            this.$emit("remove", tag);
            if (event) event.stopPropagation();
            if (this.openOnFocus && this.$refs.autocomplete) this.$refs.autocomplete.focus();
            return tag;
        },
        removeLastTag () {
            if (this.tagsLength > 0) this.removeTag(this.tagsLength - 1);
        },
        keydown (event) {
            const { key } = event;
            if (this.removeOnKeys.indexOf(key) !== -1 && !this.newTag.length) this.removeLastTag();
            if (this.autocomplete && !this.allowNew) return;
            if (this.confirmKeys.indexOf(key) >= 0) {
                if (key !== "Tab") event.preventDefault();
                if (key === "Enter" && this.isComposing) return;
                this.addTag();
            }
        },
        onTyping (event) {
            this.$emit("typing", typeof event === "number" ? event : event == null ? void 0 : event.trim());
        },
        emitInfiniteScroll () {
            this.$emit("infinite-scroll");
        }
    },
    beforeUnmount () {
        cancelAnimationFrame(this.requestID);
    }
});
const _hoisted_1$2 = [
    "disabled"
];
const _hoisted_2$1 = {
    key: 0,
    class: "help counter"
};
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_tag = (0, _vue.resolveComponent)("b-tag");
    const _component_b_autocomplete = (0, _vue.resolveComponent)("b-autocomplete");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", (0, _vue.mergeProps)({
        class: [
            "taginput control",
            _ctx.rootClasses
        ]
    }, _ctx.rootAttrs), [
        (0, _vue.createElementVNode)("div", {
            class: (0, _vue.normalizeClass)([
                "taginput-container",
                [
                    _ctx.statusType,
                    _ctx.size,
                    _ctx.containerClasses
                ]
            ]),
            disabled: _ctx.disabledOrUndefined,
            onClick: _cache[3] || (_cache[3] = ($event)=>_ctx.hasInput && _ctx.focus())
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "selected", {
                tags: _ctx.tags
            }, ()=>[
                    ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.tags, (tag, index)=>{
                        return (0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_tag, {
                            key: _ctx.getNormalizedTagText(tag) + index,
                            type: _ctx.type,
                            "close-type": _ctx.closeType,
                            size: _ctx.size,
                            rounded: _ctx.rounded,
                            attached: _ctx.attached,
                            tabstop: false,
                            disabled: _ctx.disabledOrUndefined,
                            ellipsis: _ctx.ellipsis,
                            closable: _ctx.closable,
                            "aria-close-label": _ctx.ariaCloseLabel,
                            title: _ctx.ellipsis && _ctx.getNormalizedTagText(tag),
                            onClose: ($event)=>_ctx.removeTag(index, $event)
                        }, {
                            default: (0, _vue.withCtx)(()=>[
                                    (0, _vue.renderSlot)(_ctx.$slots, "tag", {
                                        tag
                                    }, ()=>[
                                            (0, _vue.createTextVNode)((0, _vue.toDisplayString)(_ctx.getNormalizedTagText(tag)), 1)
                                        ])
                                ]),
                            _: 2
                        }, 1032, [
                            "type",
                            "close-type",
                            "size",
                            "rounded",
                            "attached",
                            "disabled",
                            "ellipsis",
                            "closable",
                            "aria-close-label",
                            "title",
                            "onClose"
                        ]);
                    }), 128))
                ]),
            _ctx.hasInput ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_autocomplete, (0, _vue.mergeProps)({
                key: 0,
                ref: "autocomplete",
                modelValue: _ctx.newTag,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.newTag = $event)
            }, _ctx.fallthroughAttrs, {
                data: _ctx.data,
                field: _ctx.field,
                icon: _ctx.icon,
                "icon-pack": _ctx.iconPack,
                maxlength: _ctx.maxlength,
                "has-counter": false,
                size: _ctx.size,
                disabled: _ctx.disabledOrUndefined,
                loading: _ctx.loading,
                autocomplete: _ctx.nativeAutocomplete,
                "open-on-focus": _ctx.openOnFocus,
                "keep-open": _ctx.keepOpen,
                "keep-first": _ctx.keepFirst,
                "group-field": _ctx.groupField,
                "group-options": _ctx.groupOptions,
                "use-html5-validation": _ctx.useHtml5Validation,
                "check-infinite-scroll": _ctx.checkInfiniteScroll,
                "append-to-body": _ctx.appendToBody,
                "confirm-keys": _ctx.confirmKeys,
                onTyping: _ctx.onTyping,
                onFocus: _ctx.onFocus,
                onBlur: _ctx.customOnBlur,
                onKeydown: _ctx.keydown,
                onCompositionstart: _cache[1] || (_cache[1] = ($event)=>_ctx.isComposing = true),
                onCompositionend: _cache[2] || (_cache[2] = ($event)=>_ctx.isComposing = false),
                onSelect: _ctx.onSelect,
                onInfiniteScroll: _ctx.emitInfiniteScroll
            }), (0, _vue.createSlots)({
                _: 2
            }, [
                _ctx.hasHeaderSlot ? {
                    name: "header",
                    fn: (0, _vue.withCtx)(()=>[
                            (0, _vue.renderSlot)(_ctx.$slots, "header")
                        ]),
                    key: "0"
                } : void 0,
                _ctx.hasDefaultSlot ? {
                    name: "default",
                    fn: (0, _vue.withCtx)((props)=>[
                            (0, _vue.renderSlot)(_ctx.$slots, "default", {
                                option: props.option,
                                index: props.index
                            })
                        ]),
                    key: "1"
                } : void 0,
                _ctx.hasEmptySlot ? {
                    name: "empty",
                    fn: (0, _vue.withCtx)(()=>[
                            (0, _vue.renderSlot)(_ctx.$slots, "empty")
                        ]),
                    key: "2"
                } : void 0,
                _ctx.hasFooterSlot ? {
                    name: "footer",
                    fn: (0, _vue.withCtx)(()=>[
                            (0, _vue.renderSlot)(_ctx.$slots, "footer")
                        ]),
                    key: "3"
                } : void 0
            ]), 1040, [
                "modelValue",
                "data",
                "field",
                "icon",
                "icon-pack",
                "maxlength",
                "size",
                "disabled",
                "loading",
                "autocomplete",
                "open-on-focus",
                "keep-open",
                "keep-first",
                "group-field",
                "group-options",
                "use-html5-validation",
                "check-infinite-scroll",
                "append-to-body",
                "confirm-keys",
                "onTyping",
                "onFocus",
                "onBlur",
                "onKeydown",
                "onSelect",
                "onInfiniteScroll"
            ])) : (0, _vue.createCommentVNode)("v-if", true)
        ], 10, _hoisted_1$2),
        _ctx.hasCounter && (_ctx.maxtags || _ctx.maxlength) ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("small", _hoisted_2$1, [
            _ctx.maxlength && _ctx.valueLength > 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                key: 0
            }, [
                (0, _vue.createTextVNode)((0, _vue.toDisplayString)(_ctx.valueLength) + " / " + (0, _vue.toDisplayString)(_ctx.maxlength), 1)
            ], 64)) : _ctx.maxtags ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                key: 1
            }, [
                (0, _vue.createTextVNode)((0, _vue.toDisplayString)(_ctx.tagsLength) + " / " + (0, _vue.toDisplayString)(_ctx.maxtags), 1)
            ], 64)) : (0, _vue.createCommentVNode)("v-if", true)
        ])) : (0, _vue.createCommentVNode)("v-if", true)
    ], 16);
}
var Taginput = /* @__PURE__ */ _export_sfc(_sfc_main, [
    [
        "render",
        _sfc_render$2
    ]
]);
const Plugin$4 = {
    install (Vue) {
        registerComponent(Vue, Taginput);
    }
};
const Plugin$3 = {
    install (Vue) {
        registerComponent(Vue, Timepicker);
    }
};
const Toast$1 = (0, _vue.defineComponent)({
    name: "BToast",
    mixins: [
        NoticeMixin
    ],
    data () {
        return {
            newDuration: this.duration || config.defaultToastDuration
        };
    }
});
const _hoisted_1$1 = [
    "aria-hidden"
];
const _hoisted_2 = [
    "innerHTML"
];
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.Transition), {
        "enter-active-class": _ctx.transition.enter,
        "leave-active-class": _ctx.transition.leave,
        persisted: ""
    }, {
        default: (0, _vue.withCtx)(()=>[
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("div", {
                    onMouseenter: _cache[0] || (_cache[0] = (...args)=>_ctx.pause && _ctx.pause(...args)),
                    onMouseleave: _cache[1] || (_cache[1] = (...args)=>_ctx.removePause && _ctx.removePause(...args)),
                    class: (0, _vue.normalizeClass)([
                        "toast",
                        [
                            _ctx.type,
                            _ctx.position
                        ]
                    ]),
                    "aria-hidden": !_ctx.isActive,
                    role: "alert"
                }, [
                    _ctx.$slots.default ? (0, _vue.renderSlot)(_ctx.$slots, "default", {
                        key: 0
                    }) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                        key: 1
                    }, [
                        (0, _vue.createCommentVNode)(" eslint-disable-next-line vue/no-v-html "),
                        (0, _vue.createElementVNode)("div", {
                            innerHTML: _ctx.message
                        }, null, 8, _hoisted_2)
                    ], 64))
                ], 42, _hoisted_1$1), [
                    [
                        (0, _vue.vShow),
                        _ctx.isActive
                    ]
                ])
            ]),
        _: 3
    }, 8, [
        "enter-active-class",
        "leave-active-class"
    ]);
}
var Toast = /* @__PURE__ */ _export_sfc(Toast$1, [
    [
        "render",
        _sfc_render$1
    ]
]);
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps = (a, b)=>__defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var __publicField = (obj, key, value)=>__defNormalProp(obj, key + "", value);
class ToastProgrammatic {
    constructor(app){
        __publicField(this, "app");
        this.app = app;
    }
    open(params) {
        if (typeof params === "string") params = {
            message: params
        };
        let slot;
        let _a = params, { message } = _a, restParams = __objRest(_a, [
            "message"
        ]);
        if (typeof message !== "string") {
            slot = message;
            message = void 0;
        }
        const propsData = __spreadValues({
            position: config.defaultToastPosition || "is-top",
            message
        }, restParams);
        const container = document.createElement("div");
        const vueInstance = (0, _vue.createApp)({
            data () {
                return {
                    toastVNode: null
                };
            },
            methods: {
                close () {
                    const toast = getComponentFromVNode(this.toastVNode);
                    if (toast) toast.close();
                }
            },
            render () {
                this.toastVNode = (0, _vue.h)(Toast, __spreadProps(__spreadValues({}, propsData), {
                    // On Vue 3, $destroy is no longer available.
                    // A toast has to be unmounted manually.
                    onClose: ()=>{
                        if (typeof propsData.onClose === "function") propsData.onClose();
                        setTimeout(()=>{
                            vueInstance.unmount();
                        }, 150);
                    }
                }), slot != null ? {
                    default: ()=>slot
                } : void 0);
                return this.toastVNode;
            }
        });
        if (this.app) copyAppContext(this.app, vueInstance);
        else vueInstance.config.globalProperties.$buefy = {};
        return vueInstance.mount(container);
    }
}
const Plugin$2 = {
    install (Vue) {
        registerComponentProgrammatic(Vue, "toast", new ToastProgrammatic(Vue));
    }
};
const Plugin$1 = {
    install (Vue) {
        registerComponent(Vue, Tooltip);
    }
};
const Upload$1 = (0, _vue.defineComponent)({
    name: "BUpload",
    mixins: [
        CompatFallthroughMixin,
        FormElementMixin
    ],
    props: {
        modelValue: {
            type: [
                Object,
                Function,
                File,
                Array
            ]
        },
        multiple: Boolean,
        disabled: Boolean,
        accept: String,
        dragDrop: Boolean,
        type: {
            type: String,
            default: "is-primary"
        },
        native: {
            type: Boolean,
            default: false
        },
        expanded: {
            type: Boolean,
            default: false
        },
        rounded: {
            type: Boolean,
            default: false
        }
    },
    emits: {
        /* eslint-disable @typescript-eslint/no-unused-vars */ invalid: ()=>true,
        "update:modelValue": (newValue)=>true
    },
    data () {
        return {
            newValue: this.modelValue,
            dragDropFocus: false,
            _elementRef: "input"
        };
    },
    computed: {
        disabledOrUndefined () {
            return this.disabled || void 0;
        }
    },
    watch: {
        modelValue (value) {
            this.newValue = value;
            if (!value || Array.isArray(value) && value.length === 0) this.$refs.input.value = "";
            !this.isValid && !this.dragDrop && this.checkHtml5Validity();
        }
    },
    methods: {
        onFileChange (event) {
            var _a, _b;
            if (this.disabled || this.loading) return;
            if (this.dragDrop) this.updateDragDropFocus(false);
            const value = (_b = (_a = event.target.files) != null ? _a : event.dataTransfer.files) != null ? _b : [];
            if (value.length === 0) {
                if (!this.newValue) return;
                if (this.native) this.newValue = null;
            } else if (!this.multiple) {
                if (this.dragDrop && value.length !== 1) return;
                else {
                    const file = value[0];
                    if (this.checkType(file)) this.newValue = file;
                    else if (this.newValue) {
                        this.newValue = null;
                        this.clearInput();
                    } else {
                        this.clearInput();
                        this.checkHtml5Validity();
                        return;
                    }
                }
            } else {
                let newValues = false;
                if (this.native || !this.newValue) {
                    this.newValue = [];
                    newValues = true;
                }
                for(let i = 0; i < value.length; i++){
                    const file = value[i];
                    if (this.checkType(file) && Array.isArray(this.newValue)) {
                        this.newValue.push(file);
                        newValues = true;
                    }
                }
                if (!newValues) return;
            }
            this.$emit("update:modelValue", this.newValue);
            !this.dragDrop && this.checkHtml5Validity();
        },
        clearInput () {
            this.$refs.input.value = "";
        },
        updateDragDropFocus (focus) {
            if (!this.disabled && !this.loading) this.dragDropFocus = focus;
        },
        checkType (file) {
            if (!this.accept) return true;
            const types = this.accept.split(",");
            if (types.length === 0) return true;
            let valid = false;
            for(let i = 0; i < types.length && !valid; i++){
                const type = types[i].trim();
                if (type) {
                    if (type.substring(0, 1) === ".") {
                        const extension = file.name.toLowerCase().slice(-type.length);
                        if (extension === type.toLowerCase()) valid = true;
                    } else if (file.type.match(type)) valid = true;
                }
            }
            if (!valid) this.$emit("invalid");
            return valid;
        }
    }
});
const _hoisted_1 = [
    "multiple",
    "accept",
    "disabled"
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("label", (0, _vue.mergeProps)({
        class: "upload control"
    }, _ctx.rootAttrs, {
        class: [
            {
                "is-expanded": _ctx.expanded,
                "is-rounded": _ctx.rounded
            }
        ]
    }), [
        !_ctx.dragDrop ? (0, _vue.renderSlot)(_ctx.$slots, "default", {
            key: 0
        }) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
            key: 1,
            class: (0, _vue.normalizeClass)([
                "upload-draggable",
                [
                    _ctx.type,
                    {
                        "is-loading": _ctx.loading,
                        "is-disabled": _ctx.disabled,
                        "is-hovered": _ctx.dragDropFocus,
                        "is-expanded": _ctx.expanded
                    }
                ]
            ]),
            onDragover: _cache[0] || (_cache[0] = (0, _vue.withModifiers)(($event)=>_ctx.updateDragDropFocus(true), [
                "prevent"
            ])),
            onDragleave: _cache[1] || (_cache[1] = (0, _vue.withModifiers)(($event)=>_ctx.updateDragDropFocus(false), [
                "prevent"
            ])),
            onDragenter: _cache[2] || (_cache[2] = (0, _vue.withModifiers)(($event)=>_ctx.updateDragDropFocus(true), [
                "prevent"
            ])),
            onDrop: _cache[3] || (_cache[3] = (0, _vue.withModifiers)((...args)=>_ctx.onFileChange && _ctx.onFileChange(...args), [
                "prevent"
            ]))
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "default")
        ], 34)),
        (0, _vue.createElementVNode)("input", (0, _vue.mergeProps)({
            ref: "input",
            type: "file"
        }, _ctx.fallthroughAttrs, {
            multiple: _ctx.multiple,
            accept: _ctx.accept,
            disabled: _ctx.disabledOrUndefined,
            onChange: _cache[4] || (_cache[4] = (...args)=>_ctx.onFileChange && _ctx.onFileChange(...args))
        }), null, 16, _hoisted_1)
    ], 16);
}
var Upload = /* @__PURE__ */ _export_sfc(Upload$1, [
    [
        "render",
        _sfc_render
    ]
]);
const Plugin = {
    install (Vue) {
        registerComponent(Vue, Upload);
    }
};
const allComponents = [
    Plugin$F,
    Plugin$E,
    Plugin$D,
    Plugin$C,
    Plugin$B,
    Plugin$x,
    Plugin$A,
    Plugin$w,
    Plugin$v,
    Plugin$u,
    Plugin$t,
    Plugin$z,
    Plugin$s,
    Plugin$r,
    Plugin$q,
    Plugin$y,
    Plugin$p,
    Plugin$o,
    Plugin$n,
    Plugin$m,
    Plugin$k,
    Plugin$l,
    Plugin$j,
    Plugin$i,
    Plugin$h,
    Plugin$g,
    Plugin$f,
    Plugin$e,
    Plugin$d,
    Plugin$c,
    Plugin$b,
    Plugin$a,
    Plugin$9,
    Plugin$8,
    Plugin$7,
    Plugin$6,
    Plugin$5,
    Plugin$4,
    Plugin$3,
    Plugin$2,
    Plugin$1,
    Plugin
];
const Buefy = {
    install (Vue, options = {}) {
        setOptions(merge(config, options, true));
        allComponents.forEach((component)=>Vue.use(component));
        registerComponentProgrammatic(Vue, "config", ConfigComponent);
        Vue.config.globalProperties.$buefy.globalNoticeInterval = void 0;
    }
};

},{"vue":"jc5UF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4iE5H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "API_URL", ()=>API_URL);
parcelHelpers.export(exports, "buefyConfig", ()=>buefyConfig);
parcelHelpers.export(exports, "isEmpty", ()=>isEmpty);
parcelHelpers.export(exports, "isInsideIFrame", ()=>isInsideIFrame);
parcelHelpers.export(exports, "fetchJson", ()=>fetchJson);
// EAUTH2-87: keepalive function to prevent session expiration, both before and after login
// Before login, the "without ix" session must be kept to remember the client's original call parameters
// After login, it is to keep the "with ix" session alive
parcelHelpers.export(exports, "keepalive", ()=>keepalive);
parcelHelpers.export(exports, "getTimezone", ()=>getTimezone);
// EAUTH2-232: avoid /sign-in or /popup-launcher page to appear when clicking on the browser's back button
// Note that moving in the browser history do not send requests at all by default
// Instead, the state is restored from the browser's "bfcache" (Back-Forward Cache)
// Therefore, we need to explicitly check if the page is restored from this bfcache
// and reload the page, which will result in a redirect back to the client.
parcelHelpers.export(exports, "reloadPageIfCached", ()=>reloadPageIfCached);
// EAUTH2-298: homogenize errors and messages for credential-related operations
// This forwards the localized IX error or a generic default error
// that fits both login and password change errors.
parcelHelpers.export(exports, "parseEloCredentialsError", ()=>parseEloCredentialsError);
// BEWARE! This is relative to the UI located at ".../plugin/auth2/"!
// API calls will break if you move UI pages within subdirectories!
// It was made on purpose using relative URLs to be "proxy-friendly"
var _translations = require("./translations");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var API_URL = '../de.elo.ix.plugin.rest/auth2';
var buefyConfig = {
    defaultIconPack: 'e-icon',
    defaultCompatFallthrough: false // EAUTH2-216: accessibilty issue, see https://github.com/buefy/buefy/issues/4159
};
function isEmpty(obj) {
    return !obj || Object.keys(obj).length === 0;
}
function isInsideIFrame() {
    return window.top !== window.self;
}
function fetchJson(url) {
    return __awaiter(this, void 0, Promise, function() {
        var req, json, e_1;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        fetch(url)
                    ];
                case 1:
                    req = _a.sent();
                    if (!req.ok) throw "Unexpected response status: ".concat(req.status);
                    return [
                        4 /*yield*/ ,
                        req.json()
                    ];
                case 2:
                    json = _a.sent();
                    console.debug(json);
                    return [
                        2 /*return*/ ,
                        json
                    ];
                case 3:
                    e_1 = _a.sent();
                    console.error(e_1);
                    alert("Failed to fetch ".concat(url));
                    throw e_1;
                case 4:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function keepalive(ixSession) {
    return __awaiter(this, void 0, void 0, function() {
        var res;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        fetch("".concat(API_URL, "/").concat(ixSession ? 'keepalive' : 'status'))
                    ];
                case 1:
                    res = _a.sent();
                    if (!res.ok) {
                        alert("Connection lost. Please login again.");
                        window.location.href = "./sign-in";
                    } else window.setTimeout(keepalive, 60000, ixSession);
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function getTimezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function reloadPageIfCached() {
    window.addEventListener("pageshow", function(event) {
        console.debug("pageshow event triggered, persisted: ".concat(event.persisted));
        if (event.persisted) {
            console.log("Page restored from bfcache");
            window.location.reload();
        }
    });
}
// EAUTH2-261: nicer error messages
// EAUTH2-298: forward IX error messages if possible
function parseErrorMessage(res, defaultMessage) {
    return __awaiter(this, void 0, Promise, function() {
        var json, e_2;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4 /*yield*/ ,
                        res.json()
                    ];
                case 1:
                    json = _a.sent();
                    if (json.isLocalized && json.message) return [
                        2 /*return*/ ,
                        json.message
                    ];
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 2:
                    e_2 = _a.sent();
                    console.warn('Unable to parse error message from response', e_2);
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 3:
                    return [
                        2 /*return*/ ,
                        defaultMessage
                    ];
            }
        });
    });
}
function parseEloCredentialsError(res) {
    return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(_a) {
            if (res.status === 401) return [
                2 /*return*/ ,
                parseErrorMessage(res, (0, _translations.$t)('error_wrong_credentials'))
            ];
            else if (res.status === 403) return [
                2 /*return*/ ,
                parseErrorMessage(res, (0, _translations.$t)('error_password_forbidden'))
            ];
            else if (res.status === 409) return [
                2 /*return*/ ,
                parseErrorMessage(res, (0, _translations.$t)('error_new_password_rejected'))
            ];
            else // EAUTH2-261: nicer errors also for unexpected ones
            return [
                2 /*return*/ ,
                parseErrorMessage(res, (0, _translations.$t)('error_unexpected'))
            ];
            return [
                2 /*return*/ 
            ];
        });
    });
}

},{"./translations":"eBebr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eBebr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setLocale", ()=>setLocale);
parcelHelpers.export(exports, "$t", ()=>$t);
parcelHelpers.export(exports, "getSelectedLocale", ()=>getSelectedLocale);
parcelHelpers.export(exports, "loadMessages", ()=>loadMessages);
parcelHelpers.export(exports, "DEFAULT_ELO_LOCALE", ()=>DEFAULT_ELO_LOCALE);
parcelHelpers.export(exports, "ELO_LOCALES", ()=>ELO_LOCALES);
parcelHelpers.export(exports, "getDefaultLocale", ()=>getDefaultLocale);
parcelHelpers.export(exports, "pickLocaleFrom", ()=>pickLocaleFrom);
// EAUTH2-153: consider selected locale for admin messages
parcelHelpers.export(exports, "loadAdminMessages", ()=>loadAdminMessages);
var _utils = require("./utils");
var _vue = require("vue");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
// To store the selected value and avoid that it resets to the Browser default each time
var AUTH2_PREFERRED_LOCALE = 'auth2-preferred-locale';
var selectedLocale = null;
var messages = (0, _vue.ref)({});
function setLocale(locale) {
    return __awaiter(this, void 0, Promise, function() {
        var _a;
        return __generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    console.log("Changing language to ".concat(locale));
                    _a = messages;
                    return [
                        4 /*yield*/ ,
                        (0, _utils.fetchJson)("./locales/sign-in-".concat(locale, ".json"))
                    ];
                case 1:
                    _a.value = _b.sent();
                    selectedLocale = locale;
                    // remember it for later
                    window.localStorage.setItem(AUTH2_PREFERRED_LOCALE, locale);
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $t(key) {
    var translated = messages.value[key];
    if (!translated) {
        console.warn('Missing translation for', key);
        return "?".concat(key, "?");
    }
    return translated;
}
function getSelectedLocale() {
    var _a;
    return (_a = selectedLocale !== null && selectedLocale !== void 0 ? selectedLocale : localStorage.getItem(AUTH2_PREFERRED_LOCALE)) !== null && _a !== void 0 ? _a : getDefaultLocale();
}
function loadMessages() {
    return __awaiter(this, void 0, Promise, function() {
        var locale, _a;
        return __generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    locale = getSelectedLocale();
                    console.log("Loading messages for ".concat(locale));
                    _a = messages;
                    return [
                        4 /*yield*/ ,
                        (0, _utils.fetchJson)("./locales/sign-in-".concat(locale, ".json"))
                    ];
                case 1:
                    _a.value = _b.sent();
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
var DEFAULT_ELO_LOCALE = "en";
var ELO_LOCALES = [
    "cs",
    "da",
    "de",
    "el",
    "en",
    "es",
    "es-419",
    "fi",
    "fr",
    "hu",
    "id",
    "it",
    "nl",
    "pl",
    "pt",
    "pt-BR",
    "ro",
    "sk",
    "sr",
    "sr-Cyrl",
    "tr",
    // EAUTH2-140: Support zh-CN
    "zh-CN"
];
var ADMIN_LOCALES = [
    "de",
    "en",
    "fr"
];
function getDefaultLocale() {
    return pickLocaleFrom(ELO_LOCALES);
}
function pickLocaleFrom(locales) {
    // in case no locales are specified, pick from all available
    if (!locales) locales = ELO_LOCALES;
    // EAUTH2-49
    if (locales.length === 1 && ELO_LOCALES.includes(locales[0])) return locales[0];
    // contains the browser locales/languages by order of preference
    var langs = navigator.languages;
    if (!langs) langs = [
        navigator.language
    ];
    for(var _i = 0, langs_1 = langs; _i < langs_1.length; _i++){
        var lang = langs_1[_i];
        if (locales.includes(lang)) return lang;
        // Fallback to the more generic language (example "pt-BR" -> "pt")
        var shortCode = lang.split("-")[0];
        if (locales.includes(shortCode)) return shortCode;
    }
    return DEFAULT_ELO_LOCALE;
}
function loadAdminMessages() {
    return __awaiter(this, void 0, Promise, function() {
        var locale, _a;
        return __generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    locale = getSelectedLocale() // The one chosen during initial sign-in
                    ;
                    if (!ADMIN_LOCALES.includes(locale)) // Note: do not update `selectedLocale`. This is a fallback only for the admin panel messages.
                    locale = DEFAULT_ELO_LOCALE;
                    _a = messages;
                    return [
                        4 /*yield*/ ,
                        (0, _utils.fetchJson)("./locales/admin-".concat(locale, ".json"))
                    ];
                case 1:
                    _a.value = _b.sent();
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}

},{"./utils":"4iE5H","vue":"jc5UF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}]},[], null, "parcelRequiree3ab", {})

//# sourceMappingURL=access-denied.e1d8e2fa.js.map
